
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("afSyV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ad4cc730f676da4b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8Uqf3 = parcelRequire("8Uqf3");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");

var $jMq3Z = parcelRequire("jMq3Z");

var $fmhfo = parcelRequire("fmhfo");

var $akiS9 = parcelRequire("akiS9");

var $16sa1 = parcelRequire("16sa1");

var $j2mVo = parcelRequire("j2mVo");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad4cc730f676da4b$export$2e2bcd8739ae039 = ({ isAdminProjectDirectoryRoute: isAdminProjectDirectoryRoute = false })=>{
    const metricsConfig = (0, $eJOHy.useMemo)(()=>isAdminProjectDirectoryRoute ? (0, $j2mVo.METRICS_CONFIG).admin : (0, $j2mVo.METRICS_CONFIG).default, [
        isAdminProjectDirectoryRoute
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: metricsConfig.sourceName,
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $akiS9.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Uqf3.ExperienceStart), {
        experience: metricsConfig.experienceKey,
        analyticsSource: metricsConfig.experienceSource
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fmhfo.default), {
        id: metricsConfig.errorBoundary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $16sa1.default), {
        name: "projects-directory-v3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jMq3Z.default), {
        isAdminSettingsContext: isAdminProjectDirectoryRoute
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null))));
};

});
// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("jMq3Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $89aff1db38552398$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1KdDN = parcelRequire("1KdDN");

var $aqnJa = parcelRequire("aqnJa");

var $4ctwv = parcelRequire("4ctwv");

var $8KUFq = parcelRequire("8KUFq");

var $ch9En = parcelRequire("ch9En");

var $2YWby = parcelRequire("2YWby");

var $9FYIg = parcelRequire("9FYIg");

var $i9ujx = parcelRequire("i9ujx");

var $kea8Y = parcelRequire("kea8Y");
const $89aff1db38552398$var$ProjectsDirectoryContainer = ({ isAdminSettingsContext: isAdminSettingsContext, queries: queries })=>{
    const queryReference = queries?.projectsDirectoryPage ? queries.projectsDirectoryPage : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $9FYIg.useRelayResource)((0, $i9ujx.projectsDirectoryPageResource), {
        suspendWhenLoading: false
    }).queryReference;
    const experienceKey = isAdminSettingsContext ? (0, $2YWby.MANAGE_PROJECTS_DIRECTORY_EXPERIENCE) : (0, $2YWby.PROJECTS_DIRECTORY_EXPERIENCE);
    const onFail = (0, $aqnJa.useExperienceFail)({
        experience: experienceKey
    });
    const onSuccess = (0, $4ctwv.useExperienceSuccess)({
        experience: experienceKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "app-container",
        packageName: "jiraProjectsDirectoryV3",
        onError: (...args)=>{
            const [, error] = args;
            (0, $8KUFq.isHttpClientErrorResponse)(error) ? onSuccess({
                view: 'fallback-error-page'
            }) : onFail(...args);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "project-directory-layout",
        fallback: null
    }, queryReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kea8Y.ProjectDirectoryLayout), {
        queryRef: queryReference,
        isAdminSettingsContext: isAdminSettingsContext
    })));
};
var $89aff1db38552398$export$2e2bcd8739ae039 = $89aff1db38552398$var$ProjectsDirectoryContainer;

});
parcelRegister("kea8Y", function(module, exports) {

$parcel$export(module.exports, "ProjectDirectoryLayout", () => $e53c29c9ab6d57f1$export$9fc4c60d00e1220);

var $63fEl = parcelRequire("63fEl");

var $3vXGP = parcelRequire("3vXGP");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $evNz6 = parcelRequire("evNz6");

var $8IeH1 = parcelRequire("8IeH1");

var $8nw3F = parcelRequire("8nw3F");

var $dSM65 = parcelRequire("dSM65");

var $lQ1ke = parcelRequire("lQ1ke");

var $1KdDN = parcelRequire("1KdDN");

var $aqnJa = parcelRequire("aqnJa");

var $4ctwv = parcelRequire("4ctwv");

var $epTsa = parcelRequire("epTsa");

var $aBIfT = parcelRequire("aBIfT");

var $lRq8t = parcelRequire("lRq8t");

var $6d9QY = parcelRequire("6d9QY");

var $2YWby = parcelRequire("2YWby");

var $g1iDH = parcelRequire("g1iDH");

var $7ik1K = parcelRequire("7ik1K");

var $lA4uT = parcelRequire("lA4uT");

var $1IbiK = parcelRequire("1IbiK");

var $cZTMg = parcelRequire("cZTMg");

var $gWu57 = parcelRequire("gWu57");

var $dTqD3 = parcelRequire("dTqD3");

var $kEUB1 = parcelRequire("kEUB1");

var $gZTP9 = parcelRequire("gZTP9");

var $lUto7 = parcelRequire("lUto7");

var $6XJko = parcelRequire("6XJko");

var $ln6Iy = parcelRequire("ln6Iy");

var $eJrcF = parcelRequire("eJrcF");

var $2emAF = parcelRequire("2emAF");

var $7jTnu = parcelRequire("7jTnu");

var $3JBFS = parcelRequire("3JBFS");

var $jalQP = parcelRequire("jalQP");

var $fzVim = parcelRequire("fzVim");

var $hHbwP = parcelRequire("hHbwP");

var $brbC9 = parcelRequire("brbC9");

var $7ZKwq = parcelRequire("7ZKwq");

var $fJ5Er = parcelRequire("fJ5Er");

var $9QHCE = parcelRequire("9QHCE");

const $e53c29c9ab6d57f1$export$9fc4c60d00e1220 = ({ queryRef: queryRef, isAdminSettingsContext: isAdminSettingsContext })=>{
    const filterResultsAnnouncementGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $brbC9.default).filterResultsAnnouncementGalaxia : (0, $brbC9.default).filterResultsAnnouncement;
    const adminDocumentTitleGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $brbC9.default).adminDocumentTitleGalaxia : (0, $brbC9.default).adminDocumentTitle;
    const documentTitleGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $brbC9.default).documentTitleGalaxia : (0, $brbC9.default).documentTitle;
    const experienceKey = isAdminSettingsContext ? (0, $2YWby.MANAGE_PROJECTS_DIRECTORY_EXPERIENCE) : (0, $2YWby.PROJECTS_DIRECTORY_EXPERIENCE);
    const cloudId = (0, $kEUB1.useCloudId)();
    const syncQueryFilter = (0, $lQ1ke.useQueryFilter)();
    const onFail = (0, $aqnJa.useExperienceFail)({
        experience: experienceKey
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [currentProjectType] = (0, $3JBFS.useScopedFilter)((0, $2YWby.FilterFields).ProjectType);
    const { data: siteTraits } = (0, $eJrcF.useResource)((0, $2emAF.fetchSiteTraitsResource));
    const shouldShowJPDCreateFirstProjectModal = ()=>{
        const productDiscoveryProjectFilterNotApplied = currentProjectType !== (0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT);
        const hasNotBeenAutoProvisionedJpd = !siteTraits?.find((trait)=>trait?.name === 'jpd.auto-provision.activationdate');
        const filteredProjectsCount = dataRef?.jira?.allJiraProjects?.totalCount;
        if (!(0, $7jTnu.fg)('jpd_ap_onboarding_kill_switcher')) return false;
        if (!(0, $7jTnu.fg)('jpd_auto-provisioning_for_jira_d0_gate')) return false;
        if (productDiscoveryProjectFilterNotApplied) return false;
        if (hasNotBeenAutoProvisionedJpd) return false;
        if (filteredProjectsCount !== 0) return false;
        return true;
    };
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const rootQueryRef = (0, $j4oe4.usePreloadedQuery)((0, $3vXGP.default), queryRef); /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ 
    const [dataRef, refetch] = (0, $j4oe4.useRefetchableFragment)((0, $63fEl.default), rootQueryRef);
    const prevDataRef = (0, $6d9QY.usePrevious)(dataRef);
    const [{ isFetching: isFetching, errors: errors }, { refetchData: refetchData }] = (0, $dSM65.useDirectoryRefetch)({
        refetch: refetch,
        query: (0, $1IbiK.default)
    });
    const handleFilterUpdate = (0, $eJOHy.useCallback)((filter)=>{
        const { [(0, $2YWby.FilterFields).Page]: currentPage } = filter;
        refetchData({
            variables: {
                cloudId: cloudId,
                filter: (0, $g1iDH.mapQueryToFilter)(filter, {
                    cloudId: cloudId
                }),
                first: (0, $2YWby.DEFAULT_LIMIT) * parseInt(currentPage, 10),
                last: (0, $2YWby.DEFAULT_LIMIT),
                isAdminSettingsContext: isAdminSettingsContext
            },
            options: {
                fetchPolicy: 'network-only'
            }
        });
        syncQueryFilter(filter);
    }, [
        cloudId,
        refetchData,
        syncQueryFilter,
        isAdminSettingsContext
    ]);
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const isJiraAdmin = (0, $gZTP9.useIsAdmin)();
    const canBrowseProjects = isSiteAdmin || isJiraAdmin || rootQueryRef?.jira?.canBrowseProjects?.hasPermission;
    if (!canBrowseProjects) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e53c29c9ab6d57f1$var$HeaderlessContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ZKwq.AsyncNoPermissionViews), {
        dataRef: rootQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: experienceKey,
        attributes: {
            view: 'no-permission'
        }
    }));
    if (errors) {
        onFail('projects-directory-v3.page', errors);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e53c29c9ab6d57f1$var$HeaderlessContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fzVim.PageErrorState), null));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "page-layout",
        packageName: "jiraProjectsDirectoryV3",
        onError: onFail
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3JBFS.FilterContainer), {
        isGlobal: true,
        onUpdate: handleFilterUpdate
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        paddingInline: (0, $6XJko.isVisualRefreshEnabled)() ? 'space.300' : 'space.500'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aBIfT.DocumentTitle), {
        title: isAdminSettingsContext ? formatMessage(adminDocumentTitleGalaxia) : formatMessage(documentTitleGalaxia)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hHbwP.Header), {
        dataRef: rootQueryRef,
        isAdminSettingsContext: isAdminSettingsContext
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9QHCE.RefinementBar), {
        dataRef: rootQueryRef
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWu57.ScrollablePage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nw3F.AnnouncerV2), {
        message: formatMessage(filterResultsAnnouncementGalaxia, {
            itemCount: dataRef?.jira?.allJiraProjects?.totalCount || 0
        }),
        shouldAnnounce: !isFetching && prevDataRef !== dataRef
    }), dataRef?.jira?.allJiraProjects && dataRef?.jira?.allJiraProjects?.totalCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fJ5Er.ProjectsList), {
        isLoading: isFetching,
        isAdminSettingsContext: isAdminSettingsContext,
        projectsRef: dataRef?.jira?.allJiraProjects,
        rootQueryRef: rootQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: experienceKey,
        attributes: {
            view: 'projects-list'
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jalQP.AsyncEmptyView), {
        dataRef: rootQueryRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4ctwv.ExperienceSuccess), {
        experience: experienceKey,
        attributes: {
            view: 'empty'
        }
    }))), shouldShowJPDCreateFirstProjectModal() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $evNz6.ProjectDirectoryOnboardingModal), {
        targetProduct: "jira-product-discovery",
        sourceComponent: "ProjectsDirectoryV3Filter"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dTqD3.SpaStatePageReady), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lA4uT.default), {
        appName: "projects-directory-v3",
        metricKey: "jira.directories.projects-v3",
        isExpectedToHaveSsr: true // @ts-expect-error - TS2322
        ,
        metric: (0, $7ik1K.pageLoad)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZTMg.SubProductUpdater), {
        subProduct: "platform"
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e53c29c9ab6d57f1$var$HeaderlessContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_ca0qvbgk",
            __cmplp.className
        ])
    });
});

});
parcelRegister("63fEl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dfb01ddde2099e0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f6003fff2598016aad9b7bcfa4be569a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $1IbiK = parcelRequire("1IbiK");
const $1dfb01ddde2099e0$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "filter"
        },
        {
            "kind": "RootArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAdminSettingsContext"
        },
        {
            "kind": "RootArgument",
            "name": "last"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $1IbiK.default)
        }
    },
    "name": "pageLayout_projectsDirectoryV3_ProjectDirectoryLayout",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "filter",
                            "variableName": "filter"
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                        },
                        {
                            "kind": "Variable",
                            "name": "last",
                            "variableName": "last"
                        }
                    ],
                    "concreteType": "JiraProjectConnection",
                    "kind": "LinkedField",
                    "name": "allJiraProjects",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isAdminSettingsContext",
                                    "variableName": "isAdminSettingsContext"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "projectsList_projectsDirectoryV3_projectsRef"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "totalCount"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$1dfb01ddde2099e0$var$node.hash = "eb5983a7159e6add64de193b1e14a2b6";
var $1dfb01ddde2099e0$export$2e2bcd8739ae039 = $1dfb01ddde2099e0$var$node;

});
parcelRegister("1IbiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2207c14ea064e3df$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2e58835ffc6d9c8dea4f7a7fb8091fa4>>
 * @relayHash d704040236368f7053a2092898c20b31
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 45f9c31ab5475a73950868ac43cc30bdbd64d5bc618f10e7497bfa8627e0be1c
const $2207c14ea064e3df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAdminSettingsContext"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "last"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "canPerform"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "isFavourite"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ProjectDirectoryRefetchQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isAdminSettingsContext",
                            "variableName": "isAdminSettingsContext"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "pageLayout_projectsDirectoryV3_ProjectDirectoryLayout"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ProjectDirectoryRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "filter",
                                    "variableName": "filter"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "first",
                                    "variableName": "first"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "last",
                                    "variableName": "last"
                                }
                            ],
                            "concreteType": "JiraProjectConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": "canViewIssue",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_ISSUES"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v1 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_ISSUES\")"
                                                },
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraFavouriteValue",
                                                    "kind": "LinkedField",
                                                    "name": "favouriteValue",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__id"
                                                                }
                                                            ]
                                                        },
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectId"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "key"
                                                },
                                                {
                                                    "concreteType": "JiraAvatar",
                                                    "kind": "LinkedField",
                                                    "name": "avatar",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "medium"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectStyle"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "navigationMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardId"
                                                                },
                                                                v2 /*: any*/ 
                                                            ],
                                                            "type": "JiraSoftwareProjectNavigationMetadata"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "concreteType": "JiraProjectCategory",
                                                    "kind": "LinkedField",
                                                    "name": "category",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "lead",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "TypeDiscriminator",
                                                            "abstractKey": "__isUser"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "accountId"
                                                        },
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v2 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "projectUrl"
                                                },
                                                {
                                                    "alias": "canViewProjectConfig",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "type",
                                                            "value": "VIEW_PROJECT_CONFIG"
                                                        }
                                                    ],
                                                    "concreteType": "JiraProjectAction",
                                                    "kind": "LinkedField",
                                                    "name": "action",
                                                    "plural": false,
                                                    "selections": v1 /*: any*/ ,
                                                    "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                                                },
                                                {
                                                    "alias": "jiraProjectType",
                                                    "kind": "ScalarField",
                                                    "name": "projectType"
                                                },
                                                {
                                                    "alias": "jiraProjectName",
                                                    "kind": "ScalarField",
                                                    "name": "name"
                                                },
                                                {
                                                    "condition": "isAdminSettingsContext",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "alias": "lastUpdatedToolTipDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "COMPLETE_DATETIME_FORMAT"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
                                                        },
                                                        {
                                                            "alias": "lastUpdatedDisplayDate",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "format",
                                                                    "value": "RELATIVE"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "lastUpdatedFormatted",
                                                            "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isHasTotal"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "45f9c31ab5475a73950868ac43cc30bdbd64d5bc618f10e7497bfa8627e0be1c",
            "metadata": {},
            "name": "ProjectDirectoryRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$2207c14ea064e3df$var$node.hash = "eb5983a7159e6add64de193b1e14a2b6";
var $2207c14ea064e3df$export$2e2bcd8739ae039 = $2207c14ea064e3df$var$node;

});


parcelRegister("evNz6", function(module, exports) {

$parcel$export(module.exports, "ProjectDirectoryOnboardingModal", () => $f0613911849d415b$export$be20197a34eb0c9a);

var $eJOHy = parcelRequire("eJOHy");

var $dZRBE = parcelRequire("dZRBE");

var $806LH = parcelRequire("806LH");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $daZe3 = parcelRequire("daZe3");

var $4xbv3 = parcelRequire("4xbv3");

var $83DiZ = parcelRequire("83DiZ");

var $bILK0 = parcelRequire("bILK0");

var $9aRzJ = parcelRequire("9aRzJ");

var $epTsa = parcelRequire("epTsa");

var $6oJ4Y = parcelRequire("6oJ4Y");

var $8nC53 = parcelRequire("8nC53");

var $dvOer = parcelRequire("dvOer");

var $gWTGo = parcelRequire("gWTGo");

var $aFb6y = parcelRequire("aFb6y");

var $c5AdF = parcelRequire("c5AdF");

var $cPEMf = parcelRequire("cPEMf");

var $gChqa = parcelRequire("gChqa");

var $3O3sz = parcelRequire("3O3sz");

var $dKytp = parcelRequire("dKytp");

var $2swfp = parcelRequire("2swfp");

var $bafjm = parcelRequire("bafjm");

var $eQlvG = parcelRequire("eQlvG");
const $f0613911849d415b$export$be20197a34eb0c9a = ({ targetProduct: targetProduct, templateKey: templateKey = (0, $daZe3.TEMPLATE_KEY), sourceComponent: sourceComponent })=>{
    const { push: push } = (0, $83DiZ.useRouterActions)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { formatMessage: formatMessage, locale: locale } = (0, $lRq8t.default)();
    const [selectedFeature, setSelectedFeature] = (0, $eJOHy.useState)(0);
    const [open, setOpen] = (0, $eJOHy.useState)(true);
    const { upgradeCCPEntitlement: upgradeCCPEntitlement, entitlementUpgrading: entitlementUpgrading, loadingUpgradeData: loadingUpgradeData } = (0, $dZRBE.useCrossFlowEditionParity)({
        sourceProduct: 'jira-software.ondemand',
        targetProduct: targetProduct
    });
    const handleFeatureUpdate = (0, $eJOHy.useCallback)((index)=>setSelectedFeature(index), [
        setSelectedFeature
    ]);
    const templateContent = (0, $eJOHy.useMemo)(()=>{
        return (0, $3O3sz.getTemplateContentFromKey)(templateKey);
    }, [
        templateKey
    ]);
    const onSuccess = (0, $eJOHy.useCallback)((createProjectResponse)=>{
        push(createProjectResponse.returnUrl);
    }, [
        push
    ]);
    const onFail = (0, $eJOHy.useCallback)((_error)=>{
        showFlag({
            type: 'error',
            id: 'project-creation-failure',
            title: formatMessage((0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $9aRzJ.default).createProjectFailureTitleNonFinalGalaxia : (0, $9aRzJ.default).createProjectFailureTitleNonFinal),
            description: formatMessage((0, $9aRzJ.default).createProjectFailureDescriptionNonFinal),
            messageId: 'cross-flow-onboarding-modal.ui.project-directory-onboarding-modal.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        formatMessage,
        showFlag
    ]);
    const [submitProjectCreate, isProjectCreateLoading, _hasProjectCreateError] = (0, $dKytp.useSubmitProjectCreate)(onSuccess, onFail);
    const onClick = (0, $eJOHy.useCallback)(async ()=>{
        if (!entitlementUpgrading && !loadingUpgradeData) upgradeCCPEntitlement({
            tosPrivacyText: 'Terms of Service and Privacy Policy accepted',
            locale: locale
        });
        await submitProjectCreate({
            payload: {
                templateKey: (0, $2swfp.getTemplateTmpKeyFromKey)(templateKey),
                name: formatMessage(templateContent.templateTitle)
            },
            analyticsAttributes: {}
        });
    }, [
        entitlementUpgrading,
        formatMessage,
        loadingUpgradeData,
        locale,
        submitProjectCreate,
        templateContent.templateTitle,
        templateKey,
        upgradeCCPEntitlement
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        attributes: {
            featureItemIndex: selectedFeature,
            templateKey: templateKey,
            message: templateContent.features[selectedFeature].description.defaultMessage
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bafjm.OnboardingModalContextProvider), {
        targetProduct: targetProduct,
        open: open
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6oJ4Y.OnboardingModalComponent), {
        targetProduct: targetProduct,
        sourceComponent: sourceComponent,
        ariaLabel: formatMessage((0, $eQlvG.default).ariaLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nC53.OnboardingGrid), {
        enableCrossButton: true,
        onClose: ()=>setOpen(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nC53.OnboardingGrid).ContentSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dvOer.OnboardingContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "large"
    }, formatMessage((0, $eQlvG.default).modalHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cPEMf.Features), null, templateContent.features.map((item, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cPEMf.Features).Item, {
            isActive: selectedFeature === i,
            key: `cross-flow-onboarding-modal-${i}-item`,
            onClick: ()=>handleFeatureUpdate(i),
            index: i
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(item.icon, {
            label: "",
            color: "var(--ds-icon-selected)",
            key: i
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            color: "inherit"
        }, formatMessage(item.description))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWTGo.LegalNotice), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nC53.OnboardingGrid).Controls, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nC53.OnboardingGrid).ControlItem, {
        variant: "cancel",
        onClick: ()=>setOpen(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nC53.OnboardingGrid).ControlItem, {
        variant: "get-started",
        appearance: "primary",
        isLoading: isProjectCreateLoading || entitlementUpgrading,
        onClick: onClick,
        disabled: loadingUpgradeData
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nC53.OnboardingGrid).ImageSection, {
        backgroundLight: (0, (/*@__PURE__*/$parcel$interopDefault($aFb6y))),
        backgroundDark: (0, (/*@__PURE__*/$parcel$interopDefault($c5AdF)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gChqa.TabContent), {
        onChange: handleFeatureUpdate,
        selected: selectedFeature,
        content: templateContent,
        templateKey: templateKey
    }))))));
};

});
parcelRegister("dZRBE", function(module, exports) {

$parcel$export(module.exports, "useCrossFlowEditionParity", () => $47d72368c1fd71b6$export$ec8b414823ff2307);

var $afkaZ = parcelRequire("afkaZ");

var $gtJNn = parcelRequire("gtJNn");
const $47d72368c1fd71b6$export$ec8b414823ff2307 = ({ sourceProduct: sourceProduct, targetProduct: targetProduct })=>{
    const { isLoading: isLoading, offeringId: offeringId, targetEdition: targetEdition, entitlementDetails: entitlementDetails, defaultOffering: defaultOffering, transactionAccountId: transactionAccountId, currentTargetEdition: currentTargetEdition, shouldUpgrade: shouldUpgrade } = (0, $gtJNn.useCrossFlowEditionParityData)({
        sourceProduct: sourceProduct,
        targetProduct: targetProduct
    });
    const { upgradeCCPEntitlement: upgradeCCPEntitlement, entitlementUpgrading: entitlementUpgrading } = (0, $afkaZ.useUpgradeEdition)({
        shouldUpgrade: !isLoading && shouldUpgrade,
        entitlementDetails: entitlementDetails,
        defaultOffering: defaultOffering,
        targetOfferingId: offeringId,
        targetEdition: targetEdition,
        transactionAccountId: transactionAccountId,
        analyticsAttributes: {
            offeringId: offeringId,
            targetEdition: targetEdition,
            hasEntitlementDetails: !!entitlementDetails,
            hasDefaultOffering: !!defaultOffering,
            entitlementId: entitlementDetails?.entitlementId || '',
            entitlementVersion: entitlementDetails?.version || '',
            transactionAccountId: transactionAccountId,
            currentTargetEdition: currentTargetEdition,
            sourceProduct: sourceProduct,
            targetProduct: targetProduct
        }
    });
    return {
        loadingUpgradeData: isLoading,
        upgradeCCPEntitlement: upgradeCCPEntitlement,
        entitlementUpgrading: entitlementUpgrading,
        targetEdition: targetEdition
    };
};

});
parcelRegister("afkaZ", function(module, exports) {

$parcel$export(module.exports, "useUpgradeEdition", () => $d8751890707151e0$export$1324d81df7c5ba38);
$parcel$export(module.exports, "targetEditionToUpgradeOfferingId", () => $d8751890707151e0$export$dfd094f098539713);

var $eJOHy = parcelRequire("eJOHy");

var $9myT7 = parcelRequire("9myT7");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $6YXku = parcelRequire("6YXku");

var $kSvZT = parcelRequire("kSvZT");

var $8Baj1 = parcelRequire("8Baj1");

var $a9ldn = parcelRequire("a9ldn");

var $hZoe8 = parcelRequire("hZoe8");

var $cnSyh = parcelRequire("cnSyh");
const $d8751890707151e0$export$7c7680e2128a0495 = 'E2102';
const $d8751890707151e0$export$a75106e6d720c94c = 3;
const $d8751890707151e0$var$ordersPostWithRetry = async (payload, retryIntervalMs = 100, maxRetries = 0)=>{
    let retry = 0;
    let result;
    do {
        // eslint-disable-next-line no-await-in-loop
        result = await (0, $6YXku.orders_post_v1)(payload);
        if (result.payload?.status === 201 || (0, $9myT7.isException)(result)) return {
            ...result,
            retry: retry
        };
        const usageError = result.payload?.body?.code === $d8751890707151e0$export$7c7680e2128a0495;
        if (!usageError) return {
            ...result,
            retry: retry
        };
        // sleep for interval
        // eslint-disable-next-line no-await-in-loop
        await new Promise((resolve)=>setTimeout(resolve, retryIntervalMs));
        retry += 1;
    }while (retry < maxRetries);
    return {
        ...result,
        retry: retry
    };
};
const $d8751890707151e0$export$1324d81df7c5ba38 = ({ shouldUpgrade: shouldUpgrade, entitlementDetails: entitlementDetails, defaultOffering: defaultOffering, targetOfferingId: targetOfferingId, targetEdition: targetEdition, transactionAccountId: transactionAccountId, retryMs: retryMs = 22000, analyticsAttributes: analyticsAttributes })=>{
    const fetch = (0, $8Baj1.useCommerceFetch)();
    const [entitlementUpgrading, setEntitlementUpgrading] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const fireErrorAnalytics = (0, $eJOHy.useCallback)((reason, attributes)=>(0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useUpgradeEdition failed', {
            ...attributes,
            ...analyticsAttributes,
            reason: reason,
            shouldUpgrade: shouldUpgrade,
            targetEdition: targetEdition,
            targetOfferingId: targetOfferingId
        }), [
        analyticsAttributes,
        createAnalyticsEvent,
        shouldUpgrade,
        targetEdition,
        targetOfferingId
    ]);
    const fireSuccessAnalytics = (0, $eJOHy.useCallback)((actionSubject, attributes)=>(0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), `${actionSubject} succeeded`, {
            ...attributes,
            ...analyticsAttributes,
            shouldUpgrade: shouldUpgrade,
            targetEdition: targetEdition,
            targetOfferingId: targetOfferingId
        }), [
        analyticsAttributes,
        createAnalyticsEvent,
        shouldUpgrade,
        targetEdition,
        targetOfferingId
    ]);
    const fireStepSuccessAnalytics = (0, $eJOHy.useCallback)((step, attributes)=>(0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useUpgradeEdition stepSucceeded', {
            ...attributes,
            ...analyticsAttributes,
            shouldUpgrade: shouldUpgrade,
            targetEdition: targetEdition,
            targetOfferingId: targetOfferingId
        }), [
        analyticsAttributes,
        createAnalyticsEvent,
        shouldUpgrade,
        targetEdition,
        targetOfferingId
    ]);
    const upgradeCCPEntitlement = (0, $eJOHy.useCallback)(async ({ tosPrivacyText: tosPrivacyText, locale: locale })=>{
        if (!shouldUpgrade) {
            fireErrorAnalytics('upgradeSkipped');
            return;
        }
        if (entitlementUpgrading || !entitlementDetails || !targetOfferingId || !defaultOffering || !transactionAccountId || !tosPrivacyText) {
            fireErrorAnalytics('upgradeCCPEntitlementCalledWithInvalidState');
            return;
        }
        try {
            setEntitlementUpgrading(true);
            if (tosPrivacyText) {
                // Only record consent if payment details are available
                // Convert locale to 2-character country code (ISO 3166-1 alpha-2)
                const countryCode = locale.split('-').pop()?.toUpperCase() || 'US';
                await (0, $cnSyh.recordTosAndPrivacyConsent)({
                    tosPrivacyText: tosPrivacyText,
                    geoLocale: countryCode
                });
                fireStepSuccessAnalytics('consentRecorded');
            }
            const orderRequest = (0, $hZoe8.createAmendmentOrderRequestDto)(defaultOffering, targetOfferingId, entitlementDetails);
            if (!orderRequest) {
                fireErrorAnalytics('orderRequestNotCreated');
                return;
            }
            const result = await $d8751890707151e0$var$ordersPostWithRetry({
                body: orderRequest,
                headers: {
                    'X-transaction-account': transactionAccountId
                }
            }, retryMs, $d8751890707151e0$export$a75106e6d720c94c);
            if ((0, $9myT7.isSuccess)(result) && result.payload.status === 201) {
                await (0, $kSvZT.waitUntilOrderSucceeds)(fetch, transactionAccountId, orderRequest.orderId);
                fireSuccessAnalytics('useUpgradeEdition', result);
            } else {
                if (result.retry === $d8751890707151e0$export$a75106e6d720c94c) {
                    // Could not upgrade entitlement after max retries
                    fireErrorAnalytics('upgradeFailedAfterMaxRetries', {
                        entitlementUpgradeError: JSON.stringify(result),
                        entitlementUpgradeErrorCode: result.error?.status
                    });
                    setEntitlementUpgrading(false);
                    return;
                }
                // encountered an error before max retries
                fireErrorAnalytics('upgradeFailedBeforeMaxRetries', {
                    entitlementUpgradeErrorCode: result.error?.status,
                    entitlementUpgradeError: JSON.stringify(result)
                });
            }
        } catch (error) {
            fireErrorAnalytics('upgradeFailedDueToException', {
                entitlementUpgradeError: JSON.stringify(error)
            });
        } finally{
            setEntitlementUpgrading(false);
        }
    }, [
        shouldUpgrade,
        entitlementUpgrading,
        entitlementDetails,
        targetOfferingId,
        defaultOffering,
        transactionAccountId,
        fireErrorAnalytics,
        retryMs,
        fireStepSuccessAnalytics,
        fetch,
        fireSuccessAnalytics
    ]);
    return {
        upgradeCCPEntitlement: upgradeCCPEntitlement,
        entitlementUpgrading: entitlementUpgrading
    };
};
const $d8751890707151e0$export$dfd094f098539713 = ({ productKey: productKey, targetEdition: targetEdition })=>{
    const offeringIdMap = {
        'jira-product-discovery': {
            [(0, $a9ldn.STANDARD_EDITION)]: '35b9268e-66e2-45fb-81d3-dacd1e31831a',
            [(0, $a9ldn.PREMIUM_EDITION)]: 'f0b24ca7-c3d8-4cac-b5ed-60f4152d4dcd',
            [(0, $a9ldn.UNLICENSED)]: null,
            [(0, $a9ldn.FREE_EDITION)]: null
        }
    };
    if (!offeringIdMap[productKey]) throw new Error(`Not supported product key: ${productKey}`);
    if (!offeringIdMap[productKey][targetEdition]) throw new Error(`Not supported target edition: ${targetEdition} for product key: ${productKey}`);
    const offeringId = offeringIdMap[productKey][targetEdition];
    if (!offeringId) throw new Error(`Upgrade Offering ID not found for product key: ${productKey} and edition: ${targetEdition}`);
    return offeringId;
};

});
parcelRegister("9myT7", function(module, exports) {

$parcel$export(module.exports, "isException", () => $847a32ec8dc3289f$export$40f07171f4b6ee01);
$parcel$export(module.exports, "isSuccess", () => $847a32ec8dc3289f$export$b0ac3e614a309be3);
$parcel$export(module.exports, "isFailure", () => $847a32ec8dc3289f$export$4ece3b219cb1e8e7);
$parcel$export(module.exports, "success", () => $847a32ec8dc3289f$export$fe7c49d056ea1d88);
$parcel$export(module.exports, "error", () => $847a32ec8dc3289f$export$a3bc9b8ed74fc);
$parcel$export(module.exports, "exception", () => $847a32ec8dc3289f$export$788a307bb494601);

var $dSqax = parcelRequire("dSqax");
"use strict";
const $847a32ec8dc3289f$export$40f07171f4b6ee01 = (result)=>result.type === $dSqax.EXCEPTION;
const $847a32ec8dc3289f$export$e6127cc7fe7395c3 = (result)=>result.type === $dSqax.ERROR;
const $847a32ec8dc3289f$export$bd63a49166768e99 = (result)=>result.type === $dSqax.SUCCESS;
const $847a32ec8dc3289f$export$46dd8fdc8be98d59 = $847a32ec8dc3289f$export$bd63a49166768e99;
const $847a32ec8dc3289f$export$b0ac3e614a309be3 = $847a32ec8dc3289f$export$bd63a49166768e99;
const $847a32ec8dc3289f$export$4ece3b219cb1e8e7 = (result)=>{
    switch(result.type){
        case $dSqax.ERROR:
        case $dSqax.EXCEPTION:
            return true;
        default:
            return false;
    }
};
const $847a32ec8dc3289f$export$5e805c3762185b4c = (payload)=>({
        type: $dSqax.SUCCESS,
        payload: payload,
        error: undefined,
        exception: undefined
    });
const $847a32ec8dc3289f$export$fe7c49d056ea1d88 = $847a32ec8dc3289f$export$5e805c3762185b4c;
const $847a32ec8dc3289f$export$411e9a7b4316b872 = $847a32ec8dc3289f$export$5e805c3762185b4c;
const $847a32ec8dc3289f$export$a3bc9b8ed74fc = (error)=>({
        type: $dSqax.ERROR,
        payload: undefined,
        error: error,
        exception: undefined
    });
const $847a32ec8dc3289f$export$788a307bb494601 = (exception)=>{
    return {
        type: $dSqax.EXCEPTION,
        payload: undefined,
        error: undefined,
        exception: exception
    };
};
const $847a32ec8dc3289f$export$aadcd93c949999c0 = (result, handlers = {})=>{
    switch(result.type){
        case $dSqax.SUCCESS:
            {
                const { payload: payload } = result;
                if (handlers.payload !== undefined) return handlers.payload(payload, result);
                break;
            }
        case $dSqax.ERROR:
            {
                const { error: error } = result;
                if (handlers.error !== undefined) return handlers.error(error, result);
                break;
            }
        case $dSqax.EXCEPTION:
            {
                const { exception: exception } = result;
                if (handlers.exception !== undefined) return handlers.exception(exception, result);
                break;
            }
    }
    return result;
};
const $847a32ec8dc3289f$export$8f34ce051745d39e = (result, handlers = {})=>{
    try {
        return $847a32ec8dc3289f$export$aadcd93c949999c0(result, handlers);
    } catch (err) {
        return $847a32ec8dc3289f$export$788a307bb494601(err);
    }
};

});
parcelRegister("dSqax", function(module, exports) {

$parcel$export(module.exports, "SUCCESS", () => $54e0aa014750d3e8$export$638cc6e36b2a737a);
$parcel$export(module.exports, "ERROR", () => $54e0aa014750d3e8$export$103bedf43ba882db);
$parcel$export(module.exports, "EXCEPTION", () => $54e0aa014750d3e8$export$e7e66e0bc92d8ea1);
"use strict";
const $54e0aa014750d3e8$export$87478ad3f0539058 = 'payload';
const $54e0aa014750d3e8$export$638cc6e36b2a737a = $54e0aa014750d3e8$export$87478ad3f0539058;
const $54e0aa014750d3e8$export$eade6b6091579183 = $54e0aa014750d3e8$export$87478ad3f0539058;
const $54e0aa014750d3e8$export$103bedf43ba882db = 'error';
const $54e0aa014750d3e8$export$e7e66e0bc92d8ea1 = 'exception';

});


parcelRegister("6YXku", function(module, exports) {

$parcel$export(module.exports, "getSuccessfulResultOrThrow", () => $91b71dd9e99d421a$export$390f7ebd9b7a4732);
$parcel$export(module.exports, "entitlementsDetails_get_byEntitlementId_v1", () => $91b71dd9e99d421a$export$5f0bdd817b9edeb1);
$parcel$export(module.exports, "invoiceGroups_post_v1", () => $91b71dd9e99d421a$export$12fe7372e856ac7f);
$parcel$export(module.exports, "orderDefaults_get_byOfferingId_v1", () => $91b71dd9e99d421a$export$4a001194c1527f6b);
$parcel$export(module.exports, "orders_post_v1", () => $91b71dd9e99d421a$export$3b9d6eeb7d030d96);
/* eslint-disable */ /* tslint:disable */ /*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */ /**
 * @title Commerce Cloud Platform
 * @version 1.0.0
 * @baseUrl https://ccp-api-gateway.prod.atl-paas.net
 * @externalDocs https://developer.atlassian.com/platform/commerce-cloud-platform/security/authentication/
 * @contact CCP Developers (https://atlassian.slack.com/archives/C016U73MTC1)
 *
 * Commerce Cloud Platform (CCP) is a part of Project Tintin (go/tintin). Tintin is the foundational initiative unifying Pricing, Product Catalog, Subscriptions and Billing engines across all our Cloud products, to unleash Atlassian’s ability to scale to a $10B company.
 */ 
var $9myT7 = parcelRequire("9myT7");
/**
 * The response from the client was not defined in the schema.
 * This doesn't necessarily mean that the fetch failed to perform its intended behaviour - It's just that the response
 * was not defined in the schema. You may want to wrap the fetch calls provided by this client with your own logic that
 * handles certain error codes as success regardless of whether it's defined in the schema or not.
 */ const $91b71dd9e99d421a$var$NOT_IN_SCHEMA = "not-in-schema";
/**
 * This error is reported when the schema does not list any mime types that we support in this client.
 */ const $91b71dd9e99d421a$var$MIME_TYPE_NOT_SUPPORTED = "mime-type-not-supported";
const $91b71dd9e99d421a$var$getValidResponseOrThrow = (result)=>{
    if (!(0, $9myT7.isSuccess)(result)) {
        if (result.error) // eslint-disable-next-line no-console
        console.log(result.error);
        if (result.exception) // eslint-disable-next-line no-console
        console.error(result.exception);
        throw new Error(`getValidResponseOrThrow: request failed: ${String(result.error ?? result.exception)}`);
    }
    return result.payload;
};
const $91b71dd9e99d421a$export$390f7ebd9b7a4732 = (result)=>{
    const response = $91b71dd9e99d421a$var$getValidResponseOrThrow(result);
    if (response.status < 200 || response.status >= 300) {
        // eslint-disable-next-line no-console
        console.log(`getSuccessfulResultOrThrow: Response: ${response}`);
        throw new Error(`getSuccessfulResultOrThrow: Status code: ${response.status} ${response.response?.url ?? ""}`);
    }
    return response.body;
};
const $91b71dd9e99d421a$export$a7fcd798548c2cab = (endpoint)=>async (...args)=>$91b71dd9e99d421a$export$390f7ebd9b7a4732(await endpoint(...args));
const $91b71dd9e99d421a$export$231366cf7929fca = (handler)=>{
    return async (...args)=>{
        try {
            return await handler(...args);
        } catch (err) {
            // TODO: Remove once AFP supports TypeScript 4
            return (0, $9myT7.exception)(err);
        }
    };
};
const $91b71dd9e99d421a$var$flatten = (params)=>{
    const result = {};
    Object.entries(params ?? {}).forEach(([key, value])=>{
        if (typeof value === "object") {
            Object.assign(result, $91b71dd9e99d421a$var$flatten(value));
            return;
        }
        result[key] = value;
    });
    return result;
};
const $91b71dd9e99d421a$var$FAKE_ORIGIN = "http://FAKE_ORIGIN";
/**
 * Determine if the given URL is a full URL (including the origin),
 * or if it it just a path
 */ const $91b71dd9e99d421a$var$isFullUrl = (url)=>new URL(url, $91b71dd9e99d421a$var$FAKE_ORIGIN).href === url;
const $91b71dd9e99d421a$export$a639a54e55b70225 = (endpointPath, baseGatewayUrl, queryParameters = {})=>{
    // The WHATWG URL API does not work with relative paths, hence FAKE_ORIGIN.
    // See: https://github.com/whatwg/url/issues/531
    const fakeUrl = new URL(endpointPath, $91b71dd9e99d421a$var$isFullUrl(baseGatewayUrl) ? baseGatewayUrl : $91b71dd9e99d421a$var$FAKE_ORIGIN);
    // TODO: find out how undefined, arrays, and objects should be encoded
    fakeUrl.search = new URLSearchParams($91b71dd9e99d421a$var$flatten(queryParameters)).toString();
    return $91b71dd9e99d421a$var$isFullUrl(baseGatewayUrl) ? fakeUrl.href : `${baseGatewayUrl}${fakeUrl.href.slice($91b71dd9e99d421a$var$FAKE_ORIGIN.length + 1)}`;
};
const $91b71dd9e99d421a$export$ac22a5efe63978d6 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/archive-configs/item-type/${pathParameters.itemType}/source-system/${pathParameters.sourceSystem}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/archive-configs/item-type/${itemType}/source-system/${sourceSystem}",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `archiveConfigsItemTypeSourceSystem_get_byItemTypeAndSourceSystem_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 409:
                case 413:
                case 500:
                case 509:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$511b1760d22f40bf = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/archives`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/archives",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `archives_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 404:
                case 409:
                case 413:
                case 500:
                case 509:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$5180125b642061b3 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/archives/item-type/${pathParameters.itemType}`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/archives/item-type/${itemType}",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `archivesItemType_get_byItemType_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 409:
                case 413:
                case 500:
                case 509:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$faaf08608a792b4f = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/archives/upload`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/archives/upload",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `archivesUpload_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 201:
                case 400:
                case 404:
                case 409:
                case 413:
                case 500:
                case 509:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$b39896a71d9902c0 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/audit-logs`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/audit-logs",
            method: "GET",
            operationId: "getAuditLogs",
            summary: null,
            methodName: `auditLogs_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$477c5184ae2b9d81 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/bill-to-party`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/bill-to-party",
            method: "GET",
            operationId: "get_1",
            summary: null,
            methodName: `billToParty_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 204:
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$a4f007423674219d = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/bill-to-party`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/bill-to-party",
            method: "PUT",
            operationId: "update",
            summary: null,
            methodName: `billToParty_put_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$9ef72d974677798 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/bill-to-party/price-eligibility`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/bill-to-party/price-eligibility",
            method: "GET",
            operationId: "getPriceEligibility_1",
            summary: null,
            methodName: `billToPartyPriceEligibility_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$1f2830ce31cd69f2 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/bill-to-party/price-eligibility`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/bill-to-party/price-eligibility",
            method: "PUT",
            operationId: "updatePriceEligibility_1",
            summary: null,
            methodName: `billToPartyPriceEligibility_put_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$f220b616e5373a22 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/bill/estimate`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/bill/estimate",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `billEstimate_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 409:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$9207949e817e53ec = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/billing-admins`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/billing-admins",
            method: "GET",
            operationId: "getBillingAdmins",
            summary: null,
            methodName: `billingAdmins_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$28ff54fcd6634633 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/catalog-accounts/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/catalog-accounts/${key}",
            method: "GET",
            operationId: null,
            summary: "Get catalog account by key ",
            methodName: `catalogAccounts_get_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$6f0cbd795b3f4c22 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/credit-notes`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/credit-notes",
            method: "POST",
            operationId: "createCreditNote",
            summary: null,
            methodName: `creditNotes_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 409:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$4c3d84986ce109bb = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/credit-notes/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/credit-notes/${id}",
            method: "GET",
            operationId: "getCreditNote",
            summary: null,
            methodName: `creditNotes_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$560c8c0c56a50a99 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/credit-notes/${pathParameters.id}/paid`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/credit-notes/${id}/paid",
            method: "POST",
            operationId: "markCreditNotePaid",
            summary: null,
            methodName: `creditNotesPaid_post_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$32b7e02bd2b3f200 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/customer-balance`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/customer-balance",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `customerBalance_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$41bbcaccf7d9d833 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/customer-balance/transactions`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/customer-balance/transactions",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `customerBalanceTransactions_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$9f590651a75a54fa = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/entitlement-templates`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlement-templates",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `entitlementTemplates_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$c3f0f78e974099f7 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/entitlement-templates/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlement-templates/${key}",
            method: "DELETE",
            operationId: null,
            summary: null,
            methodName: `entitlementTemplates_delete_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 204:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$93cd7e743e8afd55 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/entitlement-templates/${pathParameters.key}`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlement-templates/${key}",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `entitlementTemplates_get_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$c0cbaebde0bf045c = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/entitlement-templates/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlement-templates/${key}",
            method: "PUT",
            operationId: null,
            summary: null,
            methodName: `entitlementTemplates_put_byKey_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$fba042b922d41b18 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/entitlement-templates/${pathParameters.key}/history`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlement-templates/${key}/history",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `entitlementTemplatesHistory_get_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$83bb93d01b82295 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/entitlement/${pathParameters.id}/transitions`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlement/${id}/transitions",
            method: "GET",
            operationId: null,
            summary: "Get Entitlement transitions by entitlement ID",
            methodName: `entitlementTransitions_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$c6ad8b5a65449546 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/entitlements/relationships/traverse`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlements/relationships/traverse",
            method: "POST",
            operationId: null,
            summary: "Traverse through entitlements with relationships",
            methodName: `entitlementsRelationshipsTraverse_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$7312e1559e14d346 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/entitlements/slug/validate`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlements/slug/validate",
            method: "GET",
            operationId: null,
            summary: "Validate the Entitlement Slug",
            methodName: `entitlementsSlugValidate_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$ba27cb766e1bfac4 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/entitlements/${pathParameters.entitlementId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlements/${entitlementId}",
            method: "GET",
            operationId: null,
            summary: "Get an entitlement by ID",
            methodName: `entitlements_get_byEntitlementId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$edfc09bacc4cb459 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/entitlements/${pathParameters.entitlementId}/children`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlements/${entitlementId}/children",
            method: "GET",
            operationId: null,
            summary: "Get children of an entitlement by its ID. This API is eventually consistent, please re-try if you do not see all the children attached to an entitlement.",
            methodName: `entitlementsChildren_get_byEntitlementId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$5f0bdd817b9edeb1 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/entitlements/${pathParameters.entitlementId}/details`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlements/${entitlementId}/details",
            method: "GET",
            operationId: "getEntitlementDetails",
            summary: "Get details of an entitlement",
            methodName: `entitlementsDetails_get_byEntitlementId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 401:
                case 500:
                case 503:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 400:
                case 404:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$cd5c74a0786bb5cb = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoice-groups`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups",
            method: "GET",
            operationId: "getInvoiceGroups",
            summary: null,
            methodName: `invoiceGroups_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$12fe7372e856ac7f = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoice-groups`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups",
            method: "POST",
            operationId: "createInvoiceGroup",
            summary: null,
            methodName: `invoiceGroups_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$d17766b9d233e4a7 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}",
            method: "GET",
            operationId: "getInvoiceGroup",
            summary: null,
            methodName: `invoiceGroups_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$273485772505c297 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}",
            method: "PATCH",
            operationId: "updateInvoiceGroup_1",
            summary: null,
            methodName: `invoiceGroups_patch_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PATCH",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$ede4e00d1d488aaa = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}",
            method: "PUT",
            operationId: "updateInvoiceGroup",
            summary: null,
            methodName: `invoiceGroups_put_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$d59cf5490ac7d72e = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}/effective-payment-method`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}/effective-payment-method",
            method: "GET",
            operationId: "getEffectivePaymentMethod",
            summary: null,
            methodName: `invoiceGroupsEffectivePaymentMethod_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$b6375d32b727cbd9 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}/effective-price-eligibility`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}/effective-price-eligibility",
            method: "GET",
            operationId: "getEffectivePriceEligibility",
            summary: null,
            methodName: `invoiceGroupsEffectivePriceEligibility_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$7f5d899ffc9e9188 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}/estimate-tax`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}/estimate-tax",
            method: "POST",
            operationId: "getTaxEstimate",
            summary: null,
            methodName: `invoiceGroupsEstimateTax_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$5192f542472b60a0 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}/pending-invoice-requests`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}/pending-invoice-requests",
            method: "GET",
            operationId: "getPendingInvoiceRequests",
            summary: null,
            methodName: `invoiceGroupsPendingInvoiceRequests_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$b627241f39a533b5 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}/recipients`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}/recipients",
            method: "GET",
            operationId: "getRecipients",
            summary: null,
            methodName: `invoiceGroupsRecipients_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$b89c6904d2549942 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}/recipients`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}/recipients",
            method: "PUT",
            operationId: "setAllRecipients",
            summary: null,
            methodName: `invoiceGroupsRecipients_put_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$50b50a8d3882f5c3 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}/status`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}/status",
            method: "GET",
            operationId: "getStatus_1",
            summary: null,
            methodName: `invoiceGroupsStatus_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$3a758f813c4a06ce = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoice-requests`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-requests",
            method: "GET",
            operationId: "getInvoiceRequests",
            summary: null,
            methodName: `invoiceRequests_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$8613fc1e2daa9fda = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoice-requests`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-requests",
            method: "POST",
            operationId: "createInvoiceRequest",
            summary: null,
            methodName: `invoiceRequests_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 409:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$43f63eef41caee2f = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoices`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices",
            method: "GET",
            operationId: "getInvoices",
            summary: null,
            methodName: `invoices_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$714eb84561444e43 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoices`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices",
            method: "POST",
            operationId: "createAdhocInvoice",
            summary: null,
            methodName: `invoices_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 202:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$c9d893295560f19a = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${id}",
            method: "GET",
            operationId: "getInvoice",
            summary: null,
            methodName: `invoices_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$54c2c265e6083cc1 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${id}",
            method: "PATCH",
            operationId: "updateInvoice",
            summary: null,
            methodName: `invoices_patch_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PATCH",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$fafec8edb8fe6f8c = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.id}/confirm-payment`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${id}/confirm-payment",
            method: "POST",
            operationId: "confirmPayment",
            summary: null,
            methodName: `invoicesConfirmPayment_post_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 409:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$b36c6f0f47001e = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.id}/mark-uncollectible`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${id}/mark-uncollectible",
            method: "POST",
            operationId: "markInvoiceUncollectible",
            summary: null,
            methodName: `invoicesMarkUncollectible_post_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 404:
                case 409:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 202:
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$aadc4cb21160dca6 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.id}/pay`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${id}/pay",
            method: "POST",
            operationId: "attemptToPay",
            summary: null,
            methodName: `invoicesPay_post_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 402:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$e7e1e6ac70617c2c = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.id}/payment-deferred`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${id}/payment-deferred",
            method: "POST",
            operationId: "markPaymentDeferred",
            summary: null,
            methodName: `invoicesPaymentDeferred_post_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 402:
                case 404:
                case 409:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$cabe6892ecd1314e = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.id}/record-dunning`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${id}/record-dunning",
            method: "POST",
            operationId: "recordDunningAttemptPushPayment",
            summary: null,
            methodName: `invoicesRecordDunning_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 409:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$1d50003a317943a2 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.id}/resend-email`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${id}/resend-email",
            method: "POST",
            operationId: "sendEmail",
            summary: null,
            methodName: `invoicesResendEmail_post_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$2d45d57dcde79fbe = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.id}/user-defined-note`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${id}/user-defined-note",
            method: "POST",
            operationId: "addUserDefinedNote",
            summary: null,
            methodName: `invoicesUserDefinedNote_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$da1c3b49cbbcedc4 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.invoiceId}/download`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${invoiceId}/download",
            method: "GET",
            operationId: "getInvoice",
            summary: "Download an invoice",
            methodName: `invoicesDownload_get_byInvoiceId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 401:
                case 500:
                case 503:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 400:
                case 404:
                    return (0, $9myT7.success)(null);
                case 200:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$MIME_TYPE_NOT_SUPPORTED
                    });
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$5edc14752400fba9 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/migrations/payment-methods`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/migrations/payment-methods",
            method: "POST",
            operationId: "createPaymentMethod_1",
            summary: null,
            methodName: `migrationsPaymentMethods_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 202:
                case 400:
                case 404:
                case 409:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$c84e4b20160080da = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/migrations/transaction-account/event`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/migrations/transaction-account/event",
            method: "GET",
            operationId: "getTransactionAccountEvent",
            summary: null,
            methodName: `migrationsTransactionAccountEvent_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$2f62cd30845b329a = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offering-by-slug/${pathParameters.slug}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-by-slug/${slug}",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringBySlug_get_bySlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$977150cd36cd52ce = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offering-changes`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-changes",
            method: "POST",
            operationId: null,
            summary: "Create offering change",
            methodName: `offeringChanges_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$aac538cf0e3dcdb3 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offering-changes/${pathParameters.offeringChangeId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-changes/${offeringChangeId}",
            method: "DELETE",
            operationId: null,
            summary: "Delete offering change by offeringChangeId",
            methodName: `offeringChanges_delete_byOfferingChangeId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 204:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$32cb440ba5734c7a = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offering-changes/${pathParameters.offeringChangeId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-changes/${offeringChangeId}",
            method: "GET",
            operationId: null,
            summary: "Get offering change by offeringChangeId",
            methodName: `offeringChanges_get_byOfferingChangeId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$75c2e731611782fc = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offering-changes/${pathParameters.offeringChangeId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-changes/${offeringChangeId}",
            method: "PUT",
            operationId: null,
            summary: "Update offering change by offeringChangeId",
            methodName: `offeringChanges_put_byOfferingChangeId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$175c7ff1b369b392 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offering-changes/${pathParameters.offeringChangeId}/migrations`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-changes/${offeringChangeId}/migrations",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringChangesMigrations_get_byOfferingChangeId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$1b29619b910b6b21 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offering-relationship-templates`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-relationship-templates",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringRelationshipTemplates_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$4c8fb76cc8610172 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offering-relationship-templates/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-relationship-templates/${key}",
            method: "GET",
            operationId: null,
            summary: "Get offering relationship template by key ",
            methodName: `offeringRelationshipTemplates_get_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$4111243ff1874a40 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offering-relationship-templates/${pathParameters.key}/status/activate`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-relationship-templates/${key}/status/activate",
            method: "PUT",
            operationId: null,
            summary: null,
            methodName: `offeringRelationshipTemplatesStatusActivate_put_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$a59a7a1dc8423245 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offering-relationships`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-relationships",
            method: "GET",
            operationId: null,
            summary: "Get offering relationships by offeringKey, type and/or mode",
            methodName: `offeringRelationships_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$1543bcdf681968cc = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offering-relationships/bulk-fetch`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-relationships/bulk-fetch",
            method: "GET",
            operationId: null,
            summary: "Get all offering Relationships",
            methodName: `offeringRelationshipsBulkFetch_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$873c2dc19179637e = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offering-relationships/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-relationships/${key}",
            method: "GET",
            operationId: null,
            summary: "Get offering relationship  by key",
            methodName: `offeringRelationships_get_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$ef31f1b7f2ef1125 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offering-relationships/${pathParameters.offeringKey}/meaningful`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-relationships/${offeringKey}/meaningful",
            method: "GET",
            operationId: null,
            summary: "Get offering relationship by offering key and set of comma separated related keys ",
            methodName: `offeringRelationshipsMeaningful_get_byOfferingKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$ccca32cb9241996c = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offerings_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$b0596969893f348f = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offerings_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$3514f49eb9d71722 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/fetch-batch`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/fetch-batch",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsFetchBatch_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$5a1b751e8bcfdd45 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${entityKey}/extensions/${revisionKey}",
            method: "DELETE",
            operationId: null,
            summary: "Delete extension",
            methodName: `offeringsExtensions_delete_byEntityKeyAndRevisionKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 204:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$784db9bfd975b3b2 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${entityKey}/extensions/${revisionKey}",
            method: "GET",
            operationId: null,
            summary: "Get extension",
            methodName: `offeringsExtensions_get_byEntityKeyAndRevisionKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$e82a266ac9b28a7b = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${entityKey}/extensions/${revisionKey}",
            method: "PUT",
            operationId: null,
            summary: "Create/Update extensions",
            methodName: `offeringsExtensions_put_byEntityKeyAndRevisionKey_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$579a46f5e1e37c4c = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSLug}/latest-entitlement-template`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSLug}/latest-entitlement-template",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsLatestEntitlementTemplate_get_byKeyOrSLug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$4d376cbeb0d99559 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}",
            method: "DELETE",
            operationId: null,
            summary: null,
            methodName: `offerings_delete_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 204:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$c1282b9030b0d9cb = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offerings_get_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$de5d35cbcfbf0b29 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}",
            method: "PATCH",
            operationId: null,
            summary: null,
            methodName: `offerings_patch_byKeyOrSlug_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PATCH",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$17c6280640325cf8 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}",
            method: "PUT",
            operationId: null,
            summary: null,
            methodName: `offerings_put_byKeyOrSlug_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$d6cbf1681f793779 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/activation`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/activation",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsActivation_post_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$83c9a95731c3aeba = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/children`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/children",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsChildren_get_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$db06db2ec0c81341 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/depends-on-offerings`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/depends-on-offerings",
            method: "DELETE",
            operationId: null,
            summary: null,
            methodName: `offeringsDependsOnOfferings_delete_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 204:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$7832c2f84436957 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/depends-on-offerings`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/depends-on-offerings",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsDependsOnOfferings_post_byKeyOrSlug_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$f5d607984e3bcf28 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/depends-on-offerings`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/depends-on-offerings",
            method: "PUT",
            operationId: null,
            summary: null,
            methodName: `offeringsDependsOnOfferings_put_byKeyOrSlug_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$e5807df3d4f67c38 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/depends-on-offerings/${pathParameters.dependsOnKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/depends-on-offerings/${dependsOnKey}",
            method: "DELETE",
            operationId: null,
            summary: null,
            methodName: `offeringsDependsOnOfferings_delete_byKeyOrSlugAndDependsOnKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 204:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$d248131e57253ed1 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/entitlement-templates`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/entitlement-templates",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsEntitlementTemplates_post_byKeyOrSlug_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$c20df0da7a1740ee = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/pricing-changes`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/pricing-changes",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsPricingChanges_get_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$ba12661cd7c4eec8 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/pricing-plan-transitions`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/pricing-plan-transitions",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsPricingPlanTransitions_get_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$8203c67cac5cd588 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/pricing-plans`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/pricing-plans",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsPricingPlans_get_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$604113c42a8a2638 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/slugs`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/slugs",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsSlugs_post_byKeyOrSlug_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$fef1dd260076e1fb = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/synthetics`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/synthetics",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsSynthetics_get_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$deb9ee0b7e7aca11 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/synthetics`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/synthetics",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsSynthetics_post_byKeyOrSlug_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$4bfb6fe963934e2d = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/synthetics/${pathParameters.templateType}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/synthetics/${templateType}",
            method: "DELETE",
            operationId: null,
            summary: null,
            methodName: `offeringsSynthetics_delete_byKeyOrSlugAndTemplateType_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 200:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$e9b470f1c36ac062 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/synthetics/${pathParameters.templateType}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/synthetics/${templateType}",
            method: "PUT",
            operationId: null,
            summary: null,
            methodName: `offeringsSynthetics_put_byKeyOrSlugAndTemplateType_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$62b78cb04625261c = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/synthetics/${pathParameters.type}/generate`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/synthetics/${type}/generate",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsSyntheticsGenerate_post_byKeyOrSlugAndType_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$51cba03e482daaaf = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/transitions`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/transitions",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsTransitions_get_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$dc8168e4eb6f3010 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/trial`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/trial",
            method: "DELETE",
            operationId: null,
            summary: null,
            methodName: `offeringsTrial_delete_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 200:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$2f4131ab4e1d7a8e = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/trial`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/trial",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsTrial_post_byKeyOrSlug_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$4a001194c1527f6b = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/order-defaults/${pathParameters.offeringId}`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/order-defaults/${offeringId}",
            method: "GET",
            operationId: "getOrderDefault",
            summary: "Get order default",
            methodName: `orderDefaults_get_byOfferingId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 412:
                case 500:
                case 503:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$cd66f06369cd63cf = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/orderIntent`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orderIntent",
            method: "POST",
            operationId: null,
            summary: "Create Order Intent",
            methodName: `orderIntent_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$c35af7866b12b1af = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/orderIntent/estimate`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orderIntent/estimate",
            method: "POST",
            operationId: null,
            summary: "Get Bill Estimate for Order",
            methodName: `orderIntentEstimate_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$ce7a87dd3cb8b7b8 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/orderIntent/preview`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orderIntent/preview",
            method: "POST",
            operationId: null,
            summary: "Preview Order",
            methodName: `orderIntentPreview_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$b84fa7efc0407766 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/orderIntent/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orderIntent/${id}",
            method: "GET",
            operationId: null,
            summary: "Get order intent by id",
            methodName: `orderIntent_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$a111b175e51c818d = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/orderIntent/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orderIntent/${id}",
            method: "PATCH",
            operationId: null,
            summary: "Update status of order intent by id",
            methodName: `orderIntent_patch_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PATCH",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 200:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$5e9650246ea130d = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/orderItem/${pathParameters.orderItemId}/rewindToDetails`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orderItem/${orderItemId}/rewindToDetails",
            method: "GET",
            operationId: null,
            summary: "Get RewindToDetails From OrderItemId",
            methodName: `orderItemRewindToDetails_get_byOrderItemId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$78301b217fb99316 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/orderItems`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orderItems",
            method: "GET",
            operationId: null,
            summary: "Get order by entitlement id",
            methodName: `orderItems_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$3b9d6eeb7d030d96 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/orders`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orders",
            method: "POST",
            operationId: null,
            summary: "Create order",
            methodName: `orders_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$4412f9c3ddfc1f12 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/orders/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orders/${id}",
            method: "GET",
            operationId: null,
            summary: "Get order by id",
            methodName: `orders_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$1c0e11b1c2be4f09 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/orders/${pathParameters.orderId}/orderItem/${pathParameters.orderItemId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orders/${orderId}/orderItem/${orderItemId}",
            method: "GET",
            operationId: null,
            summary: "Get order by order item id",
            methodName: `ordersOrderItem_get_byOrderIdAndOrderItemId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$b61cd22bcdefca48 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/partner-acquisitions/entitlements/${pathParameters.entitlementId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/partner-acquisitions/entitlements/${entitlementId}",
            method: "GET",
            operationId: "getEntitlementSummary",
            summary: "Get summary of an entitlement for partners",
            methodName: `partnerAcquisitionsEntitlements_get_byEntitlementId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 401:
                case 500:
                case 503:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 400:
                case 404:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$b6294bcb6452472d = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/partner-status`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/partner-status",
            method: "GET",
            operationId: "getPartnerStatus",
            summary: null,
            methodName: `partnerStatus_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$8754bb4d180f1b03 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/payment-methods`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/payment-methods",
            method: "GET",
            operationId: "getPaymentMethods",
            summary: null,
            methodName: `paymentMethods_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$7d2defaa4dff104e = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/payment-methods`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/payment-methods",
            method: "POST",
            operationId: "createPaymentMethod",
            summary: null,
            methodName: `paymentMethods_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$cd3edf7e3b063725 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/payment-methods/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/payment-methods/${id}",
            method: "DELETE",
            operationId: "deletePaymentMethod",
            summary: null,
            methodName: `paymentMethods_delete_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 204:
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$2bebd0d8b3fab52a = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/payment-methods/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/payment-methods/${id}",
            method: "GET",
            operationId: "getPaymentMethod",
            summary: null,
            methodName: `paymentMethods_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$dc1e4d0137613f87 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/payment-methods/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/payment-methods/${id}",
            method: "PATCH",
            operationId: "updateDeferredPaymentMethod",
            summary: null,
            methodName: `paymentMethods_patch_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PATCH",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$7a4975126fecfbef = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/payment-methods/${pathParameters.id}/delete`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/payment-methods/${id}/delete",
            method: "POST",
            operationId: "deletePaymentMethodV2",
            summary: null,
            methodName: `paymentMethodsDelete_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 204:
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$38239369451605f0 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/payment-methods/${pathParameters.id}/set-default`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/payment-methods/${id}/set-default",
            method: "PUT",
            operationId: "setDefault",
            summary: null,
            methodName: `paymentMethodsSetDefault_put_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$69411303ef646976 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/pricing-changes`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-changes",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `pricingChanges_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$fec2c6189c2cc272 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/pricing-changes/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-changes/${id}",
            method: "PUT",
            operationId: null,
            summary: null,
            methodName: `pricingChanges_put_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$5f4e44f2e37ee88a = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/pricing-changes/${pathParameters.pricingChangeId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-changes/${pricingChangeId}",
            method: "DELETE",
            operationId: null,
            summary: null,
            methodName: `pricingChanges_delete_byPricingChangeId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 204:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$67236cecf4989e8f = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/pricing-changes/${pathParameters.pricingChangeId}/migrations`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-changes/${pricingChangeId}/migrations",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `pricingChangesMigrations_get_byPricingChangeId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$49a75b9033421fce = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/pricing-plans`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `pricingPlans_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$bbf988401d0542fe = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/pricing-plans`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `pricingPlans_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$de1a4f824d8c5d4f = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/pricing-plans/event`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans/event",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `pricingPlansEvent_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$cfb577a37b681cd5 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/pricing-plans/fetch-batch`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans/fetch-batch",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `pricingPlansFetchBatch_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$4a543453e9124c17 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/pricing-plans/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans/${entityKey}/extensions/${revisionKey}",
            method: "DELETE",
            operationId: null,
            summary: "Delete extension",
            methodName: `pricingPlansExtensions_delete_byEntityKeyAndRevisionKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 204:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$b2ffe6a4625f3e5a = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/pricing-plans/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans/${entityKey}/extensions/${revisionKey}",
            method: "GET",
            operationId: null,
            summary: "Get extension",
            methodName: `pricingPlansExtensions_get_byEntityKeyAndRevisionKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$1435710623655598 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/pricing-plans/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans/${entityKey}/extensions/${revisionKey}",
            method: "PUT",
            operationId: null,
            summary: "Create/Update extensions",
            methodName: `pricingPlansExtensions_put_byEntityKeyAndRevisionKey_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$30c5db285cef99c2 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/pricing-plans/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans/${key}",
            method: "DELETE",
            operationId: null,
            summary: null,
            methodName: `pricingPlans_delete_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 204:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$a2c2134cad391600 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/pricing-plans/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans/${key}",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `pricingPlans_get_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$d4eda58409c2a5f3 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/pricing-plans/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans/${key}",
            method: "PUT",
            operationId: null,
            summary: null,
            methodName: `pricingPlans_put_byKey_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$b73bd73e7153ed2c = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/pricing-plans/${pathParameters.key}/transitions`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans/${key}/transitions",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `pricingPlansTransitions_get_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$4ee3bc885afe9cd2 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/product-ignore-rule/${pathParameters.productKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/product-ignore-rule/${productKey}",
            method: "DELETE",
            operationId: null,
            summary: "Delete product ignore rule by product key",
            methodName: `productIgnoreRule_delete_byProductKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 204:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$8b5cf78f8d4822a = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/product-ignore-rule/${pathParameters.productKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/product-ignore-rule/${productKey}",
            method: "GET",
            operationId: null,
            summary: "Get product ignore rule by product key",
            methodName: `productIgnoreRule_get_byProductKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$da81cfb110e24504 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/product-ignore-rule/${pathParameters.productKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/product-ignore-rule/${productKey}",
            method: "POST",
            operationId: null,
            summary: "Create new product ignore rule",
            methodName: `productIgnoreRule_post_byProductKey_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$d0f8604ef8fb016c = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/product-ignore-rule/${pathParameters.productKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/product-ignore-rule/${productKey}",
            method: "PUT",
            operationId: null,
            summary: "Update existing product ignore rule",
            methodName: `productIgnoreRule_put_byProductKey_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 204:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$858c6a9779df7b0c = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/products`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `products_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$1a9d49af5faa5607 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/products`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `products_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$eb4b1bdf7b6d1330 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/products/event`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/event",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `productsEvent_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$998ae45f4ab47ae5 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/products/fetch-batch`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/fetch-batch",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `productsFetchBatch_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$c7060835ec030854 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/products/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${entityKey}/extensions/${revisionKey}",
            method: "DELETE",
            operationId: null,
            summary: "Delete extension",
            methodName: `productsExtensions_delete_byEntityKeyAndRevisionKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 204:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$367e9592db7d46da = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/products/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${entityKey}/extensions/${revisionKey}",
            method: "GET",
            operationId: null,
            summary: "Get extension",
            methodName: `productsExtensions_get_byEntityKeyAndRevisionKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$7f704cc93413d3af = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/products/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${entityKey}/extensions/${revisionKey}",
            method: "PUT",
            operationId: null,
            summary: "Create/Update extensions",
            methodName: `productsExtensions_put_byEntityKeyAndRevisionKey_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$462b4802870c16de = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/products/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${key}",
            method: "DELETE",
            operationId: null,
            summary: null,
            methodName: `products_delete_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 204:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$3bcf0dd6b7a90147 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/products/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${key}",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `products_get_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$8acdde07553cc857 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/products/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${key}",
            method: "PATCH",
            operationId: null,
            summary: null,
            methodName: `products_patch_byKey_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PATCH",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$7ab20f0f53a0a7e9 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/products/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${key}",
            method: "PUT",
            operationId: null,
            summary: null,
            methodName: `products_put_byKey_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$5983aa44b9b9d33c = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/products/${pathParameters.key}/offering-changes`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${key}/offering-changes",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `productsOfferingChanges_get_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$8e4c31a99f2a3e6c = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/products/${pathParameters.key}/status/active`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${key}/status/active",
            method: "PUT",
            operationId: null,
            summary: null,
            methodName: `productsStatusActive_put_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 204:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$c25290c2f592e275 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/products/${pathParameters.productId}/entitlement-templates`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${productId}/entitlement-templates",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `productsEntitlementTemplates_get_byProductId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$6834600abc16ae45 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/products/${pathParameters.productKey}/offering-groups`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${productKey}/offering-groups",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `productsOfferingGroups_get_byProductKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$62dc9fec3c836eff = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/products/${pathParameters.productKey}/offerings`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${productKey}/offerings",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `productsOfferings_get_byProductKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$ec91a4fe56de5d51 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/promotion-codes/applicable`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotion-codes/applicable",
            method: "POST",
            operationId: null,
            summary: "Verifies the applicability of the promotion codes",
            methodName: `promotionCodesApplicable_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$63948248a3ed19a1 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/promotion-codes/exhausted`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotion-codes/exhausted",
            method: "POST",
            operationId: null,
            summary: "Verifies the promotion codes has already been used",
            methodName: `promotionCodesExhausted_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$62a939642e00b9d8 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/promotions/available`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/available",
            method: "POST",
            operationId: "getAvailablePromotion",
            summary: "Returns all promotion, satisfying promotion rules",
            methodName: `promotionsAvailable_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$dea95cb86eebef9c = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/promotions/event/${pathParameters.promotionId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/event/${promotionId}",
            method: "PUT",
            operationId: "updatePromotionStatusEvent",
            summary: "Update promotion status",
            methodName: `promotionsEvent_put_byPromotionId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 204:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$98768e3f40c0cfdb = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/promotions/redemptions`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/redemptions",
            method: "GET",
            operationId: "getPaginatedRedemptions",
            summary: "Get paginated redemptions",
            methodName: `promotionsRedemptions_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$96ea62595122da2f = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/promotions/${pathParameters.promotionId}/promotion-codes`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/${promotionId}/promotion-codes",
            method: "GET",
            operationId: "getPromotionCodesByPromotionIdAndStatus",
            summary: "Get all promotion codes by promotion id and status",
            methodName: `promotionsPromotionCodes_get_byPromotionId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$523784976dad86af = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/promotions/${pathParameters.promotionId}/promotion-codes`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/${promotionId}/promotion-codes",
            method: "POST",
            operationId: "createPromotionCode",
            summary: "Create new promotion codes",
            methodName: `promotionsPromotionCodes_post_byPromotionId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$bf703926b07e9f11 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/promotions/${pathParameters.promotionId}/promotion-codes/${pathParameters.promotionCode}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/${promotionId}/promotion-codes/${promotionCode}",
            method: "GET",
            operationId: "getPromotionCode",
            summary: "Get promotion code by promotion id and code",
            methodName: `promotionsPromotionCodes_get_byPromotionIdAndPromotionCode_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$4662a6074db86be8 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/promotions/${pathParameters.promotionId}/promotion-codes/${pathParameters.promotionCode}/event/${pathParameters.event}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/${promotionId}/promotion-codes/${promotionCode}/event/${event}",
            method: "PUT",
            operationId: "updatePromotionStatus_1",
            summary: "Update promotion code status",
            methodName: `promotionsPromotionCodesEvent_put_byPromotionIdAndPromotionCodeAndEvent_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 204:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$6e1c8bd110ba18ab = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/promotions/${pathParameters.promotionId}/promotion-codes/${pathParameters.promotionCode}/redemption`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/${promotionId}/promotion-codes/${promotionCode}/redemption",
            method: "PUT",
            operationId: "redeemPromoCode_1",
            summary: "Update Redemption For valid Promo Code",
            methodName: `promotionsPromotionCodesRedemption_put_byPromotionIdAndPromotionCode_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$19bf421d174c60ee = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/promotions/${pathParameters.promotionId}/promotion-codes/${pathParameters.promotionCode}/redemptions`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/${promotionId}/promotion-codes/${promotionCode}/redemptions",
            method: "GET",
            operationId: "getAllRedemptionsByPromotionIdAndPromotionCode",
            summary: "Get redemptions by promotion code",
            methodName: `promotionsPromotionCodesRedemptions_get_byPromotionIdAndPromotionCode_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$7282157f5c1b905b = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/promotions/${pathParameters.promotionId}/randomised-promotion-codes`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/${promotionId}/randomised-promotion-codes",
            method: "POST",
            operationId: "createRandom",
            summary: "Create new randomised promotion codes",
            methodName: `promotionsRandomisedPromotionCodes_post_byPromotionId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$f841b45d7999eb46 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/promotions/${pathParameters.promotionId}/${pathParameters.event}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/${promotionId}/${event}",
            method: "PUT",
            operationId: "updatePromotionStatus",
            summary: "Update promotion status",
            methodName: `promotions_put_byPromotionIdAndEvent_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 204:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$77859df048f21f33 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/quotes`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes",
            method: "POST",
            operationId: null,
            summary: "Create draft quote",
            methodName: `quotes_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$4142abd422c6a87a = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/quotes/open`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/open",
            method: "POST",
            operationId: null,
            summary: "Create new open quote",
            methodName: `quotesOpen_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$427baae892994f3f = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}",
            method: "GET",
            operationId: null,
            summary: "Get quote",
            methodName: `quotes_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$b5c39ab604a396f = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}",
            method: "PATCH",
            operationId: null,
            summary: "Update an open quote",
            methodName: `quotes_patch_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PATCH",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$37b5ddadc6bf9219 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}",
            method: "PUT",
            operationId: null,
            summary: "Update an existing quote",
            methodName: `quotes_put_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$d48674411fa7c111 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}/cancel`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}/cancel",
            method: "POST",
            operationId: null,
            summary: "Cancel a quote",
            methodName: `quotesCancel_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$ee0a95f68903e5ac = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}/clone`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}/clone",
            method: "POST",
            operationId: null,
            summary: "Clone a new quote from a given quote",
            methodName: `quotesClone_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$2d893a8f61257586 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}/download`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}/download",
            method: "GET",
            operationId: null,
            summary: "Download quote",
            methodName: `quotesDownload_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 200:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$MIME_TYPE_NOT_SUPPORTED
                    });
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$d459665743fd49c3 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}/draft`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}/draft",
            method: "POST",
            operationId: null,
            summary: "Move stale quote to draft",
            methodName: `quotesDraft_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$fe62e4c16e2bc31c = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}/finalize`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}/finalize",
            method: "POST",
            operationId: null,
            summary: "Finalize a quote",
            methodName: `quotesFinalize_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$f590e474b09e604e = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}/reestimate`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}/reestimate",
            method: "POST",
            operationId: null,
            summary: "Re-estimate a quote",
            methodName: `quotesReestimate_post_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 202:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$b729d81f10afda7c = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}/revise`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}/revise",
            method: "POST",
            operationId: null,
            summary: "Create new revision of a quote",
            methodName: `quotesRevise_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$4906099f27fab3d2 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}/version/${pathParameters.version}/accept`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}/version/${version}/accept",
            method: "POST",
            operationId: null,
            summary: "Accept a quote",
            methodName: `quotesVersionAccept_post_byIdAndVersion_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$ef9e25a85bc0acfb = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/roles/assignments/create`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/roles/assignments/create",
            method: "POST",
            operationId: "addRoleAssignment",
            summary: null,
            methodName: `rolesAssignmentsCreate_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$bb02dedc68cc730e = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/roles/assignments/create/bulk`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/roles/assignments/create/bulk",
            method: "POST",
            operationId: "addBulkRoleAssignments",
            summary: null,
            methodName: `rolesAssignmentsCreateBulk_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 202:
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$28c3c666c914a67e = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/roles/assignments/delete`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/roles/assignments/delete",
            method: "POST",
            operationId: "deleteRoleAssignment",
            summary: null,
            methodName: `rolesAssignmentsDelete_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 204:
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$1fbeb8957df41f86 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/roles/assignments/principals`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/roles/assignments/principals",
            method: "GET",
            operationId: "queryPrincipals",
            summary: null,
            methodName: `rolesAssignmentsPrincipals_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$25f3475dfe736e33 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/routes`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/routes",
            method: "POST",
            operationId: null,
            summary: "Get route for promotion",
            methodName: `routes_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$eb04a65b0a9e9f54 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/search`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/search",
            method: "POST",
            operationId: null,
            summary: "Provides search capabilities for different ccp primitives",
            methodName: `search_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 400:
                case 404:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$4bf83929e86ba835 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/search/count`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/search/count",
            method: "POST",
            operationId: null,
            summary: "Provides count for different ccp primitives",
            methodName: `searchCount_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 400:
                case 404:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$847ab50bf477bbe8 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/search/public-search`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/search/public-search",
            method: "POST",
            operationId: null,
            summary: "Provides search capabilities for public ccp primitives",
            methodName: `searchPublicSearch_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 400:
                case 404:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$fdeb33d0bad52579 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/setup-intents`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/setup-intents",
            method: "POST",
            operationId: "createSetUpIntent",
            summary: null,
            methodName: `setupIntents_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$ec8b46b98d8656e4 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/ship-to-parties`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/ship-to-parties",
            method: "GET",
            operationId: "getAll",
            summary: null,
            methodName: `shipToParties_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$ee6147dbccbd12a8 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/ship-to-parties`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/ship-to-parties",
            method: "POST",
            operationId: "createNew",
            summary: null,
            methodName: `shipToParties_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$bdb1aa3f48765578 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/ship-to-parties/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/ship-to-parties/${id}",
            method: "GET",
            operationId: "get",
            summary: null,
            methodName: `shipToParties_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$be695fff70c368af = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/ship-to-parties/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/ship-to-parties/${id}",
            method: "PUT",
            operationId: "updateAddress",
            summary: null,
            methodName: `shipToParties_put_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$3cd9d779af362e56 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/ship-to-parties/${pathParameters.id}/price-eligibility`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/ship-to-parties/${id}/price-eligibility",
            method: "GET",
            operationId: "getPriceEligibility",
            summary: null,
            methodName: `shipToPartiesPriceEligibility_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$96225d78c7ec6fa0 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/ship-to-parties/${pathParameters.id}/price-eligibility`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/ship-to-parties/${id}/price-eligibility",
            method: "PUT",
            operationId: "updatePriceEligibility",
            summary: null,
            methodName: `shipToPartiesPriceEligibility_put_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$7550184da29bfc5f = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/status`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/status",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `status_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$bbbefa7976cb6a96 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/test/billing-clocks`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/test/billing-clocks",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `testBillingClocks_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 404:
                case 409:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$ecbb714809618dcf = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/test/billing-clocks/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/test/billing-clocks/${id}",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `testBillingClocks_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 409:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$83b6c4c183260714 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/test/billing-clocks/${pathParameters.id}/advance`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/test/billing-clocks/${id}/advance",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `testBillingClocksAdvance_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 202:
                case 400:
                case 404:
                case 409:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$b389f95f6743518a = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/test/subscription/usage`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/test/subscription/usage",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `testSubscriptionUsage_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 404:
                case 409:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 200:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$c86fe91ccd40c3d2 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/transaction-accounts`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/transaction-accounts",
            method: "GET",
            operationId: "getTransactionAccounts",
            summary: null,
            methodName: `transactionAccounts_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$cc5d8891fb2996a7 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v1/transaction-accounts`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/transaction-accounts",
            method: "POST",
            operationId: "create",
            summary: null,
            methodName: `transactionAccounts_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 202:
                case 400:
                case 429:
                    return (0, $9myT7.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $9myT7.success)(null);
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$397fa8292bb60668 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v2/offerings`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/offerings",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offerings_get_v2`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$914bdd382bf4f842 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v2/offerings`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/offerings",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offerings_post_v2`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$ff1bebecb4c4f758 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v2/offerings/event`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/offerings/event",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsEvent_get_v2`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$7c2faa2e7deb25fa = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v2/offerings/fetch-batch`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/offerings/fetch-batch",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsFetchBatch_post_v2`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$e3af894c788b8060 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v2/offerings/${pathParameters.id}/default-entitlement-template`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/offerings/${id}/default-entitlement-template",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsDefaultEntitlementTemplate_get_byId_v2`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$28955c9e2ad42a04 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v2/offerings/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/offerings/${key}",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offerings_get_byKey_v2`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$4df5689a1d4857d9 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v2/offerings/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/offerings/${key}",
            method: "PATCH",
            operationId: null,
            summary: null,
            methodName: `offerings_patch_byKey_v2`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PATCH",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$2bea338c3c49b1a1 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v2/offerings/${pathParameters.key}/activation`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/offerings/${key}/activation",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsActivation_post_byKey_v2`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$c566a1cb96e67330 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v2/offerings/${pathParameters.offeringKey}/active-pricing-plans-count`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/offerings/${offeringKey}/active-pricing-plans-count",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsActivePricingPlansCount_get_byOfferingKey_v2`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$80a8163873d9040c = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v2/promotions`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/promotions",
            method: "GET",
            operationId: null,
            summary: "Get paginated promotions",
            methodName: `promotions_get_v2`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$2b0ddaa223c45fff = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v2/promotions`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/promotions",
            method: "POST",
            operationId: null,
            summary: "Create new promotion",
            methodName: `promotions_post_v2`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$1a4c42c3dd4c2894 = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v2/promotions/applicable`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/promotions/applicable",
            method: "POST",
            operationId: null,
            summary: "Verifies the applicability of the promotions",
            methodName: `promotionsApplicable_post_v2`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$f7759eb9d4d2ddaf = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v2/promotions/${pathParameters.promotionId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/promotions/${promotionId}",
            method: "GET",
            operationId: null,
            summary: "Get promotion by id",
            methodName: `promotions_get_byPromotionId_v2`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$8a1f2d6ca826beda = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v2/promotions/${pathParameters.promotionId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/promotions/${promotionId}",
            method: "PATCH",
            operationId: null,
            summary: "Patch promotion details",
            methodName: `promotions_patch_byPromotionId_v2`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PATCH",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 204:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});
const $91b71dd9e99d421a$export$591e24eef82e873b = $91b71dd9e99d421a$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $91b71dd9e99d421a$export$a639a54e55b70225(`api/v2/promotions/${pathParameters.promotionId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/promotions/${promotionId}",
            method: "PUT",
            operationId: null,
            summary: "Update promotion details",
            methodName: `promotions_put_byPromotionId_v2`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 204:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $9myT7.success)(await fetchResponse.json());
                default:
                    return (0, $9myT7.error)({
                        ...sharedFields,
                        code: $91b71dd9e99d421a$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $9myT7.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $9myT7.isFailure)(bodyResult)) return bodyResult;
        return (0, $9myT7.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $9myT7.exception)(ex);
    }
});

});

parcelRegister("kSvZT", function(module, exports) {

$parcel$export(module.exports, "waitUntilOrderSucceeds", () => $06d1d49885bf5841$export$e370b2b3a9821bfb);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $8Baj1 = parcelRequire("8Baj1");
var $d1ev5 = parcelRequire("d1ev5");

var $gXC8S = parcelRequire("gXC8S");
var $ipQss = parcelRequire("ipQss");
var $8I3Xx = parcelRequire("8I3Xx");

var $j8Vkb = parcelRequire("j8Vkb");
const $06d1d49885bf5841$export$48314f791897fe3f = `${(0, $a8ff9d294b96fb29$export$91e8019c72e4e6d)}/ccp/api/v1/search`;
const $06d1d49885bf5841$export$379f8fb50913b795 = `${(0, $a8ff9d294b96fb29$export$91e8019c72e4e6d)}/ccp/api/v1/orders`;
const $06d1d49885bf5841$export$2f5d92f388177e48 = ()=>(0, $aXKmr.v4)();
const $06d1d49885bf5841$export$d0923e8c8c053e24 = ()=>(0, $aXKmr.v4)();
const $06d1d49885bf5841$export$256229d46cfa9189 = ()=>(0, $aXKmr.v4)();
const $06d1d49885bf5841$export$50105fab9be545c6 = ()=>(0, $aXKmr.v4)();
const $06d1d49885bf5841$export$94b5d2568b5b7b0a = ()=>(0, $aXKmr.v4)();
/**
 * TODO: verify with OMS team why the promotionId of a promotion definition might be null if the OmsPromotionDto
 * requires this property to be always defined
 *
 * This error might go away once we refactore this util to use the auto-generated types
 */ const $06d1d49885bf5841$var$isPromotionInstanceWithIds = (promotion)=>!!promotion.promotionInstanceId && !!promotion.promotionDefinition?.promotionId;
const $06d1d49885bf5841$export$2de1c5c9ead290a3 = async (fetch, orderRequest)=>{
    const { transactionAccountId: transactionAccountId, orderId: orderId, invoiceGroupId: invoiceGroupId, items: items } = orderRequest;
    await (0, $ipQss.rejectOnHttpError)('entitlements-orders', fetch($06d1d49885bf5841$export$379f8fb50913b795, {
        headers: {
            'X-transaction-account': transactionAccountId,
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify({
            orderId: orderId,
            invoiceGroupId: invoiceGroupId,
            items: items
        })
    }));
};
const $06d1d49885bf5841$export$31ff0c1eeecbe893 = async (fetch, txaId, orderId)=>{
    const response = await (0, $ipQss.rejectOnHttpError)('order-fetch', fetch(`${$06d1d49885bf5841$export$379f8fb50913b795}/${orderId}`, {
        headers: {
            'Content-Type': 'application/json',
            'X-transaction-account': txaId
        }
    }));
    const order = await response.json();
    return order;
};
const $06d1d49885bf5841$export$e370b2b3a9821bfb = async (fetch, txaId, orderId, retryInterval = 2500, maxRetries = 8)=>{
    const isOrderProcessing = (order)=>order.items.some((item)=>item.processingInfo.status === 'PROCESSING');
    const orderResponse = await (0, $gXC8S.autoRetry)(()=>$06d1d49885bf5841$export$31ff0c1eeecbe893(fetch, txaId, orderId), (order)=>isOrderProcessing(order), retryInterval, maxRetries);
    if (isOrderProcessing(orderResponse)) throw new (0, $ipQss.HttpResponseError)('order-poll', 504, `Polling for order "${orderId}" timed out after ${maxRetries} retries`);
};
const $06d1d49885bf5841$var$getVersionMapForOrderEntitlements = (orderRequest)=>{
    return new Map(orderRequest.items.map((item)=>[
            item.entitlement.id,
            item.entitlement.version
        ]));
};
const $06d1d49885bf5841$var$getVersionMapForEntitlementsList = (entitlements)=>{
    return new Map(entitlements.map(({ entitlementId: entitlementId, version: version })=>[
            entitlementId,
            version
        ]));
};
const $06d1d49885bf5841$export$46129542ede154d4 = async (fetch, orderRequest)=>{
    const currentVersionsMap = $06d1d49885bf5841$var$getVersionMapForOrderEntitlements(orderRequest);
    const entitlementsResponse = await (0, $ipQss.rejectOnHttpError)('entitlements-search', fetch(`${$06d1d49885bf5841$export$48314f791897fe3f}`, {
        method: 'post',
        headers: {
            'X-transaction-account': orderRequest.transactionAccountId,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            class: 'entitlement',
            expand: [
                'subscriptionId'
            ],
            payload: {
                query: {
                    term: {
                        'order.id': orderRequest.orderId
                    }
                }
            }
        })
    }));
    const entitlements = (await entitlementsResponse.json()).results;
    const newVersionsMap = $06d1d49885bf5841$var$getVersionMapForEntitlementsList(entitlements);
    // return as soon as one version is the same (meaning it hasn't been updated), or
    // as soon as the response doesn't have an entitlement (meaning search doesn't have the new entitlement yet)
    for (let [id, version] of currentVersionsMap){
        if (!newVersionsMap.has(id) || version === newVersionsMap.get(id)) return true;
    }
    return false;
};
const $06d1d49885bf5841$export$b1b388229645e8e4 = async (fetch, orderRequest, retryInterval = 2500, maxRetries = 8)=>{
    const hasPendingUpdates = await (0, $gXC8S.autoRetry)(()=>$06d1d49885bf5841$export$46129542ede154d4(fetch, orderRequest), (_hasPendingUpdates)=>_hasPendingUpdates, retryInterval, maxRetries);
    if (hasPendingUpdates) throw new (0, $ipQss.HttpResponseError)('order-entitlements-poll', 504, `Polling for entitlements in order "${orderRequest.orderId}" timed out after ${maxRetries} retries`);
};
const $06d1d49885bf5841$export$3c81576194724224 = async (fetch, orderRequest, retryInterval, maxRetries)=>{
    await $06d1d49885bf5841$export$2de1c5c9ead290a3(fetch, orderRequest);
    await $06d1d49885bf5841$export$e370b2b3a9821bfb(fetch, orderRequest.transactionAccountId, orderRequest.orderId, retryInterval, maxRetries);
    await $06d1d49885bf5841$export$b1b388229645e8e4(fetch, orderRequest, retryInterval, maxRetries);
};
const $06d1d49885bf5841$export$18b49be4814ab31c = (txaId, retryInterval, maxRetries)=>{
    const fetch = (0, $8Baj1.useCommerceFetch)();
    const _generateOrderId = (0, $d1ev5.useCommerceOverride)($06d1d49885bf5841$export$2f5d92f388177e48);
    return (0, $8I3Xx.useUpdateService)((0, $eJOHy.useCallback)((orderRequest)=>$06d1d49885bf5841$export$3c81576194724224(fetch, {
            ...orderRequest,
            transactionAccountId: txaId,
            orderId: _generateOrderId()
        }, retryInterval, maxRetries), [
        fetch,
        _generateOrderId,
        txaId,
        retryInterval,
        maxRetries
    ]));
};
const $06d1d49885bf5841$export$a3a3e07542ce16 = (entitlement)=>{
    if (entitlement.subscription?.pricingPlan?.items?.[0]?.chargeType === 'AUTO_SCALING') return true;
    return false;
};
/**
 * Using the entitlement information, it returns an optedUsageOptions object if possible or undefined.
 *
 * @param entitlement
 */ const $06d1d49885bf5841$var$getOptedUsageFromEntitlement = (entitlement)=>{
    if (!entitlement.subscription || !entitlement.subscription.pricingPlanId) return undefined;
    const autoScalingSubsciption = $06d1d49885bf5841$export$a3a3e07542ce16(entitlement);
    if (!autoScalingSubsciption) return {
        trial: {
            skipTrial: true
        },
        chargingDetails: {
            pricingPlanId: entitlement.subscription.pricingPlanId,
            chargeQuantities: entitlement.subscription.chargeQuantities
        }
    };
    else // If subscription has auto-scaling charging type, then chargeQuantities must not exist in the ammendment order item.
    // Otherwise if we add chargeQuantities: undefined, with ammendment order will return a 400.
    return {
        trial: {
            skipTrial: true
        },
        chargingDetails: {
            pricingPlanId: entitlement.subscription.pricingPlanId
        }
    };
};
const $06d1d49885bf5841$var$requiresChargeDetails = ({ pricingType: pricingType })=>!(pricingType === 'FREE' || pricingType === 'LIMITED_FREE');
const $06d1d49885bf5841$var$getOptedUsageForReactivatedEntitlement = (entitlement)=>{
    const optedUsageOptions = $06d1d49885bf5841$var$getOptedUsageFromEntitlement(entitlement);
    if (!optedUsageOptions) return optedUsageOptions;
    if (!$06d1d49885bf5841$var$requiresChargeDetails(entitlement.offering)) {
        const { chargingDetails: chargingDetails, ...optedUsageOptionsSubset } = optedUsageOptions;
        return optedUsageOptionsSubset;
    }
    return optedUsageOptions;
};
const $06d1d49885bf5841$export$8c9559fef22c5e46 = (subscriptionDto)=>{
    const currentPromotionInstanceIds = new Set(subscriptionDto?.promotionInstances?.map((promoInstance)=>promoInstance.promotionInstanceId || '') || []);
    const currentPromotions = subscriptionDto?.promotionInstances?.map((promoInstance)=>({
            promotionInstanceId: promoInstance.promotionInstanceId ?? undefined
        })) || [];
    // Filter out all current promotions from scheduled promotions to avoid issues with multi-cycle promotion
    // https://atlassian.slack.com/archives/C010B6XQQ3T/p1649251440267139
    const scheduledPromotions = subscriptionDto?.scheduledChanges?.promotionInstances?.filter($06d1d49885bf5841$var$isPromotionInstanceWithIds).filter((promoInstance)=>!currentPromotionInstanceIds.has(promoInstance.promotionInstanceId)).map((promoInstance)=>({
            promotionDefinition: promoInstance.promotionDefinition
        })) || [];
    const promotionsArray = [
        ...currentPromotions,
        ...scheduledPromotions
    ];
    return promotionsArray;
};
const $06d1d49885bf5841$export$3fb5139cf8d29535 = (entitlement)=>({
        entitlement: {
            id: entitlement.entitlementId,
            version: entitlement.version
        },
        itemId: '1',
        type: 'CANCELLATION_ORDER',
        reasonCode: 'PRODUCT_CANCELLATION',
        promotions: $06d1d49885bf5841$export$8c9559fef22c5e46(entitlement.subscription)
    });
const $06d1d49885bf5841$export$a6143557206ad5b4 = (entitlement)=>({
        entitlement: {
            id: entitlement.entitlementId,
            version: entitlement.version
        },
        itemId: '1',
        offeringId: entitlement.offering.key,
        optedUsageOptions: $06d1d49885bf5841$var$getOptedUsageForReactivatedEntitlement(entitlement),
        promotions: $06d1d49885bf5841$export$8c9559fef22c5e46(entitlement.subscription),
        type: 'REACTIVATION_ORDER'
    });
const $06d1d49885bf5841$export$527d583c9538a61b = (entitlement, orderItemToMerge = {})=>({
        entitlement: {
            id: entitlement.entitlementId,
            version: entitlement.version
        },
        itemId: '1',
        offeringId: entitlement.offering.key,
        optedUsageOptions: $06d1d49885bf5841$var$getOptedUsageFromEntitlement(entitlement),
        promotions: $06d1d49885bf5841$export$8c9559fef22c5e46(entitlement.subscription),
        ...orderItemToMerge,
        type: 'AMENDMENT_ORDER'
    });
const $06d1d49885bf5841$export$59893afb7fc87683 = (entitlement, orderItemToMerge = {})=>{
    const orderItem = $06d1d49885bf5841$export$527d583c9538a61b(entitlement, orderItemToMerge);
    if (orderItem.optedUsageOptions) // was in trial -> don't skipTrial when reverting back
    // was not in trial -> skipTrial when reverting back
    orderItem.optedUsageOptions.trial.skipTrial = !(0, $j8Vkb.isEntitlementInTrial)(entitlement);
    return orderItem;
};

});
// top level domain should have a stargate proxy under this path
// see https://developer.atlassian.com/platform/stargate/concepts/domains/
const $a8ff9d294b96fb29$export$91e8019c72e4e6d = `/gateway/api`;

parcelRegister("8Baj1", function(module, exports) {

$parcel$export(module.exports, "useCommerceFetch", () => $611245c4dfd0fae3$export$5f844fc0012b62a);

var $eJOHy = parcelRequire("eJOHy");

var $2QO3b = parcelRequire("2QO3b");

var $ipQss = parcelRequire("ipQss");

var $kIkIX = parcelRequire("kIkIX");

var $4rbsy = parcelRequire("4rbsy");

var $d1ev5 = parcelRequire("d1ev5");

var $1ilA9 = parcelRequire("1ilA9");
const $611245c4dfd0fae3$export$5f844fc0012b62a = ()=>{
    const commerceContextFetch = (0, $d1ev5.useCommerceOverride)(fetch);
    const dispatchSentryException = (0, $kIkIX.useSentryExceptionDispatch)();
    return (0, $eJOHy.useCallback)(async (...args)=>{
        const startTime = performance.now();
        const [fetchInput] = args;
        const sanitizedUrl = (0, $4rbsy.sanitizeUrlString)((0, $1ilA9.getRequestUrl)(fetchInput));
        try {
            const response = await commerceContextFetch(...args);
            if (response.status >= 400) dispatchSentryException({
                exception: new Error(`Status: ${response.status}\nURL: ${sanitizedUrl}`)
            });
            (0, $2QO3b.addSpanToAll)('fetch', sanitizedUrl, [
                {
                    name: 'network'
                }
            ], startTime, performance.now(), JSON.stringify(response).length);
            return response;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
            const oldErrorMessage = (()=>{
                if (error instanceof Error) return error.stack ?? error.toString();
                else return JSON.stringify(error);
            })();
            const newErrorMessage = `An error occurred when fetching from ${sanitizedUrl}\n\n ${oldErrorMessage}`;
            const wrappedError = new Error(newErrorMessage);
            dispatchSentryException({
                exception: wrappedError
            });
            throw error;
        }
    }, [
        commerceContextFetch,
        dispatchSentryException
    ]);
};
const $611245c4dfd0fae3$export$2eeff918208c7909 = (request, dispatchSentryException)=>request.catch((error)=>{
        // reportHttpError doesn't dispatch url as HttpResponseError has a resource name in the message
        if (error instanceof (0, $ipQss.HttpResponseError)) dispatchSentryException({
            exception: error
        });
        const oldErrorMessage = (()=>{
            if (error instanceof Error) return error.stack ?? error.toString();
            else return JSON.stringify(error);
        })();
        const newErrorMessage = `An error occurred when fetching data\n\n ${oldErrorMessage}`;
        dispatchSentryException({
            exception: new Error(newErrorMessage)
        });
        return error;
    });

});
parcelRegister("ipQss", function(module, exports) {

$parcel$export(module.exports, "HttpResponseError", () => $b6719a5b7342c9ac$export$d2f2761cbe9cebf2);
$parcel$export(module.exports, "rejectOnHttpError", () => $b6719a5b7342c9ac$export$a4c208475de70990);
class $b6719a5b7342c9ac$export$d2f2761cbe9cebf2 extends Error {
    constructor(resourceName, statusCode, body){
        super(`Unable to fetch ${resourceName}, status: ${statusCode}`);
        this.name = 'HttpResponseError';
        this.statusCode = statusCode;
        this.body = body;
        // necessary as Subclassing Error needs special treatment in typescript for some compilation targets
        //https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $b6719a5b7342c9ac$export$d2f2761cbe9cebf2.prototype);
    }
}
const $b6719a5b7342c9ac$export$a4c208475de70990 = async (resourceName, response)=>{
    const res = await response;
    if (res.ok) return response;
    throw new $b6719a5b7342c9ac$export$d2f2761cbe9cebf2(resourceName, res.status, // ignore error if there is no body,
    // there is no way to check if body is set as https://developer.mozilla.org/en-US/docs/Web/API/Body/bodyUsed is not supported by many browsers
    await res.json().catch(()=>undefined));
};

});

parcelRegister("kIkIX", function(module, exports) {

$parcel$export(module.exports, "useSentryExceptionDispatch", () => $e11ec2cd7c693f6f$export$cf4d833c52e18bed);

var $kUytz = parcelRequire("kUytz");

var $kZjdy = parcelRequire("kZjdy");

var $ak0NR = parcelRequire("ak0NR");
const { useBreadcrumbedEventDispatch: $e11ec2cd7c693f6f$export$3c3f21d4489e178a } = (0, $kUytz.internalGasV3UIEventChannel);
const { useEventDispatch: $e11ec2cd7c693f6f$export$5e75c4fb0a07e6f4 } = (0, $kUytz.internalGasV3ScreenEventChannel);
const { useBreadcrumbedEventDispatch: $e11ec2cd7c693f6f$export$eb1dac57abae25e8 } = (0, $kUytz.internalGasV3TrackEventChannel);
const { useBreadcrumbedEventDispatch: $e11ec2cd7c693f6f$export$ab6d20b2228c09c6 } = (0, $kUytz.internalGasV3OperationalEventChannel);
const { useBreadcrumbedEventDispatch: $e11ec2cd7c693f6f$export$cf4d833c52e18bed } = (0, $kUytz.internalSentryExceptionChannel);
const $e11ec2cd7c693f6f$export$8eb9a37a282b8ea6 = (0, $kZjdy.createAtlaskitToEventChannelRepackager)($e11ec2cd7c693f6f$export$3c3f21d4489e178a);
const { Listener: $e11ec2cd7c693f6f$export$d6cab26720f11779 } = (0, $kUytz.breadcrumbMountedEventChannel);
const $e11ec2cd7c693f6f$export$794ea2871d096951 = (Component, name, attributes)=>(0, $ak0NR.withBreadcrumb)(Component, (0, $kUytz.Breadcrumb), name, attributes);

});
parcelRegister("kUytz", function(module, exports) {

$parcel$export(module.exports, "breadcrumbMountedEventChannel", () => $80dda0259ee6add7$export$1622e7b9340efb0);
$parcel$export(module.exports, "Breadcrumb", () => $80dda0259ee6add7$export$dabcc1ec9dd9d1cc);
$parcel$export(module.exports, "internalGasV3UIEventChannel", () => $80dda0259ee6add7$export$b7973f9532f3f87f);
$parcel$export(module.exports, "internalGasV3ScreenEventChannel", () => $80dda0259ee6add7$export$5a78c7e669ed705e);
$parcel$export(module.exports, "internalGasV3TrackEventChannel", () => $80dda0259ee6add7$export$90a2fbbf51eb525f);
$parcel$export(module.exports, "internalGasV3OperationalEventChannel", () => $80dda0259ee6add7$export$c70a8fa9e6b52c91);
$parcel$export(module.exports, "internalSentryExceptionChannel", () => $80dda0259ee6add7$export$d9101fe70b7457a1);

var $ak0NR = parcelRequire("ak0NR");

var $3oOU0 = parcelRequire("3oOU0");
const $80dda0259ee6add7$var$breadcrumbAPI = (0, $ak0NR.createBreadcrumbAPI)();
const { breadcrumbMountedEventChannel: $80dda0259ee6add7$export$1622e7b9340efb0, Breadcrumb: $80dda0259ee6add7$export$dabcc1ec9dd9d1cc, useGetBreadcrumbs: $80dda0259ee6add7$export$a841c408695b0137 } = $80dda0259ee6add7$var$breadcrumbAPI;
const $80dda0259ee6add7$export$58a908b728d2cddc = (0, $3oOU0.createCatchingEventChannel)();
const $80dda0259ee6add7$export$34eb9485fd3a664a = (0, $3oOU0.createCatchingEventChannel)();
const $80dda0259ee6add7$export$fb5e587076f78057 = (0, $3oOU0.createCatchingEventChannel)();
const $80dda0259ee6add7$export$f92d259194a988f8 = (0, $3oOU0.createCatchingEventChannel)();
const $80dda0259ee6add7$export$d9c23c680d73705d = (0, $3oOU0.createCatchingEventChannel)();
const $80dda0259ee6add7$export$b7973f9532f3f87f = (0, $ak0NR.createBreadcrumbedEventChannel)($80dda0259ee6add7$var$breadcrumbAPI, (0, $3oOU0.createCatchingEventChannel));
const $80dda0259ee6add7$export$5a78c7e669ed705e = (0, $3oOU0.createCatchingEventChannel)();
const $80dda0259ee6add7$export$90a2fbbf51eb525f = (0, $ak0NR.createBreadcrumbedEventChannel)($80dda0259ee6add7$var$breadcrumbAPI, (0, $3oOU0.createCatchingEventChannel));
const $80dda0259ee6add7$export$c70a8fa9e6b52c91 = (0, $ak0NR.createBreadcrumbedEventChannel)($80dda0259ee6add7$var$breadcrumbAPI, (0, $3oOU0.createCatchingEventChannel));
const $80dda0259ee6add7$export$d9101fe70b7457a1 = (0, $ak0NR.createBreadcrumbedEventChannel)($80dda0259ee6add7$var$breadcrumbAPI, (0, $3oOU0.createCatchingEventChannel));

});
parcelRegister("ak0NR", function(module, exports) {

$parcel$export(module.exports, "createBreadcrumbAPI", () => $4ab785ca8bcd9647$export$783e5d823c500873);
$parcel$export(module.exports, "createBreadcrumbedEventChannel", () => $4ab785ca8bcd9647$export$d3653322274df895);
$parcel$export(module.exports, "withBreadcrumb", () => $4ab785ca8bcd9647$export$794ea2871d096951);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $3oOU0 = parcelRequire("3oOU0");
const $4ab785ca8bcd9647$var$emptyObject = {};
const $4ab785ca8bcd9647$export$783e5d823c500873 = ()=>{
    const context = /*#__PURE__*/ (0, $eJOHy.createContext)(()=>undefined);
    const useGetBreadcrumbs = ()=>(0, $eJOHy.useContext)(context);
    const breadcrumbMountedEventChannel = (0, $3oOU0.createEventChannel)();
    const { useEventDispatch: useEventDispatch } = breadcrumbMountedEventChannel;
    const EmitEventOnMount = ({ name: name, getMountedBreadcrumbPayload: getMountedBreadcrumbPayload })=>{
        const eventDispatch = useEventDispatch();
        (0, $eJOHy.useEffect)(()=>{
            // Should always be defined at this point.
            eventDispatch(getMountedBreadcrumbPayload());
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            name
        ]);
        return null;
    };
    const Breadcrumb = ({ children: children, ...breadcrumbPayload })=>{
        const getParentBreadcrumbs = useGetBreadcrumbs();
        // TODO: Type inference doesn't seem to understand that children and name are never a part of breadcrumbPayload. Investigate and fix.
        const castBreadcrumbPayload = breadcrumbPayload;
        // Prevents breadcrumb callback from being recreated everytime props change/every-render
        const breadcrumbRef = (0, $eJOHy.useRef)(castBreadcrumbPayload);
        (0, $eJOHy.useLayoutEffect)(()=>{
            // Ensures that the breadcrumb only updates when it component is mounted
            breadcrumbRef.current = castBreadcrumbPayload;
        });
        // TODO: Memoize this in the future?
        const getMountedBreadcrumbPayload = (0, $eJOHy.useCallback)(()=>({
                breadcrumbs: [
                    ...getParentBreadcrumbs()?.breadcrumbs ?? [],
                    breadcrumbRef.current
                ],
                payload: breadcrumbRef.current
            }), [
            getParentBreadcrumbs
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)(EmitEventOnMount, {
                    name: breadcrumbPayload.name,
                    getMountedBreadcrumbPayload: getMountedBreadcrumbPayload
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)(context.Provider, {
                    value: getMountedBreadcrumbPayload,
                    children: children
                })
            ]
        });
    };
    return {
        breadcrumbMountedEventChannel: /**
		 * An event channel whos event represents that a breadcrumb was mounted
		 */ breadcrumbMountedEventChannel,
        Breadcrumb: Breadcrumb,
        useGetBreadcrumbs: useGetBreadcrumbs
    };
};
const $4ab785ca8bcd9647$export$d3653322274df895 = ({ useGetBreadcrumbs: useGetBreadcrumbs }, createEventChannelFn = (0, $3oOU0.createEventChannel))=>{
    const { Listener: Listener, useEventDispatch: useEventDispatch } = createEventChannelFn();
    const useBreadcrumbedEventDispatch = ()=>{
        const eventDispatch = useEventDispatch();
        const getParentBreadcrumbs = useGetBreadcrumbs();
        const breadcrumbedEventDispatch = (0, $eJOHy.useCallback)((payload)=>eventDispatch({
                breadcrumbs: getParentBreadcrumbs()?.breadcrumbs ?? [],
                payload: payload
            }), [
            getParentBreadcrumbs,
            eventDispatch
        ]);
        return breadcrumbedEventDispatch;
    };
    return {
        Listener: Listener,
        useEventDispatch: useEventDispatch,
        useBreadcrumbedEventDispatch: useBreadcrumbedEventDispatch
    };
};
const $4ab785ca8bcd9647$export$794ea2871d096951 = (Component, Breadcrumb, name, // TODO: Fix up this type
breadcrumbFields = $4ab785ca8bcd9647$var$emptyObject)=>{
    const ComponentWithBreadcrumb = (props)=>/*#__PURE__*/ (0, $gt9Am.jsx)(Breadcrumb, {
            ...breadcrumbFields,
            name: name,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
                ...props
            })
        });
    return ComponentWithBreadcrumb;
};

});
parcelRegister("3oOU0", function(module, exports) {

$parcel$export(module.exports, "createCatchingEventChannel", () => $9f4c23fc0bec8114$export$5f3dbb5babc7e42e);
$parcel$export(module.exports, "createEventChannel", () => $9f4c23fc0bec8114$export$7b182ad6fa711a33);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
const $9f4c23fc0bec8114$export$5f3dbb5babc7e42e = (defaultOnEventCallback)=>{
    const context = /*#__PURE__*/ (0, $eJOHy.createContext)(defaultOnEventCallback);
    const useEventDispatch = ()=>{
        const onEventCallback = (0, $eJOHy.useContext)(context);
        const fireEventCallback = (0, $eJOHy.useCallback)((event)=>{
            onEventCallback?.(event);
        }, [
            onEventCallback
        ]);
        return fireEventCallback;
    };
    const EventCatcher = ({ onEvent: onEvent, children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)(context.Provider, {
            value: onEvent,
            children: children
        });
    return {
        Listener: EventCatcher,
        useEventDispatch: useEventDispatch
    };
};
const $9f4c23fc0bec8114$export$7b182ad6fa711a33 = ()=>{
    const catchingEventChannel = $9f4c23fc0bec8114$export$5f3dbb5babc7e42e();
    const ListenerThatDoesntConsumeEvent = $9f4c23fc0bec8114$export$a5fa32b3c7f79e99({
        from: catchingEventChannel.Listener,
        to: catchingEventChannel.useEventDispatch
    });
    return {
        Listener: ListenerThatDoesntConsumeEvent,
        useEventDispatch: catchingEventChannel.useEventDispatch
    };
};
const $9f4c23fc0bec8114$export$21d0f08655d40180 = (...listenersToCombine)=>{
    const CombinedListener = ({ children: children, onEvent: onEvent })=>{
        let wrappedChildren = children;
        for (const ListenerToCombine of listenersToCombine)wrappedChildren = ListenerToCombine({
            onEvent: onEvent,
            children: wrappedChildren
        });
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
            children: wrappedChildren
        });
    };
    return CombinedListener;
};
const $9f4c23fc0bec8114$export$9591aa59b8e3deeb = ({ from: inboundListenerValue, to: useOutboundEventDispatch, useTransformer: useTransformer })=>{
    const InboundListener = Array.isArray(inboundListenerValue) ? $9f4c23fc0bec8114$export$21d0f08655d40180(...inboundListenerValue) : inboundListenerValue;
    const Transformer = ({ children: children, ...transformerProps })=>{
        const dispatchTransformedEvent = useOutboundEventDispatch();
        const transform = useTransformer(transformerProps);
        const transformFn = (0, $eJOHy.useCallback)((payload)=>{
            const transformed = transform(payload);
            dispatchTransformedEvent(transformed);
        }, [
            dispatchTransformedEvent,
            transform
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)(InboundListener, {
            onEvent: transformFn,
            children: children
        });
    };
    return Transformer;
};
const $9f4c23fc0bec8114$export$a5fa32b3c7f79e99 = ({ from: from, to: to })=>{
    const ListenerThatDoesntConsumeEvent = $9f4c23fc0bec8114$export$9591aa59b8e3deeb({
        from: from,
        to: to,
        useTransformer: ({ onEvent: onEvent })=>(0, $eJOHy.useCallback)((payload)=>{
                onEvent(payload);
                return payload;
            }, [
                onEvent
            ])
    });
    return ListenerThatDoesntConsumeEvent;
};
const $9f4c23fc0bec8114$export$6c91a1925c226122 = (Listener, filter)=>{
    const FilteredListener = ({ onEvent: onEvent, ...other })=>{
        const filteredOnEvent = (0, $eJOHy.useCallback)((eventPayload)=>{
            if (filter(eventPayload)) onEvent(eventPayload);
        }, [
            onEvent
        ]);
        return Listener({
            onEvent: filteredOnEvent,
            ...other
        });
    };
    return FilteredListener;
};
const $9f4c23fc0bec8114$export$acca048df1683b81 = (children, components)=>{
    let wrappedChildren = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $gt9Am.Fragment), {
        children: children
    });
    for(let i = components.length - 1; i >= 0; i--){
        const { Listener: Listener, onEvent: onEvent } = components[i];
        wrappedChildren = /*#__PURE__*/ (0, $gt9Am.jsx)(Listener, {
            onEvent: onEvent,
            children: wrappedChildren
        });
    }
    return wrappedChildren;
};

});



parcelRegister("kZjdy", function(module, exports) {

$parcel$export(module.exports, "createAtlaskitToEventChannelRepackager", () => $b94298b2c9c2527b$export$1ec809871e34d2f0);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8QoO2 = parcelRequire("8QoO2");
var $ftN6c = parcelRequire("ftN6c");
const $b94298b2c9c2527b$var$ATLASKIT_CHANNEL = 'atlaskit';
const $b94298b2c9c2527b$export$b1e3a2222bb9a86d = (useEventDispatch, channel)=>{
    const RepackageAnalyticsNextEvent = ({ children: children, ...uiProperties })=>{
        const dispatchAnalytics = useEventDispatch();
        const repackageAtlaskitEvent = (0, $eJOHy.useCallback)((event)=>{
            dispatchAnalytics({
                ...uiProperties,
                ...event.payload,
                attributes: {
                    ...uiProperties.attributes,
                    ...event.payload.attributes
                }
            });
        }, [
            dispatchAnalytics,
            uiProperties
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8QoO2.default), {
            channel: channel,
            onEvent: repackageAtlaskitEvent,
            children: children
        });
    };
    return RepackageAnalyticsNextEvent;
};
const $b94298b2c9c2527b$export$1ec809871e34d2f0 = (// TODO: Technically, we can make the type more specific than just UIAnalyticsPayload
useEventDispatch)=>{
    const RepackageAtlaskitEvent = $b94298b2c9c2527b$export$b1e3a2222bb9a86d(useEventDispatch, 'atlaskit');
    return RepackageAtlaskitEvent;
};
const $b94298b2c9c2527b$export$ad0c43fbe23d07ab = (Listener, channel = $b94298b2c9c2527b$var$ATLASKIT_CHANNEL)=>{
    return ({ children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
        const fireAsAtlaskitEvent = (0, $eJOHy.useCallback)((payload)=>{
            createAnalyticsEvent(payload).fire(channel);
        }, [
            createAnalyticsEvent
        ]);
        return /*#__PURE__*/ (0, $gt9Am.jsx)(Listener, {
            onEvent: fireAsAtlaskitEvent,
            children: children
        });
    };
};

});


parcelRegister("4rbsy", function(module, exports) {

$parcel$export(module.exports, "sanitizeUrlString", () => $65358c8af74573af$export$ceb09b958e605eff);
/**
 * @param url The URL you want to sanitize
 * @returns A URL string without any user generated content (UGC) or PII (personally identifiable information). The URL will not necessarily be valid URL.
 */ const $65358c8af74573af$export$ceb09b958e605eff = (url)=>{
    // TODO: Should redact anything not from atlassian.com/atlassian.net/bitbucket.org/etc
    return url.replace(/\?.*$/, '');
};

});

parcelRegister("d1ev5", function(module, exports) {

$parcel$export(module.exports, "useCommerceOverride", () => $5a2522c5322373b0$export$cf6f15ae0c6d3b84);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $8uCsC = parcelRequire("8uCsC");
const $5a2522c5322373b0$export$8d3ccdf5c3b9600a = ({ children: children, overrides: overrides })=>{
    const [registry] = (0, $eJOHy.useState)(()=>new Map(overrides));
    (0, $eJOHy.useEffect)(()=>{
        const callbacks = overrides.map(([subject, target])=>$5a2522c5322373b0$export$87a46fc2314946e0(registry, subject, target));
        return ()=>callbacks.forEach((cb)=>cb());
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    overrides);
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8uCsC.overrideContext).Provider, {
        value: registry,
        children: children
    });
};
const $5a2522c5322373b0$export$edb6244a86733174 = ()=>(0, $eJOHy.useContext)((0, $8uCsC.overrideContext));
const $5a2522c5322373b0$export$87a46fc2314946e0 = (registry, subject, override)=>{
    registry.set(subject, override);
    return ()=>{
        registry.delete(subject);
    };
};
const $5a2522c5322373b0$export$9218bfcced62f524 = (registry, subject)=>{
    return registry.get(subject) || subject;
};
const $5a2522c5322373b0$export$cf6f15ae0c6d3b84 = (subject)=>{
    const registry = $5a2522c5322373b0$export$edb6244a86733174();
    return (registry || new Map()).get(subject) || subject;
};
const $5a2522c5322373b0$export$ef191f4a42af511d = (subject, target)=>[
        subject,
        target
    ];

});
parcelRegister("8uCsC", function(module, exports) {

$parcel$export(module.exports, "overrideContext", () => $61970f6c9e64f097$export$81b0387840a1a60c);
// eslint-disable-next-line import/no-extraneous-dependencies

var $eJOHy = parcelRequire("eJOHy");
const $61970f6c9e64f097$export$81b0387840a1a60c = (0, $eJOHy.createContext)(new Map());

});


parcelRegister("1ilA9", function(module, exports) {

$parcel$export(module.exports, "getRequestUrl", () => $1898ed962d2d6f74$export$14619c0eed01a470);
const $1898ed962d2d6f74$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;

});


parcelRegister("gXC8S", function(module, exports) {

$parcel$export(module.exports, "autoRetry", () => $3196837970367122$export$d1e1b46258030985);
const $3196837970367122$var$asyncWait = (interval)=>new Promise((resolve)=>setTimeout(resolve, interval));
const $3196837970367122$export$d1e1b46258030985 = async (call, shouldRetry, interval = 1500, maxRetries = 3)=>{
    const tryCall = async (remainingRetries)=>{
        const result = await call();
        if (remainingRetries === 0 || !shouldRetry(result)) return result;
        await $3196837970367122$var$asyncWait(interval);
        return tryCall(remainingRetries - 1);
    };
    return tryCall(maxRetries);
};

});

parcelRegister("8I3Xx", function(module, exports) {

$parcel$export(module.exports, "useFetchService", () => $d4496234f8b1e928$export$ff7e5879ade03276);
$parcel$export(module.exports, "useUpdateService", () => $d4496234f8b1e928$export$18e513c1248d8ad5);
// eslint-disable-next-line import/no-extraneous-dependencies

var $eJOHy = parcelRequire("eJOHy");
const $d4496234f8b1e928$export$6de4685a6c88b4e9 = (request, initialState = {
    loading: false,
    data: undefined,
    error: undefined
})=>{
    const [state, setState] = (0, $eJOHy.useState)(initialState);
    const fetchData = (0, $eJOHy.useCallback)(async (...requestArgs)=>{
        setState({
            loading: true,
            data: undefined,
            error: undefined
        });
        try {
            const data = await request(...requestArgs);
            setState({
                loading: false,
                data: data,
                error: undefined
            });
            return data;
        } catch (error) {
            // Casting promise error to provided type. I assumes that the person that
            // provides types know that kind of type promise will return on reject.
            setState({
                loading: false,
                data: undefined,
                error: error
            });
            throw error;
        }
    }, [
        request
    ]);
    return (0, $eJOHy.useMemo)(()=>({
            ...state,
            fetchData: fetchData
        }), [
        state,
        fetchData
    ]);
};
const $d4496234f8b1e928$export$ff7e5879ade03276 = (request)=>{
    const service = $d4496234f8b1e928$export$6de4685a6c88b4e9(request, {
        loading: true,
        data: undefined,
        error: undefined
    });
    const { fetchData: fetchData } = service;
    (0, $eJOHy.useEffect)(()=>{
        // on error promise will be resolved to undefined, error instance available in state
        // eslint-disable-next-line no-console
        fetchData().catch((error)=>console.warn(error));
    }, [
        fetchData
    ]);
    return (0, $eJOHy.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            refresh: ()=>fetchData()
        };
    }, [
        service
    ]);
};
const $d4496234f8b1e928$export$18e513c1248d8ad5 = (request)=>{
    const service = $d4496234f8b1e928$export$6de4685a6c88b4e9(request, {
        loading: false,
        data: undefined,
        error: undefined
    });
    return (0, $eJOHy.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            update: fetchData
        };
    }, [
        service
    ]);
};
const $d4496234f8b1e928$export$d9765c5cd98039 = (request)=>{
    const service = $d4496234f8b1e928$export$18e513c1248d8ad5(request);
    return (0, $eJOHy.useMemo)(()=>{
        const { update: update, ...state } = service;
        return {
            ...state,
            fetch: update
        };
    }, [
        service
    ]);
};
const $d4496234f8b1e928$export$7077fee76310bc60 = (request)=>{
    const service = $d4496234f8b1e928$export$6de4685a6c88b4e9(request);
    return (0, $eJOHy.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            create: fetchData
        };
    }, [
        service
    ]);
};

});

parcelRegister("j8Vkb", function(module, exports) {

$parcel$export(module.exports, "isEntitlementInTrial", () => $8bf774bc7d837cfd$export$fbb9aa0901da1265);

var $aXKmr = parcelRequire("aXKmr");

var $8j4Dk = parcelRequire("8j4Dk");

const $8bf774bc7d837cfd$export$142d2efc3dec2198 = (entitlement)=>{
    if (entitlement.status === 'ACTIVE' && entitlement.order?.item?.type === 'CANCELLATION_ORDER' && entitlement.subscription?.status === 'ACTIVE' && entitlement.subscription?.endTimestamp) return entitlement.subscription.endTimestamp;
    return undefined;
};
const $8bf774bc7d837cfd$export$fc60d6ed290c50 = ()=>(0, $aXKmr.v4)();
const $8bf774bc7d837cfd$var$isActiveSubscriptionStatus = (status)=>status === 'ACTIVE';
const $8bf774bc7d837cfd$export$fbb9aa0901da1265 = (item)=>{
    if (item.subscription && $8bf774bc7d837cfd$var$isActiveSubscriptionStatus(item.subscription.status) && item.subscription.trial?.endTimestamp) return !(0, $8j4Dk.isDateInPast)(item.subscription.trial.endTimestamp);
    return false;
};

});
parcelRegister("8j4Dk", function(module, exports) {

$parcel$export(module.exports, "isDateInPast", () => $b0b34ad78cc602ba$export$b61c42c7211e77c7);
const $b0b34ad78cc602ba$export$b61c42c7211e77c7 = (timestamp)=>timestamp < Date.now();

});



parcelRegister("hZoe8", function(module, exports) {

$parcel$export(module.exports, "createAmendmentOrderRequestDto", () => $406c26f2d1fb40be$export$e696ce842af4ff59);

var $aXKmr = parcelRequire("aXKmr");
const $406c26f2d1fb40be$var$AMENDMENT_ORDER_ITEM_ID = '1';
const $406c26f2d1fb40be$export$e696ce842af4ff59 = (ccpOrderDefaults, targetOfferingId, entitlement)=>{
    if (!entitlement.entitlementId || !entitlement.version) return undefined;
    return {
        orderId: (0, $aXKmr.v4)(),
        invoiceGroupId: ccpOrderDefaults.invoiceGroupId?.value,
        items: [
            {
                nextBillingAnchorTimestamp: ccpOrderDefaults.billingAnchorTime?.constrained ? ccpOrderDefaults.billingAnchorTime.value : undefined,
                offeringId: targetOfferingId,
                entitlement: {
                    id: entitlement.entitlementId,
                    version: entitlement.version.toString()
                },
                optedUsageOptions: {
                    trial: {
                        skipTrial: false
                    },
                    chargingDetails: {
                        pricingPlanId: ccpOrderDefaults.pricingPlanId?.value
                    }
                },
                type: 'AMENDMENT_ORDER',
                itemId: $406c26f2d1fb40be$var$AMENDMENT_ORDER_ITEM_ID
            }
        ]
    };
};

});

parcelRegister("cnSyh", function(module, exports) {

$parcel$export(module.exports, "recordTosAndPrivacyConsent", () => $6d8067afab030393$export$10b8b8eb8664f272);

var $jGzN3 = parcelRequire("jGzN3");
const $6d8067afab030393$var$recordConsent = async (consents, geoLocale)=>{
    const url = '/gateway/api/consenthub/session/user';
    const consentData = {
        // This is the "page" that loaded consent.
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        formUrl: window.location.href,
        // This needs to be the geo corresponding to the user's IP, and must be determined on the backend
        locale: geoLocale,
        // always `atlassian`
        site: 'atlassian',
        // always `FORM_FILL` since this is in a web form
        action: 'FORM_FILL',
        // JIRA is defined in consenthub. This is the source of the consent.
        source: 'JIRA',
        consents: consents
    };
    // don't need request options
    await (0, $jGzN3.performPostRequest)(url, {
        body: JSON.stringify(consentData),
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
const $6d8067afab030393$export$10b8b8eb8664f272 = async ({ tosPrivacyText: tosPrivacyText, geoLocale: geoLocale = 'UNKNOWN' })=>{
    await $6d8067afab030393$var$recordConsent([
        {
            key: 'termsOfService',
            granted: true,
            displayedText: tosPrivacyText
        },
        {
            key: 'privacyPolicy',
            granted: true,
            displayedText: tosPrivacyText
        }
    ], geoLocale);
};

});


parcelRegister("gtJNn", function(module, exports) {

$parcel$export(module.exports, "useCrossFlowEditionParityData", () => $b41998f8e1a63b69$export$44f3e13b40934eae);

var $eJOHy = parcelRequire("eJOHy");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $kEUB1 = parcelRequire("kEUB1");

var $9HmCl = parcelRequire("9HmCl");

var $fqpZW = parcelRequire("fqpZW");

var $3s1pa = parcelRequire("3s1pa");

var $afkaZ = parcelRequire("afkaZ");

var $dSVpi = parcelRequire("dSVpi");

var $lrm81 = parcelRequire("lrm81");
const $b41998f8e1a63b69$export$44f3e13b40934eae = ({ sourceProduct: sourceProduct, targetProduct: targetProduct })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const productEntitlementDetails = (0, $9HmCl.useProductEntitlementDetails)();
    const targetProductEntitlementDetails = productEntitlementDetails?.[targetProduct];
    const billingSourceSystem = targetProductEntitlementDetails?.billingSourceSystem;
    const fireErrorAnalytics = (0, $eJOHy.useCallback)((reason, attributes)=>(0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useCrossFlowEditionParityData failed', {
            ...attributes,
            reason: reason,
            sourceProduct: sourceProduct,
            targetProduct: targetProduct
        }), [
        createAnalyticsEvent,
        sourceProduct,
        targetProduct
    ]);
    const { data: targetEdition, loading: targetEditionLoading, error: targetEditionError } = (0, $fqpZW.useTargetEdition)({
        sourceProduct: sourceProduct,
        targetProduct: targetProduct
    });
    const { data: licenseInformation, loading: licenseInformationLoading, error: licenseInformationError } = (0, $3s1pa.useLicenseInformation)({
        cloudId: cloudId
    });
    const ccpEntitlementId = licenseInformationLoading ? null : (0, $3s1pa.getCcpEntitlementIdFromLicense)({
        licenseInformation: licenseInformation,
        productKey: targetProduct
    });
    const currentTargetEdition = licenseInformationLoading ? null : (0, $3s1pa.getCurrentEditionFromLicense)({
        licenseInformation: licenseInformation,
        productKey: targetProduct
    });
    const transactionAccountId = licenseInformationLoading ? null : (0, $3s1pa.getCcpTransactionAccountIdFromLicense)({
        licenseInformation: licenseInformation,
        productKey: targetProduct
    });
    const { data: entitlementDetails, loading: entitlementDetailsLoading, error: entitlementDetailsError } = (0, $lrm81.useEntitlementInformation)({
        entitlementId: ccpEntitlementId
    });
    const getTargetEditionToUpgradeOfferingId = (0, $eJOHy.useCallback)(()=>{
        if (targetEditionLoading || targetEdition?.edition === 'free' || targetEdition?.edition === currentTargetEdition) return null;
        try {
            return (0, $afkaZ.targetEditionToUpgradeOfferingId)({
                productKey: targetProduct,
                targetEdition: (0, $fqpZW.editionKeyToEdition)(targetEdition?.edition)
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            fireErrorAnalytics('InvalidTargetEditionToUpgradeOfferingId', {
                errorMessage: error.message,
                targetEdition: targetEdition,
                targetProduct: targetProduct
            });
            return null;
        }
    }, [
        targetEditionLoading,
        targetEdition,
        currentTargetEdition,
        targetProduct,
        fireErrorAnalytics
    ]);
    const offeringId = getTargetEditionToUpgradeOfferingId();
    const { data: defaultOffering, loading: defaultOfferingLoading, error: defaultOfferingError } = (0, $dSVpi.useDefaultOffering)({
        offeringId: offeringId,
        entitlementId: ccpEntitlementId || '',
        transactionAccountId: (0, $3s1pa.getCcpTransactionAccountIdFromLicense)({
            licenseInformation: licenseInformation,
            productKey: targetProduct
        }) || '',
        targetEdition: (0, $fqpZW.editionKeyToEdition)(targetEdition?.edition)
    });
    (0, $eJOHy.useEffect)(()=>{
        if (billingSourceSystem && billingSourceSystem !== 'CCP') fireErrorAnalytics('UnsupportedBillingSourceSystem', {
            billingSourceSystem: billingSourceSystem,
            sourceProduct: sourceProduct,
            targetProduct: targetProduct
        });
    }, [
        targetEdition,
        billingSourceSystem,
        fireErrorAnalytics,
        sourceProduct,
        targetProduct
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (targetEditionError) fireErrorAnalytics('TargetEditionError', {
            errorMessage: targetEditionError.message
        });
        if (licenseInformationError) fireErrorAnalytics('LicenseInformationError', {
            errorMessage: licenseInformationError.message
        });
        if (entitlementDetailsError) fireErrorAnalytics('EntitlementDetailsError', {
            errorMessage: entitlementDetailsError.message
        });
        if (defaultOfferingError) fireErrorAnalytics('DefaultOfferingError', {
            errorMessage: defaultOfferingError.message
        });
    }, [
        targetEditionError,
        licenseInformationError,
        entitlementDetailsError,
        defaultOfferingError,
        fireErrorAnalytics
    ]);
    return {
        isLoading: targetEditionLoading || licenseInformationLoading || defaultOfferingLoading || entitlementDetailsLoading,
        shouldUpgrade: !(targetEdition?.edition === 'free' || targetEdition?.edition === currentTargetEdition || targetEditionError || licenseInformationError || entitlementDetailsError || defaultOfferingError || !entitlementDetails || !offeringId || !defaultOffering || !transactionAccountId),
        ccpEntitlementId: ccpEntitlementId,
        offeringId: offeringId,
        targetEdition: targetEdition && (0, $fqpZW.editionKeyToEdition)(targetEdition.edition),
        entitlementDetails: entitlementDetails,
        billingSourceSystem: billingSourceSystem,
        defaultOffering: defaultOffering,
        currentTargetEdition: currentTargetEdition,
        transactionAccountId: transactionAccountId
    };
};

});
parcelRegister("fqpZW", function(module, exports) {

$parcel$export(module.exports, "editionKeyToEdition", () => $ac69dde9b78a7c5b$export$21d25cf944084a5e);
$parcel$export(module.exports, "useTargetEdition", () => $ac69dde9b78a7c5b$export$7869f74418d54846);

var $eJOHy = parcelRequire("eJOHy");

var $jGzN3 = parcelRequire("jGzN3");

var $8vyDv = parcelRequire("8vyDv");

var $a9ldn = parcelRequire("a9ldn");

var $kEUB1 = parcelRequire("kEUB1");

var $2dZPN = parcelRequire("2dZPN");
const $ac69dde9b78a7c5b$export$21d25cf944084a5e = (edition)=>{
    switch(edition){
        case 'free':
            return 'FREE_EDITION';
        case 'standard':
            return 'STANDARD_EDITION';
        case 'premium':
            return 'PREMIUM_EDITION';
        default:
            return 'UNLICENSED';
    }
};
const $ac69dde9b78a7c5b$export$7869f74418d54846 = ({ sourceProduct: sourceProduct, targetProduct: targetProduct })=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const appEditions = (0, $8vyDv.useAppEditions)();
    const [loading, setLoading] = (0, $eJOHy.useState)(true);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [data, setData] = (0, $eJOHy.useState)(null);
    const getSourceEdition = (0, $eJOHy.useCallback)(()=>{
        let sourceEdition = 'FREE_EDITION';
        switch(sourceProduct){
            case 'jira-software.ondemand':
                sourceEdition = appEditions?.software;
                break;
            case 'jira-service-desk.ondemand':
                sourceEdition = appEditions?.serviceDesk;
                break;
            case 'jira-core.ondemand':
                sourceEdition = appEditions?.core;
                break;
            case 'jira-product-discovery':
                sourceEdition = appEditions?.productDiscovery;
                break;
            default:
                sourceEdition = 'FREE_EDITION';
        }
        return (0, $a9ldn.editionToEditionKey)(sourceEdition);
    }, [
        appEditions,
        sourceProduct
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const fetchData = async ()=>{
            setLoading(true);
            try {
                const targetEdition = await (0, $jGzN3.performPostRequestWithRetry)(`/gateway/api/xflow/${cloudId}/${targetProduct}/edition`, {
                    body: JSON.stringify({
                        requestedEditionId: getSourceEdition() || 'FREE_EDITION'
                    }),
                    retryPredicate: (err)=>{
                        const errorCode = (0, $2dZPN.hasStatusCode)(err) ? err.statusCode : undefined;
                        return (0, $2dZPN.isServerSideResponse)(errorCode);
                    },
                    retryAttempts: 3
                });
                setData(targetEdition);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                setError(err);
            }
            setLoading(false);
        };
        fetchData();
    }, [
        cloudId,
        targetProduct,
        getSourceEdition
    ]);
    return {
        loading: loading,
        error: error,
        data: data
    };
};

});
parcelRegister("2dZPN", function(module, exports) {

$parcel$export(module.exports, "hasStatusCode", () => $9b9032d9622eb593$export$e9e8d85bf8f6f7d8);
$parcel$export(module.exports, "isServerSideResponse", () => $9b9032d9622eb593$export$f9b2925ef93132ee);
const $9b9032d9622eb593$export$e9e8d85bf8f6f7d8 = (err)=>{
    return 'statusCode' in err && typeof err.statusCode === 'number';
};
const $9b9032d9622eb593$export$f9b2925ef93132ee = (errorCode)=>!!errorCode && errorCode >= 500 && errorCode < 600;

});


parcelRegister("3s1pa", function(module, exports) {

$parcel$export(module.exports, "useLicenseInformation", () => $174a005cfcdbd238$export$15270500324d66e1);
$parcel$export(module.exports, "getCcpEntitlementIdFromLicense", () => $174a005cfcdbd238$export$f54116a7e5c025b2);
$parcel$export(module.exports, "getCcpTransactionAccountIdFromLicense", () => $174a005cfcdbd238$export$2a07c1f0aeb9cb80);
$parcel$export(module.exports, "getCurrentEditionFromLicense", () => $174a005cfcdbd238$export$15cc5b4e3a4137e5);

var $eJOHy = parcelRequire("eJOHy");

var $jGzN3 = parcelRequire("jGzN3");
const $174a005cfcdbd238$export$15270500324d66e1 = ({ cloudId: cloudId })=>{
    const [loading, setLoading] = (0, $eJOHy.useState)(true);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [data, setData] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        const fetchData = async ()=>{
            setLoading(true);
            try {
                const targetEdition = await (0, $jGzN3.performGetRequest)(`/gateway/api/xflow/${cloudId}/license-information`);
                setData(targetEdition);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                setError(err);
            }
            setLoading(false);
        };
        fetchData();
    }, [
        cloudId
    ]);
    return {
        loading: loading,
        error: error,
        data: data
    };
};
const $174a005cfcdbd238$export$f54116a7e5c025b2 = ({ licenseInformation: licenseInformation, productKey: productKey })=>{
    const product = licenseInformation?.products[productKey];
    return product?.ccpEntitlementId || null;
};
const $174a005cfcdbd238$export$2a07c1f0aeb9cb80 = ({ licenseInformation: licenseInformation, productKey: productKey })=>{
    const product = licenseInformation?.products[productKey];
    return product?.ccpTransactionAccountId || null;
};
const $174a005cfcdbd238$export$15cc5b4e3a4137e5 = ({ licenseInformation: licenseInformation, productKey: productKey })=>{
    const product = licenseInformation?.products[productKey];
    return product?.edition || null;
};

});

parcelRegister("dSVpi", function(module, exports) {

$parcel$export(module.exports, "useDefaultOffering", () => $7ea979d9474b0d58$export$2f20bd1cce4ae90e);

var $eJOHy = parcelRequire("eJOHy");

var $6YXku = parcelRequire("6YXku");

var $6YXku = parcelRequire("6YXku");

var $bNCA8 = parcelRequire("bNCA8");
const $7ea979d9474b0d58$export$2f20bd1cce4ae90e = ({ offeringId: offeringId, entitlementId: entitlementId, transactionAccountId: transactionAccountId, targetEdition: targetEdition })=>{
    const [loading, setLoading] = (0, $eJOHy.useState)(true);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [data, setData] = (0, $eJOHy.useState)(null);
    const [invoiceGroupCreated, setInvoiceGroupCreated] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        const fetchData = async ()=>{
            setLoading(true);
            if (!offeringId || !entitlementId || !transactionAccountId) {
                setLoading(false);
                return;
            }
            try {
                // fetch default order configuration for the target offering
                const orderDefaults = (0, $6YXku.getSuccessfulResultOrThrow)(await (0, $6YXku.orderDefaults_get_byOfferingId_v1)({
                    pathParameters: {
                        offeringId: offeringId
                    },
                    queryParameters: {
                        currentEntitlementId: entitlementId
                    },
                    headers: {
                        'X-Transaction-Account': transactionAccountId
                    }
                }));
                const defaultOffering = orderDefaults;
                // Create an invoice group if it doesn't exist
                if (!defaultOffering.invoiceGroupId?.value && !invoiceGroupCreated) {
                    await (0, $bNCA8.createInvoiceGroup)(transactionAccountId);
                    setInvoiceGroupCreated(true);
                }
                setData(defaultOffering);
            } catch (err) {
                if (err instanceof Error) setError(err);
                else setError(new Error('Unknown error occurred'));
            }
            setLoading(false);
        };
        if (offeringId && (targetEdition === 'FREE_EDITION' || targetEdition === 'UNLICENSED')) {
            // If the target edition is free or unlicensed, we do not need to fetch the default offering
            setData(null);
            setLoading(false);
            return;
        }
        fetchData();
    }, [
        offeringId,
        entitlementId,
        transactionAccountId,
        invoiceGroupCreated,
        targetEdition
    ]);
    return {
        loading: loading,
        error: error,
        data: data
    };
};

});
parcelRegister("bNCA8", function(module, exports) {

$parcel$export(module.exports, "createInvoiceGroup", () => $2735ea43ba725766$export$9f23c1d7be126513);

var $6YXku = parcelRequire("6YXku");

var $6YXku = parcelRequire("6YXku");
const $2735ea43ba725766$export$9f23c1d7be126513 = async (transactionAccountId)=>{
    if (!transactionAccountId) throw new Error('Missing transactionAccountId');
    (0, $6YXku.getSuccessfulResultOrThrow)(await (0, $6YXku.invoiceGroups_post_v1)({
        fetch: fetch,
        headers: {
            'X-transaction-account': transactionAccountId
        },
        body: {
            name: 'USD',
            currency: 'USD'
        }
    }));
};

});


parcelRegister("lrm81", function(module, exports) {

$parcel$export(module.exports, "useEntitlementInformation", () => $412df00a3bb4ded4$export$4da888ede4718fb2);

var $eJOHy = parcelRequire("eJOHy");

var $6YXku = parcelRequire("6YXku");

var $6YXku = parcelRequire("6YXku");
const $412df00a3bb4ded4$export$4da888ede4718fb2 = ({ entitlementId: entitlementId })=>{
    const [loading, setLoading] = (0, $eJOHy.useState)(true);
    const [error, setError] = (0, $eJOHy.useState)(null);
    const [data, setData] = (0, $eJOHy.useState)(null);
    (0, $eJOHy.useEffect)(()=>{
        const fetchData = async ()=>{
            setLoading(true);
            try {
                const entitlementResponse = (0, $6YXku.getSuccessfulResultOrThrow)(await (0, $6YXku.entitlementsDetails_get_byEntitlementId_v1)({
                    pathParameters: {
                        entitlementId: entitlementId || ''
                    }
                }));
                setData(entitlementResponse);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                setError(err);
            }
            setLoading(false);
        };
        if (entitlementId && entitlementId.trim().length > 0) fetchData();
        else setLoading(false);
    }, [
        entitlementId
    ]);
    return {
        loading: loading,
        error: error,
        data: data
    };
};

});



parcelRegister("daZe3", function(module, exports) {

$parcel$export(module.exports, "TEMPLATE_KEY", () => $0c3dfcafdc1f6b15$export$34963d9cf9309358);
$parcel$export(module.exports, "prioritizationProductDiscoveryProject", () => $0c3dfcafdc1f6b15$export$ede27cb809770905);
// GALILEO-2516 START

var $eJOHy = parcelRequire("eJOHy");

var $i83VC = parcelRequire("i83VC");

var $kHSr3 = parcelRequire("kHSr3");

var $9yreF = parcelRequire("9yreF");

var $364YC = parcelRequire("364YC");

var $fL54S = parcelRequire("fL54S");
const $0c3dfcafdc1f6b15$export$34963d9cf9309358 = 'jpd.prioritization';
const $0c3dfcafdc1f6b15$export$ede27cb809770905 = {
    key: $0c3dfcafdc1f6b15$export$34963d9cf9309358,
    overviewContent: {
        valueProps: [
            {
                title: (0, $fL54S.default).valueProp1Title,
                description: (0, $fL54S.default).valueProp1Description,
                imageComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kHSr3.default), {
                        alt: ""
                    }),
                imageUrl: ''
            },
            {
                title: (0, $fL54S.default).valueProp2Title,
                description: (0, $fL54S.default).valueProp2Description,
                imageUrl: '',
                imageComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9yreF.default), {
                        alt: ""
                    })
            },
            {
                title: (0, $fL54S.default).valueProp3Title,
                description: (0, $fL54S.default).valueProp3Description,
                imageUrl: '',
                imageComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i83VC.default), {
                        alt: ""
                    })
            }
        ],
        recommendedList: [
            (0, $fL54S.default).recommendedList1
        ],
        workType: 'Issue',
        issueTypes: [
            {
                key: 'idea',
                label: (0, $364YC.default).idea
            }
        ],
        workflow: [
            {
                label: (0, $364YC.default).parkingLot,
                appearance: 'default'
            },
            {
                label: (0, $364YC.default).discovery,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).readyForDelivery,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).delivery,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).impact,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).archived,
                appearance: 'success'
            }
        ]
    }
}; // GALILEO-2516 END

});
parcelRegister("i83VC", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c98cc44e5c8f9df$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md
// GALILEO-2516 START

var $c4huj = parcelRequire("c4huj");

var $cKbkk = parcelRequire("cKbkk");

var $5ZdkH = parcelRequire("5ZdkH");
const $0c98cc44e5c8f9df$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5ZdkH)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($cKbkk)),
    autoDark: false
});
var $0c98cc44e5c8f9df$export$2e2bcd8739ae039 = $0c98cc44e5c8f9df$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $0c98cc44e5c8f9df$export$a179c88182cb9d56 = [
    0,
    0,
    294,
    224
];
 // GALILEO-2516 END

});
parcelRegister("cKbkk", function(module, exports) {
module.exports = new URL("jpd-prioritization-delivery-status-dark.df6b55d9.svg", import.meta.url).toString();

});

parcelRegister("5ZdkH", function(module, exports) {
module.exports = new URL("jpd-prioritization-delivery-status.90946ca3.svg", import.meta.url).toString();

});


parcelRegister("kHSr3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8124e3addfa0156$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md
// GALILEO-2516 START

var $c4huj = parcelRequire("c4huj");

var $hCdd6 = parcelRequire("hCdd6");

var $23X18 = parcelRequire("23X18");
const $b8124e3addfa0156$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($23X18)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($hCdd6)),
    autoDark: false
});
var $b8124e3addfa0156$export$2e2bcd8739ae039 = $b8124e3addfa0156$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $b8124e3addfa0156$export$a179c88182cb9d56 = [
    0,
    0,
    294,
    224
];
 // GALILEO-2516 END

});
parcelRegister("hCdd6", function(module, exports) {
module.exports = new URL("jpd-prioritization-idea-dark.6d9c45cf.svg", import.meta.url).toString();

});

parcelRegister("23X18", function(module, exports) {
module.exports = new URL("jpd-prioritization-idea.70909cc6.svg", import.meta.url).toString();

});


parcelRegister("9yreF", function(module, exports) {

$parcel$export(module.exports, "default", () => $09efe318bbdf74bf$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md
// GALILEO-2516 START

var $c4huj = parcelRequire("c4huj");

var $9t9Hr = parcelRequire("9t9Hr");

var $1Yg7m = parcelRequire("1Yg7m");
const $09efe318bbdf74bf$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1Yg7m)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($9t9Hr)),
    autoDark: false
});
var $09efe318bbdf74bf$export$2e2bcd8739ae039 = $09efe318bbdf74bf$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $09efe318bbdf74bf$export$a179c88182cb9d56 = [
    0,
    0,
    294,
    224
];
 // GALILEO-2516 END

});
parcelRegister("9t9Hr", function(module, exports) {
module.exports = new URL("jpd-prioritization-roadmap-dark.54413b95.svg", import.meta.url).toString();

});

parcelRegister("1Yg7m", function(module, exports) {
module.exports = new URL("jpd-prioritization-roadmap.4b4874ca.svg", import.meta.url).toString();

});


parcelRegister("364YC", function(module, exports) {

$parcel$export(module.exports, "default", () => $39aa78881849f147$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $39aa78881849f147$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    archived: {
        "id": "project-template-select-v2.utils.templates.product-discovery.archived",
        "defaultMessage": "Archived"
    },
    done: {
        "id": "project-template-select-v2.utils.templates.product-discovery.done",
        "defaultMessage": "Done"
    },
    idea: {
        "id": "project-template-select-v2.utils.templates.product-discovery.idea",
        "defaultMessage": "Idea"
    },
    delivery: {
        "id": "project-template-select-v2.utils.templates.product-discovery.delivery",
        "defaultMessage": "Delivery"
    },
    discovery: {
        "id": "project-template-select-v2.utils.templates.product-discovery.discovery",
        "defaultMessage": "Discovery"
    },
    impact: {
        "id": "project-template-select-v2.utils.templates.product-discovery.impact",
        "defaultMessage": "Impact"
    },
    parkingLot: {
        "id": "project-template-select-v2.utils.templates.product-discovery.parking-lot",
        "defaultMessage": "Parking lot"
    },
    readyForDelivery: {
        "id": "project-template-select-v2.utils.templates.product-discovery.ready-for-delivery",
        "defaultMessage": "Ready for delivery"
    }
});

});

parcelRegister("fL54S", function(module, exports) {

$parcel$export(module.exports, "default", () => $566e0555465cdb31$export$2e2bcd8739ae039);
// GALILEO-2516 START

var $7qGN1 = parcelRequire("7qGN1");
var $566e0555465cdb31$export$2e2bcd8739ae039 // GALILEO-2516 END
 = (0, $7qGN1.defineMessages)({
    // Section 1
    valueProp1Title: {
        "id": "project-template-select-v2.utils.templates.product-discovery.prioritization.value-prop-1-title",
        "defaultMessage": "Prioritize with confidence"
    },
    valueProp1Description: {
        "id": "project-template-select-v2.utils.templates.product-discovery.prioritization.value-prop-1-description",
        "defaultMessage": "Identify your highest impact ideas using our RICE template, or your team's preferred prioritization framework."
    },
    // Section 2
    valueProp2Title: {
        "id": "project-template-select-v2.utils.templates.product-discovery.prioritization.value-prop-2-title",
        "defaultMessage": "Align your team with roadmaps"
    },
    valueProp2Description: {
        "id": "project-template-select-v2.utils.templates.product-discovery.prioritization.value-prop-2-description",
        "defaultMessage": "Create and share custom roadmaps with different stakeholders - even your customers."
    },
    // Section 3
    valueProp3Title: {
        "id": "project-template-select-v2.utils.templates.product-discovery.prioritization.value-prop-3-title",
        "defaultMessage": "Connect with delivery"
    },
    valueProp3Description: {
        "id": "project-template-select-v2.utils.templates.product-discovery.prioritization.value-prop-3-description",
        "defaultMessage": "Seamlessly connect your ideas to delivery work in Jira so your teams have full context and visibility from discovery to delivery."
    },
    recommendedList1: {
        "id": "project-template-select-v2.utils.templates.product-discovery.prioritization.recommended-list-1",
        "defaultMessage": "Teams that need to prioritize work"
    },
    recommendedList2: {
        "id": "project-template-select-v2.utils.templates.product-discovery.prioritization.recommended-list-2",
        "defaultMessage": "Product teams"
    }
});

});


parcelRegister("9aRzJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $333fed63ef3b7475$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $333fed63ef3b7475$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createProject: {
        "id": "project-create-form.ui.create-project",
        "defaultMessage": "Create project"
    },
    create: {
        "id": "project-create-form.ui.create",
        "defaultMessage": "Create"
    },
    createPageTitle: {
        "id": "project-create-form.ui.create-page-title",
        "defaultMessage": "Create Project - Jira"
    },
    back: {
        "id": "project-create-form.ui.back",
        "defaultMessage": "Back"
    },
    next: {
        "id": "project-create-form.ui.next",
        "defaultMessage": "Next"
    },
    close: {
        "id": "project-create-form.ui.close",
        "defaultMessage": "Close"
    },
    template: {
        "id": "project-create-form.ui.template",
        "defaultMessage": "Template"
    },
    defaultLanguage: {
        "id": "project-create-form.ui.default-language",
        "defaultMessage": "Default language"
    },
    changeTemplate: {
        "id": "project-create-form.ui.change-template",
        "defaultMessage": "Change template"
    },
    advanced: {
        "id": "project-create-form.ui.advanced",
        "defaultMessage": "Advanced"
    },
    whatIsInThis: {
        "id": "project-create-form.ui.what-is-in-this",
        "defaultMessage": "What's in this?"
    },
    tellMeMore: {
        "id": "project-create-form.ui.tell-me-more",
        "defaultMessage": "Tell me more"
    },
    // new project create screen
    backToProjectTemplate: {
        "id": "project-create-form.ui.back-to-project-template",
        "defaultMessage": "Back to project templates"
    },
    backToChooseAProjectType: {
        "id": "project-create-form.ui.back-to-choose-a-project-type",
        "defaultMessage": "Back to project types"
    },
    createProjectTitle: {
        "id": "project-create-form.ui.create-project-title",
        "defaultMessage": "Add project details"
    },
    createProjectPageTitle: {
        "id": "project-create-form.ui.create-project-page-title",
        "defaultMessage": "Add project details - Jira"
    },
    createProjectDescription: {
        "id": "project-create-form.ui.create-project-description",
        "defaultMessage": "Explore what's possible when you collaborate with your team. Edit project details anytime in project settings."
    },
    createProjectDescriptionJsm: {
        "id": "project-create-form.ui.create-project-description-jsm",
        "defaultMessage": "Add your project\u2019s details and confirm your template to create your new project in seconds. Edit project details anytime in project settings."
    },
    createCrossTeamTemplateProjectDescription: {
        "id": "project-create-form.ui.create-cross-team-template-project-description",
        "defaultMessage": "This template creates a project to store your high-level goals and uses it as a basis of a plan."
    },
    createCrossTeamPlanningTemplateProjectDescription: {
        "id": "project-create-form.ui.create-cross-team-planning-template-project-description",
        "defaultMessage": "This template creates a project, a plan, and two new teams with their own scrum board."
    },
    cancel: {
        "id": "project-create-form.ui.cancel",
        "defaultMessage": "Cancel"
    },
    createProjectText: {
        "id": "project-create-form.ui.create-project-text",
        "defaultMessage": "Create project"
    },
    createProjectAndPlanText: {
        "id": "project-create-form.ui.create-project-and-plan-text",
        "defaultMessage": "Create a project and a plan"
    },
    recommendationLozenge: {
        "id": "project-create-form.ui.recommendation-lozenge",
        "defaultMessage": "Recommended"
    },
    /* eslint-disable jira/i18n/id-named-by-package */ PROJECT_SHARED_CONFIG_NAME: {
        "id": "project-create.create-form.project-shared-config-name",
        "defaultMessage": "Shared with an existing project"
    },
    /* eslint-disable jira/i18n/id-named-by-package */ PROJECT_SHARED_CONFIG_DESCRIPTION: {
        "id": "project-create.create-form.project-shared-config-description",
        "defaultMessage": "Create a project with pre-existing shared configuration"
    },
    createProjectFailureTitleNonFinal: {
        "id": "project-create-common.common.flags.create-project-failure-title",
        "defaultMessage": "Project not created"
    },
    createProjectFailureDescriptionNonFinal: {
        "id": "project-create-common.common.flags.create-project-failure-description",
        "defaultMessage": "For some reason the magic didn't happen. Click Create to try again."
    },
    backToProjectTemplateGalaxia: {
        "id": "project-create-form.ui.back-to-project-template-galaxia",
        "defaultMessage": "Back to templates"
    },
    createProjectTitleGalaxia: {
        "id": "project-create-form.ui.create-project-title-galaxia",
        "defaultMessage": "Add space details"
    },
    createProjectPageTitleGalaxia: {
        "id": "project-create-form.ui.create-project-page-title-galaxia",
        "defaultMessage": "Add space details - Jira"
    },
    createProjectTextGalaxia: {
        "id": "project-create-form.ui.create-project-text-galaxia",
        "defaultMessage": "Create space"
    },
    createProjectDescriptionGalaxia: {
        "id": "project-create-form.ui.create-project-description-galaxia",
        "defaultMessage": "Explore what's possible when you collaborate with your team. Edit space details anytime in space settings."
    },
    createProjectFailureTitleNonFinalGalaxia: {
        "id": "project-create-common.common.flags.create-project-failure-title-galaxia",
        "defaultMessage": "Space not created"
    }
});

});

parcelRegister("6oJ4Y", function(module, exports) {

$parcel$export(module.exports, "OnboardingModalComponent", () => $161eac9b0cecdc3a$export$a405cd786ed4bace);

var $eJOHy = parcelRequire("eJOHy");

var $956it = parcelRequire("956it");

var $aC4Bh = parcelRequire("aC4Bh");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");

var $bafjm = parcelRequire("bafjm");
const $161eac9b0cecdc3a$export$a405cd786ed4bace = ({ children: children, targetProduct: targetProduct, sourceComponent: sourceComponent, ariaLabel: ariaLabel })=>{
    const { open: open } = (0, $bafjm.useOnboardingModalContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: sourceComponent,
        sourceType: (0, $466f60259c330878$export$1171103ea9083ffa),
        attributes: {
            targetProduct: targetProduct
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, open && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        width: "x-large",
        shouldScrollInViewport: true,
        testId: "cross-flow-onboarding-modal.common.ui.modal.modal",
        messageId: "cross-flow-onboarding-modal.common.ui.modal",
        messageType: "engagement",
        label: ariaLabel || 'Jira modal'
    }, children))));
};

});
parcelRegister("bafjm", function(module, exports) {

$parcel$export(module.exports, "OnboardingModalContextProvider", () => $64e6799e9eb16e09$export$a2507b5b283f9e5c);
$parcel$export(module.exports, "useOnboardingModalContext", () => $64e6799e9eb16e09$export$1d302ab3ce19a744);

var $eJOHy = parcelRequire("eJOHy");
const $64e6799e9eb16e09$var$OnboardingModalContext = /*#__PURE__*/ (0, $eJOHy.createContext)({
    open: false,
    targetProduct: undefined
});
const $64e6799e9eb16e09$export$a2507b5b283f9e5c = ({ children: children, targetProduct: targetProduct, open: open })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($64e6799e9eb16e09$var$OnboardingModalContext.Provider, {
        value: {
            open: open,
            targetProduct: targetProduct
        }
    }, children);
};
const $64e6799e9eb16e09$export$1d302ab3ce19a744 = ()=>(0, $eJOHy.useContext)($64e6799e9eb16e09$var$OnboardingModalContext);

});


parcelRegister("8nC53", function(module, exports) {

$parcel$export(module.exports, "OnboardingGrid", () => $e908d93e1b520080$export$573f4c9432d67c0b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $hYvlq = parcelRequire("hYvlq");

var $6qaBj = parcelRequire("6qaBj");

var $d8bgD = parcelRequire("d8bgD");

var $3JcKT = parcelRequire("3JcKT");

var $fJFO7 = parcelRequire("fJFO7");

var $8bs5A = parcelRequire("8bs5A");

var $5x8a7 = parcelRequire("5x8a7");
const $e908d93e1b520080$var$gridStyles = {
    grid: "_yv0ewxkt",
    root: "_4t3i1osq _c71l1osq _p12f1osq _1tkesby8 _kqswh2mm"
};
const $e908d93e1b520080$export$573f4c9432d67c0b = ({ children: children, enableCrossButton: enableCrossButton = true, onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $e908d93e1b520080$var$gridStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hYvlq.default), {
        xcss: (0, $6qaBj.cx)($e908d93e1b520080$var$gridStyles.grid)
    }, children), enableCrossButton && onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5x8a7.ExitButton), {
        onClose: onClose
    }));
};
$e908d93e1b520080$export$573f4c9432d67c0b.ContentSection = (0, $d8bgD.ContentLayoutSection);
$e908d93e1b520080$export$573f4c9432d67c0b.ImageSection = (0, $3JcKT.ImageLayoutSection);
$e908d93e1b520080$export$573f4c9432d67c0b.Controls = (0, $fJFO7.Controls);
$e908d93e1b520080$export$573f4c9432d67c0b.ControlItem = (0, $8bs5A.ControlItem);

});
parcelRegister("hYvlq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e062987a137d87a$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $3e062987a137d87a$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $3e062987a137d87a$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $3e062987a137d87a$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $3e062987a137d87a$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $3e062987a137d87a$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $3e062987a137d87a$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $3e062987a137d87a$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $3e062987a137d87a$var$Grid = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $hcewu.default)([
            $3e062987a137d87a$var$baseStyles.root,
            gap && $3e062987a137d87a$var$columnGapMap[gap],
            columnGap && $3e062987a137d87a$var$columnGapMap[columnGap],
            gap && $3e062987a137d87a$var$rowGapMap[gap],
            rowGap && $3e062987a137d87a$var$rowGapMap[rowGap],
            alignItems && $3e062987a137d87a$var$alignItemsMap[alignItems],
            alignContent && $3e062987a137d87a$var$alignContentMap[alignContent],
            justifyContent && $3e062987a137d87a$var$justifyContentMap[justifyContent],
            autoFlow && $3e062987a137d87a$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$3e062987a137d87a$var$Grid.displayName = 'Grid';
var $3e062987a137d87a$export$2e2bcd8739ae039 = $3e062987a137d87a$var$Grid;

});

parcelRegister("d8bgD", function(module, exports) {

$parcel$export(module.exports, "ContentLayoutSection", () => $26b0d983b80b37fb$export$ca7676c0cee802d9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $78OnL = parcelRequire("78OnL");

var $6qaBj = parcelRequire("6qaBj");
const $26b0d983b80b37fb$var$layoutSectionStyles = {
    box: "_ca0qoahv _u5f3oahv _n3tdoahv _19bvoahv"
};
const $26b0d983b80b37fb$export$ca7676c0cee802d9 = ({ children: children, space: space = 'space.300' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: space,
        xcss: (0, $6qaBj.cx)($26b0d983b80b37fb$var$layoutSectionStyles.box)
    }, children);
};

});

parcelRegister("3JcKT", function(module, exports) {

$parcel$export(module.exports, "ImageLayoutSection", () => $b6b772386d8598ef$export$e6817c6d4e29081d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $6qaBj = parcelRequire("6qaBj");

var $58yRG = parcelRequire("58yRG");
const $b6b772386d8598ef$var$layoutSectionStyles = {
    root: "_1bsb1osq _4t3i1osq _ca0qxncg _n3td1jfw _19bv1jfw"
};
const $b6b772386d8598ef$export$e6817c6d4e29081d = ({ children: children, backgroundDark: backgroundDark, backgroundLight: backgroundLight })=>{
    const { colorMode: colorMode } = (0, $58yRG.default)();
    const isDarkMode = colorMode === 'dark';
    const backgroundUrl = isDarkMode ? backgroundDark : backgroundLight;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: (0, $6qaBj.cx)($b6b772386d8598ef$var$layoutSectionStyles.root),
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            backgroundImage: `url(${backgroundUrl})`
        }
    }, children);
};

});

parcelRegister("fJFO7", function(module, exports) {

$parcel$export(module.exports, "Controls", () => $b1f250f7b47c616d$export$c7c44baae9d9f25f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $6djmC = parcelRequire("6djmC");
const $b1f250f7b47c616d$var$controlsStyles = {
    root: "_zulp1b66 _1bsb1osq"
};
const $b1f250f7b47c616d$export$c7c44baae9d9f25f = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        xcss: $b1f250f7b47c616d$var$controlsStyles.root,
        alignInline: "end"
    }, children);
};

});

parcelRegister("8bs5A", function(module, exports) {

$parcel$export(module.exports, "ControlItem", () => $a0d73d2b179c3250$export$a816714097e366bc);

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $gCeeo = parcelRequire("gCeeo");

var $lRq8t = parcelRequire("lRq8t");

var $jE6TE = parcelRequire("jE6TE");
const $a0d73d2b179c3250$var$controlItemMessageMap = {
    cancel: (0, $jE6TE.default).close,
    back: (0, $jE6TE.default).back,
    'get-started': (0, $jE6TE.default).getStarted
};
const $a0d73d2b179c3250$var$controlItemActionSubjectMap = {
    cancel: 'cancel',
    back: 'back',
    'get-started': 'getStarted'
};
const $a0d73d2b179c3250$export$a816714097e366bc = ({ onClick: onClick, variant: variant, disabled: disabled = false, ...props })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        onClick?.(e, analyticsEvent);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, $a0d73d2b179c3250$var$controlItemActionSubjectMap[variant]);
    }, [
        onClick,
        variant
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        interactionName: "onboarding-control",
        onClick: handleClick,
        isDisabled: disabled,
        ...props
    }, formatMessage($a0d73d2b179c3250$var$controlItemMessageMap[variant]));
};

});
parcelRegister("jE6TE", function(module, exports) {

$parcel$export(module.exports, "default", () => $514e406b84100546$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $514e406b84100546$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    close: {
        "id": "cross-flow-onboarding-modal.controls.close",
        "defaultMessage": "Close"
    },
    getStarted: {
        "id": "cross-flow-onboarding-modal.controls.get-started",
        "defaultMessage": "Get started"
    },
    back: {
        "id": "cross-flow-onboarding-modal.controls.back",
        "defaultMessage": "Back"
    }
});

});


parcelRegister("5x8a7", function(module, exports) {

$parcel$export(module.exports, "ExitButton", () => $7e24f468dfd2d13d$export$8487f31cf59eaa1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $gCeeo = parcelRequire("gCeeo");

var $lRq8t = parcelRequire("lRq8t");

var $5pUxH = parcelRequire("5pUxH");
const $7e24f468dfd2d13d$var$exitButtonStyles = {
    root: "_kqswstnw _154ipxbi _1xi2pxbi _1pbyb4wl"
};
const $7e24f468dfd2d13d$export$8487f31cf59eaa1 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleClose = (0, $eJOHy.useCallback)((_, analyticsEvent)=>{
        onClose();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'cross');
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $7e24f468dfd2d13d$var$exitButtonStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        label: formatMessage((0, $5pUxH.default).exit),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))),
        onClick: handleClose,
        appearance: "subtle"
    }));
};

});
parcelRegister("5pUxH", function(module, exports) {

$parcel$export(module.exports, "default", () => $643586c744218041$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $643586c744218041$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    exit: {
        "id": "project-directory-onboarding-modal.label.exit",
        "defaultMessage": "Exit"
    }
});

});



parcelRegister("dvOer", function(module, exports) {

$parcel$export(module.exports, "OnboardingContent", () => $7301b4f128627f51$export$6520ccc585a3e97);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $78OnL = parcelRequire("78OnL");

var $6qaBj = parcelRequire("6qaBj");

var $dckyV = parcelRequire("dckyV");
const $7301b4f128627f51$var$contentStyles = {
    modalContent: "_1tke1j89"
};
const $7301b4f128627f51$export$6520ccc585a3e97 = ({ children: children, space: space = 'space.300', inModal: inModal = true })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dckyV.Header), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        xcss: (0, $6qaBj.cx)(inModal && $7301b4f128627f51$var$contentStyles.modalContent),
        space: space
    }, children));
};

});
parcelRegister("dckyV", function(module, exports) {

$parcel$export(module.exports, "Header", () => $eb588669ec6511b4$export$8b251419efc915eb);

var $eJOHy = parcelRequire("eJOHy");

var $eLyKZ = parcelRequire("eLyKZ");
const $eb588669ec6511b4$export$8b251419efc915eb = (props)=>{
    const { Logo: Logo } = (0, $eLyKZ.useCommonContent)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Logo, {
        size: "small",
        appearance: "brand",
        shouldUseNewLogoDesign: true,
        ...props
    });
};

});
parcelRegister("eLyKZ", function(module, exports) {

$parcel$export(module.exports, "useCommonContent", () => $29d10569e1ddc48c$export$fae55c254b393ff0);

var $dNnxZ = parcelRequire("dNnxZ");

var $lgMTT = parcelRequire("lgMTT");

var $bafjm = parcelRequire("bafjm");
const $29d10569e1ddc48c$var$logoForTargetProduct = {
    [(0, $dNnxZ.Targets).JIRA_SERVICE_DESK]: (0, $lgMTT.JiraServiceManagementLogo),
    [(0, $dNnxZ.Targets).JIRA_PRODUCT_DISCOVERY]: (0, $lgMTT.JiraProductDiscoveryLogo),
    [(0, $dNnxZ.Targets).JIRA_SOFTWARE]: (0, $lgMTT.JiraLogo),
    [(0, $dNnxZ.Targets).CONFLUENCE]: (0, $lgMTT.ConfluenceLogo)
};
const $29d10569e1ddc48c$export$fae55c254b393ff0 = ()=>{
    const context = (0, $bafjm.useOnboardingModalContext)();
    if (!context) throw new Error('useCommonContent must be used within a OnboardingModalProvider');
    if (!context.targetProduct) throw new Error('Missing target product');
    return $29d10569e1ddc48c$export$54048a21efd7081f(context.targetProduct);
};
const $29d10569e1ddc48c$export$54048a21efd7081f = (targetProduct)=>{
    return {
        Logo: $29d10569e1ddc48c$var$logoForTargetProduct[targetProduct] || (0, $lgMTT.JiraLogo)
    };
};

});



parcelRegister("gWTGo", function(module, exports) {

$parcel$export(module.exports, "LegalNotice", () => $769d08a60689f662$export$d827c8b45da59336);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");

var $eJ9f5 = parcelRequire("eJ9f5");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");

var $kgyvt = parcelRequire("kgyvt");
const $769d08a60689f662$var$CUSTOMER_AGREEMENT_URL = 'https://www.atlassian.com/legal/atlassian-customer-agreement';
const $769d08a60689f662$var$PRIVACY_POLICY_URL = 'https://www.atlassian.com/legal/privacy-policy';
const $769d08a60689f662$export$44668d61e614423 = {
    tc: (...args)=>{
        const onClick = (e, analyticsEvent)=>{
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'customerAgreementUrl');
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: $769d08a60689f662$var$CUSTOMER_AGREEMENT_URL,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: onClick
        }, args);
    },
    pp: (...args)=>{
        const onClick = (e, analyticsEvent)=>{
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'privacyPolicyUrl');
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: $769d08a60689f662$var$PRIVACY_POLICY_URL,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: onClick
        }, args);
    }
};
const $769d08a60689f662$export$d827c8b45da59336 = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        color: "color.text.subtle",
        size: "small"
    }, formatMessage((0, $kgyvt.default).trialInfo, $769d08a60689f662$export$44668d61e614423));
};

});
parcelRegister("kgyvt", function(module, exports) {

$parcel$export(module.exports, "default", () => $622e7439998c124e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $622e7439998c124e$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    trialInfo: {
        "id": "project-directory-onboarding-modal.trial-info",
        "defaultMessage": "Free 30-day Premium plan trial. Cancel or downgrade anytime. By selecting \u201CGet started\u201D you agree to the <tc>Atlassian Customer Agreement</tc> and <pp>Privacy Policy</pp>."
    }
});

});


parcelRegister("aFb6y", function(module, exports) {
module.exports = new URL("background-light.e4dc0004.png", import.meta.url).toString();

});

parcelRegister("c5AdF", function(module, exports) {
module.exports = new URL("background-dark.41c2b84f.png", import.meta.url).toString();

});

parcelRegister("cPEMf", function(module, exports) {

$parcel$export(module.exports, "Features", () => $9c760627dd540395$export$617d79dae526d2cf);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $78OnL = parcelRequire("78OnL");

var $fJeLO = parcelRequire("fJeLO");
const $9c760627dd540395$var$featuresStyles = {
    root: "_zulpze3t _1bsb1osq _4cvr1y6m _2mzuglyw _19bvze3t _19pkze3t _18u0ze3t _ae4v1h6o"
};
const $9c760627dd540395$export$617d79dae526d2cf = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        as: "ul",
        xcss: $9c760627dd540395$var$featuresStyles.root
    }, children);
};
// Attach FeatureItem to Features
$9c760627dd540395$export$617d79dae526d2cf.Item = (0, $fJeLO.FeatureItem);

});
parcelRegister("fJeLO", function(module, exports) {

$parcel$export(module.exports, "FeatureItem", () => $56f8ac4cc1b67a72$export$989506d4e6ea852a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $46R8N = parcelRequire("46R8N");

var $6qaBj = parcelRequire("6qaBj");

var $gCeeo = parcelRequire("gCeeo");
const $56f8ac4cc1b67a72$var$featureItemStyles = {
    root: "_zulputpp _18zrpxbi _1rjcu2gc _1kl7j1ic _1e0c1txw _4cvr1h6o _80omtlke _1bsb1osq _irr3i1yw _1smf1yqz",
    box: "_1bsb1osq"
};
const $56f8ac4cc1b67a72$var$featureItemPressableStyles = {
    root: "_bfhk18uv"
};
const $56f8ac4cc1b67a72$var$featureItemActiveStyles = {
    root: "_syazaqb7 _bfhkfg4m _5wra1yqz"
};
const $56f8ac4cc1b67a72$export$989506d4e6ea852a = ({ children: children, isActive: isActive, onClick: onClick, index: index })=>{
    const handleClick = (0, $eJOHy.useCallback)((e, analyticsEvent)=>{
        onClick(e, analyticsEvent);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'featureItem', {
            index: index
        });
    }, [
        index,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        as: "li",
        xcss: (0, $6qaBj.cx)($56f8ac4cc1b67a72$var$featureItemStyles.box, isActive && $56f8ac4cc1b67a72$var$featureItemActiveStyles.root),
        "data-active": isActive,
        "aria-hidden": "false"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $46R8N.default), {
        "aria-pressed": isActive,
        onClick: handleClick,
        xcss: (0, $6qaBj.cx)($56f8ac4cc1b67a72$var$featureItemStyles.root, $56f8ac4cc1b67a72$var$featureItemPressableStyles.root)
    }, children));
};

});


parcelRegister("gChqa", function(module, exports) {

$parcel$export(module.exports, "TabContent", () => $95b0c0f59034be4b$export$9c591276dfd5d919);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $cpHe2 = parcelRequire("cpHe2");
var $41h42 = parcelRequire("41h42");
var $7oCv0 = parcelRequire("7oCv0");
var $2cSdF = parcelRequire("2cSdF");

var $6qaBj = parcelRequire("6qaBj");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $78OnL = parcelRequire("78OnL");

var $806LH = parcelRequire("806LH");

var $8wyVH = parcelRequire("8wyVH");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
const $95b0c0f59034be4b$var$panelStyles = {
    logo: "_2rkoiti9",
    dynamicTab: "_1reo15vq _18m915vq _bfhkvuon _4t3i1ber",
    modalBorderRadius: "_13li1y44 _mrkb1y44",
    title: "_19bv1ejb _ca0qxy5q",
    panel: "_2rkosqtm _11c84xcc _1pfhpxbi",
    panelNotRoadmap: "_19bv1ejb",
    tabsList: "_19bv1ejb",
    dynamicProjectName: "_1reo15vq _18m915vq _o5721q9c _1bto1l2s _1e0c5mfb _1kqm1n9t _1bsb1osq"
};
const $95b0c0f59034be4b$var$TabComponent = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $41h42.default), null, label);
const $95b0c0f59034be4b$export$9c591276dfd5d919 = ({ onChange: onChange, selected: selected, content: content, dynamicTemplateName: dynamicTemplateName, inModal: inModal = true })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleChange = (0, $eJOHy.useCallback)((index, analyticsEvent)=>{
        onChange(index);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'featureItem', {
            index: index
        });
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        xcss: (0, $6qaBj.cx)($95b0c0f59034be4b$var$panelStyles.dynamicTab, inModal && $95b0c0f59034be4b$var$panelStyles.modalBorderRadius),
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $95b0c0f59034be4b$var$panelStyles.title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8wyVH.default), {
        src: content.logo,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "medium"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        as: "span",
        xcss: (0, $6qaBj.cx)($95b0c0f59034be4b$var$panelStyles.dynamicProjectName)
    }, dynamicTemplateName ?? formatMessage(content.templateTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cpHe2.default), {
        onChange: handleChange,
        selected: selected,
        id: "onboarding-modal-tooltip-tabs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
        xcss: $95b0c0f59034be4b$var$panelStyles.tabsList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7oCv0.default), null, content.features.map((feature)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($95b0c0f59034be4b$var$TabComponent, {
            key: feature.title.id,
            label: formatMessage(feature.title)
        })))), content.features.map((feature)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2cSdF.default), {
            key: `${feature.title.id}-content`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
            xcss: (0, $6qaBj.cx)($95b0c0f59034be4b$var$panelStyles.panel, feature.title.defaultMessage !== 'Roadmap' && $95b0c0f59034be4b$var$panelStyles.panelNotRoadmap)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(feature.image, {
            alt: ""
        }))))));
};

});
parcelRegister("cpHe2", function(module, exports) {

$parcel$export(module.exports, "default", () => $03090e4bd6ee746b$export$2e2bcd8739ae039);
/* tabs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jrFnt = parcelRequire("jrFnt");

var $4OxCz = parcelRequire("4OxCz");
const $03090e4bd6ee746b$var$baseStyles = null;
const $03090e4bd6ee746b$var$tabsStyles = null;
const $03090e4bd6ee746b$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $03090e4bd6ee746b$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OxCz.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        children: tabPanel
    }, index); /**
                                * __Tabs__
                                *
                                * Tabs acts as a container for all Tab components.
                                *
                                * - [Examples](https://atlassian.design/components/tabs/examples)
                                * - [Code](https://atlassian.design/components/tabs/code)
                                * - [Usage](https://atlassian.design/components/tabs/usage)
                                */ 
const $03090e4bd6ee746b$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $eJOHy.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $eJOHy.Children).toArray(children) // Don't include any conditional children
    .filter((child)=>Boolean(child)); // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray; // Keep track of visited and add to a set
    const visited = (0, $eJOHy.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $eJOHy.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$03090e4bd6ee746b$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $03090e4bd6ee746b$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$03090e4bd6ee746b$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return /*#__PURE__*/ (0, $gt9Am.jsxs)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OxCz.TabListContext).Provider, {
                value: {
                    selected: selected,
                    onChange: onChangeAnalytics,
                    tabsId: id
                },
                children: tabList
            }),
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
                children: tabPanelsWithContext
            })
        ]
    });
};
var $03090e4bd6ee746b$export$2e2bcd8739ae039 = $03090e4bd6ee746b$var$Tabs;

});
parcelRegister("4OxCz", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $079a819a44225d4e$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $079a819a44225d4e$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $079a819a44225d4e$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $eJOHy = parcelRequire("eJOHy");
const $079a819a44225d4e$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $079a819a44225d4e$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $079a819a44225d4e$export$2054129d247c3102 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);

});


parcelRegister("41h42", function(module, exports) {

$parcel$export(module.exports, "default", () => $c693230e7a8a8f94$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $g6Dmv = parcelRequire("g6Dmv");
var $3cMgR = parcelRequire("3cMgR");

var $lcHWu = parcelRequire("lcHWu");
/**
 * __Tab__
 *
 * Tab represents an individual Tab displayed in a TabList.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $c693230e7a8a8f94$var$Tab = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function Tab({ children: children, testId: testId }, ref) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $lcHWu.useTab)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g6Dmv.default), {
        as: "div",
        isInset: true,
        testId: testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex,
        ref: ref,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
            weight: "medium",
            color: "inherit",
            maxLines: 1,
            children: children
        })
    }));
});
var $c693230e7a8a8f94$export$2e2bcd8739ae039 = $c693230e7a8a8f94$var$Tab;

});
parcelRegister("lcHWu", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $91221b4997543842$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $91221b4997543842$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $91221b4997543842$export$fae0121b5afe572d);

var $eJOHy = parcelRequire("eJOHy");

var $4OxCz = parcelRequire("4OxCz");
const $91221b4997543842$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $eJOHy.useContext)((0, $4OxCz.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $91221b4997543842$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $eJOHy.useContext)((0, $4OxCz.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $91221b4997543842$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $eJOHy.useContext)((0, $4OxCz.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("7oCv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b96e2c7b7779acd6$export$2e2bcd8739ae039);
/* tab-list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eGOwo = parcelRequire("eGOwo");

var $lcHWu = parcelRequire("lcHWu");

var $4OxCz = parcelRequire("4OxCz");
const $b96e2c7b7779acd6$var$baseStyles = null;
const $b96e2c7b7779acd6$var$tabListStyles = null;
const $b96e2c7b7779acd6$var$tabListStylesOld = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $b96e2c7b7779acd6$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $lcHWu.useTabList)();
    const ref = /*#__PURE__*/ (0, $eJOHy.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $eJOHy.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $eJOHy.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $eJOHy.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $eJOHy.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $4OxCz.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            children: tab
        }, index), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        role: "tablist",
        ref: ref,
        className: (0, $hcewu.default)([
            "_1e0c1txw _kqswh2mm _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $eGOwo.fg)('platform-component-visual-refresh') ? "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu8zxi _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d8zxi _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmz174y _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc" : "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _17hygqwt _1lzu1eqa _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1jakgqwt _1b8d1eqa _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _9r9ugqwt _rsmz1gcm _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _rfx3gqwt _1mp41kw7 _kfgt1bk5 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ]),
        children: childrenArray.map((child, index)=>getTabWithContext({
                tab: child,
                index: index,
                isSelected: index === selected
            }))
    });
};
var $b96e2c7b7779acd6$export$2e2bcd8739ae039 = $b96e2c7b7779acd6$var$TabList;

});

parcelRegister("2cSdF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9291670942049679$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $g6Dmv = parcelRequire("g6Dmv");

var $lcHWu = parcelRequire("lcHWu");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $9291670942049679$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $lcHWu.useTabPanel)();
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $g6Dmv.default), {
        as: "div",
        isInset: true,
        testId: testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Fragment), {
            children: children
        })
    });
};
var $9291670942049679$export$2e2bcd8739ae039 = $9291670942049679$var$TabPanel;

});


parcelRegister("3O3sz", function(module, exports) {

$parcel$export(module.exports, "getTemplateContentFromKey", () => $7e792ff5eae28ec8$export$66df4630b1453982);

var $gqEmK = parcelRequire("gqEmK");

var $Wdhjx = parcelRequire("Wdhjx");

var $cfSUy = parcelRequire("cfSUy");

var $daZe3 = parcelRequire("daZe3");

var $gLHTZ = parcelRequire("gLHTZ");

var $7mOKw = parcelRequire("7mOKw");

var $3NxXn = parcelRequire("3NxXn");

var $epTsa = parcelRequire("epTsa");

var $2Z1L2 = parcelRequire("2Z1L2");

var $loX5q = parcelRequire("loX5q");

var $iM36w = parcelRequire("iM36w");

var $2gRgh = parcelRequire("2gRgh");

var $jkFp3 = parcelRequire("jkFp3");
const $7e792ff5eae28ec8$export$5e3c3841bbdbd77f = {
    [(0, $daZe3.prioritizationProductDiscoveryProject).key]: {
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($2Z1L2))),
        templateTitle: (0, $jkFp3.default).projectTitlePrioritization,
        ariaLabel: (0, $jkFp3.default).ariaLabel,
        projectNameDefault: (0, $jkFp3.default).prioritizationProjectNameDefault,
        modalTitleDefault: (0, $jkFp3.default).modalTitleDefault,
        projectDescription: (0, $jkFp3.default).projectDescription,
        projectNameLabel: (0, $jkFp3.default).projectNameLabel,
        projectNamePlaceholder: (0, $jkFp3.default).projectNamePlaceholder,
        features: [
            {
                title: (0, $jkFp3.default).ideas,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfSUy))),
                description: (0, $jkFp3.default).logIdeas,
                image: (0, $2gRgh.ideasIllustration)
            },
            {
                title: (0, $jkFp3.default).roadmap,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($Wdhjx))),
                description: (0, $jkFp3.default).shareRoadmaps,
                image: (0, $2gRgh.roadmapIllustration)
            },
            {
                title: (0, $jkFp3.default).delivery,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($gqEmK))),
                description: (0, $jkFp3.default).connectToJira,
                image: (0, $2gRgh.deliveryIllustration)
            }
        ]
    },
    [(0, $gLHTZ.roadMapProductDiscoveryProject).key]: {
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($loX5q))),
        templateTitle: (0, $jkFp3.default).projectTitleProductRoadmap,
        ariaLabel: (0, $jkFp3.default).ariaLabel,
        projectNameDefault: (0, $jkFp3.default).roadmapProjectNameDefault,
        modalTitleDefault: (0, $jkFp3.default).modalTitleDefault,
        projectDescription: (0, $jkFp3.default).productRoadmapProjectDescription,
        projectNameLabel: (0, $jkFp3.default).projectNameLabel,
        projectNamePlaceholder: (0, $jkFp3.default).projectNamePlaceholder,
        features: [
            {
                title: (0, $jkFp3.default).roadmap,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($Wdhjx))),
                description: (0, $jkFp3.default).shareRoadmaps,
                image: (0, $2gRgh.roadmapIllustration)
            },
            {
                title: (0, $jkFp3.default).ideas,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfSUy))),
                description: (0, $jkFp3.default).logIdeas,
                image: (0, $2gRgh.ideasIllustration)
            },
            {
                title: (0, $jkFp3.default).delivery,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($gqEmK))),
                description: (0, $jkFp3.default).connectToJira,
                image: (0, $2gRgh.deliveryIllustration)
            }
        ]
    },
    [(0, $7mOKw.productDiscovery).key]: {
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($2Z1L2))),
        templateTitle: (0, $jkFp3.default).projectTitleProductDiscovery,
        ariaLabel: (0, $jkFp3.default).productDiscoveryAriaLabel,
        modalTitleDefault: (0, $jkFp3.default).modalTitleDefault,
        projectDescription: (0, $jkFp3.default).productDiscoveryProjectDescription,
        projectNameDefault: (0, $jkFp3.default).productDiscoveryProjectNameDefault,
        projectNameLabel: (0, $jkFp3.default).projectNameLabel,
        projectNamePlaceholder: (0, $jkFp3.default).projectNamePlaceholder,
        features: [
            {
                title: (0, $jkFp3.default).ideas,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfSUy))),
                description: (0, $jkFp3.default).logIdeas,
                image: (0, $2gRgh.ideasIllustration)
            },
            {
                title: (0, $jkFp3.default).roadmap,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($Wdhjx))),
                description: (0, $jkFp3.default).shareRoadmaps,
                image: (0, $2gRgh.roadmapIllustration)
            },
            {
                title: (0, $jkFp3.default).delivery,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($gqEmK))),
                description: (0, $jkFp3.default).connectToJira,
                image: (0, $2gRgh.deliveryIllustration)
            }
        ]
    },
    [(0, $3NxXn.portfolioManagementProductDiscoveryProject).key]: {
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($iM36w))),
        templateTitle: (0, $jkFp3.default).modalTitleDefault,
        ariaLabel: (0, $jkFp3.default).productDiscoveryAriaLabel,
        modalTitleDefault: (0, $jkFp3.default).modalTitleDefault,
        projectDescription: (0, $jkFp3.default).productDiscoveryProjectDescription,
        projectNameDefault: (0, $jkFp3.default).portfolioManagementProjectNameDefault,
        projectNameLabel: (0, $jkFp3.default).projectNameLabel,
        projectNamePlaceholder: (0, $jkFp3.default).projectNamePlaceholder,
        features: [
            {
                title: (0, $jkFp3.default).delivery,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($gqEmK))),
                description: (0, $jkFp3.default).connectToJira,
                image: (0, $2gRgh.deliveryIllustration)
            },
            {
                title: (0, $jkFp3.default).ideas,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfSUy))),
                description: (0, $jkFp3.default).logIdeas,
                image: (0, $2gRgh.ideasIllustration)
            },
            {
                title: (0, $jkFp3.default).roadmap,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($Wdhjx))),
                description: (0, $jkFp3.default).shareRoadmaps,
                image: (0, $2gRgh.roadmapIllustration)
            }
        ]
    }
};
const $7e792ff5eae28ec8$export$628702b6f3a5571a = {
    [(0, $daZe3.prioritizationProductDiscoveryProject).key]: {
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($2Z1L2))),
        templateTitle: (0, $jkFp3.default).projectTitlePrioritization,
        ariaLabel: (0, $jkFp3.default).ariaLabel,
        projectNameDefault: (0, $jkFp3.default).prioritizationProjectNameDefault,
        modalTitleDefault: (0, $jkFp3.default).modalTitleDefaultGalaxia,
        projectDescription: (0, $jkFp3.default).projectDescriptionGalaxia,
        projectNameLabel: (0, $jkFp3.default).projectNameLabelGalaxia,
        projectNamePlaceholder: (0, $jkFp3.default).projectNamePlaceholderGalaxia,
        features: [
            {
                title: (0, $jkFp3.default).ideas,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfSUy))),
                description: (0, $jkFp3.default).logIdeas,
                image: (0, $2gRgh.ideasIllustration)
            },
            {
                title: (0, $jkFp3.default).roadmap,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($Wdhjx))),
                description: (0, $jkFp3.default).shareRoadmaps,
                image: (0, $2gRgh.roadmapIllustration)
            },
            {
                title: (0, $jkFp3.default).delivery,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($gqEmK))),
                description: (0, $jkFp3.default).connectToJira,
                image: (0, $2gRgh.deliveryIllustration)
            }
        ]
    },
    [(0, $gLHTZ.roadMapProductDiscoveryProject).key]: {
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($loX5q))),
        templateTitle: (0, $jkFp3.default).projectTitleProductRoadmap,
        ariaLabel: (0, $jkFp3.default).ariaLabel,
        projectNameDefault: (0, $jkFp3.default).roadmapProjectNameDefault,
        modalTitleDefault: (0, $jkFp3.default).modalTitleDefaultGalaxia,
        projectDescription: (0, $jkFp3.default).onboardingTemplateProductRoadmapSpaceDescriptionGalaxia,
        projectNameLabel: (0, $jkFp3.default).projectNameLabelGalaxia,
        projectNamePlaceholder: (0, $jkFp3.default).projectNamePlaceholderGalaxia,
        features: [
            {
                title: (0, $jkFp3.default).roadmap,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($Wdhjx))),
                description: (0, $jkFp3.default).shareRoadmaps,
                image: (0, $2gRgh.roadmapIllustration)
            },
            {
                title: (0, $jkFp3.default).ideas,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfSUy))),
                description: (0, $jkFp3.default).logIdeas,
                image: (0, $2gRgh.ideasIllustration)
            },
            {
                title: (0, $jkFp3.default).delivery,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($gqEmK))),
                description: (0, $jkFp3.default).connectToJira,
                image: (0, $2gRgh.deliveryIllustration)
            }
        ]
    },
    [(0, $7mOKw.productDiscovery).key]: {
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($2Z1L2))),
        templateTitle: (0, $jkFp3.default).projectTitleProductDiscovery,
        ariaLabel: (0, $jkFp3.default).productDiscoveryAriaLabel,
        modalTitleDefault: (0, $jkFp3.default).modalTitleDefaultGalaxia,
        projectDescription: (0, $jkFp3.default).productDiscoveryProjectDescriptionGalaxia,
        projectNameDefault: (0, $jkFp3.default).productDiscoveryProjectNameDefault,
        projectNameLabel: (0, $jkFp3.default).projectNameLabelGalaxia,
        projectNamePlaceholder: (0, $jkFp3.default).projectNamePlaceholderGalaxia,
        features: [
            {
                title: (0, $jkFp3.default).ideas,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($cfSUy))),
                description: (0, $jkFp3.default).logIdeas,
                image: (0, $2gRgh.ideasIllustration)
            },
            {
                title: (0, $jkFp3.default).roadmap,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($Wdhjx))),
                description: (0, $jkFp3.default).shareRoadmaps,
                image: (0, $2gRgh.roadmapIllustration)
            },
            {
                title: (0, $jkFp3.default).delivery,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($gqEmK))),
                description: (0, $jkFp3.default).connectToJira,
                image: (0, $2gRgh.deliveryIllustration)
            }
        ]
    }
};
const $7e792ff5eae28ec8$export$66df4630b1453982 = (templateKey)=>{
    return (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? $7e792ff5eae28ec8$export$628702b6f3a5571a[templateKey] : $7e792ff5eae28ec8$export$5e3c3841bbdbd77f[templateKey];
};

});
parcelRegister("gLHTZ", function(module, exports) {

$parcel$export(module.exports, "TEMPLATE_KEY", () => $6612dc74ddc38354$export$34963d9cf9309358);
$parcel$export(module.exports, "roadMapProductDiscoveryProject", () => $6612dc74ddc38354$export$a7898172f590d33d);

var $eJOHy = parcelRequire("eJOHy");

var $epTsa = parcelRequire("epTsa");

var $hbF3h = parcelRequire("hbF3h");

var $crUL2 = parcelRequire("crUL2");

var $leHJ9 = parcelRequire("leHJ9");

var $cqYvc = parcelRequire("cqYvc");

var $364YC = parcelRequire("364YC");

var $6o17k = parcelRequire("6o17k");
const $6612dc74ddc38354$export$34963d9cf9309358 = 'jpd.product-roadmap';
const $6612dc74ddc38354$var$roadMapProductDiscoveryProjectWithIssueTerm = {
    key: $6612dc74ddc38354$export$34963d9cf9309358,
    overviewContent: {
        valueProps: [
            {
                title: (0, $6o17k.default).valueProp1Title,
                description: (0, $6o17k.default).valueProp1Description,
                imageUrl: '',
                imageComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $leHJ9.default), {
                        alt: ""
                    })
            },
            {
                title: (0, $6o17k.default).valueProp2Title,
                description: (0, $6o17k.default).valueProp2Description,
                imageUrl: '',
                imageComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $crUL2.default), {
                        alt: ""
                    })
            },
            {
                title: (0, $6o17k.default).valueProp3Title,
                description: (0, $6o17k.default).valueProp3DescriptionSpork,
                imageUrl: '',
                imageComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cqYvc.default), {
                        alt: ""
                    })
            }
        ],
        recommendedList: [
            (0, $6o17k.default).recommendedList1
        ],
        workType: 'Issue',
        issueTypes: [
            {
                key: 'idea',
                label: (0, $364YC.default).idea
            }
        ],
        workflow: [
            {
                label: (0, $364YC.default).parkingLot,
                appearance: 'default'
            },
            {
                label: (0, $364YC.default).discovery,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).readyForDelivery,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).delivery,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).impact,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).archived,
                appearance: 'success'
            }
        ]
    }
};
const $6612dc74ddc38354$var$roadMapProductDiscoveryProjectWitoutIssueTerm = {
    key: $6612dc74ddc38354$export$34963d9cf9309358,
    overviewContent: {
        valueProps: [
            {
                title: (0, $6o17k.default).valueProp1Title,
                description: (0, $6o17k.default).valueProp1Description,
                imageUrl: '',
                imageComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $leHJ9.default), {
                        alt: ""
                    })
            },
            {
                title: (0, $6o17k.default).valueProp2Title,
                description: (0, $6o17k.default).valueProp2Description,
                imageUrl: '',
                imageComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $crUL2.default), {
                        alt: ""
                    })
            },
            {
                title: (0, $6o17k.default).valueProp3Title,
                description: (0, $6o17k.default).valueProp3DescriptionSporkIssueTermRefresh,
                imageUrl: '',
                imageComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cqYvc.default), {
                        alt: ""
                    })
            }
        ],
        recommendedList: [
            (0, $6o17k.default).recommendedList1
        ],
        workType: 'Issue',
        issueTypes: [
            {
                key: 'idea',
                label: (0, $364YC.default).idea
            }
        ],
        workflow: [
            {
                label: (0, $364YC.default).parkingLot,
                appearance: 'default'
            },
            {
                label: (0, $364YC.default).discovery,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).readyForDelivery,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).delivery,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).impact,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).archived,
                appearance: 'success'
            }
        ]
    }
};
const $6612dc74ddc38354$var$getRoadMapProductDiscoveryProject = (0, $hbF3h.functionWithCondition)(()=>(0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false), ()=>$6612dc74ddc38354$var$roadMapProductDiscoveryProjectWitoutIssueTerm, ()=>$6612dc74ddc38354$var$roadMapProductDiscoveryProjectWithIssueTerm);
const $6612dc74ddc38354$export$a7898172f590d33d = $6612dc74ddc38354$var$getRoadMapProductDiscoveryProject();

});
parcelRegister("crUL2", function(module, exports) {

$parcel$export(module.exports, "default", () => $97a7b81e7780a313$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $7LYSb = parcelRequire("7LYSb");

var $68iw1 = parcelRequire("68iw1");
const $97a7b81e7780a313$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($68iw1)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($7LYSb))
});
var $97a7b81e7780a313$export$2e2bcd8739ae039 = $97a7b81e7780a313$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $97a7b81e7780a313$export$a179c88182cb9d56 = [
    0,
    0,
    100,
    80
];

});
parcelRegister("7LYSb", function(module, exports) {
module.exports = new URL("idea-engagement-darkmode.a19539a5.svg", import.meta.url).toString();

});

parcelRegister("68iw1", function(module, exports) {
module.exports = new URL("idea-engagement.c9b47ac0.svg", import.meta.url).toString();

});


parcelRegister("leHJ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9baab68e82399440$export$2e2bcd8739ae039);

var $c4huj = parcelRequire("c4huj");

var $2myct = parcelRequire("2myct");

var $4Gvvh = parcelRequire("4Gvvh");
const $9baab68e82399440$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4Gvvh)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2myct))
});
var $9baab68e82399440$export$2e2bcd8739ae039 = $9baab68e82399440$var$Illustration;
const $9baab68e82399440$export$a179c88182cb9d56 = [
    0,
    0,
    352,
    224
];

});
parcelRegister("2myct", function(module, exports) {
module.exports = new URL("new-roadmap-darkmode.9b5479d5.svg", import.meta.url).toString();

});

parcelRegister("4Gvvh", function(module, exports) {
module.exports = new URL("new-roadmap.76d9897f.svg", import.meta.url).toString();

});


parcelRegister("cqYvc", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd444982ede16970$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $g2uFK = parcelRequire("g2uFK");

var $gdlib = parcelRequire("gdlib");
const $fd444982ede16970$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($gdlib)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($g2uFK))
});
var $fd444982ede16970$export$2e2bcd8739ae039 = $fd444982ede16970$var$Illustration;
// for advanced use only
const $fd444982ede16970$export$a179c88182cb9d56 = [
    0,
    0,
    578,
    333
];

});
parcelRegister("g2uFK", function(module, exports) {
module.exports = new URL("progress-in-idea-darkmode.68052358.svg", import.meta.url).toString();

});

parcelRegister("gdlib", function(module, exports) {
module.exports = new URL("progress-in-idea.36378d24.svg", import.meta.url).toString();

});


parcelRegister("6o17k", function(module, exports) {

$parcel$export(module.exports, "default", () => $000569c9b390afde$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $000569c9b390afde$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    // Section 1
    valueProp1Title: {
        "id": "project-template-select-v2.utils.templates.product-discovery.product-roadmap.value-prop-1-title",
        "defaultMessage": "Easily share info with anyone"
    },
    valueProp1Description: {
        "id": "project-template-select-v2.utils.templates.product-discovery.product-roadmap.value-prop-1-description",
        "defaultMessage": "Create and share custom roadmaps with different stakeholders - even your customers."
    },
    // Section 2
    valueProp2Title: {
        "id": "project-template-select-v2.utils.templates.product-discovery.product-roadmap.value-prop-2-title",
        "defaultMessage": "Keep your team engaged"
    },
    valueProp2Description: {
        "id": "project-template-select-v2.utils.templates.product-discovery.product-roadmap.value-prop-2-description",
        "defaultMessage": "Get everyone involved in building your roadmap using comments, reactions, and votes."
    },
    // Section 3
    valueProp3Title: {
        "id": "project-template-select-v2.utils.templates.product-discovery.product-roadmap.value-prop-3-title",
        "defaultMessage": "See progress, without tool-switching"
    },
    valueProp3DescriptionSpork: {
        "id": "project-template-select-v2.utils.templates.product-discovery.product-roadmap.value-prop-3-description-spork",
        "defaultMessage": "Track progress to delivery by linking ideas to Jira issues for a seamless workflow."
    },
    recommendedList1: {
        "id": "project-template-select-v2.utils.templates.product-discovery.product-roadmap.recommended-list-1",
        "defaultMessage": "Teams that need to create and share roadmaps"
    },
    valueProp3DescriptionSporkIssueTermRefresh: {
        "id": "project-template-select-v2.utils.templates.product-discovery.product-roadmap.value-prop-3-description-spork-issue-term-refresh",
        "defaultMessage": "Track progress to delivery by linking ideas to Jira work items for a seamless workflow."
    }
});

});


parcelRegister("7mOKw", function(module, exports) {

$parcel$export(module.exports, "TEMPLATE_KEY", () => $3e6b1345cd0e7859$export$34963d9cf9309358);
$parcel$export(module.exports, "productDiscovery", () => $3e6b1345cd0e7859$export$e14f6a6f5de6b62e);

var $eJOHy = parcelRequire("eJOHy");

var $eg23M = parcelRequire("eg23M");

var $phrKk = parcelRequire("phrKk");

var $9XkQw = parcelRequire("9XkQw");

var $i9l19 = parcelRequire("i9l19");

var $364YC = parcelRequire("364YC");

var $4FAsU = parcelRequire("4FAsU");
const $3e6b1345cd0e7859$export$34963d9cf9309358 = 'jpd.product-discovery';
const $3e6b1345cd0e7859$export$e14f6a6f5de6b62e = {
    key: $3e6b1345cd0e7859$export$34963d9cf9309358,
    overviewContent: {
        valueProps: [
            {
                title: (0, $4FAsU.default).valueProp1Title,
                description: (0, $4FAsU.default).valueProp1Description,
                imageUrl: '',
                imageComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9XkQw.default), {
                        alt: ""
                    })
            },
            {
                title: (0, $4FAsU.default).valueProp2Title,
                description: (0, $4FAsU.default).valueProp2Description,
                imageUrl: '',
                imageComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i9l19.ResizedImageWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eg23M.default), {
                        alt: ""
                    }))
            },
            {
                title: (0, $4FAsU.default).valueProp3Title,
                description: (0, $4FAsU.default).valueProp3DescriptionSpork,
                imageUrl: '',
                imageComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $phrKk.default), {
                        alt: ""
                    })
            }
        ],
        recommendedList: [
            (0, $4FAsU.default).recommendedList1,
            (0, $4FAsU.default).recommendedList2
        ],
        workType: 'Issue',
        issueTypes: [
            {
                key: 'idea',
                label: (0, $364YC.default).idea
            }
        ],
        workflow: [
            {
                label: (0, $364YC.default).parkingLot,
                appearance: 'default'
            },
            {
                label: (0, $364YC.default).discovery,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).readyForDelivery,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).delivery,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).impact,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).archived,
                appearance: 'success'
            }
        ]
    }
};

});
parcelRegister("eg23M", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff0321afcb1833ec$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = frr9fm85q6prrfsvj5758qz
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/frr9fm85q6prrfsvj5758qz

var $c4huj = parcelRequire("c4huj");

var $141nS = parcelRequire("141nS");

var $gNSbf = parcelRequire("gNSbf");
const $ff0321afcb1833ec$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($gNSbf)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($141nS))
});
var $ff0321afcb1833ec$export$2e2bcd8739ae039 = $ff0321afcb1833ec$var$Illustration;
// for advanced use only
const $ff0321afcb1833ec$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    228
];

});
parcelRegister("141nS", function(module, exports) {
module.exports = new URL("blueprint-darkmode.3429d36a.svg", import.meta.url).toString();

});

parcelRegister("gNSbf", function(module, exports) {
module.exports = new URL("blueprint.422f9298.svg", import.meta.url).toString();

});


parcelRegister("phrKk", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f349aab8e6e63f3$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $G7T4G = parcelRequire("G7T4G");
const $2f349aab8e6e63f3$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($G7T4G)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($G7T4G)),
    autoDark: false
});
var $2f349aab8e6e63f3$export$2e2bcd8739ae039 = $2f349aab8e6e63f3$var$Illustration;
// for advanced use only
const $2f349aab8e6e63f3$export$a179c88182cb9d56 = [
    0,
    0,
    960,
    540
];

});
parcelRegister("G7T4G", function(module, exports) {
module.exports = new URL("ticket-bulb-chat.9690bd27.png", import.meta.url).toString();

});


parcelRegister("9XkQw", function(module, exports) {

$parcel$export(module.exports, "default", () => $14af42e4e5c0884f$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $c4huj = parcelRequire("c4huj");

var $lVMiZ = parcelRequire("lVMiZ");
const $14af42e4e5c0884f$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($lVMiZ)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($lVMiZ)),
    autoDark: false
});
var $14af42e4e5c0884f$export$2e2bcd8739ae039 = $14af42e4e5c0884f$var$Illustration;
// for advanced use only
const $14af42e4e5c0884f$export$a179c88182cb9d56 = [
    0,
    0,
    960,
    540
];

});
parcelRegister("lVMiZ", function(module, exports) {
module.exports = new URL("approved-file.3645ad0e.png", import.meta.url).toString();

});


parcelRegister("i9l19", function(module, exports) {

$parcel$export(module.exports, "ResizedImageWrapper", () => $3bac46ce3da6ca5e$export$78834bb028bd9979);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $3bac46ce3da6ca5e$export$78834bb028bd9979 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3bac46ce3da6ca5e$var$image2ResizeStyles
    }, children);
const $3bac46ce3da6ca5e$var$image2ResizeStyles = (0, $1DXK0.xcss)({
    width: '50%',
    margin: 'auto'
});

});

parcelRegister("4FAsU", function(module, exports) {

$parcel$export(module.exports, "default", () => $37760eccda08cbae$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $37760eccda08cbae$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    // Section 1
    valueProp1Title: {
        "id": "project-template-select-v2.utils.templates.product-discovery.product-discovery.value-prop-1-title",
        "defaultMessage": "Capture and prioritize"
    },
    valueProp1Description: {
        "id": "project-template-select-v2.utils.templates.product-discovery.product-discovery.value-prop-1-description",
        "defaultMessage": "Gather and organize product ideas and customer insights from across the business in one place instead of disparate tools. Use criteria to make decisions and prioritize ideas based on customer and business impact."
    },
    // Section 2
    valueProp2Title: {
        "id": "project-template-select-v2.utils.templates.product-discovery.product-discovery.value-prop-2-title",
        "defaultMessage": "Engage"
    },
    valueProp2Description: {
        "id": "project-template-select-v2.utils.templates.product-discovery.product-discovery.value-prop-2-description",
        "defaultMessage": "Spend less time persuading and updating by inviting key teams to contribute to insights and outcomes. Keep stakeholders and leadership informed and aligned on your product strategy with custom roadmaps."
    },
    // Section 3
    valueProp3Title: {
        "id": "project-template-select-v2.utils.templates.product-discovery.product-discovery.value-prop-3-title",
        "defaultMessage": "Connect"
    },
    valueProp3DescriptionSpork: {
        "id": "project-template-select-v2.utils.templates.product-discovery.product-discovery.value-prop-3-description-spork",
        "defaultMessage": "Bridge the gap between business and tech teams by connecting your product ideas, with context, to the delivery work happening in Jira - the tool your developers already know and trust."
    },
    recommendedList1: {
        "id": "project-template-select-v2.utils.templates.product-discovery.product-discovery.recommended-list-1",
        "defaultMessage": "Product managers"
    },
    recommendedList2: {
        "id": "project-template-select-v2.utils.templates.product-discovery.product-discovery.recommended-list-2",
        "defaultMessage": "Product teams"
    }
});

});


parcelRegister("3NxXn", function(module, exports) {

$parcel$export(module.exports, "portfolioManagementProductDiscoveryProject", () => $385a6ad36dc0e52c$export$4a9109da79bcc3c);
// GALILEO-4584 START

var $eJOHy = parcelRequire("eJOHy");

var $d32TR = parcelRequire("d32TR");

var $5wHJ7 = parcelRequire("5wHJ7");

var $3s5Gm = parcelRequire("3s5Gm");

var $364YC = parcelRequire("364YC");

var $eheya = parcelRequire("eheya");
const $385a6ad36dc0e52c$export$34963d9cf9309358 = 'jpd.portfolio-management';
const $385a6ad36dc0e52c$export$4a9109da79bcc3c = {
    key: $385a6ad36dc0e52c$export$34963d9cf9309358,
    overviewContent: {
        valueProps: [
            {
                title: (0, $eheya.default).valueProp1Title,
                description: (0, $eheya.default).valueProp1Description,
                imageComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5wHJ7.default), {
                        alt: ""
                    }),
                imageUrl: ''
            },
            {
                title: (0, $eheya.default).valueProp2Title,
                description: (0, $eheya.default).valueProp2Description,
                imageUrl: '',
                imageComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3s5Gm.default), {
                        alt: ""
                    })
            },
            {
                title: (0, $eheya.default).valueProp3Title,
                description: (0, $eheya.default).valueProp3Description,
                imageUrl: '',
                imageComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d32TR.default), {
                        alt: ""
                    })
            }
        ],
        recommendedList: [
            (0, $eheya.default).recommendedList1
        ],
        workType: 'Issue',
        issueTypes: [
            {
                key: 'idea',
                label: (0, $364YC.default).idea
            }
        ],
        workflow: [
            {
                label: (0, $364YC.default).parkingLot,
                appearance: 'default'
            },
            {
                label: (0, $364YC.default).discovery,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).readyForDelivery,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).delivery,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).impact,
                appearance: 'inprogress'
            },
            {
                label: (0, $364YC.default).archived,
                appearance: 'success'
            }
        ]
    }
}; // GALILEO-4584 END

});
parcelRegister("d32TR", function(module, exports) {

$parcel$export(module.exports, "default", () => $deef131d14e26d41$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md
// GALILEO-4584 START

var $c4huj = parcelRequire("c4huj");

var $gvyhF = parcelRequire("gvyhF");

var $44Oif = parcelRequire("44Oif");
const $deef131d14e26d41$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($44Oif)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($gvyhF)),
    autoDark: false
});
var $deef131d14e26d41$export$2e2bcd8739ae039 = $deef131d14e26d41$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $deef131d14e26d41$export$a179c88182cb9d56 = [
    0,
    0,
    294,
    224
];
 // GALILEO-4584 END

});
parcelRegister("gvyhF", function(module, exports) {
module.exports = new URL("jpd-portfolio-management-communicate-progress-dark.d0c6d635.svg", import.meta.url).toString();

});

parcelRegister("44Oif", function(module, exports) {
module.exports = new URL("jpd-portfolio-management-communicate-progress.cf4ff262.svg", import.meta.url).toString();

});


parcelRegister("5wHJ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $68008744be5d719c$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md
// GALILEO-4584 START

var $c4huj = parcelRequire("c4huj");

var $39Fbb = parcelRequire("39Fbb");

var $9Fczn = parcelRequire("9Fczn");
const $68008744be5d719c$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($9Fczn)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($39Fbb)),
    autoDark: false
});
var $68008744be5d719c$export$2e2bcd8739ae039 = $68008744be5d719c$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $68008744be5d719c$export$a179c88182cb9d56 = [
    0,
    0,
    294,
    224
];
 // GALILEO-4584 END

});
parcelRegister("39Fbb", function(module, exports) {
module.exports = new URL("jpd-portfolio-management-intake-dark.9e658e8b.svg", import.meta.url).toString();

});

parcelRegister("9Fczn", function(module, exports) {
module.exports = new URL("jpd-portfolio-management-intake.e5d5c157.svg", import.meta.url).toString();

});


parcelRegister("3s5Gm", function(module, exports) {

$parcel$export(module.exports, "default", () => $8706fb712d027aed$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md
// GALILEO-4584 START

var $c4huj = parcelRequire("c4huj");

var $7X9Tw = parcelRequire("7X9Tw");

var $hicJZ = parcelRequire("hicJZ");
const $8706fb712d027aed$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($hicJZ)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($7X9Tw)),
    autoDark: false
});
var $8706fb712d027aed$export$2e2bcd8739ae039 = $8706fb712d027aed$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $8706fb712d027aed$export$a179c88182cb9d56 = [
    0,
    0,
    294,
    224
];
 // GALILEO-4584 END

});
parcelRegister("7X9Tw", function(module, exports) {
module.exports = new URL("jpd-portfolio-management-capacity-planning-dark.2f63f151.svg", import.meta.url).toString();

});

parcelRegister("hicJZ", function(module, exports) {
module.exports = new URL("jpd-portfolio-management-capacity-planning.31658e30.svg", import.meta.url).toString();

});


parcelRegister("eheya", function(module, exports) {

$parcel$export(module.exports, "default", () => $2252d9fb5b1e9af3$export$2e2bcd8739ae039);
// GALILEO-4584 START

var $7qGN1 = parcelRequire("7qGN1");
var $2252d9fb5b1e9af3$export$2e2bcd8739ae039 // GALILEO-4584 END
 = (0, $7qGN1.defineMessages)({
    // Section 1
    valueProp1Title: {
        "id": "project-template-select-v2.utils.templates.product-discovery.portfolio-management.value-prop-1-title",
        "defaultMessage": "Portfolio intake"
    },
    valueProp1Description: {
        "id": "project-template-select-v2.utils.templates.product-discovery.portfolio-management.value-prop-1-description",
        "defaultMessage": "Centralize project intake and prioritize based on goal alignment and business impact."
    },
    // Section 2
    valueProp2Title: {
        "id": "project-template-select-v2.utils.templates.product-discovery.portfolio-management.value-prop-2-title",
        "defaultMessage": "Lightweight capacity planning"
    },
    valueProp2Description: {
        "id": "project-template-select-v2.utils.templates.product-discovery.portfolio-management.value-prop-2-description",
        "defaultMessage": "Use high-level capacity planning to start discussions on how to allocate teams across programs."
    },
    // Section 3
    valueProp3Title: {
        "id": "project-template-select-v2.utils.templates.product-discovery.portfolio-management.value-prop-3-title",
        "defaultMessage": "Communicate progress"
    },
    valueProp3Description: {
        "id": "project-template-select-v2.utils.templates.product-discovery.portfolio-management.value-prop-3-description",
        "defaultMessage": "Share a single view with your portfolio's latest priorities and progress."
    },
    recommendedList1: {
        "id": "project-template-select-v2.utils.templates.product-discovery.portfolio-management.recommended-list-1",
        "defaultMessage": "Prioritizing projects and programs across teams."
    },
    recommendedList2: {
        "id": "project-template-select-v2.utils.templates.product-discovery.portfolio-management.recommended-list-2",
        "defaultMessage": "Product teams"
    }
});

});


parcelRegister("2Z1L2", function(module, exports) {
module.exports = new URL("light-bulb.ae4a67fb.svg", import.meta.url).toString();

});

parcelRegister("loX5q", function(module, exports) {
module.exports = new URL("compass.9f623f39.svg", import.meta.url).toString();

});

parcelRegister("iM36w", function(module, exports) {
module.exports = new URL("portfolio.68edeb1a.svg", import.meta.url).toString();

});

parcelRegister("2gRgh", function(module, exports) {

$parcel$export(module.exports, "ideasIllustration", () => $ac4f54eb29eb88b4$export$5a69d049af50280a);
$parcel$export(module.exports, "roadmapIllustration", () => $ac4f54eb29eb88b4$export$d6870d9a08935cb8);
$parcel$export(module.exports, "deliveryIllustration", () => $ac4f54eb29eb88b4$export$c6397cfd57cdb375);

var $c4huj = parcelRequire("c4huj");

var $IKiyB = parcelRequire("IKiyB");

var $cW8IU = parcelRequire("cW8IU");

var $fpRir = parcelRequire("fpRir");

var $1gn6S = parcelRequire("1gn6S");

var $4aw62 = parcelRequire("4aw62");

var $fnZRM = parcelRequire("fnZRM");
const $ac4f54eb29eb88b4$export$5a69d049af50280a = (0, $c4huj.createIllustration)({
    srcLight: (0, (/*@__PURE__*/$parcel$interopDefault($IKiyB))),
    srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($cW8IU)))
});
const $ac4f54eb29eb88b4$export$d6870d9a08935cb8 = (0, $c4huj.createIllustration)({
    srcLight: (0, (/*@__PURE__*/$parcel$interopDefault($fpRir))),
    srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($1gn6S)))
});
const $ac4f54eb29eb88b4$export$c6397cfd57cdb375 = (0, $c4huj.createIllustration)({
    srcLight: (0, (/*@__PURE__*/$parcel$interopDefault($4aw62))),
    srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($fnZRM)))
});

});
parcelRegister("IKiyB", function(module, exports) {
module.exports = new URL("ideas-light.5df5366a.svg", import.meta.url).toString();

});

parcelRegister("cW8IU", function(module, exports) {
module.exports = new URL("ideas-dark.706e5473.svg", import.meta.url).toString();

});

parcelRegister("fpRir", function(module, exports) {
module.exports = new URL("roadmap-light.7a029252.svg", import.meta.url).toString();

});

parcelRegister("1gn6S", function(module, exports) {
module.exports = new URL("roadmap-dark.94c33e4a.svg", import.meta.url).toString();

});

parcelRegister("4aw62", function(module, exports) {
module.exports = new URL("delivery-light.3a73ce5e.svg", import.meta.url).toString();

});

parcelRegister("fnZRM", function(module, exports) {
module.exports = new URL("delivery-dark.cece1e61.svg", import.meta.url).toString();

});


parcelRegister("jkFp3", function(module, exports) {

$parcel$export(module.exports, "default", () => $69895dbc2bce269c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $69895dbc2bce269c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    ariaLabel: {
        "id": "jpd-project-template-onboarding-modal.aria-label",
        "defaultMessage": "Jira Product Discovery onboarding modal"
    },
    projectNameDefault: {
        "id": "jpd-project-template-onboarding-modal.project-name",
        "defaultMessage": "Product discovery"
    },
    projectNameLabel: {
        "id": "jpd-project-template-onboarding-modal.project-name-label",
        "defaultMessage": "Project name"
    },
    projectNameLabelGalaxia: {
        "id": "jpd-project-template-onboarding-modal.project-name-label-galaxia",
        "defaultMessage": "Space name"
    },
    projectNamePlaceholder: {
        "id": "jpd-project-template-onboarding-modal.project-name-placeholder",
        "defaultMessage": "Enter your project name here"
    },
    projectNamePlaceholderGalaxia: {
        "id": "jpd-project-template-onboarding-modal.project-name-placeholder-galaxia",
        "defaultMessage": "Enter your space name here"
    },
    projectDescription: {
        "id": "jpd-project-template-onboarding-modal.project-description",
        "defaultMessage": "Your first discovery project is ready to kick off. Use it to evaluate and compare ideas."
    },
    projectDescriptionGalaxia: {
        "id": "jpd-project-template-onboarding-modal.project-description-galaxia",
        "defaultMessage": "Your first discovery space is ready to kick off. Use it to evaluate and compare ideas."
    },
    projectTitleProductRoadmap: {
        "id": "cross-flow-onboarding-modal.project-title.product-roadmap",
        "defaultMessage": "Product roadmap"
    },
    projectTitlePrioritization: {
        "id": "cross-flow-onboarding-modal.project-title.prioritizatino",
        "defaultMessage": "Prioritization"
    },
    logIdeas: {
        "id": "cross-flow-onboarding-modal.jpd.feature.log-ideas",
        "defaultMessage": "Log ideas and use insights to prioritize them"
    },
    shareRoadmaps: {
        "id": "cross-flow-onboarding-modal.jpd.share-roadmaps",
        "defaultMessage": "Share custom roadmaps with anyone"
    },
    connectToJira: {
        "id": "cross-flow-onboarding-modal.jpd.connect-to-jira",
        "defaultMessage": "Easily connect ideas into Jira for delivery"
    },
    ideas: {
        "id": "cross-flow-onboarding-modal.jpd-feature-ideas-title",
        "defaultMessage": "Ideas"
    },
    roadmap: {
        "id": "cross-flow-onboarding-modal.jpd-feature-share-roadmap-title",
        "defaultMessage": "Roadmap"
    },
    delivery: {
        "id": "cross-flow-onboarding-modal.jpd-feature-delivery-title",
        "defaultMessage": "Delivery"
    },
    roadmapProjectNameDefault: {
        "id": "cross-flow-onboarding-modal.project-name-default",
        "defaultMessage": "Product roadmap"
    },
    prioritizationProjectNameDefault: {
        "id": "cross-flow-onboarding-modal.prioritization-project-name-default",
        "defaultMessage": "Prioritization"
    },
    modalTitleDefault: {
        "id": "cross-flow-onboarding-modal.onboarding-template-title-default",
        "defaultMessage": "Name your project"
    },
    modalTitleDefaultGalaxia: {
        "id": "cross-flow-onboarding-modal.onboarding-template-title-default-galaxia",
        "defaultMessage": "Name your space"
    },
    onboardingSpaceTemplateTitleDefaultGalaxia: {
        "id": "cross-flow-onboarding-modal.onboarding-space-template-title-default-galaxia",
        "defaultMessage": "Name your space"
    },
    productRoadmapProjectDescription: {
        "id": "cross-flow-onboarding-modal.onboarding-template-product-roadmap-project-description",
        "defaultMessage": "Your first discovery project is ready to kick off. Use it to align your team with product roadmaps."
    },
    onboardingTemplateProductRoadmapProjectDescription: {
        "id": "cross-flow-onboarding-modal.onboarding-template-product-roadmap-project-description",
        "defaultMessage": "Your first discovery project is ready to kick off. Use it to align your team with product roadmaps."
    },
    productRoadmapProjectDescriptionGalaxia: {
        "id": "cross-flow-onboarding-modal.onboarding-template-product-roadmap-project-description-galaxia",
        "defaultMessage": "Your first discovery space is ready to kick off. Use it to align your team with product roadmaps."
    },
    onboardingTemplateProductRoadmapSpaceDescriptionGalaxia: {
        "id": "cross-flow-onboarding-modal.onboarding-template-product-roadmap-space-description-galaxia",
        "defaultMessage": "Your first discovery space is ready to kick off. Use it to align your team with product roadmaps."
    },
    projectTitleProductDiscovery: {
        "id": "cross-flow-onboarding-modal.project-title.product-discovery",
        "defaultMessage": "Product discovery"
    },
    productDiscoveryProjectNameDefault: {
        "id": "cross-flow-onboarding-modal.product-discovery-project-name-default",
        "defaultMessage": "Product discovery"
    },
    productDiscoveryProjectDescription: {
        "id": "cross-flow-onboarding-modal.onboarding-template-product-discovery-project-description",
        "defaultMessage": "Your first discovery project is ready to kick off. Use it to evaluate and compare ideas."
    },
    productDiscoveryProjectDescriptionGalaxia: {
        "id": "cross-flow-onboarding-modal.onboarding-template-product-discovery-project-description-galaxia",
        "defaultMessage": "Your first discovery space is ready to kick off. Use it to evaluate and compare ideas."
    },
    productDiscoveryAriaLabel: {
        "id": "cross-flow-onboarding-modal.onboarding-template-product-discovery-aria-label",
        "defaultMessage": "Jira Product Discovery onboarding modal"
    },
    portfolioManagementAriaLabel: {
        "id": "cross-flow-onboarding-modal.onboarding-template-portfolio-management-aria-label",
        "defaultMessage": "Jira Product Discovery Portfolio Management template onboarding modal"
    },
    portfolioManagementProjectNameDefault: {
        "id": "cross-flow-onboarding-modal.portfolio-management-project-name-default",
        "defaultMessage": "Portfolio"
    }
});

});


parcelRegister("dKytp", function(module, exports) {

$parcel$export(module.exports, "useSubmitProjectCreate", () => $89d8789e94c773a8$export$270f71e0c5fbace6);

var $eJOHy = parcelRequire("eJOHy");

var $fTwuq = parcelRequire("fTwuq");

var $cHsVl = parcelRequire("cHsVl");

var $gYnSx = parcelRequire("gYnSx");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $88KzK = parcelRequire("88KzK");
const $89d8789e94c773a8$export$270f71e0c5fbace6 = (onSuccess, onFail)=>{
    const [createProject, isLoading, hasError] = (0, $fTwuq.useCreateProject)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const submitProjectCreate = (0, $eJOHy.useCallback)(async (body)=>{
        try {
            const validName = await (0, $88KzK.getValidProjectName)(body.payload.name);
            const result = await createProject({
                ...body,
                payload: {
                    ...body.payload,
                    name: validName
                }
            });
            (0, $gCeeo.fireTrackAnalytics)(createAnalyticsEvent({}), 'submitProjectCreate success');
            if (result !== undefined) onSuccess(result);
            return result;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gYnSx.default)({
                meta: {
                    id: `${(0, $cHsVl.PROJECT_CREATE_APP_NAME)}.use-create-project-with-shared-config.error`,
                    packageName: (0, $cHsVl.PACKAGE_NAME),
                    teamName: (0, $cHsVl.TEAM_NAME)
                },
                error: error
            });
            onFail(error);
        }
    }, [
        createAnalyticsEvent,
        createProject,
        onFail,
        onSuccess
    ]);
    return [
        submitProjectCreate,
        isLoading,
        hasError
    ];
};

});
parcelRegister("fTwuq", function(module, exports) {

$parcel$export(module.exports, "post", () => $ae186494a9a8dfc9$export$299ba2dee77727e9);
$parcel$export(module.exports, "useCreateProject", () => $ae186494a9a8dfc9$export$4ad6f12a4acf1a5d);

var $eJOHy = parcelRequire("eJOHy");

var $gYnSx = parcelRequire("gYnSx");

var $jGzN3 = parcelRequire("jGzN3");

var $cHsVl = parcelRequire("cHsVl");
const $ae186494a9a8dfc9$export$a5b7a8c3b1c6e775 = ()=>'/rest/simplified/latest/project';
const $ae186494a9a8dfc9$export$299ba2dee77727e9 = (payload)=>{
    const url = $ae186494a9a8dfc9$export$a5b7a8c3b1c6e775();
    const options = {
        body: JSON.stringify(payload)
    };
    return (0, $jGzN3.performPostRequest)(url, options);
};
const $ae186494a9a8dfc9$export$4ad6f12a4acf1a5d = ()=>{
    const [isLoading, setIsLoading] = (0, $eJOHy.useState)(false);
    const [hasError, setHasError] = (0, $eJOHy.useState)(false);
    const createProject = (0, $eJOHy.useCallback)(async ({ payload: payload })=>{
        setIsLoading(true);
        try {
            const result = await $ae186494a9a8dfc9$export$299ba2dee77727e9(payload);
            setIsLoading(false);
            return result;
        } catch (error) {
            setHasError(true);
            setIsLoading(false);
            if (error instanceof Error) (0, $gYnSx.default)({
                meta: {
                    id: `${(0, $cHsVl.PROJECT_CREATE_APP_NAME)}.use-create-project.error`,
                    packageName: (0, $cHsVl.PACKAGE_NAME),
                    teamName: (0, $cHsVl.TEAM_NAME)
                },
                error: error
            });
            throw error;
        }
    }, []);
    return [
        createProject,
        isLoading,
        hasError
    ];
};

});
parcelRegister("cHsVl", function(module, exports) {

$parcel$export(module.exports, "CATEGORY_OVERVIEW_SCREEN", () => $75bb99b40f958626$export$f0eabcea9f9bfa58);
$parcel$export(module.exports, "PROJECT_TYPE_SCREEN", () => $75bb99b40f958626$export$ddc53eae99d06417);
$parcel$export(module.exports, "AGILITY_SCRUM", () => $75bb99b40f958626$export$419614a75e3c8c96);
$parcel$export(module.exports, "AGILITY_KANBAN", () => $75bb99b40f958626$export$65a1f1d90570ca24);
$parcel$export(module.exports, "CLASSIC_KANBAN", () => $75bb99b40f958626$export$5440382b762f7979);
$parcel$export(module.exports, "CLASSIC_SCRUM", () => $75bb99b40f958626$export$3548d21fa371324);
$parcel$export(module.exports, "PROJECT_SHARED_CONFIG_NAME", () => $75bb99b40f958626$export$5b1e7155f957f879);
$parcel$export(module.exports, "PROJECT_SHARED_CONFIG_NAME_GALAXIA", () => $75bb99b40f958626$export$90901e21085702d6);
$parcel$export(module.exports, "PROJECT_SHARED_CONFIG_DESCRIPTION", () => $75bb99b40f958626$export$2340e239460b4b15);
$parcel$export(module.exports, "PROJECT_SHARED_CONFIG_DESCRIPTION_GALAXIA", () => $75bb99b40f958626$export$6be64f0aa7cdeb0a);
$parcel$export(module.exports, "BACK_TO_PROJECT_TYPES", () => $75bb99b40f958626$export$9be72cd0551f5635);
$parcel$export(module.exports, "BACK_TO_PROJECT_TEMPLATES", () => $75bb99b40f958626$export$bd0b65a432910549);
$parcel$export(module.exports, "CHANGE_TEMPLATE", () => $75bb99b40f958626$export$8846f056194ea535);
$parcel$export(module.exports, "CHANGE_PROJECT_TYPE", () => $75bb99b40f958626$export$d12aafb7071e830e);
$parcel$export(module.exports, "VIEW_TEMPLATE_OVERVIEW", () => $75bb99b40f958626$export$9ed04c8d3ebcadc8);
$parcel$export(module.exports, "CREATE_PROJECT_SOURCE_NAME", () => $75bb99b40f958626$export$6c31fc7edf30602b);
$parcel$export(module.exports, "TEAM_NAME", () => $75bb99b40f958626$export$d57b6b390e78d90f);
$parcel$export(module.exports, "PROJECT_CREATE_APP_NAME", () => $75bb99b40f958626$export$8f0c4426531e762);
$parcel$export(module.exports, "PACKAGE_NAME", () => $75bb99b40f958626$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", () => $75bb99b40f958626$export$57d877f2e01e0029);
$parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", () => $75bb99b40f958626$export$6f4213a3addc3fdb);
const $75bb99b40f958626$export$f0eabcea9f9bfa58 = 'projectCategoryOverviewScreen';
const $75bb99b40f958626$export$adc6c29a8a3f89a3 = 'projectTemplateOverviewScreen';
const $75bb99b40f958626$export$ddc53eae99d06417 = 'projectTypeScreen';
const $75bb99b40f958626$export$680408b6d6c59caf = 'importScreen';
const $75bb99b40f958626$export$9d2a55db48f4ec86 = {
    presetBundlesScreen: 'presetBundlesScreen',
    customizeBundlesScreen: 'customizeTemplateBundlesScreen',
    bundleCreationLoadingScreen: 'bundleCreationLoadingScreen'
};
const $75bb99b40f958626$export$419614a75e3c8c96 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
const $75bb99b40f958626$export$65a1f1d90570ca24 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
const $75bb99b40f958626$export$5440382b762f7979 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
const $75bb99b40f958626$export$3548d21fa371324 = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
const $75bb99b40f958626$export$5b1e7155f957f879 = 'PROJECT_SHARED_CONFIG_NAME';
const $75bb99b40f958626$export$90901e21085702d6 = 'PROJECT_SHARED_CONFIG_NAME_GALAXIA';
const $75bb99b40f958626$export$2340e239460b4b15 = 'PROJECT_SHARED_CONFIG_DESCRIPTION';
const $75bb99b40f958626$export$6be64f0aa7cdeb0a = 'PROJECT_SHARED_CONFIG_DESCRIPTION_GALAXIA';
const $75bb99b40f958626$export$9be72cd0551f5635 = 'backToProjectTypes';
const $75bb99b40f958626$export$bd0b65a432910549 = 'backToProjectTemplates';
const $75bb99b40f958626$export$8846f056194ea535 = 'changeTemplate';
const $75bb99b40f958626$export$d12aafb7071e830e = 'changeProjectType';
const $75bb99b40f958626$export$9ed04c8d3ebcadc8 = 'viewTemplateOverview';
const $75bb99b40f958626$export$6c31fc7edf30602b = 'createProject';
const $75bb99b40f958626$export$d57b6b390e78d90f = 'helix';
const $75bb99b40f958626$export$8f0c4426531e762 = 'project-create';
const $75bb99b40f958626$export$b8b9d90f9e5bd72b = 'jiraProjectCreateCommon';
const $75bb99b40f958626$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
const $75bb99b40f958626$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';

});


parcelRegister("88KzK", function(module, exports) {

$parcel$export(module.exports, "getValidProjectName", () => $fe8ba53d387b5ec8$export$66d5243e39ae3991);

var $1oMOM = parcelRequire("1oMOM");
const $fe8ba53d387b5ec8$export$66d5243e39ae3991 = async (name)=>{
    try {
        // Call the validation endpoint which returns a valid project name as text/plain
        // This may return the original name if valid, or a corrected version if needed
        const url = `/rest/api/3/projectvalidate/validProjectName?name=${name}`;
        const validName = await fetch(url, (0, $1oMOM.getDefaultOptions)(url)).then((res)=>res.text());
        if (validName === null) throw new Error('Unable to generate valid project name');
        return validName;
    } catch (error) {
        if (error instanceof Error) throw new Error(`Unable to validate project name: ${error.message}`);
        throw new Error('Unable to validate project name');
    }
};

});


parcelRegister("2swfp", function(module, exports) {

$parcel$export(module.exports, "getTemplateTmpKeyFromKey", () => $5e9471cba399671d$export$9b7a7fdb245824da);

var $dhdXs = parcelRequire("dhdXs");

var $daZe3 = parcelRequire("daZe3");

var $gLHTZ = parcelRequire("gLHTZ");

var $7mOKw = parcelRequire("7mOKw");
const $5e9471cba399671d$var$templateKeyToTmpKey = {
    [(0, $7mOKw.TEMPLATE_KEY)]: (0, $dhdXs.PRODUCT_DISCOVERY_TEAM_MANAGED_KEY),
    [(0, $gLHTZ.TEMPLATE_KEY)]: (0, $dhdXs.PRODUCT_DISCOVERY_ROADMAP_TEAM_MANAGED_KEY),
    [(0, $daZe3.TEMPLATE_KEY)]: (0, $dhdXs.PRODUCT_DISCOVERY_PRIORITIZE_TEAM_MANAGED_KEY),
    [(0, $dhdXs.PRODUCT_DICOVERY_PORTFOLIO_MANAGEMENT_TEAM_MANAGED_KEY)]: (0, $dhdXs.PRODUCT_DICOVERY_PORTFOLIO_MANAGEMENT_TEAM_MANAGED_KEY)
};
const $5e9471cba399671d$export$9b7a7fdb245824da = (templateKey)=>{
    return $5e9471cba399671d$var$templateKeyToTmpKey[templateKey];
};

});

parcelRegister("eQlvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9141397cd7255afe$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9141397cd7255afe$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    modalHeading: {
        "id": "jpd-project-directory-onboarding-modal.modal.heading",
        "defaultMessage": "Welcome to Jira Product Discovery"
    },
    modalDescription: {
        "id": "jpd-project-directory-onboarding-modal.modal.description",
        "defaultMessage": "Here\u2019s a few things you can use it for:"
    },
    captureIdeas: {
        "id": "jpd-project-directory-onboarding-modal.capture-ideas",
        "defaultMessage": "Easily capture ideas and insights in one place"
    },
    logIdeas: {
        "id": "jpd-project-directory-onboarding-modal.log-ideas",
        "defaultMessage": "Log ideas and use insights to prioritize them"
    },
    prioritizeWithData: {
        "id": "jpd-project-directory-onboarding-modal.prioritize-with-data",
        "defaultMessage": "Use data and insights to prioritize them"
    },
    shareRoadmaps: {
        "id": "jpd-project-directory-onboarding-modal.share-roadmaps",
        "defaultMessage": "Share custom roadmaps with anyone"
    },
    connectToJira: {
        "id": "jpd-project-directory-onboarding-modal.connect-to-jira",
        "defaultMessage": "Easily connect ideas into Jira for delivery"
    },
    close: {
        "id": "jpd-project-directory-onboarding-modal.close",
        "defaultMessage": "Close"
    },
    getStarted: {
        "id": "jpd-project-directory-onboarding-modal.get-started",
        "defaultMessage": "Get started"
    },
    trialInfo: {
        "id": "jpd-project-directory-onboarding-modal.trial-info",
        "defaultMessage": "Free 30-day Premium plan trial. Cancel or downgrade anytime. By selecting \u201CGet started\u201D you agree to the <tc>Atlassian Customer Agreement</tc> and <pp>Privacy Policy</pp>."
    },
    modalSubHeading: {
        "id": "jpd-project-directory-onboarding-modal.modal.sub-heading",
        "defaultMessage": "Here\u2019s a few things you can use it for:"
    },
    ariaLabel: {
        "id": "jpd-project-directory-onboarding-modal.aria-label",
        "defaultMessage": "Jira Product Discovery onboarding modal"
    },
    projectTitleProductRoadmap: {
        "id": "jpd-project-directory-onboarding-modal.project-title.product-roadmap",
        "defaultMessage": "Product roadmap"
    },
    projectTitlePrioritization: {
        "id": "jpd-project-directory-onboarding-modal.project-title.prioritization",
        "defaultMessage": "Prioritization"
    }
});

});


parcelRegister("dSM65", function(module, exports) {

$parcel$export(module.exports, "useDirectoryRefetch", () => $478e478ac09072fe$export$6e338326a9da0df2);

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $37Ewn = parcelRequire("37Ewn");
const $478e478ac09072fe$export$6e338326a9da0df2 = ({ refetch: refetch, query: query })=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    const requestInFlight = (0, $eJOHy.useRef)();
    const [isFetching, setIsFetching] = (0, $eJOHy.useState)(false);
    const [errors, setErrors] = (0, $eJOHy.useState)(null);
    const refetchData = (0, $eJOHy.useCallback)(({ variables: variables, options: options })=>{
        requestInFlight.current?.unsubscribe();
        setIsFetching(true);
        setErrors(null);
        requestInFlight.current = (0, $37Ewn.fetchQuery)(environment, query, variables, {
            fetchPolicy: options?.fetchPolicy || 'store-or-network'
        }).subscribe({
            complete: ()=>{
                refetch(variables, {
                    fetchPolicy: 'store-only',
                    onComplete: ()=>{
                        setIsFetching(false);
                        options?.onComplete && options.onComplete();
                    }
                });
            },
            error: (error)=>{
                setIsFetching(false);
                setErrors(error);
                options?.onError && options.onError();
            }
        });
    }, [
        environment,
        query,
        refetch
    ]);
    return [
        {
            isFetching: isFetching,
            errors: errors
        },
        {
            refetchData: refetchData
        }
    ];
};

});

parcelRegister("lQ1ke", function(module, exports) {

$parcel$export(module.exports, "useQueryFilter", () => $08293440803ca194$export$d0b8acaa70818f20);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $b5RwB = parcelRequire("b5RwB");

var $gCY1z = parcelRequire("gCY1z");
const $08293440803ca194$export$d0b8acaa70818f20 = ({ override: override = true } = {})=>{
    const [{ query: query, match: match }, routerActions] = (0, $gCY1z.useRouter)();
    const syncQueryFilter = (0, $eJOHy.useCallback)((filter)=>{
        const normalizedFilter = Object.entries(filter).reduce((acc, [key, val])=>{
            if (val) acc[key] = val;
            return acc;
        }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {});
        !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(normalizedFilter, query) && routerActions.replace(`${match.path}?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify(override ? normalizedFilter : {
            ...query,
            ...normalizedFilter
        })}`);
    }, [
        override,
        match.path,
        query,
        routerActions
    ]);
    return syncQueryFilter;
};

});

parcelRegister("aBIfT", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $730554390b82eb2a$export$dd5ad0b65cf665da);

var $eJOHy = parcelRequire("eJOHy");

var $bJscI = parcelRequire("bJscI");

var $baxYj = parcelRequire("baxYj");
// eslint-disable-next-line jira/react/no-class-components
class $730554390b82eb2a$var$DocumentTitleOld extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $baxYj.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $baxYj.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $baxYj.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $730554390b82eb2a$export$dd5ad0b65cf665da = (0, $bJscI.componentWithFG)('jira-concurrent-document-title', (0, $baxYj.DocumentTitleHelper), $730554390b82eb2a$var$DocumentTitleOld);

});

parcelRegister("7ik1K", function(module, exports) {

$parcel$export(module.exports, "pageLoad", () => $3335788409c09b89$export$791d520f7e8058a5);
// eslint-disable-next-line jira/import-whitelist

var $hqYEY = parcelRequire("hqYEY");
const $3335788409c09b89$export$791d520f7e8058a5 = (0, $hqYEY.metrics).pageLoad({
    key: 'projects-directory-v3',
    ssr: {
        doneAsFmp: true
    },
    featureFlags: [
        'projects-directory-entrypoint_sn3p0'
    ]
});

});

parcelRegister("lA4uT", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $70fb2661bfe02c7c$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $70fb2661bfe02c7c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $70fb2661bfe02c7c$export$9b3029ee6188a41f);

var $eJOHy = parcelRequire("eJOHy");

var $2gvG4 = parcelRequire("2gvG4");

var $6whQo = parcelRequire("6whQo");

var $kVpZx = parcelRequire("kVpZx");

var $ioEQd = parcelRequire("ioEQd");

var $4l9pO = parcelRequire("4l9pO");

var $2UxSQ = parcelRequire("2UxSQ");

var $jPcl6 = parcelRequire("jPcl6");

var $9j9F7 = parcelRequire("9j9F7");

var $jSrj1 = parcelRequire("jSrj1");
const $70fb2661bfe02c7c$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $70fb2661bfe02c7c$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $70fb2661bfe02c7c$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $9j9F7.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $jPcl6.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $jSrj1.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2gvG4.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6whQo.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2UxSQ.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $kVpZx.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4l9pO.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $70fb2661bfe02c7c$export$9b3029ee6188a41f = $70fb2661bfe02c7c$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("6whQo", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $3708d872c36dd1bb$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $3708d872c36dd1bb$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $3708d872c36dd1bb$export$d93d677ef2f33c5c);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $3708d872c36dd1bb$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    (0, $eJOHy.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $3708d872c36dd1bb$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingsConfig);
        (0, $2QO3b.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("4l9pO", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $4802f5e968b3fe62$export$575e93c0f9905999);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $k04JP = parcelRequire("k04JP");

var $6uWhG = parcelRequire("6uWhG");

var $2HxHL = parcelRequire("2HxHL");

var $akiS9 = parcelRequire("akiS9");

var $dydef = parcelRequire("dydef");

var $9DwQv = parcelRequire("9DwQv");

const $4802f5e968b3fe62$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $dydef.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $9DwQv.isAutomaticExposureCollectionEnabled)()) (0, $2HxHL.stopLowPriorityEventDelay)();
};
class $4802f5e968b3fe62$export$575e93c0f9905999 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $k04JP.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $akiS9.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $2e47af044bce450a$export$99c08ec92759c71c));
                (0, $6uWhG.setMark)((0, $2e47af044bce450a$export$99c08ec92759c71c));
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $2e47af044bce450a$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $4802f5e968b3fe62$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $dydef.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $akiS9.PRODUCT_START_MARK), true);
            $4802f5e968b3fe62$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("akiS9", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $50b865cde2c2d004$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $50b865cde2c2d004$export$2a999c5f84501025);

var $6uWhG = parcelRequire("6uWhG");
const $50b865cde2c2d004$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $50b865cde2c2d004$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($50b865cde2c2d004$export$8e54fca0a680fdfd);
        (0, $6uWhG.setMark)($50b865cde2c2d004$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $2e47af044bce450a$export$56940a9488e85199 = 'jira.fe.spa-';
const $2e47af044bce450a$export$45c4b6bf7935c69a = `${$2e47af044bce450a$export$56940a9488e85199}start`;
const $2e47af044bce450a$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $2e47af044bce450a$export$ff834eccc35b9089 = 'appBundleReady';
const $2e47af044bce450a$export$86b05e34d462ead8 = 'prefetchApiReady';
const $2e47af044bce450a$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $2e47af044bce450a$export$3ae43cc1782d058f = 'jswRenderStart';
const $2e47af044bce450a$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $2e47af044bce450a$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $2e47af044bce450a$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $2e47af044bce450a$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $2e47af044bce450a$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $2e47af044bce450a$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $2e47af044bce450a$export$99c08ec92759c71c = 'tti-raf-mark';
const $2e47af044bce450a$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("2UxSQ", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $9ca3da1474781c5a$export$d91154f099475c5);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $ioEQd = parcelRequire("ioEQd");
class $9ca3da1474781c5a$export$d91154f099475c5 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $ioEQd.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("jPcl6", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9af3d786d904c43c$export$bf239ac2bfb04967);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $9af3d786d904c43c$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("9j9F7", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $79450f1fef3080e8$export$e63862cd888fe05a);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $ioEQd = parcelRequire("ioEQd");
var $8tVkR = parcelRequire("8tVkR");
async function $79450f1fef3080e8$export$e63862cd888fe05a() {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $ioEQd.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $8tVkR.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("jSrj1", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $0af00334d248807d$export$f00f1e874ce869e9);

var $kVpZx = parcelRequire("kVpZx");

var $j500r = parcelRequire("j500r");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0af00334d248807d$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0af00334d248807d$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0af00334d248807d$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $0af00334d248807d$export$7b4abba432e57989 = (value)=>$0af00334d248807d$var$isString(value) && $0af00334d248807d$var$startsAsObject(value) || $0af00334d248807d$var$isObject(value);
const $0af00334d248807d$export$fcc03ee4c944962f = (featureFlagValue)=>$0af00334d248807d$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $0af00334d248807d$export$d2818866b4acbea4 = new Map();
const $0af00334d248807d$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $j500r.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $0af00334d248807d$export$fcc03ee4c944962f(value);
            $0af00334d248807d$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("cZTMg", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $e3e218a75c21102a$export$eb40d3df56aa5c53);

var $eJOHy = parcelRequire("eJOHy");

var $5onjV = parcelRequire("5onjV");

var $figsJ = parcelRequire("figsJ");

var $5nYJB = parcelRequire("5nYJB");

var $aO6tw = parcelRequire("aO6tw");

var $adiVF = parcelRequire("adiVF");
const $e3e218a75c21102a$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $adiVF.isSubProductProps)(props) ? props.subProduct : (0, $figsJ.subProductFromProjectTypeForAnalytics)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5onjV.default), {
        op: (0, $aO6tw.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5nYJB.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("5nYJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $82e051cbb2adac57$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3aa9n = parcelRequire("3aa9n");

var $8VfmF = parcelRequire("8VfmF");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$82e051cbb2adac57$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3aa9n.default), {
        op: (0, $8VfmF.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("8VfmF", function(module, exports) {

$parcel$export(module.exports, "default", () => $811461c69dc55236$export$2e2bcd8739ae039);

var $eSnSE = parcelRequire("eSnSE");

var $jGzN3 = parcelRequire("jGzN3");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$811461c69dc55236$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $jGzN3.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $eSnSE.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("aO6tw", function(module, exports) {

$parcel$export(module.exports, "default", () => $53a2c520c0b2b632$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $97BGz = parcelRequire("97BGz");
var $iyT45 = parcelRequire("iyT45");
var $4T9yL = parcelRequire("4T9yL");


var $eSnSE = parcelRequire("eSnSE");

var $2Mqjh = parcelRequire("2Mqjh");
const $53a2c520c0b2b632$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$53a2c520c0b2b632$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $99993c16fc53d6ec$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $53a2c520c0b2b632$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4T9yL.waitForHeritage)() : null, ()=>(0, $97BGz.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $iyT45.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $eSnSE.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $99993c16fc53d6ec$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("adiVF", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $b41c599c0dbb9c69$export$c3063d6d7a8c075f);
const $b41c599c0dbb9c69$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("gWu57", function(module, exports) {

$parcel$export(module.exports, "ScrollablePage", () => $3970ca9ce19c6445$export$8d7a30196b47fe34);
$parcel$export(module.exports, "PageLayout", () => $3970ca9ce19c6445$export$6d1402fb58384e4f);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $6XJko = parcelRequire("6XJko");
const $3970ca9ce19c6445$export$8d7a30196b47fe34 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.scrollable-page',
        xcss: $3970ca9ce19c6445$var$scrollablePageStyles,
        paddingBlock: "space.0",
        paddingInline: (0, $6XJko.isVisualRefreshEnabled)() ? 'space.300' : 'space.500'
    }, children);
const $3970ca9ce19c6445$export$6d1402fb58384e4f = ({ children: children, hideMargin: hideMargin, ...rest })=>{
    const isVisualRefresh = (0, $6XJko.isVisualRefreshEnabled)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.page-layout',
        xcss: // eslint-disable-next-line no-nested-ternary
        hideMargin ? $3970ca9ce19c6445$var$pageLayoutWithoutMarginStyles : isVisualRefresh ? $3970ca9ce19c6445$var$pageLayoutWithMarginStyles : $3970ca9ce19c6445$var$pageLayoutWithMarginStylesOld
    }, children);
};
const $3970ca9ce19c6445$var$scrollablePageStyles = (0, $1DXK0.xcss)({
    minWidth: '800px',
    margin: 'space.0'
});
const $3970ca9ce19c6445$var$pageLayoutWithoutMarginStyles = (0, $1DXK0.xcss)({
    margin: 'space.0'
});
const $3970ca9ce19c6445$var$pageLayoutWithMarginStylesOld = (0, $1DXK0.xcss)({
    marginBlock: '0',
    marginInline: 'space.500'
});
const $3970ca9ce19c6445$var$pageLayoutWithMarginStyles = (0, $1DXK0.xcss)({
    marginBlock: '0',
    marginInline: 'space.300'
});

});

parcelRegister("3JBFS", function(module, exports) {

$parcel$export(module.exports, "useScopedFilter", () => $4303e0d3050bcf7e$export$c0c3d622c43d72e);
$parcel$export(module.exports, "useFilter", () => $4303e0d3050bcf7e$export$3274cf84b703fff);
$parcel$export(module.exports, "FilterContainer", () => $4303e0d3050bcf7e$export$2f96f6f204f87534);

var $5W62K = parcelRequire("5W62K");

var $j8Fdp = parcelRequire("j8Fdp");

var $2YWby = parcelRequire("2YWby");

var $g1iDH = parcelRequire("g1iDH");
const { useScopedFilter: $4303e0d3050bcf7e$export$c0c3d622c43d72e, useFilter: $4303e0d3050bcf7e$export$3274cf84b703fff, FilterContainer: $4303e0d3050bcf7e$export$2f96f6f204f87534 } = (0, $5W62K.createUseFilter)('ProjectsDirectoryFilterState', {
    getInitialState: ({ routeQuery: routeQuery })=>(0, $j8Fdp.matchAliases)((0, $2YWby.filterInitialState), (0, $g1iDH.sanitizeLegacyQuery)(routeQuery), (0, $2YWby.filterAliasMap))
});

});

parcelRegister("jalQP", function(module, exports) {

$parcel$export(module.exports, "AsyncEmptyView", () => $4c0d9a1dfc6e5c90$export$548ce7324e0de587);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4c0d9a1dfc6e5c90$var$LazyEmptyView = (0, $bQWwW.lazy)(()=>(parcelRequire("hfy8d")).then(({ EmptyView: EmptyView })=>EmptyView), {
    ssr: false,
    moduleId: "./src/packages/global-pages/directories/projects-directory-v3/src/ui/page-layout/empty-view/index.tsx"
});
const $4c0d9a1dfc6e5c90$export$548ce7324e0de587 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "empty-view",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4c0d9a1dfc6e5c90$var$LazyEmptyView, props));

});
parcelRegister("hfy8d", function(module, exports) {

let $c8ee502d375dece8$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $c8ee502d375dece8$var$load("l61He").then(()=>parcelRequire('kNUmN'));

});


parcelRegister("fzVim", function(module, exports) {

$parcel$export(module.exports, "PageErrorState", () => $a4b0be5ba17a6a29$export$93e16ad79580c69);

var $eJOHy = parcelRequire("eJOHy");

var $1sChl = parcelRequire("1sChl");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $dsG8I = parcelRequire("dsG8I");
const $a4b0be5ba17a6a29$export$93e16ad79580c69 = ()=>{
    const descriptionGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dsG8I.default).descriptionGalaxia : (0, $dsG8I.default).description;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const onRetry = (0, $eJOHy.useCallback)(()=>window.location.reload(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1sChl.default), {
        header: formatMessage((0, $dsG8I.default).header),
        description: formatMessage(descriptionGalaxia),
        onRetry: onRetry
    });
};

});
parcelRegister("1sChl", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bf0f4be8561750a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $idGBm = parcelRequire("idGBm");

var $jiDI0 = parcelRequire("jiDI0");

var $bxoX3 = parcelRequire("bxoX3");

var $iAkRR = parcelRequire("iAkRR");
function $6bf0f4be8561750a$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage, headingLevel: headingLevel } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($jiDI0))) : (0, (/*@__PURE__*/$parcel$interopDefault($bxoX3)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (renderErrorImage) imageUrl = undefined;
    else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        testId: "common-components-error-state.empty-state",
        width: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage,
        headingLevel: headingLevel
    });
}
$6bf0f4be8561750a$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $iAkRR.default).retry
};
var $6bf0f4be8561750a$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($6bf0f4be8561750a$export$edf27be85e5f6da0);

});
parcelRegister("jiDI0", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("bxoX3", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("iAkRR", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf64bf54453c0d07$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $cf64bf54453c0d07$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("dsG8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e21e3f3d346d4c9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $8e21e3f3d346d4c9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    header: {
        "id": "projects-directory-v3.page-layout.error-state.header",
        "defaultMessage": "An error occurred"
    },
    description: {
        "id": "projects-directory-v3.page-layout.error-state.description",
        "defaultMessage": "There was a problem loading your projects. Try again or contact your administrator for support."
    },
    descriptionGalaxia: {
        "id": "projects-directory-v3.page-layout.error-state.description-galaxia",
        "defaultMessage": "There was a problem loading your spaces. Try again or contact your administrator for support."
    }
});

});


parcelRegister("hHbwP", function(module, exports) {

$parcel$export(module.exports, "Header", () => $413701c4351ec211$export$8b251419efc915eb);

var $2Vp9I = parcelRequire("2Vp9I");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4nIrU = parcelRequire("4nIrU");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $cECwI = parcelRequire("cECwI");

var $kucAV = parcelRequire("kucAV");

var $2rrEk = parcelRequire("2rrEk");

var $1MOMk = parcelRequire("1MOMk");
const $413701c4351ec211$export$8b251419efc915eb = ({ dataRef: dataRef, isAdminSettingsContext: isAdminSettingsContext })=>{
    const adminHeaderCaptionGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $2rrEk.default).adminHeaderCaptionGalaxia : (0, $2rrEk.default).adminHeaderCaption;
    const headerCaptionGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $2rrEk.default).headerCaptionGalaxia : (0, $2rrEk.default).headerCaption;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { jira: jira } = (0, $j4oe4.useFragment)((0, $2Vp9I.default), dataRef);
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4nIrU.Header), {
        title: isAdminSettingsContext ? formatMessage(adminHeaderCaptionGalaxia) : formatMessage(headerCaptionGalaxia),
        actions: jira ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kucAV.CreateButton), {
            dataRef: jira
        }), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1MOMk.OpenTemplatesPanelButton), {
            dataRef: jira
        })) : undefined,
        isAdminSettingsContext: isAdminSettingsContext
    });
};

});
parcelRegister("2Vp9I", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d7723d04043cc0f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<364beda65bbbc75d8787e30400e03a32>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9d7723d04043cc0f$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAnonymous"
        }
    ],
    "kind": "Fragment",
    "name": "header_projectsDirectoryV3",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "createProjectAction_projectsDirectoryV3_CreateButton"
                },
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "openTemplatesPanel_projectsDirectoryV3_OpenTemplatesPanelButton"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$9d7723d04043cc0f$var$node.hash = "22f237392203128d7ea8a45840fcb1ff";
var $9d7723d04043cc0f$export$2e2bcd8739ae039 = $9d7723d04043cc0f$var$node;

});

parcelRegister("4nIrU", function(module, exports) {

$parcel$export(module.exports, "Header", () => $1d9ee1a0095603af$export$8b251419efc915eb);

var $eJOHy = parcelRequire("eJOHy");

var $48q59 = parcelRequire("48q59");
var $goZPP = parcelRequire("goZPP");

var $i0iAU = parcelRequire("i0iAU");

var $1BWxH = parcelRequire("1BWxH");

var $g51Bg = parcelRequire("g51Bg");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $5B7pS = parcelRequire("5B7pS");
const $1d9ee1a0095603af$export$8b251419efc915eb = ({ title: title, actions: actions, children: children, isAdminSettingsContext: isAdminSettingsContext })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const searchActionLabel = formatMessage((0, $5B7pS.default).searchJiraAdmin);
    const { open: open } = (0, $g51Bg.useActionsCommandPalette)();
    const onClick = (0, $eJOHy.useCallback)(()=>{
        open();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'searchActionButton'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'dotDialog');
    }, [
        createAnalyticsEvent,
        open
    ]);
    const shifterAction = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, actions, isAdminSettingsContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i0iAU))), {
            label: "",
            LEGACY_size: "small"
        }),
        onClick: onClick
    }, searchActionLabel));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1BWxH.default), {
        actions: shifterAction
    }, title), children);
};

});
parcelRegister("5B7pS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6df82c00830e4c87$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $6df82c00830e4c87$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    searchJiraAdmin: {
        "id": "directory-base-v3.header.search-jira-admin",
        "defaultMessage": "Search Jira admin"
    }
});

});


parcelRegister("kucAV", function(module, exports) {

$parcel$export(module.exports, "CreateButton", () => $63101d789f24886e$export$6d3c345ce7c38fd9);

var $5hKQh = parcelRequire("5hKQh");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $k71qx = parcelRequire("k71qx");

var $kO1ht = parcelRequire("kO1ht");

var $1KdDN = parcelRequire("1KdDN");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $9o3jI = parcelRequire("9o3jI");

var $7jTnu = parcelRequire("7jTnu");

var $01c1s = parcelRequire("01c1s");
const $63101d789f24886e$var$CreateButtonComponent = (props)=>{
    const createProjectGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $01c1s.default).createProjectGalaxia : (0, $01c1s.default).createProject;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "primary",
        ...props
    }, formatMessage(createProjectGalaxia));
};
const $63101d789f24886e$var$DisabledCreateButtonComponent = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onShowTooltip = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'projectCreateButtonDisabledTooltip'
        }));
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: formatMessage((0, $01c1s.default).createProjectDisabledTooltip),
        onShow: onShowTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($63101d789f24886e$var$CreateButtonComponent, {
        isDisabled: true
    }));
};
const $63101d789f24886e$var$CreateButton = ({ dataRef: dataRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'directoryHeader'
    });
    const data = (0, $j4oe4.useFragment)((0, $5hKQh.default), dataRef);
    const [, { on: openProjectCreateDrawer }] = (0, $9o3jI.useSwitchModals)((0, $kO1ht.MODAL_ID).PROJECT_CREATE);
    const handleCreate = (0, $eJOHy.useCallback)(()=>{
        openProjectCreateDrawer();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'CreateProjectButton');
    }, [
        analyticsEvent,
        openProjectCreateDrawer
    ]);
    const shouldDisplayCreateProject = (0, $7jTnu.fg)('allow_end_users_to_access_custom_templates') ? !!data?.shouldDisplay : !!data?.canCreateProject;
    const fireProjectCreateButtonComponentEvent = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'rendered',
            actionSubject: 'projectCreateButtonComponent'
        }), {
            shouldDisplay: !!data?.shouldDisplay,
            canCreateProject: !!data?.canCreateProject,
            shouldDisplayCreateProject: shouldDisplayCreateProject
        });
    }, [
        createAnalyticsEvent,
        data?.canCreateProject,
        data?.shouldDisplay,
        shouldDisplayCreateProject
    ]);
    (0, $eJOHy.useEffect)(()=>{
        fireProjectCreateButtonComponentEvent();
    }, [
        fireProjectCreateButtonComponentEvent
    ]);
    if (!shouldDisplayCreateProject && (0, $epTsa.expVal)('jira_project_create_button_with_tooltip', 'isEnabled', false)) // Poster: https://hello.atlassian.net/wiki/spaces/Spork/pages/5678308889/ONE+PAGER+Project+create+permission+awareness
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($63101d789f24886e$var$DisabledCreateButtonComponent, null);
    if (!shouldDisplayCreateProject) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($63101d789f24886e$var$CreateButtonComponent, {
        "data-testId": "global-pages.directories.projects-directory-v3.create-projects-button",
        onClick: handleCreate
    });
};
const $63101d789f24886e$export$6d3c345ce7c38fd9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "create-project-button",
        packageName: "jira-project-directory-page-v3",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($63101d789f24886e$var$CreateButton, props));

});
parcelRegister("5hKQh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e765c6b399e51c98$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<43083bc6f937ec6f368bde332fd2f70e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e765c6b399e51c98$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "createProjectAction_projectsDirectoryV3_CreateButton",
        "selections": [
            {
                "alias": "canCreateProject",
                "args": [
                    v0 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "CREATE_PROJECT"
                    }
                ],
                "kind": "ScalarField",
                "name": "canPerform"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "shouldDisplay",
                        "args": [
                            v0 /*: any*/ ,
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "VIEW_PROJECT_CREATION_ENTRY"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "canPerform"
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
}();
$e765c6b399e51c98$var$node.hash = "6bcbad309a5d12beb79a7280ea2c0ff8";
var $e765c6b399e51c98$export$2e2bcd8739ae039 = $e765c6b399e51c98$var$node;

});

parcelRegister("01c1s", function(module, exports) {

$parcel$export(module.exports, "default", () => $01171433d120f493$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $01171433d120f493$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    createProject: {
        "id": "projects-directory-v3.page-layout.header.create-project-action.create-project",
        "defaultMessage": "Create project"
    },
    createProjectGalaxia: {
        "id": "projects-directory-v3.page-layout.header.create-project-action.create-project-galaxia",
        "defaultMessage": "Create space"
    },
    createProjectDisabledTooltip: {
        "id": "projects-directory-v3.page-layout.header.create-project-action.create-project-disabled-tooltip",
        "defaultMessage": "You do not have permission to create projects. Please contact your administrator."
    }
});

});


parcelRegister("2rrEk", function(module, exports) {

$parcel$export(module.exports, "default", () => $453edd68ddcf9e42$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $453edd68ddcf9e42$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    headerCaption: {
        "id": "projects-directory-v3.page-layout.header.header-caption",
        "defaultMessage": "Projects"
    },
    adminHeaderCaption: {
        "id": "projects-directory-v3.page-layout.header.admin-header-caption",
        "defaultMessage": "Manage Projects"
    },
    headerCaptionGalaxia: {
        "id": "projects-directory-v3.page-layout.header.header-caption-galaxia",
        "defaultMessage": "Spaces"
    },
    adminHeaderCaptionGalaxia: {
        "id": "projects-directory-v3.page-layout.header.admin-header-caption-galaxia",
        "defaultMessage": "Manage Spaces"
    }
});

});

parcelRegister("1MOMk", function(module, exports) {

$parcel$export(module.exports, "OpenTemplatesPanelButton", () => $4ee3efdcd84afbba$export$6ac7df8c3bce770);

var $lePHr = parcelRequire("lePHr");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $1KdDN = parcelRequire("1KdDN");

var $lRq8t = parcelRequire("lRq8t");

var $dfP3D = parcelRequire("dfP3D");

var $4xbv3 = parcelRequire("4xbv3");
var $iqtgH = parcelRequire("iqtgH");
var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $ham2H = parcelRequire("ham2H");

var $jwXVX = parcelRequire("jwXVX");

var $7jTnu = parcelRequire("7jTnu");

var $lE8Sf = parcelRequire("lE8Sf");
const $4ee3efdcd84afbba$var$OpenTemplatesPanelButton = ({ dataRef: dataRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'directoryHeader'
    });
    const rightSidebarCurrentState = (0, $dfP3D.useActiveRightSidebarState)();
    const { openRightSidebar: openRightSidebar } = (0, $dfP3D.useRightSidebarController)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { canCreateProject: canCreateProject, userPreferences: userPreferences, sidebarExperimentTemplates: sidebarExperimentTemplates, shouldDisplay: shouldDisplay } = (0, $j4oe4.useFragment)((0, $lePHr.default), dataRef);
    const setProjectListRightPanelState = (0, $jwXVX.useSetProjectListRightPanelState)(userPreferences.__id);
    const onClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'openTemplatesPanelButton');
        if (userPreferences.projectListRightPanelState === 'OPEN' && rightSidebarCurrentState?.panelId !== (0, $ham2H.PANEL_ID)) {
            openRightSidebar((0, $ham2H.PANEL_ID), (0, $ham2H.SIDEBAR_WIDTH), false, true);
            return;
        }
        setProjectListRightPanelState(userPreferences.projectListRightPanelState === 'OPEN' ? 'CLOSED' : 'OPEN');
    }, [
        analyticsEvent,
        openRightSidebar,
        rightSidebarCurrentState?.panelId,
        setProjectListRightPanelState,
        userPreferences.projectListRightPanelState
    ]);
    const shouldDisplayCreateProject = (0, $7jTnu.fg)('allow_end_users_to_access_custom_templates') ? shouldDisplay : canCreateProject;
    if (!shouldDisplayCreateProject || typeof sidebarExperimentTemplates?.totalCount !== 'number' || sidebarExperimentTemplates.totalCount === 0) // Don't show the button if the user can't create a project or if there are no templates recommended.
    return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        "data-testId": "global-pages.directories.projects-directory-v3.templates-panel-button",
        isSelected: rightSidebarCurrentState?.panelId === (0, $ham2H.PANEL_ID),
        onClick: onClick
    }, formatMessage((0, $lE8Sf.default).templatesButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireScreenAnalytics), {
        attributes: {
            experiment: 'recommendationsinProjectsDirectoryWithHoverPreview',
            totalCount: sidebarExperimentTemplates.totalCount,
            canCreateProject: canCreateProject
        }
    }));
};
const $4ee3efdcd84afbba$export$6ac7df8c3bce770 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "open-templates-panel-button",
        packageName: "jiraProjectsDirectoryV3",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
        sourceName: "projectsV3",
        sourceType: (0, $466f60259c330878$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4ee3efdcd84afbba$var$OpenTemplatesPanelButton, props)));

});
parcelRegister("lePHr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6164769d69e1e64f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9f3d23d020934b93d62f270656ede141>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6164769d69e1e64f$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "openTemplatesPanel_projectsDirectoryV3_OpenTemplatesPanelButton",
        "selections": [
            {
                "alias": "canCreateProject",
                "args": [
                    v0 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "CREATE_PROJECT"
                    }
                ],
                "kind": "ScalarField",
                "name": "canPerform"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "shouldDisplay",
                        "args": [
                            v0 /*: any*/ ,
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "VIEW_PROJECT_CREATION_ENTRY"
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "canPerform"
                    }
                ]
            },
            {
                "kind": "RequiredField",
                "field": {
                    "args": [
                        v0 /*: any*/ 
                    ],
                    "concreteType": "JiraUserPreferences",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "projectListRightPanelState"
                        },
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                }
                            ]
                        }
                    ]
                },
                "action": "THROW",
                "path": "userPreferences"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "alias": "sidebarExperimentTemplates",
                    "args": [
                        v0 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "experimentKey",
                            "value": "sidebarExperiment"
                        }
                    ],
                    "concreteType": "JiraProjectListViewTemplateConnection",
                    "kind": "LinkedField",
                    "name": "projectListViewTemplates",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "totalCount"
                            },
                            "action": "THROW",
                            "path": "sidebarExperimentTemplates.totalCount"
                        }
                    ]
                },
                "action": "THROW",
                "path": "sidebarExperimentTemplates"
            }
        ],
        "type": "JiraQuery"
    };
}();
$6164769d69e1e64f$var$node.hash = "e48c036460980f3b260084bce6706d60";
var $6164769d69e1e64f$export$2e2bcd8739ae039 = $6164769d69e1e64f$var$node;

});

parcelRegister("ham2H", function(module, exports) {

$parcel$export(module.exports, "TEAM_NAME", () => $3a1532ebfbd963fa$export$d57b6b390e78d90f);
$parcel$export(module.exports, "PACKAGE_NAME", () => $3a1532ebfbd963fa$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $3a1532ebfbd963fa$export$780035d9fe48eb32);
$parcel$export(module.exports, "SIDEBAR_WIDTH_REFRESH", () => $3a1532ebfbd963fa$export$a191a221249cbcae);
$parcel$export(module.exports, "PANEL_ID", () => $3a1532ebfbd963fa$export$e1d562d81d0e502d);
$parcel$export(module.exports, "PROJECT_CREATE_SOURCE", () => $3a1532ebfbd963fa$export$280536374592bda3);
$parcel$export(module.exports, "PROJECT_TYPE_TARGETS_MAP", () => $3a1532ebfbd963fa$export$990484f4e8c06c90);
$parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", () => $3a1532ebfbd963fa$export$29629758934356a6);

var $dNnxZ = parcelRequire("dNnxZ");

var $dUrLZ = parcelRequire("dUrLZ");
const $3a1532ebfbd963fa$export$d57b6b390e78d90f = 'helix';
const $3a1532ebfbd963fa$export$b8b9d90f9e5bd72b = 'jiraGrowthRecommendationsInProjectList';
const $3a1532ebfbd963fa$export$780035d9fe48eb32 = 365;
const $3a1532ebfbd963fa$export$a191a221249cbcae = 400;
const $3a1532ebfbd963fa$export$e1d562d81d0e502d = 'recommendationsInProjectList';
const $3a1532ebfbd963fa$export$675d6d49067be942 = 'recommendationsInProjectListHoverAnchor';
const $3a1532ebfbd963fa$export$280536374592bda3 = 'recommendationsInProjectList';
const $3a1532ebfbd963fa$export$990484f4e8c06c90 = {
    BUSINESS: (0, $dNnxZ.Targets).JIRA_CORE,
    SOFTWARE: (0, $dNnxZ.Targets).JIRA_SOFTWARE,
    SERVICE_DESK: (0, $dNnxZ.Targets).JIRA_SERVICE_DESK,
    PRODUCT_DISCOVERY: (0, $dNnxZ.Targets).JIRA_PRODUCT_DISCOVERY
};
const $3a1532ebfbd963fa$export$29629758934356a6 = (environment)=>{
    const env = environment === 'prod' ? 'prod' : 'staging';
    return {
        BUSINESS: (0, $dUrLZ.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
        SOFTWARE: (0, $dUrLZ.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
        SERVICE_DESK: (0, $dUrLZ.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
        PRODUCT_DISCOVERY: (0, $dUrLZ.FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
    };
};

});

parcelRegister("jwXVX", function(module, exports) {

$parcel$export(module.exports, "useSetProjectListRightPanelState", () => $2cca22b3e352a74a$export$f7872413c3847449);

var $9KAKd = parcelRequire("9KAKd");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gYnSx = parcelRequire("gYnSx");

var $kEUB1 = parcelRequire("kEUB1");

var $ham2H = parcelRequire("ham2H");
const $2cca22b3e352a74a$var$PROJECT_LIST_RIGHT_PANEL_STATE = 'projectListRightPanelState';
const $2cca22b3e352a74a$var$relayStoreUpdater = (store, userPreferencesRefId, state)=>{
    if (typeof userPreferencesRefId === 'string') {
        const record = store.get(userPreferencesRefId);
        record?.setValue(state, $2cca22b3e352a74a$var$PROJECT_LIST_RIGHT_PANEL_STATE);
    }
};
const $2cca22b3e352a74a$export$f7872413c3847449 = (userPreferencesRefId)=>{
    const cloudId = (0, $kEUB1.useCloudId)();
    const [commit] = (0, $j4oe4.useMutation)((0, $9KAKd.default));
    const setRightPanelState = (0, $eJOHy.useCallback)((state)=>{
        commit({
            variables: {
                cloudId: cloudId,
                state: state
            },
            optimisticUpdater: (store)=>$2cca22b3e352a74a$var$relayStoreUpdater(store, userPreferencesRefId, state),
            updater: (store, { // @ts-expect-error TS-2339 - Property 'jira' does not exist on type 'setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation$data | null | undefined'.
            jira: { userPreferences: { setProjectListRightPanelState: { projectListRightPanelState: projectListRightPanelState } } } })=>$2cca22b3e352a74a$var$relayStoreUpdater(store, userPreferencesRefId, projectListRightPanelState ?? state),
            onCompleted: ({ jira: { // @ts-expect-error(Suppressed for relay bump) - Property 'userPreferences' does not exist on type '{ readonly userPreferences: { readonly setProjectListRightPanelState: { readonly errors: readonly { readonly extensions: { readonly statusCode: number | null | undefined; } | null | undefined; readonly message: string | null | undefined; }[] | null | undefined; readonly projectListRightPanelState: JiraProjectListRig...'.
            userPreferences: { setProjectListRightPanelState: { success: success, errors: errors } } } })=>{
                const error = (errors ?? [])[0];
                if (!success || error) {
                    const errorMessage = `error on set project list right panel state: ${error.message}`;
                    const statusCode = error.extensions?.statusCode;
                    (0, $gYnSx.default)({
                        error: new Error(`status code: ${statusCode ?? 'unknown'}, ${errorMessage}`),
                        meta: {
                            id: 'jiraSetProjectListRightPanelStateError',
                            packageName: (0, $ham2H.PACKAGE_NAME),
                            teamName: (0, $ham2H.TEAM_NAME)
                        }
                    });
                }
            },
            onError: (error)=>{
                (0, $gYnSx.default)({
                    error: new Error(`jiraSetProjectListRightPanelStateMutationError with ${error.message}`),
                    meta: {
                        id: 'jiraSetProjectListRightPanelStateMutationError',
                        packageName: (0, $ham2H.PACKAGE_NAME),
                        teamName: (0, $ham2H.TEAM_NAME)
                    }
                });
            }
        });
    }, [
        cloudId,
        commit,
        userPreferencesRefId
    ]);
    return setRightPanelState;
};

});
parcelRegister("9KAKd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2ffffb7e0445226$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f982c84219e38d14c162a90f7e73d838>>
 * @relayHash 932a6ab30b4abea8c4b298d0299ba01a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c9fc45f1ccb390d27ba078874be435f11bb5799b236a50a6fc32b19b5b705f8b
const $c2ffffb7e0445226$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "state"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "state",
            "variableName": "state"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "message"
    }, v6 = {
        "kind": "ScalarField",
        "name": "projectListRightPanelState"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserPreferencesMutation",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraProjectListRightPanelStateMutationPayload",
                                    "kind": "LinkedField",
                                    "name": "setProjectListRightPanelState",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "MutationError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ 
                                                    ]
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUserPreferencesMutation",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraProjectListRightPanelStateMutationPayload",
                                    "kind": "LinkedField",
                                    "name": "setProjectListRightPanelState",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "concreteType": "MutationError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "id"
                                                                }
                                                            ],
                                                            "type": "BulkMutationErrorExtension"
                                                        }
                                                    ]
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c9fc45f1ccb390d27ba078874be435f11bb5799b236a50a6fc32b19b5b705f8b",
            "metadata": {},
            "name": "setRightPanelState_jiraGrowthRecommendationsInProjectList_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c2ffffb7e0445226$var$node.hash = "1cbcdd010c06eb6470327729729fba37";
var $c2ffffb7e0445226$export$2e2bcd8739ae039 = $c2ffffb7e0445226$var$node;

});


parcelRegister("lE8Sf", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcf6229de0504ba8$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $fcf6229de0504ba8$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    templatesButton: {
        "id": "projects-directory-v3.page-layout.header.open-templates-panel.templates-button",
        "defaultMessage": "Templates"
    }
});

});



parcelRegister("brbC9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ea915522b81e803$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9ea915522b81e803$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    documentTitle: {
        "id": "projects-directory-v3.page-layout.document-title",
        "defaultMessage": "Projects"
    },
    adminDocumentTitle: {
        "id": "projects-directory-v3.page-layout.admin-document-title",
        "defaultMessage": "Manage Projects"
    },
    filterResultsAnnouncement: {
        "id": "projects-directory-v3.page-layout.filter-results-announcement",
        "defaultMessage": "{itemCount, plural, =0 {No projects were found that match your search} one {{itemCount} project found} other {{itemCount} projects found}}"
    },
    documentTitleGalaxia: {
        "id": "projects-directory-v3.page-layout.document-title-galaxia",
        "defaultMessage": "Spaces"
    },
    adminDocumentTitleGalaxia: {
        "id": "projects-directory-v3.page-layout.admin-document-title-galaxia",
        "defaultMessage": "Manage Spaces"
    },
    filterResultsAnnouncementGalaxia: {
        "id": "projects-directory-v3.page-layout.filter-results-announcement-galaxia",
        "defaultMessage": "{itemCount, plural, =0 {No spaces were found that match your search} one {{itemCount} space found} other {{itemCount} spaces found}}"
    }
});

});

parcelRegister("7ZKwq", function(module, exports) {

$parcel$export(module.exports, "AsyncNoPermissionViews", () => $f29e77511cd50ab4$export$a2f35d77f8a7c2df);

var $eJOHy = parcelRequire("eJOHy");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f29e77511cd50ab4$var$LazyNoPermissionViews = (0, $bQWwW.lazy)(()=>(parcelRequire("iud3J")).then(({ NoPermissionViews: NoPermissionViews })=>NoPermissionViews), {
    ssr: false,
    moduleId: "./src/packages/global-pages/directories/projects-directory-v3/src/ui/page-layout/no-permission-views/index.tsx"
});
const $f29e77511cd50ab4$export$a2f35d77f8a7c2df = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "no-permission-views",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f29e77511cd50ab4$var$LazyNoPermissionViews, props));

});
parcelRegister("iud3J", function(module, exports) {

let $d755289c934ee300$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $d755289c934ee300$var$load("aYM0d").then(()=>parcelRequire('afkXQ'));

});


parcelRegister("fJ5Er", function(module, exports) {

$parcel$export(module.exports, "ProjectsList", () => $1bbd1a6cf1a4eea5$export$99bffacbdbcb5195);

var $gYHdy = parcelRequire("gYHdy");

var $4gAss = parcelRequire("4gAss");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $7ep4S = parcelRequire("7ep4S");

var $7jTnu = parcelRequire("7jTnu");

var $eyaXF = parcelRequire("eyaXF");

var $7c6TJ = parcelRequire("7c6TJ");
const $1bbd1a6cf1a4eea5$export$99bffacbdbcb5195 = ({ projectsRef: projectsRef, rootQueryRef: rootQueryRef, isLoading: isLoading, isAdminSettingsContext: isAdminSettingsContext })=>{
    const dataRef = (0, $j4oe4.useFragment)((0, $4gAss.default), projectsRef);
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const categoriesData = (0, $j4oe4.useFragment)((0, $gYHdy.default), rootQueryRef);
    const shouldShowCategories = (0, $eJOHy.useMemo)(()=>Boolean(categoriesData.jira?.allJiraProjectCategories?.edges?.length), [
        categoriesData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1bbd1a6cf1a4eea5$var$Container, {
        isLoading: (0, $7jTnu.fg)('better_loading_state_projects_directory') ? false : isLoading,
        "data-testid": "global-pages.directories.projects-directory-v3.ui.page-layout.projects-list.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7c6TJ.ResultsTable), {
        shouldShowCategories: shouldShowCategories,
        projectsRef: dataRef,
        jiraQueryRef: categoriesData.jira || null,
        isAdminSettingsContext: isAdminSettingsContext
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eyaXF.Pagination), {
        projectsRef: dataRef
    }), isLoading && (0, $7jTnu.fg)('better_loading_state_projects_directory') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1bbd1a6cf1a4eea5$var$LoadingOverlay, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        testId: "global-pages.directories.projects-directory-v3.ui.page-layout.projects-list.spinner",
        size: "large",
        interactionName: "projects-list-loading"
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1bbd1a6cf1a4eea5$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _n3tdpxbi _aetrb3bt _18postnw _z0ai1osq _1qdg1osq _1hfk1bhr _15l2idpf _19doidpf",
            __cmplp.isLoading ? "_1ywu1ule" : "_1ywuglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1bbd1a6cf1a4eea5$var$LoadingOverlay = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1r04idpf _1sb2b3bt _kqswstnw _1e0c1txw _1bah1h6o _1q511epz _1tesidpf _1kt9b3bt _1cs8stnw _1rus1bhr _154ptxnc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gYHdy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e78be72371e7ed49$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<00f1382389e8ddfb70ece3b8fdc2d637>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e78be72371e7ed49$var$node = function() {
    var v0 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isAnonymous"
            }
        ],
        "kind": "Fragment",
        "name": "projectsList_projectsDirectoryV3_rootQueryRef",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "condition": "isAnonymous",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "args": v0 /*: any*/ ,
                                "concreteType": "JiraProjectCategoryConnection",
                                "kind": "LinkedField",
                                "name": "allJiraProjectCategories",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectCategoryEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "args": v0 /*: any*/ ,
                        "kind": "FragmentSpread",
                        "name": "actionsCell_projectsDirectoryV3_ActionsCellDropdown_jiraQueryRef"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$e78be72371e7ed49$var$node.hash = "17861eb1411077bef688cc2747a1321b";
var $e78be72371e7ed49$export$2e2bcd8739ae039 = $e78be72371e7ed49$var$node;

});

parcelRegister("4gAss", function(module, exports) {

$parcel$export(module.exports, "default", () => $cde88d8f1ebb8790$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1c7c638034af1606cfc66ad7c0873876>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cde88d8f1ebb8790$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAdminSettingsContext"
        }
    ],
    "kind": "Fragment",
    "name": "projectsList_projectsDirectoryV3_projectsRef",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isAdminSettingsContext",
                    "variableName": "isAdminSettingsContext"
                }
            ],
            "kind": "FragmentSpread",
            "name": "resultsTable_projectsDirectoryV3"
        },
        {
            "kind": "FragmentSpread",
            "name": "pagination_projectsDirectoryV3"
        }
    ],
    "type": "JiraProjectConnection"
};
$cde88d8f1ebb8790$var$node.hash = "a2ac4e53b4aeb7f1a30eaf9175bfdeae";
var $cde88d8f1ebb8790$export$2e2bcd8739ae039 = $cde88d8f1ebb8790$var$node;

});

parcelRegister("eyaXF", function(module, exports) {

$parcel$export(module.exports, "Pagination", () => $f15e1c62402ef612$export$68f5e1453c188a82);

var $72Wpr = parcelRequire("72Wpr");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2sLVw = parcelRequire("2sLVw");

var $fKsYy = parcelRequire("fKsYy");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $2YWby = parcelRequire("2YWby");

var $6XJko = parcelRequire("6XJko");

var $3JBFS = parcelRequire("3JBFS");
const $f15e1c62402ef612$export$68f5e1453c188a82 = ({ projectsRef: projectsRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'changed',
        actionSubject: 'resultsTable'
    });
    const [value, { updateFilter: updateFilter }] = (0, $3JBFS.useScopedFilter)((0, $2YWby.FilterFields).Page);
    const currentPage = parseInt(value, 10);
    const dataRef = (0, $j4oe4.useFragment)((0, $72Wpr.default), projectsRef);
    const handleChange = (0, $eJOHy.useCallback)((page)=>{
        updateFilter((0, $2YWby.FilterFields).Page, page.toString());
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'PageNumber');
    }, [
        analyticsEvent,
        updateFilter
    ]);
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKsYy.Pagination), {
        dataRef: dataRef,
        itemsPerPage: (0, $2YWby.DEFAULT_LIMIT),
        currentPage: currentPage,
        onChange: handleChange
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKsYy.Pagination), {
        dataRef: dataRef,
        itemsPerPage: (0, $2YWby.DEFAULT_LIMIT),
        currentPage: currentPage,
        onChange: handleChange
    });
};

});
parcelRegister("72Wpr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ccdf32ee426f027$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<278a452adea7689a9e2551bcd4ee9f68>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0ccdf32ee426f027$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "pagination_projectsDirectoryV3",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "pagination_directoryBaseV3"
        }
    ],
    "type": "JiraProjectConnection"
};
$0ccdf32ee426f027$var$node.hash = "ab05e4ef735cb6b0a98b29d30007a5ef";
var $0ccdf32ee426f027$export$2e2bcd8739ae039 = $0ccdf32ee426f027$var$node;

});

parcelRegister("fKsYy", function(module, exports) {

$parcel$export(module.exports, "Pagination", () => $ce8d367a5a5998bb$export$68f5e1453c188a82);

var $77MYw = parcelRequire("77MYw");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $b3eVo = parcelRequire("b3eVo");

var $lRq8t = parcelRequire("lRq8t");

var $5VfAT = parcelRequire("5VfAT");
const $ce8d367a5a5998bb$var$PAGES_TO_DISPLAY = 10;
const $ce8d367a5a5998bb$export$68f5e1453c188a82 = ({ dataRef: dataRef, itemsPerPage: itemsPerPage, currentPage: currentPage, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { totalCount: totalCount } = (0, $j4oe4.useFragment)((0, $77MYw.default), dataRef);
    const handlePageChange = (0, $eJOHy.useCallback)((_, page)=>{
        onChange(page);
    }, [
        onChange
    ]);
    const pages = (0, $eJOHy.useMemo)(()=>{
        if (!totalCount) return [];
        const totalPages = Math.ceil(totalCount / itemsPerPage);
        const middle = [];
        const end = Math.min(currentPage + $ce8d367a5a5998bb$var$PAGES_TO_DISPLAY, totalPages);
        const start = Math.max(currentPage - $ce8d367a5a5998bb$var$PAGES_TO_DISPLAY, 1);
        for(let i = start; i < end; i += 1)middle.push(i);
        return Array.from(new Set([
            1,
            ...middle,
            totalPages
        ]));
    }, [
        totalCount,
        itemsPerPage,
        currentPage
    ]);
    const selectedIndex = (0, $eJOHy.useMemo)(()=>pages.findIndex((p)=>p === currentPage), [
        pages,
        currentPage
    ]);
    if (!totalCount) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b3eVo.default), {
        pages: pages,
        onChange: handlePageChange,
        selectedIndex: selectedIndex,
        nextLabel: formatMessage((0, $5VfAT.default).next),
        previousLabel: formatMessage((0, $5VfAT.default).previous)
    });
};

});
parcelRegister("77MYw", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2c3bd1f1075f36e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9c2e64beddc9c311d09d56ae5eaf9bcb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c2c3bd1f1075f36e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "pagination_directoryBaseV3",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "totalCount"
        }
    ],
    "type": "HasTotal",
    "abstractKey": "__isHasTotal"
};
$c2c3bd1f1075f36e$var$node.hash = "38583de0cf0e75e654e4970a8d336719";
var $c2c3bd1f1075f36e$export$2e2bcd8739ae039 = $c2c3bd1f1075f36e$var$node;

});

parcelRegister("b3eVo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e9938bbbd4852c0$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $7O2l7 = parcelRequire("7O2l7");

var $a2JSB = parcelRequire("a2JSB");

var $1kTzc = parcelRequire("1kTzc");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $2xCo3 = parcelRequire("2xCo3");

var $6CP4r = parcelRequire("6CP4r");

var $3IiVn = parcelRequire("3IiVn");

var $1CN10 = parcelRequire("1CN10");

var $1hfAD = parcelRequire("1hfAD");
const $2e9938bbbd4852c0$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $2e9938bbbd4852c0$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $2e9938bbbd4852c0$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($a2JSB))) : (0, (/*@__PURE__*/$parcel$interopDefault($1kTzc)));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $2e9938bbbd4852c0$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor",
            size: "small"
        })
    });
}
function $2e9938bbbd4852c0$var$InnerPagination({ components: components = (0, $1CN10.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1CN10.emptyObject), max: max = 7, onChange: onChange = (0, $3Vuhz.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $3IiVn.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $7O2l7.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$2e9938bbbd4852c0$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
            as: "li",
            xcss: $2e9938bbbd4852c0$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6CP4r.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $2e9938bbbd4852c0$var$styles.paginationMenu,
                    children: (0, $1hfAD.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $2e9938bbbd4852c0$var$Pagination = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)($2e9938bbbd4852c0$var$InnerPagination));
var $2e9938bbbd4852c0$export$2e2bcd8739ae039 = $2e9938bbbd4852c0$var$Pagination;

});
parcelRegister("a2JSB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e34bc8237f35d48455854b605c0f874a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74fdae0df2a41f03$var$_react = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $74fdae0df2a41f03$var$_chevronLeft = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("8PCRQ")));

var $74fdae0df2a41f03$var$_chevronLeftLarge = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("k9ooi")));
function $74fdae0df2a41f03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74fdae0df2a41f03$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $74fdae0df2a41f03$var$_react.default.createElement($74fdae0df2a41f03$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $74fdae0df2a41f03$var$_chevronLeftLarge.default
    }, props));
$74fdae0df2a41f03$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $74fdae0df2a41f03$var$_default = module.exports.default = $74fdae0df2a41f03$var$ChevronLeftIcon;

});
parcelRegister("8PCRQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b851fec559156e1edca3c5f214f4a7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66e13c6de5d90262$var$_react = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $66e13c6de5d90262$var$_baseNew = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $66e13c6de5d90262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66e13c6de5d90262$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $66e13c6de5d90262$var$_react.default.createElement($66e13c6de5d90262$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$66e13c6de5d90262$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $66e13c6de5d90262$var$_default = module.exports.default = $66e13c6de5d90262$var$ChevronLeftIcon;

});

parcelRegister("k9ooi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eab7917427604e36$var$_react = $eab7917427604e36$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $eab7917427604e36$var$_chevronLeft = $eab7917427604e36$var$_interopRequireDefault((parcelRequire("8PCRQ")));
function $eab7917427604e36$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eab7917427604e36$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $eab7917427604e36$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $eab7917427604e36$var$_chevronLeft.default
    }));
$eab7917427604e36$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $eab7917427604e36$var$_default = module.exports.default = $eab7917427604e36$var$ChevronLeftLargeIcon;

});


parcelRegister("1kTzc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4724a1e5dc4e8ab6ea5bb133724929>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f92c313e495a986$var$_react = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $0f92c313e495a986$var$_chevronRight = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("cQxBL")));

var $0f92c313e495a986$var$_chevronRightLarge = $0f92c313e495a986$var$_interopRequireDefault((parcelRequire("czcci")));
function $0f92c313e495a986$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Next page of pagination results, collapsed tree item, expand tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f92c313e495a986$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $0f92c313e495a986$var$_react.default.createElement($0f92c313e495a986$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $0f92c313e495a986$var$_chevronRightLarge.default
    }, props));
$0f92c313e495a986$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $0f92c313e495a986$var$_default = module.exports.default = $0f92c313e495a986$var$ChevronRightIcon;

});
parcelRegister("czcci", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9262370c29d80ea9$var$_react = $9262370c29d80ea9$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $9262370c29d80ea9$var$_chevronRight = $9262370c29d80ea9$var$_interopRequireDefault((parcelRequire("cQxBL")));
function $9262370c29d80ea9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9262370c29d80ea9$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9262370c29d80ea9$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $9262370c29d80ea9$var$_chevronRight.default
    }));
$9262370c29d80ea9$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9262370c29d80ea9$var$_default = module.exports.default = $9262370c29d80ea9$var$ChevronRightLargeIcon;

});


parcelRegister("2xCo3", function(module, exports) {

$parcel$export(module.exports, "default", () => $390a465a7b875c7d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $390a465a7b875c7d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("6CP4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7a0738c73e50f62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $a7a0738c73e50f62$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("3IiVn", function(module, exports) {

$parcel$export(module.exports, "default", () => $eee95bde3b212432$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $6fs4r = parcelRequire("6fs4r");
const $eee95bde3b212432$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $eee95bde3b212432$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "li",
        testId: testId,
        xcss: $eee95bde3b212432$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3cMgR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6fs4r.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("1CN10", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $1b85b3c8ab534085$export$3f860eba1218f8d3);
const $1b85b3c8ab534085$export$3f860eba1218f8d3 = {};

});

parcelRegister("1hfAD", function(module, exports) {

$parcel$export(module.exports, "default", () => $916df7f6e7c50105$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $916df7f6e7c50105$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $LFmXM.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $916df7f6e7c50105$export$2e2bcd8739ae039 = $916df7f6e7c50105$var$collapseRange;

});


parcelRegister("5VfAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff5ffc7ed0382060$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ff5ffc7ed0382060$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    next: {
        "id": "pagination.next",
        "defaultMessage": "Next page"
    },
    previous: {
        "id": "pagination.previous",
        "defaultMessage": "Previous page"
    }
});

});



parcelRegister("7c6TJ", function(module, exports) {

$parcel$export(module.exports, "ResultsTable", () => $7a1e3fd5f8d9eb39$export$cd4354c9a18aa0b5);

var $96A5f = parcelRequire("96A5f");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $2YWby = parcelRequire("2YWby");

var $gNX15 = parcelRequire("gNX15");

var $cECwI = parcelRequire("cECwI");

var $3JBFS = parcelRequire("3JBFS");

var $dDA51 = parcelRequire("dDA51");

var $5TsXT = parcelRequire("5TsXT");

var $8hgwA = parcelRequire("8hgwA");
const $7a1e3fd5f8d9eb39$export$cd4354c9a18aa0b5 = ({ shouldShowCategories: shouldShowCategories, projectsRef: projectsRef, jiraQueryRef: jiraQueryRef, isAdminSettingsContext: isAdminSettingsContext })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isAnonymous = (0, $cECwI.useIsAnonymous)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'changed',
        actionSubject: 'resultsTable'
    });
    const [filter, { updateFilter: updateFilter }] = (0, $3JBFS.useFilter)();
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const projects = (0, $j4oe4.useFragment)((0, $96A5f.default), projectsRef);
    const head = (0, $eJOHy.useMemo)(()=>(0, $5TsXT.getTableHeader)({
            formatMessage: formatMessage,
            isAnonymous: isAnonymous,
            shouldShowCategories: shouldShowCategories,
            isAdminSettingsContext: isAdminSettingsContext
        }), [
        formatMessage,
        isAnonymous,
        shouldShowCategories,
        isAdminSettingsContext
    ]);
    const projectsItems = (0, $eJOHy.useMemo)(()=>{
        const totalCount = projects?.totalCount || 0;
        return projects?.pageInfo?.hasNextPage ? projects?.edges : projects?.edges?.slice(totalCount % (0, $2YWby.DEFAULT_LIMIT) * -1);
    }, [
        projects?.edges,
        projects?.pageInfo?.hasNextPage,
        projects?.totalCount
    ]);
    const rows = (0, $eJOHy.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        projectsItems?.map((project)=>project && (0, $8hgwA.getTableRow)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            project.node, isAdminSettingsContext, jiraQueryRef)).filter(Boolean), [
        projectsItems,
        isAdminSettingsContext,
        jiraQueryRef
    ]);
    const handleSort = (0, $eJOHy.useCallback)(({ key: key, sortOrder: sortOrder })=>{
        updateFilter({
            [(0, $2YWby.FilterFields).SortOrder]: sortOrder,
            [(0, $2YWby.FilterFields).SortKey]: key
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'SortOrder', {
            sortOrder: sortOrder,
            sortKey: key
        });
    }, [
        analyticsEvent,
        updateFilter
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // This change has been added to resolve https://jplat.atlassian.net/browse/BLU-4931
        handleSort({
            key: filter[(0, $2YWby.FilterFields).SortKey],
            // This suppression is consistent with existing code when the fix was added
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            sortOrder: filter[(0, $2YWby.FilterFields).SortOrder]
        });
    // We just want this to run once on component mount, so we don't need to add `filter` to the dependencies
    // Which is why we're suppressing the warning
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getCaptionText = ()=>{
        const tableCaptionSpecificProductSpecificCategoriesGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dDA51.default).tableCaptionSpecificProductSpecificCategoriesGalaxia : (0, $dDA51.default).tableCaptionSpecificProductSpecificCategories;
        const tableCaptionSpecificProductAllCategoriesGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dDA51.default).tableCaptionSpecificProductAllCategoriesGalaxia : (0, $dDA51.default).tableCaptionSpecificProductAllCategories;
        const tableCaptionSpecificCategoryGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dDA51.default).tableCaptionSpecificCategoryGalaxia : (0, $dDA51.default).tableCaptionSpecificCategory;
        const tableCaptionSpecificProductGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dDA51.default).tableCaptionSpecificProductGalaxia : (0, $dDA51.default).tableCaptionSpecificProduct;
        const tableCaptionAllProjectsAndAllCategoriesGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dDA51.default).tableCaptionAllProjectsAndAllCategoriesGalaxia : (0, $dDA51.default).tableCaptionAllProjectsAndAllCategories;
        const tableCaptionAllProjectsGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $dDA51.default).tableCaptionAllProjectsGalaxia : (0, $dDA51.default).tableCaptionAllProjects;
        const selectedProductsKeys = filter[(0, $2YWby.FilterFields).ProjectType]?.split(',').filter(Boolean) || [];
        const selectedProjectCategory = filter[(0, $2YWby.FilterFields).ProjectCategoryLabel];
        const selectedProductsLabels = filter[(0, $2YWby.FilterFields).ProjectTypeLabel];
        if (!selectedProductsKeys.length) {
            if (!shouldShowCategories) return formatMessage(tableCaptionAllProjectsGalaxia);
            if (!selectedProjectCategory) return formatMessage(tableCaptionAllProjectsAndAllCategoriesGalaxia);
            return formatMessage(tableCaptionSpecificCategoryGalaxia, {
                category: selectedProjectCategory
            });
        }
        if (!shouldShowCategories) return formatMessage(tableCaptionSpecificProductGalaxia, {
            product: selectedProductsLabels
        });
        if (!selectedProjectCategory) return formatMessage(tableCaptionSpecificProductAllCategoriesGalaxia, {
            product: selectedProductsLabels
        });
        return formatMessage(tableCaptionSpecificProductSpecificCategoriesGalaxia, {
            product: selectedProductsLabels,
            category: selectedProjectCategory
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gNX15.SimpleTable), {
        captionText: getCaptionText(),
        head: head,
        rows: rows,
        sortKey: filter[(0, $2YWby.FilterFields).SortKey],
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        sortOrder: filter[(0, $2YWby.FilterFields).SortOrder],
        onSort: handleSort
    });
};

});
parcelRegister("96A5f", function(module, exports) {

$parcel$export(module.exports, "default", () => $227d44470ac2c7f2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7df0b3b5b48dae9d5693144b33eee9ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $227d44470ac2c7f2$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAdminSettingsContext"
        }
    ],
    "kind": "Fragment",
    "name": "resultsTable_projectsDirectoryV3",
    "selections": [
        {
            "concreteType": "JiraProjectEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "favouriteCell_projectsDirectoryV3_FavoriteCell"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "nameCell_projectsDirectoryV3"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "keyCell_projectsDirectoryV3"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "projectTypeCell_projectsDirectoryV3"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "projectCategoryCell_projectsDirectoryV3"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "leadCell_projectsDirectoryV3"
                        },
                        {
                            "condition": "isAdminSettingsContext",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "lastIssueUpdateCell_projectsDirectoryV3"
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "urlCell_projectsDirectoryV3"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "actionsCell_projectsDirectoryV3_project"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalCount"
        },
        {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        }
    ],
    "type": "JiraProjectConnection"
};
$227d44470ac2c7f2$var$node.hash = "9ed13593445dfde5eabe8be75addbd2e";
var $227d44470ac2c7f2$export$2e2bcd8739ae039 = $227d44470ac2c7f2$var$node;

});

parcelRegister("gNX15", function(module, exports) {

$parcel$export(module.exports, "SimpleTable", () => $d14eb68022387c04$export$3fe48f9151d0ecc2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $f2JN3 = parcelRequire("f2JN3");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $9iDYo = parcelRequire("9iDYo");

var $9mLID = parcelRequire("9mLID");

var $cqa3B = parcelRequire("cqa3B");

var $18PIn = parcelRequire("18PIn");
const $d14eb68022387c04$export$3fe48f9151d0ecc2 = ({ head: head, rows: rows, sortKey: sortKey, sortOrder: sortOrder, onSort: onSort, captionText: captionText })=>{
    const columnKeys = (0, $eJOHy.useMemo)(()=>head.cells.map((cell)=>cell.key), [
        head
    ]);
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const alertMessage = sortOrder === (0, $9mLID.SortOrder).ASC ? (0, $9iDYo.default).srOnlySortingAlertAsc : (0, $9iDYo.default).srOnlySortingAlertDesc;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d14eb68022387c04$export$54ec01a60f47d33d, null, captionText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d14eb68022387c04$var$SrOnlyCaption, null, captionText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d14eb68022387c04$var$SrOnlyCaption, null, formatMessage((0, $9iDYo.default).srOnlyCaption), sortOrder && // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        "aria-live": "polite",
        "aria-relevant": "text"
    }, formatMessage(alertMessage, {
        sortKey: sortKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cqa3B.TableHead), {
        onSort: onSort,
        ...head,
        sortKey: sortKey,
        sortOrder: sortOrder
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("tbody", null, rows.map((rowProps, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $18PIn.TableRow), {
            isLastRow: (0, $6XJko.isVisualRefreshEnabled)() ? index === rows.length - 1 : false,
            columnKeys: columnKeys,
            ...rowProps,
            key: `table-row-${index}`
        }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d14eb68022387c04$var$TableOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "table", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_yq5hcfaq _1bsb1osq _1kqm1n9t _19pkidpf _2hwxidpf _otyr1ejb _18u0idpf",
            __cmplp.className
        ])
    });
});
const $d14eb68022387c04$export$54ec01a60f47d33d = (0, $f2JN3.componentWithCondition)(()=>(0, $6XJko.isVisualRefreshEnabled)(), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "table",
        xcss: $d14eb68022387c04$var$tableStyles
    }, children), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($d14eb68022387c04$var$TableOld, null, children));
const $d14eb68022387c04$var$tableStyles = (0, $1DXK0.xcss)({
    width: '100%',
    tableLayout: 'fixed',
    margin: 'space.0',
    marginBottom: 'space.300',
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    borderRadius: 'border.radius.200',
    borderCollapse: 'separate',
    borderSpacing: 0,
    overflow: 'hidden'
});
const $d14eb68022387c04$var$srOnlyStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d14eb68022387c04$var$SrOnlyCaption = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _kqswstnw _154i1wug _ogto7mnp _1bsbt94y _4t3it94y _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9iDYo", function(module, exports) {

$parcel$export(module.exports, "default", () => $95fe2a5bed5e4d5b$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $95fe2a5bed5e4d5b$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    srOnlyCaption: {
        "id": "simple-table.sr-only-caption",
        "defaultMessage": "Use column header buttons to sort"
    },
    srOnlySortingAlertAsc: {
        "id": "simple-table.sr-only-sorting-alert-asc",
        "defaultMessage": "{sortKey} column is sorted by ascending order"
    },
    srOnlySortingAlertDesc: {
        "id": "simple-table.sr-only-sorting-alert-desc",
        "defaultMessage": "{sortKey} column is sorted by descending order"
    }
});

});

parcelRegister("9mLID", function(module, exports) {

$parcel$export(module.exports, "SortOrder", () => $a95162e2c2872d09$export$7ae723045d45777a);
$parcel$export(module.exports, "SortOrderLabel", () => $a95162e2c2872d09$export$6123155563a1925);
const $a95162e2c2872d09$export$7ae723045d45777a = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $a95162e2c2872d09$export$6123155563a1925 = {
    ASC: 'ascending',
    DESC: 'descending'
};

});

parcelRegister("cqa3B", function(module, exports) {

$parcel$export(module.exports, "TableHead", () => $2fd551f9fd08d0e3$export$2f4a7be4f0dcc2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");

var $2WYS9 = parcelRequire("2WYS9");
const $2fd551f9fd08d0e3$export$2f4a7be4f0dcc2 = ({ cells: cells, sortOrder: sortOrder, sortKey: sortKey, onSort: onSort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2fd551f9fd08d0e3$export$686fc6781ca5e30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2fd551f9fd08d0e3$export$2ed37f428538a29e, null, cells.map((headCell)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2WYS9.HeadCell), {
            ...headCell,
            key: headCell.key,
            onSort: onSort,
            sortOrder: sortOrder,
            sortKey: sortKey,
            cellKey: headCell.key
        }))));
const $2fd551f9fd08d0e3$var$SortIconContainerSelector = 'simple-table-sort-icon-container';
const $2fd551f9fd08d0e3$var$SortableIconCellContentWrapperSelector = 'simple-table-sortable-icon-cell-content-wrapper';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2fd551f9fd08d0e3$var$TableHeadContainerOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "thead", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itglyw _1r04idpf _s7n4nkob _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $2fd551f9fd08d0e3$export$686fc6781ca5e30 = (0, $f2JN3.componentWithCondition)(()=>(0, $6XJko.isVisualRefreshEnabled)(), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "thead",
        xcss: $2fd551f9fd08d0e3$var$tableHeadStyles
    }, children), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2fd551f9fd08d0e3$var$TableHeadContainerOld, null, children));
const $2fd551f9fd08d0e3$var$tableHeadStyles = (0, $1DXK0.xcss)({
    verticalAlign: 'middle',
    inset: 'space.0',
    position: 'relative',
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    backgroundColor: 'elevation.surface.sunken',
    borderTopLeftRadius: 'border.radius.200',
    height: 'space.500'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2fd551f9fd08d0e3$var$TableHeadRowContainerOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_189e18uv _1dqoglyw _1h6d18uv _4t3i14no _10dk105o _bd0s105o _aswu1b66 _d1ad1b66 _174iidpf _1thxidpf",
            __cmplp.className
        ])
    });
});
const $2fd551f9fd08d0e3$export$2ed37f428538a29e = (0, $f2JN3.componentWithCondition)(()=>(0, $6XJko.isVisualRefreshEnabled)(), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "tr"
    }, children), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2fd551f9fd08d0e3$var$TableHeadRowContainerOld, null, children));

});
parcelRegister("2WYS9", function(module, exports) {

$parcel$export(module.exports, "HeadCell", () => $2bac8e52eb5fa2f6$export$4e8024263ace498b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $3ZjSN = parcelRequire("3ZjSN");

var $k71qx = parcelRequire("k71qx");

var $7jTnu = parcelRequire("7jTnu");

var $f2JN3 = parcelRequire("f2JN3");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $9mLID = parcelRequire("9mLID");

var $f8sbK = parcelRequire("f8sbK");
const $2bac8e52eb5fa2f6$var$TooltipContent = ({ children: children, sortOrder: sortOrder })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bac8e52eb5fa2f6$var$TooltipContentWrapper, null, children, " \u2022", ' ', formatMessage(sortOrder === (0, $9mLID.SortOrder).ASC ? (0, $f8sbK.default).tooltipAscSortingDirectionContent : (0, $f8sbK.default).tooltipDescSortingDirectionContent));
};
const $2bac8e52eb5fa2f6$var$TooltipWrapper = ({ tooltipContent: tooltipContent, content: content, sortOrder: sortOrder, children: children })=>{
    if (false) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltipContent || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bac8e52eb5fa2f6$var$TooltipContent, {
            sortOrder: sortOrder
        }, content),
        position: "top"
    }, children);
};
const $2bac8e52eb5fa2f6$export$1c3e7abe01fad210 = 'simple-table-sortable-icon-cell-content-wrapper';
const $2bac8e52eb5fa2f6$export$4e8024263ace498b = ({ isSortable: isSortable, cellKey: cellKey, content: content, sortKey: sortKey, sortOrder: sortOrder, tooltipContent: tooltipContent, onSort: onSort, width: width, textAlign: textAlign, isIconColumn: isIconColumn, element: element })=>{
    const isActive = cellKey === sortKey;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const handleClick = (0, $eJOHy.useCallback)(()=>onSort({
            key: cellKey,
            sortOrder: isActive && sortOrder === (0, $9mLID.SortOrder).ASC ? (0, $9mLID.SortOrder).DESC : (0, $9mLID.SortOrder).ASC
        }), [
        cellKey,
        sortOrder,
        onSort,
        isActive
    ]);
    let sortableValue;
    if (isSortable) {
        sortableValue = 'none';
        if (isActive && sortOrder) sortableValue = (0, $9mLID.SortOrderLabel)[sortOrder];
    }
    const buttonProperties = {
        'aria-roledescription': isSortable ? formatMessage((0, $f8sbK.default).a11YSortButtonDescriptionLabel) : undefined
    };
    const wrappedContent = isIconColumn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bac8e52eb5fa2f6$var$IconCellContentWrapper, {
        "data-component-selector": isSortable ? $2bac8e52eb5fa2f6$export$1c3e7abe01fad210 : '',
        isSortable: isSortable,
        isActive: isActive
    }, content) : content;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bac8e52eb5fa2f6$var$HeadCellContainer, {
        as: element,
        isSortable: isSortable,
        width: width,
        "aria-sort": sortableValue,
        textAlign: textAlign,
        isIconColumn: isIconColumn,
        isA11YArrowHoverColourFG: (0, $7jTnu.fg)('blu-7427_sorting_arrow_colour_contrast_a11y')
    }, isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bac8e52eb5fa2f6$var$TooltipWrapper, {
        tooltipContent: tooltipContent,
        content: content,
        sortOrder: sortOrder
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bac8e52eb5fa2f6$var$SortHeadCellContainer, {
        width: width,
        isActive: isActive,
        onClick: handleClick,
        isIconColumn: isIconColumn,
        isVisualRefresh: (0, $6XJko.isVisualRefreshEnabled)(),
        ...buttonProperties
    }, wrappedContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2bac8e52eb5fa2f6$var$SortIconContainer, {
        isActive: isActive,
        sortOrder: sortOrder,
        isIconColumn: isIconColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3ZjSN))), {
        LEGACY_size: "small",
        label: "",
        color: "var(--ds-text-subtle, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)"
    })))) : wrappedContent);
};
const $2bac8e52eb5fa2f6$var$SortIconContainerSelector = 'simple-table-sort-icon-container'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2bac8e52eb5fa2f6$var$SortIconContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, isIconColumn: isIconColumn, sortOrder: sortOrder, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v5641b4w",
            __cmplp.isActive ? "_tzy4zg3v" : "_tzy4idpf",
            __cmplp.isActive || __cmplp.isIconColumn ? "_18u01b66" : "_18u0idpf",
            __cmplp.isIconColumn ? "_2hwx1b66" : "_2hwxidpf",
            __cmplp.sortOrder === (0, $9mLID.SortOrder).DESC ? "_t9ec1sub" : "_t9ecglyw",
            __cmplp.className
        ])
    });
});
$2bac8e52eb5fa2f6$var$SortIconContainer.defaultProps = {
    'data-component-selector': $2bac8e52eb5fa2f6$var$SortIconContainerSelector
};
const $2bac8e52eb5fa2f6$var$IconCellContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSortable: isSortable, isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v564wz4i _154i1ssb _1ltv1ssb",
            __cmplp.isSortable ? "_kqswstnw" : "_kqswn7od",
            __cmplp.isActive ? "_tzy4grf3" : "_tzy4kb7n",
            __cmplp.isSortable ? "_t9ec1ooe" : "_t9ecglyw",
            __cmplp.className
        ])
    });
});
const $2bac8e52eb5fa2f6$var$HeadCellContainerOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSortable: isSortable, isIconColumn: isIconColumn, textAlign: textAlign, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $awdRS.default)(__cmplp.width, "%"),
            "--_1tpx2gk": (0, $awdRS.default)(__cmplp.textAlign)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_5pio18uv _11c82smr _1h6d18uv _1dqoglyw _189e18uv _1e0cdav6 _kqswh2mm _r06hglyw _s7n4nkob _vchhusvi _k48p1wq8 _syaz1fxt _1tesidpf _1cs8stnw _txdo12hm _1kt9b3bt _dsq4glyw _19woidpf _1aukidpf",
            __cmplp.isSortable || __cmplp.isIconColumn && __cmplp.textAlign === 'center' ? "_19bvidpf" : "_19bvu2gc",
            __cmplp.isIconColumn && __cmplp.textAlign === 'center' ? "_u5f3idpf" : "_u5f3u2gc",
            __cmplp.width ? "_1bsb1efm" : "_1bsb1osq",
            __cmplp.textAlign && "_y3gnp1rm",
            __cmplp.isSortable || __cmplp.isIconColumn && __cmplp.textAlign === 'center' ? "_1lhcidpf" : "_1lhcu2gc",
            __cmplp.isIconColumn && __cmplp.textAlign === 'center' ? "_1o59idpf" : "_1o59u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2bac8e52eb5fa2f6$var$HeadCellContainerNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSortable: isSortable, isIconColumn: isIconColumn, textAlign: textAlign, isA11YArrowHoverColourFG: isA11YArrowHoverColourFG, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $awdRS.default)(__cmplp.width, "%"),
            "--_1tpx2gk": (0, $awdRS.default)(__cmplp.textAlign)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_5pio18uv _11c81vhk _1h6d18uv _1dqoglyw _189e18uv _n7zlzgxb _1e0cdav6 _kqswh2mm _r06hglyw _s7n4nkob _vchhusvi _syaz1gjq _aswu1b66 _d1ad1b66 _174iidpf _1thxidpf",
            __cmplp.isSortable || __cmplp.isIconColumn && __cmplp.textAlign === 'center' ? "_19bvidpf" : "_19bvu2gc",
            __cmplp.isIconColumn && __cmplp.textAlign === 'center' ? "_u5f3idpf" : "_u5f3u2gc",
            __cmplp.width ? "_1bsb1efm" : "_1bsb1osq",
            __cmplp.textAlign && "_y3gnp1rm",
            __cmplp.isSortable || __cmplp.isIconColumn && __cmplp.textAlign === 'center' ? "_1lhcidpf" : "_1lhcu2gc",
            __cmplp.isIconColumn && __cmplp.textAlign === 'center' ? "_1o59idpf" : "_1o59u2gc",
            __cmplp.isA11YArrowHoverColourFG ? "_10dk15iw _bd0s15iw" : "_10dk105o _bd0s105o",
            __cmplp.className
        ])
    });
});
const $2bac8e52eb5fa2f6$var$HeadCellContainer = (0, $f2JN3.componentWithCondition)(()=>(0, $6XJko.isVisualRefreshEnabled)(), $2bac8e52eb5fa2f6$var$HeadCellContainerNew, $2bac8e52eb5fa2f6$var$HeadCellContainerOld);
const $2bac8e52eb5fa2f6$var$SortHeadCellContainerOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIconColumn: isIconColumn, isVisualRefresh: isVisualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_tsntec": (0, $awdRS.default)(`${"var(--ds-space-050, 4px)"} ${__cmplp.isIconColumn && __cmplp.isVisualRefresh ? "var(--ds-space-0, 0px)" : "var(--ds-space-100, 8px)"}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itidpf _11q7glyw _11c82smr _1yt46tij _2rkosqtm _k48p1wq8 _syaz1fxt _16qsidpf _1e0c116y _80omtlke _1di6qbzx _irr3qbzx",
            __cmplp.isIconColumn ? "_kqswh2mm" : "_kqswn7od",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2bac8e52eb5fa2f6$var$SortHeadCellContainerNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isIconColumn: isIconColumn, isVisualRefresh: isVisualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_tsntec": (0, $awdRS.default)(`${"var(--ds-space-050, 4px)"} ${__cmplp.isIconColumn && __cmplp.isVisualRefresh ? "var(--ds-space-0, 0px)" : "var(--ds-space-100, 8px)"}`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19itidpf _11q7glyw _11c81vhk _1yt46tij _2rkoglpi _syaz1gjq _4cvr1h6o _1e0c116y _80omtlke _1di6qbzx _irr3qbzx",
            __cmplp.isIconColumn ? "_kqswh2mm" : "_kqswn7od",
            __cmplp.className
        ])
    });
});
const $2bac8e52eb5fa2f6$var$SortHeadCellContainer = (0, $f2JN3.componentWithCondition)(()=>(0, $6XJko.isVisualRefreshEnabled)(), $2bac8e52eb5fa2f6$var$SortHeadCellContainerNew, $2bac8e52eb5fa2f6$var$SortHeadCellContainerOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2bac8e52eb5fa2f6$var$TooltipContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1p1d1dk0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3ZjSN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c41b8a7a2a0e885f53178dceb7a8d3e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e767de815953df7$var$_react = $2e767de815953df7$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $2e767de815953df7$var$_arrowDown = $2e767de815953df7$var$_interopRequireDefault((parcelRequire("8Gywp")));

var $2e767de815953df7$var$_arrowDown2 = $2e767de815953df7$var$_interopRequireDefault((parcelRequire("56U2f")));
function $2e767de815953df7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowDownIcon.
 * This component is ArrowDownIcon, with `UNSAFE_fallbackIcon` set to "ArrowDownIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2e767de815953df7$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $2e767de815953df7$var$_react.default.createElement($2e767de815953df7$var$_arrowDown.default, Object.assign({
        LEGACY_fallbackIcon: $2e767de815953df7$var$_arrowDown2.default
    }, props));
$2e767de815953df7$var$ArrowDownIcon.Name = 'ArrowDownIconMigration';
var $2e767de815953df7$var$_default = module.exports.default = $2e767de815953df7$var$ArrowDownIcon;

});
parcelRegister("8Gywp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d7f5a6659a6d5dd6eaa41936b6c8533f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $652d0645e24346a6$var$_react = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $652d0645e24346a6$var$_baseNew = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $652d0645e24346a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $652d0645e24346a6$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $652d0645e24346a6$var$_react.default.createElement($652d0645e24346a6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$652d0645e24346a6$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $652d0645e24346a6$var$_default = module.exports.default = $652d0645e24346a6$var$ArrowDownIcon;

});

parcelRegister("56U2f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b88fabfb9049421$var$_react = $3b88fabfb9049421$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $3b88fabfb9049421$var$_arrowDown = $3b88fabfb9049421$var$_interopRequireDefault((parcelRequire("8Gywp")));
function $3b88fabfb9049421$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3b88fabfb9049421$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $3b88fabfb9049421$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11 6v9.586l-3.793-3.793a1 1 0 0 0-1.414 0c-.39.39-.39 1.024 0 1.415l5.5 5.499A1 1 0 0 0 12 19a1 1 0 0 0 .707-.293l5.5-5.499a1 1 0 1 0-1.414-1.415L13 15.586V6a1 1 0 0 0-2 0"/></svg>`
    }, props, {
        newIcon: $3b88fabfb9049421$var$_arrowDown.default
    }));
$3b88fabfb9049421$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $3b88fabfb9049421$var$_default = module.exports.default = $3b88fabfb9049421$var$ArrowDownIcon;

});


parcelRegister("f8sbK", function(module, exports) {

$parcel$export(module.exports, "default", () => $494196207036609a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $494196207036609a$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tooltipAscSortingDirectionContent: {
        "id": "simple-table.table-head.table-head-cell.tooltip-asc-sorting-direction-content",
        "defaultMessage": "A \u279E Z"
    },
    tooltipDescSortingDirectionContent: {
        "id": "simple-table.table-head.table-head-cell.tooltip-desc-sorting-direction-content",
        "defaultMessage": "Z \u279E A"
    },
    a11YSortButtonDescriptionLabel: {
        "id": "simple-table.table-head.table-head-cell.a-11-y-sort-button-description-label",
        "defaultMessage": "column sort button"
    }
});

});



parcelRegister("18PIn", function(module, exports) {

$parcel$export(module.exports, "TableRow", () => $92f90f22928d1a17$export$b05581f4e764e162);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $f2JN3 = parcelRequire("f2JN3");

var $6XJko = parcelRequire("6XJko");

var $90QsY = parcelRequire("90QsY");
const $92f90f22928d1a17$export$b05581f4e764e162 = ({ columnKeys: columnKeys, cells: cells, isLastRow: isLastRow })=>{
    const Cells = (0, $eJOHy.useMemo)(()=>cells.filter((cell)=>columnKeys.includes(cell.key)).map(({ key: key, content: content })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($92f90f22928d1a17$var$TableCell, {
                isLastRow: isLastRow,
                key: `table-row-cell-${key}`
            }, content)), [
        columnKeys,
        cells,
        isLastRow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($92f90f22928d1a17$var$TableRowContainer, null, Cells);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $92f90f22928d1a17$var$TableRowContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_189e18uv _1dqoglyw _1h6d18uv _4t3ickbl _kqswh2mm _1bsb1osq _irr3166n",
            __cmplp.className
        ])
    });
});
const $92f90f22928d1a17$var$CellContainerNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLastRow: isLastRow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_5pio18uv _1h6d18uv _1dqoglyw _189e18uv _r06hglyw _vchhusvi _1e0cdav6 _19bvu2gc _u5f3u2gc _kqswh2mm _s7n4nkob _1bsbzwfg _1lhcu2gc _1o59u2gc",
            __cmplp.isLastRow ? "_n7zlglyw" : "_n7zlzgxb",
            __cmplp.className
        ])
    });
});
const $92f90f22928d1a17$var$TableCell = (0, $f2JN3.componentWithCondition)(()=>(0, $6XJko.isVisualRefreshEnabled)(), $92f90f22928d1a17$var$CellContainerNew, (0, $90QsY.CellContainer));

});
parcelRegister("90QsY", function(module, exports) {

$parcel$export(module.exports, "CellContainer", () => $faefd00d840c8bdd$export$287da707e3318210);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $faefd00d840c8bdd$export$287da707e3318210 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_5pio18uv _1h6d18uv _1dqoglyw _189e18uv _r06hglyw _vchhusvi _1e0cdav6 _19bvu2gc _u5f3u2gc _kqswh2mm _s7n4nkob _1bsbzwfg _1lhcu2gc _1o59u2gc",
            __cmplp.className
        ])
    });
});

});



parcelRegister("dDA51", function(module, exports) {

$parcel$export(module.exports, "default", () => $3704d7b63dad8e4d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3704d7b63dad8e4d$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    tableCaptionAllProjects: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-caption-all-projects",
        "defaultMessage": "Table showing all projects"
    },
    tableCaptionAllProjectsAndAllCategories: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-caption-all-projects-and-all-categories",
        "defaultMessage": "Table showing all projects for all categories."
    },
    tableCaptionSpecificProduct: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-product",
        "defaultMessage": "Table showing {product} projects."
    },
    tableCaptionSpecificCategory: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-category",
        "defaultMessage": "Table showing all projects for {category} category"
    },
    tableCaptionSpecificProductAllCategories: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-product-all-categories",
        "defaultMessage": "Table showing {product} projects for all categories"
    },
    tableCaptionSpecificProductSpecificCategories: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-product-specific-categories",
        "defaultMessage": "Table showing {product} projects for {category} category"
    },
    tableCaptionAllProjectsGalaxia: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-caption-all-projects-galaxia",
        "defaultMessage": "Table showing all spaces"
    },
    tableCaptionAllProjectsAndAllCategoriesGalaxia: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-caption-all-projects-and-all-categories-galaxia",
        "defaultMessage": "Table showing all spaces for all categories."
    },
    tableCaptionSpecificProductGalaxia: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-product-galaxia",
        "defaultMessage": "Table showing {product} spaces."
    },
    tableCaptionSpecificCategoryGalaxia: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-category-galaxia",
        "defaultMessage": "Table showing all spaces for {category} category"
    },
    tableCaptionSpecificProductAllCategoriesGalaxia: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-product-all-categories-galaxia",
        "defaultMessage": "Table showing {product} spaces for all categories"
    },
    tableCaptionSpecificProductSpecificCategoriesGalaxia: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-caption-specific-product-specific-categories-galaxia",
        "defaultMessage": "Table showing {product} spaces for {category} category"
    }
});

});

parcelRegister("5TsXT", function(module, exports) {

$parcel$export(module.exports, "getTableHeader", () => $9ad6aeed7f4eee50$export$ee524713fdf0677d);

var $eJOHy = parcelRequire("eJOHy");

var $epTsa = parcelRequire("epTsa");

var $2YWby = parcelRequire("2YWby");

var $6XJko = parcelRequire("6XJko");

var $dgjrF = parcelRequire("dgjrF");

var $hEHz0 = parcelRequire("hEHz0");
const $9ad6aeed7f4eee50$export$ee524713fdf0677d = ({ formatMessage: formatMessage, isAnonymous: isAnonymous, shouldShowCategories: shouldShowCategories, isAdminSettingsContext: isAdminSettingsContext })=>{
    const projectUrlGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $hEHz0.messages).projectUrlGalaxia : (0, $hEHz0.messages).projectUrl;
    return {
        cells: [
            {
                key: (0, $2YWby.TableColumns).Favourites,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dgjrF.StarredHeader), {
                    label: formatMessage((0, $hEHz0.messages).starred)
                }),
                width: 2.85,
                testId: 'jira-project-directory.results-table.header.favourites',
                disabled: isAnonymous,
                isIconColumn: true,
                textAlign: 'center'
            },
            {
                key: (0, $2YWby.TableColumns).Name,
                content: formatMessage((0, $hEHz0.messages).name),
                width: 22,
                testId: 'jira-project-directory.results-table.header.name'
            },
            {
                key: (0, $2YWby.TableColumns).Key,
                content: formatMessage((0, $hEHz0.messages).key),
                width: 12,
                testId: 'jira-project-directory.results-table.header.key'
            },
            {
                key: (0, $2YWby.TableColumns).Type,
                content: formatMessage((0, $hEHz0.messages).type),
                width: 20,
                testId: 'jira-project-directory.results-table.header.type'
            },
            {
                key: (0, $2YWby.TableColumns).Lead,
                content: formatMessage((0, $hEHz0.messages).owner),
                width: shouldShowCategories ? 20 : 36,
                testId: 'jira-project-directory.results-table.header.owner'
            },
            {
                key: (0, $2YWby.TableColumns).Category,
                content: formatMessage((0, $hEHz0.messages).category),
                width: 16,
                testId: 'jira-project-directory.results-table.header.category',
                disabled: !shouldShowCategories
            },
            {
                key: (0, $2YWby.TableColumns).LastIssueUpdate,
                content: formatMessage((0, $epTsa.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hEHz0.messages).lastIssueUpdateIssueTermRefresh : (0, $hEHz0.messages).lastIssueUpdate),
                width: 16,
                testId: 'jira-project-directory.results-table.header.last-issue-update',
                disabled: !isAdminSettingsContext
            },
            {
                key: (0, $2YWby.TableColumns).Url,
                content: formatMessage(projectUrlGalaxia),
                width: (0, $6XJko.isVisualRefreshEnabled)() ? 15 : 7,
                testId: 'jira-project-directory.results-table.header.url'
            },
            ...!(0, $6XJko.isVisualRefreshEnabled)() ? [
                {
                    key: (0, $2YWby.TableColumns).Action,
                    content: formatMessage((0, $hEHz0.messages).action),
                    width: 8,
                    textAlign: 'right',
                    testId: 'jira-project-directory.results-table.header.action'
                }
            ] : []
        ].filter((cell)=>!cell.disabled).map((cell)=>({
                ...cell,
                isSortable: (0, $2YWby.SortableColumns).includes(cell.key)
            }))
    };
};

});
parcelRegister("dgjrF", function(module, exports) {

$parcel$export(module.exports, "StarredHeader", () => $0af5e4cbe8991b27$export$808dc759b0b23f14);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1zDn7 = parcelRequire("1zDn7");
const $0af5e4cbe8991b27$export$808dc759b0b23f14 = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($0af5e4cbe8991b27$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1zDn7))), {
        color: "currentColor",
        label: label,
        LEGACY_size: "small"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0af5e4cbe8991b27$var$ContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1zDn7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b98083f7180ee5a6483375174c0842e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $125799c0d76ceff5$var$_react = $125799c0d76ceff5$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $125799c0d76ceff5$var$_starStarred = $125799c0d76ceff5$var$_interopRequireDefault((parcelRequire("gGgaG")));

var $125799c0d76ceff5$var$_starFilled = $125799c0d76ceff5$var$_interopRequireDefault((parcelRequire("91hUW")));
function $125799c0d76ceff5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StarStarredIcon.
 * This component is StarStarredIcon, with `UNSAFE_fallbackIcon` set to "StarFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $125799c0d76ceff5$var$StarStarredIcon = (props)=>/*#__PURE__*/ $125799c0d76ceff5$var$_react.default.createElement($125799c0d76ceff5$var$_starStarred.default, Object.assign({
        LEGACY_fallbackIcon: $125799c0d76ceff5$var$_starFilled.default
    }, props));
$125799c0d76ceff5$var$StarStarredIcon.Name = 'StarStarredIconMigration';
var $125799c0d76ceff5$var$_default = module.exports.default = $125799c0d76ceff5$var$StarStarredIcon;

});
parcelRegister("gGgaG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c24d1cda47746043$var$_react = $c24d1cda47746043$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $c24d1cda47746043$var$_baseNew = $c24d1cda47746043$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $c24d1cda47746043$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c24d1cda47746043$var$StarStarredIcon = (props)=>/*#__PURE__*/ $c24d1cda47746043$var$_react.default.createElement($c24d1cda47746043$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$c24d1cda47746043$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $c24d1cda47746043$var$_default = module.exports.default = $c24d1cda47746043$var$StarStarredIcon;

});

parcelRegister("91hUW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $69121b14e227da1b$var$_react = $69121b14e227da1b$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $69121b14e227da1b$var$_starStarred = $69121b14e227da1b$var$_interopRequireDefault((parcelRequire("gGgaG")));
function $69121b14e227da1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $69121b14e227da1b$var$StarFilledIcon = (props)=>/*#__PURE__*/ $69121b14e227da1b$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props, {
        newIcon: $69121b14e227da1b$var$_starStarred.default
    }));
$69121b14e227da1b$var$StarFilledIcon.displayName = 'StarFilledIcon';
var $69121b14e227da1b$var$_default = module.exports.default = $69121b14e227da1b$var$StarFilledIcon;

});



parcelRegister("hEHz0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $cb05f504a1be8714$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $cb05f504a1be8714$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    starred: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.starred",
        "defaultMessage": "Starred"
    },
    name: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.name",
        "defaultMessage": "Name"
    },
    key: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.key",
        "defaultMessage": "Key"
    },
    type: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.type",
        "defaultMessage": "Type"
    },
    owner: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.owner",
        "defaultMessage": "Lead"
    },
    category: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.category",
        "defaultMessage": "Category"
    },
    lastIssueUpdate: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.last-issue-update",
        "defaultMessage": "Last issue update"
    },
    projectUrl: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.project-url",
        "defaultMessage": "Project URL"
    },
    // delete this when cleaning up isVisualRefreshEnabled FG
    action: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.action",
        "defaultMessage": "More actions"
    },
    lastIssueUpdateIssueTermRefresh: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.last-issue-update-issue-term-refresh",
        "defaultMessage": "Last work update"
    },
    projectUrlGalaxia: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-head.project-url-galaxia",
        "defaultMessage": "Space URL"
    }
});

});


parcelRegister("8hgwA", function(module, exports) {

$parcel$export(module.exports, "getTableRow", () => $c71f9c5b580620b3$export$8a668e19c44a2b13);

var $eJOHy = parcelRequire("eJOHy");

var $2sLVw = parcelRequire("2sLVw");

var $2YWby = parcelRequire("2YWby");

var $6XJko = parcelRequire("6XJko");

var $goZs6 = parcelRequire("goZs6");

var $2Q58E = parcelRequire("2Q58E");

var $1TZVp = parcelRequire("1TZVp");

var $kewVL = parcelRequire("kewVL");

var $3S9oE = parcelRequire("3S9oE");

var $d3aM8 = parcelRequire("d3aM8");

var $lw8GH = parcelRequire("lw8GH");

var $55eHL = parcelRequire("55eHL");

var $ftvZv = parcelRequire("ftvZv");
const $c71f9c5b580620b3$export$8a668e19c44a2b13 = (projectRef, isAdminSettingsContext = false, jiraQueryRef)=>({
        cells: [
            {
                key: (0, $2YWby.TableColumns).Favourites,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2Q58E.FavoriteCell), {
                    project: projectRef
                })
            },
            {
                key: (0, $2YWby.TableColumns).Name,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d3aM8.NameCell), {
                    project: projectRef
                })
            },
            {
                key: (0, $2YWby.TableColumns).Key,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1TZVp.KeyCell), {
                    project: projectRef
                })
            },
            {
                key: (0, $2YWby.TableColumns).Type,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $55eHL.ProjectTypeCell), {
                    project: projectRef
                })
            },
            {
                key: (0, $2YWby.TableColumns).Lead,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3S9oE.LeadCell), {
                    project: projectRef
                })
            },
            {
                key: (0, $2YWby.TableColumns).Category,
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lw8GH.ProjectCategoryCell), {
                    project: projectRef
                })
            },
            ...isAdminSettingsContext ? [
                {
                    key: (0, $2YWby.TableColumns).LastIssueUpdate,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kewVL.LastIssueUpdateCell), {
                        project: projectRef
                    })
                }
            ] : [],
            {
                key: (0, $2YWby.TableColumns).Url,
                content: (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
                    alignItems: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ftvZv.UrlCell), {
                    project: projectRef
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZs6.ActionsCell), {
                    project: projectRef,
                    jiraQueryRef: jiraQueryRef
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ftvZv.UrlCell), {
                    project: projectRef
                })
            },
            ...!(0, $6XJko.isVisualRefreshEnabled)() ? [
                {
                    key: (0, $2YWby.TableColumns).Action,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZs6.ActionsCell), {
                        project: projectRef,
                        jiraQueryRef: jiraQueryRef
                    })
                }
            ] : []
        ]
    });

});
parcelRegister("goZs6", function(module, exports) {

$parcel$export(module.exports, "ActionsCell", () => $adc77ab26ee2035e$export$eee95bbb96e96f7b);

var $kjnwE = parcelRequire("kjnwE");

var $9b6XI = parcelRequire("9b6XI");

var $1We7P = parcelRequire("1We7P");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $aMdh8 = parcelRequire("aMdh8");

var $956it = parcelRequire("956it");

var $Ay1uj = parcelRequire("Ay1uj");

var $2sLVw = parcelRequire("2sLVw");

var $ln6Iy = parcelRequire("ln6Iy");

var $ciFJV = parcelRequire("ciFJV");

var $cystD = parcelRequire("cystD");

var $bbdV2 = parcelRequire("bbdV2");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $jd93d = parcelRequire("jd93d");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lldWQ = parcelRequire("lldWQ");

var $5YT8x = parcelRequire("5YT8x");

var $dd65x = parcelRequire("dd65x");

var $ijMKb = parcelRequire("ijMKb");

var $2ruNJ = parcelRequire("2ruNJ");

var $4aSRi = parcelRequire("4aSRi");

var $8vyDv = parcelRequire("8vyDv");

var $gZTP9 = parcelRequire("gZTP9");

var $c9uTK = parcelRequire("c9uTK");

var $6XJko = parcelRequire("6XJko");

var $3JBFS = parcelRequire("3JBFS");

var $8hdLr = parcelRequire("8hdLr");

var $cBHyd = parcelRequire("cBHyd");

var $fyP0d = parcelRequire("fyP0d");

var $4CUbd = parcelRequire("4CUbd");
const $adc77ab26ee2035e$var$PREMIUM = 'PREMIUM';
function $adc77ab26ee2035e$var$useModalReturnFocusTo({ projectToRestore: projectToRestore }) {
    const { setReturnFocusTo: setReturnFocusTo } = (0, $4aSRi.useModalDialogActions)();
    const renderButtonRef = (0, $eJOHy.useRef)(null);
    const setModalReturnFocusTo = (0, $eJOHy.useCallback)(()=>{
        setReturnFocusTo(renderButtonRef);
    }, [
        setReturnFocusTo,
        renderButtonRef
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (projectToRestore) setModalReturnFocusTo();
    }, [
        projectToRestore,
        setModalReturnFocusTo,
        setReturnFocusTo
    ]);
    return {
        setModalReturnFocusTo: setModalReturnFocusTo,
        renderButtonRef: renderButtonRef
    };
}
const $adc77ab26ee2035e$var$ActionsCellDropdown = ({ project: project, jiraQueryRef: jiraQueryRef })=>{
    const settingsGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $fyP0d.default).settingsGalaxia : (0, $fyP0d.default).settings;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'resultsTable'
    });
    const isAdmin = (0, $gZTP9.useIsAdmin)();
    const appEditions = (0, $8vyDv.useAppEditions)();
    const [, { forceUpdate: forceUpdate }] = (0, $3JBFS.useFilter)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eJOHy.useState)(false);
    const [projectToRestore, setProjectToRestore] = (0, $eJOHy.useState)(null);
    const [activeEntryPoint, setActiveEntryPoint] = (0, $eJOHy.useState)(null);
    const { jiraProjectType: jiraProjectType, jiraProjectName: jiraProjectName, projectStyle: projectStyle, key: key, id: id } = (0, $j4oe4.useFragment)((0, $1We7P.default), project);
    const jwmNavigationData = (0, $j4oe4.useFragment)((0, $9b6XI.default), jiraQueryRef);
    const { setModalReturnFocusTo: setModalReturnFocusTo, renderButtonRef: renderButtonRef } = $adc77ab26ee2035e$var$useModalReturnFocusTo({
        projectToRestore: projectToRestore
    });
    const isCorePremiumUserSeat = Boolean(jwmNavigationData?.jwmLicensing?.currentUserSeatEdition === $adc77ab26ee2035e$var$PREMIUM);
    const entryPointParams = (0, $eJOHy.useMemo)(()=>({
            projectId: id
        }), [
        id
    ]);
    const { entryPointReferenceSubject: deleteRefSubject, entryPointActions: deleteActions } = (0, $bbdV2.useEntryPoint)((0, $2ruNJ.deleteProjectModalEntryPoint), entryPointParams, undefined, // TODO: add performance metrics
    {
        timeToIntent: 50
    });
    const deleteEntryPointRuntimeProps = (0, $eJOHy.useMemo)(()=>({
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onClose: ()=>{},
            onDeleteProjectSuccess: ()=>{
                forceUpdate();
                deleteActions.unload();
            },
            onProjectRestore: setProjectToRestore
        }), [
        deleteActions,
        forceUpdate
    ]);
    const deleteTriggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(deleteActions);
    const { entryPointReferenceSubject: archiveRefSubject, entryPointActions: archiveActions } = (0, $bbdV2.useEntryPoint)((0, $ijMKb.archiveProjectModalEntryPoint), entryPointParams, undefined, // TODO: add performance metrics
    {
        timeToIntent: 50
    });
    const archiveEntryPointRuntimeProps = (0, $eJOHy.useMemo)(()=>({
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onClose: ()=>{},
            onArchiveProjectSuccess: ()=>{
                forceUpdate();
                archiveActions.unload();
            },
            onProjectRestore: setProjectToRestore
        }), [
        archiveActions,
        forceUpdate
    ]);
    const archiveTriggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(archiveActions);
    const { entryPointReferenceSubject: archiveProjectFeatureGateRefSubject, entryPointActions: archiveProjectFeatureGateActions } = (0, $bbdV2.useEntryPoint)((0, $dd65x.archiveProjectFeatureGateModalEntryPoint), {});
    const archiveFeatureGateEntryPointRuntimeProps = (0, $eJOHy.useMemo)(()=>({
            onClose: ()=>{
                archiveProjectFeatureGateActions.unload();
            }
        }), [
        archiveProjectFeatureGateActions
    ]);
    const archiveFeatureGateTriggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(archiveProjectFeatureGateActions);
    const handleTrashClick = (0, $eJOHy.useCallback)(()=>{
        setModalReturnFocusTo();
        setActiveEntryPoint({
            entryPointReferenceSubject: deleteRefSubject,
            runtimeProps: deleteEntryPointRuntimeProps,
            entryPointActions: deleteActions,
            id: 'project-delete-modal'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'trashDropdownItem');
    }, [
        setModalReturnFocusTo,
        deleteRefSubject,
        deleteEntryPointRuntimeProps,
        deleteActions,
        analyticsEvent
    ]);
    const isSoftwareAppStandardEdition = (0, $lldWQ.isStandardEdition)((0, $ln6Iy.SOFTWARE_PROJECT), appEditions);
    const isSoftwareAppFreeEdition = (0, $lldWQ.isFreeEdition)((0, $ln6Iy.SOFTWARE_PROJECT), appEditions);
    const handleArchiveClick = (0, $eJOHy.useCallback)(()=>{
        setModalReturnFocusTo();
        if ((isSoftwareAppStandardEdition || isSoftwareAppFreeEdition) && (jiraProjectType === (0, $ln6Iy.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT) || jiraProjectType === (0, $ln6Iy.JIRA_PROJECT_TYPE_CORE_PROJECT))) {
            setActiveEntryPoint({
                entryPointReferenceSubject: archiveProjectFeatureGateRefSubject,
                runtimeProps: archiveFeatureGateEntryPointRuntimeProps,
                entryPointActions: archiveProjectFeatureGateActions,
                id: 'project-archive-feature-gate-modal'
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'projectArchivingFeatureGateItem');
        } else {
            setActiveEntryPoint({
                entryPointReferenceSubject: archiveRefSubject,
                runtimeProps: archiveEntryPointRuntimeProps,
                entryPointActions: archiveActions,
                id: 'project-archive-modal'
            });
            (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'archiveDropdownItem');
        }
    }, [
        setModalReturnFocusTo,
        isSoftwareAppStandardEdition,
        isSoftwareAppFreeEdition,
        jiraProjectType,
        archiveProjectFeatureGateRefSubject,
        archiveFeatureGateEntryPointRuntimeProps,
        archiveProjectFeatureGateActions,
        analyticsEvent,
        archiveRefSubject,
        archiveEntryPointRuntimeProps,
        archiveActions
    ]);
    const handleSettingsClick = (0, $eJOHy.useCallback)(()=>{
        setIsDropdownOpen(false);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'settingsDropdownItem');
    }, [
        analyticsEvent
    ]);
    const handleDropdownClick = (0, $eJOHy.useCallback)(({ isOpen: isOpen })=>{
        setIsDropdownOpen(isOpen);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'dropdownMenu');
    }, [
        analyticsEvent
    ]);
    const isSimplified = projectStyle === 'TEAM_MANAGED_PROJECT'; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const projectType = jiraProjectType?.toLowerCase();
    const archiveTriggerRefToUse = (jiraProjectType === (0, $ln6Iy.JIRA_PROJECT_TYPE_SOFTWARE_PROJECT) || jiraProjectType === (0, $ln6Iy.JIRA_PROJECT_TYPE_CORE_PROJECT)) && (isSoftwareAppStandardEdition || isSoftwareAppFreeEdition) ? archiveFeatureGateTriggerRef : archiveTriggerRef;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($adc77ab26ee2035e$var$ActionCellWrapper, null, activeEntryPoint !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cystD.ModalEntryPointContainer), {
        ...activeEntryPoint,
        id: id,
        packageName: `jira-projects-directory-v3-delete-${id}`
    }), projectToRestore !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $956it.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5YT8x.default), {
        ...projectToRestore,
        onProjectRestoreSuccess: ()=>{
            setProjectToRestore(null);
            forceUpdate();
        },
        onClose: ()=>setProjectToRestore(null),
        onProjectRestoreFailure: ()=>setProjectToRestore(null)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        placement: "bottom-end",
        isOpen: isDropdownOpen,
        onOpenChange: handleDropdownClick,
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>(0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                ...props,
                label: formatMessage((0, $fyP0d.default).moreActions, {
                    name: jiraProjectName
                }),
                appearance: "subtle",
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                        label: formatMessage((0, $fyP0d.default).moreActions, {
                            name: jiraProjectName
                        })
                    }),
                ref: (0, $jd93d.mergeRefs)(triggerRef, renderButtonRef),
                spacing: "compact",
                isTooltipDisabled: false,
                tooltip: {
                    content: formatMessage((0, $fyP0d.default).moreActionsTooltip),
                    hideTooltipOnClick: true
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...props,
                appearance: "subtle",
                "aria-label": formatMessage((0, $fyP0d.default).moreActions, {
                    name: jiraProjectName
                }),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                    spacing: "spacious",
                    label: ""
                }),
                ref: (0, $jd93d.mergeRefs)(triggerRef, renderButtonRef)
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ), {
        onClick: handleSettingsClick,
        component: ({ onClick: onClick, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c9uTK.Link), {
                ...props,
                onClick: onClick,
                to: (0, $4CUbd.getSettingsUrl)(projectType, isSimplified, key)
            })
    }, formatMessage(settingsGalaxia)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBHyd.TrashProjectDropdownItem), {
        projectType: projectType,
        isAdmin: isAdmin,
        canAdministerProject: true,
        isSimplified: isSimplified,
        ref: deleteTriggerRef,
        onClick: handleTrashClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8hdLr.ArchiveProjectDropdownItem), {
        projectType: projectType,
        isAdmin: isAdmin,
        canAdministerProject: true,
        isSimplified: isSimplified,
        ref: archiveTriggerRefToUse,
        onClick: handleArchiveClick,
        isCorePremiumUserSeat: isCorePremiumUserSeat
    }))));
};
const $adc77ab26ee2035e$export$eee95bbb96e96f7b = ({ project: project, jiraQueryRef: jiraQueryRef })=>{
    const dataRef = (0, $j4oe4.useFragment)((0, $kjnwE.default), project);
    if (!dataRef?.canViewProjectConfig?.canPerform) return null;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($adc77ab26ee2035e$var$ActionsCellDropdown, {
        project: dataRef,
        jiraQueryRef: jiraQueryRef
    });
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        justifyContent: "end",
        xcss: $adc77ab26ee2035e$var$styles.container
    }, content) : content;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $adc77ab26ee2035e$var$ActionCellWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $adc77ab26ee2035e$var$styles = {
    container: "_1rjcu2gc _19bvu2gc _u5f3utpp"
};

});
parcelRegister("kjnwE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f5e962ce42aa71f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4f107b1dd5aac0ef2fc16a6661a002b9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4f5e962ce42aa71f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "actionsCell_projectsDirectoryV3_project",
    "selections": [
        {
            "alias": "canViewProjectConfig",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "VIEW_PROJECT_CONFIG"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "actionsCell_projectsDirectoryV3_ActionsCellDropdown_project"
        }
    ],
    "type": "JiraProject"
};
$4f5e962ce42aa71f$var$node.hash = "c8748624e96975706ef2288b147d4354";
var $4f5e962ce42aa71f$export$2e2bcd8739ae039 = $4f5e962ce42aa71f$var$node;

});

parcelRegister("9b6XI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddfefecd193f690e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8ed08c6672a1eaf3b9b82bab3a381f5a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ddfefecd193f690e$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "actionsCell_projectsDirectoryV3_ActionsCellDropdown_jiraQueryRef",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraWorkManagementLicensing",
            "kind": "LinkedField",
            "name": "jwmLicensing",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "currentUserSeatEdition"
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$ddfefecd193f690e$var$node.hash = "5b00115542e25c7594cc5725fc674963";
var $ddfefecd193f690e$export$2e2bcd8739ae039 = $ddfefecd193f690e$var$node;

});

parcelRegister("1We7P", function(module, exports) {

$parcel$export(module.exports, "default", () => $2de45d70ce117581$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<364088419a35537f43370e010e4d245d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2de45d70ce117581$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "actionsCell_projectsDirectoryV3_ActionsCellDropdown_project",
    "selections": [
        {
            "alias": "jiraProjectType",
            "kind": "ScalarField",
            "name": "projectType"
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "alias": "jiraProjectName",
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ],
    "type": "JiraProject"
};
$2de45d70ce117581$var$node.hash = "c940602017bcd3fd11260c66a06307d5";
var $2de45d70ce117581$export$2e2bcd8739ae039 = $2de45d70ce117581$var$node;

});

parcelRegister("lldWQ", function(module, exports) {

$parcel$export(module.exports, "hasPermissionGate", () => $aad1b3258d475d56$export$2d7869ada39bf0b);
$parcel$export(module.exports, "isStandardEdition", () => $aad1b3258d475d56$export$4b1af5399a63f452);
$parcel$export(module.exports, "isFreeEdition", () => $aad1b3258d475d56$export$a8e9f6df1deeb7d);
$parcel$export(module.exports, "hasPermissionToArchive", () => $aad1b3258d475d56$export$70eef98d89c5d158);

var $ln6Iy = parcelRequire("ln6Iy");

var $a9ldn = parcelRequire("a9ldn");
const $aad1b3258d475d56$export$2d7869ada39bf0b = (projectType, appEditions)=>(0, $a9ldn.getEditionForProject)(projectType, appEditions) === (0, $a9ldn.PREMIUM_EDITION);
const $aad1b3258d475d56$export$4b1af5399a63f452 = (projectType, appEditions)=>(0, $a9ldn.getEditionForProject)(projectType, appEditions) === (0, $a9ldn.STANDARD_EDITION);
const $aad1b3258d475d56$export$a8e9f6df1deeb7d = (projectType, appEditions)=>(0, $a9ldn.getEditionForProject)(projectType, appEditions) === (0, $a9ldn.FREE_EDITION);
const $aad1b3258d475d56$var$hasPermissionToArchiveProject = (isSimplified, isAdmin, canAdministerProject)=>{
    if (isSimplified) return isAdmin || canAdministerProject; // Either Jira admins or Project admins can archive the simplified/next-gen project
    return isAdmin; // Only Jira admins can archive the classic software project
};
const $aad1b3258d475d56$export$70eef98d89c5d158 = ({ projectType: projectType, isSimplified: isSimplified, isAdmin: isAdmin, canAdministerProject: canAdministerProject })=>{
    switch(projectType){
        case 0, $ln6Iy.SOFTWARE_PROJECT:
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
        case 0, $ln6Iy.CORE_PROJECT:
            return $aad1b3258d475d56$var$hasPermissionToArchiveProject(isSimplified, isAdmin, canAdministerProject);
        default:
            return false;
    }
};

});

parcelRegister("5YT8x", function(module, exports) {

$parcel$export(module.exports, "default", () => $5888590eefdcd2c9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eK5AI = parcelRequire("eK5AI");

var $1KdDN = parcelRequire("1KdDN");

var $ch9En = parcelRequire("ch9En");

var $bQWwW = parcelRequire("bQWwW");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5888590eefdcd2c9$var$LazyComponent = (0, $bQWwW.lazy)(()=>(parcelRequire("7QaRS")), {
    moduleId: "./src/packages/project-pages/project-restore/project-restore-modal/src/index.tsx"
});
const $5888590eefdcd2c9$var$Component = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        fallback: "flag",
        id: "bundle-async-project-restore-modal",
        packageName: "jira-project-restore-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ch9En.default), {
        name: "project-restore-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
            metricKey: (0, $158f8dea36e8141e$export$37312a67c3e314c6)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5888590eefdcd2c9$var$LazyComponent, props)));
var $5888590eefdcd2c9$export$2e2bcd8739ae039 = $5888590eefdcd2c9$var$Component;

});
const $158f8dea36e8141e$export$37312a67c3e314c6 = 'PROJECT_RESTORE_MODAL_LOAD_START_MARK_KEY';
const $158f8dea36e8141e$export$367c841df4ac5730 = 'https://support.atlassian.com/jira-service-management-cloud/docs/trash-and-restore-a-project/';

parcelRegister("7QaRS", function(module, exports) {

let $5b55d1de0f1ea79d$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5b55d1de0f1ea79d$var$load("846i1").then(()=>parcelRequire('ibNjJ'));

});


parcelRegister("dd65x", function(module, exports) {

$parcel$export(module.exports, "archiveProjectFeatureGateModalEntryPoint", () => $547efcf16158096c$export$fcdeeeabe3fc5ecf);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $547efcf16158096c$export$fcdeeeabe3fc5ecf = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("82MBH")), {
        moduleId: "1b29af53",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("82MBH", function(module, exports) {

let $5db436fc617b9672$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $5db436fc617b9672$var$load("41Zns").then(()=>parcelRequire('2jwi6'));

});


parcelRegister("ijMKb", function(module, exports) {

$parcel$export(module.exports, "archiveProjectModalEntryPoint", () => $848fd6e44f59f597$export$31eb70b07b11d874);

var $7SPOj = parcelRequire("7SPOj");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $848fd6e44f59f597$export$31eb70b07b11d874 = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("4U2IW")), {
        moduleId: "a707d335",
        priority: "interaction"
    }),
    getPreloadProps: ({ projectId: projectId })=>({
            queries: {
                project: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $7SPOj.default,
                    variables: {
                        projectId: projectId
                    }
                }
            }
        })
});

});
parcelRegister("7SPOj", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3f7fe4fa6d7ce1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6e47b16dcd2a4c0090f75b99be9dfb50>>
 * @relayHash f80461cb9c20e5817d234cd6193aff07
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a9daa742fffdffb3be75a50f4d433a30c07a6212c4a9d23a43b3664323d1faa0
const $4d3f7fe4fa6d7ce1$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a9daa742fffdffb3be75a50f4d433a30c07a6212c4a9d23a43b3664323d1faa0",
        "metadata": {},
        "name": "uiArchiveProjectModal_getProjectQuery",
        "operationKind": "query",
        "text": null
    }
};
var $4d3f7fe4fa6d7ce1$export$2e2bcd8739ae039 = $4d3f7fe4fa6d7ce1$var$node;

});

parcelRegister("4U2IW", function(module, exports) {

let $391e814db4255e9e$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $391e814db4255e9e$var$load("4W9r8").then(()=>parcelRequire('9PU1X'));

});


parcelRegister("2ruNJ", function(module, exports) {

$parcel$export(module.exports, "deleteProjectModalEntryPoint", () => $b9a228d8a7cdd23e$export$71ab1db8fa3662de);

var $dHH3S = parcelRequire("dHH3S");

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $b9a228d8a7cdd23e$export$71ab1db8fa3662de = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("6fplr")), {
        moduleId: "0a83cef5",
        priority: "interaction"
    }),
    getPreloadProps: ({ projectId: projectId })=>({
            queries: {
                project: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $dHH3S.default,
                    variables: {
                        projectId: projectId
                    }
                }
            }
        })
});

});
parcelRegister("dHH3S", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6d8bb0342610e3a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1a1fd0fb256e69d343384e4492a60188>>
 * @relayHash bedfc53abda2b09909778822a77ae8e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b970039aa2992a80e17db04733801c9fc94a870f85ad01abf94a227b9b0a28de
const $e6d8bb0342610e3a$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "b970039aa2992a80e17db04733801c9fc94a870f85ad01abf94a227b9b0a28de",
        "metadata": {},
        "name": "uiDeleteProjectModal_getProjectQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e6d8bb0342610e3a$export$2e2bcd8739ae039 = $e6d8bb0342610e3a$var$node;

});

parcelRegister("6fplr", function(module, exports) {

let $48c7cdbf8dbdae55$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $48c7cdbf8dbdae55$var$load("bmqlo").then(()=>parcelRequire('2Mt0n'));

});


parcelRegister("8hdLr", function(module, exports) {

$parcel$export(module.exports, "ArchiveProjectDropdownItem", () => $7a1d575ee0976296$export$26fac2325408ae57);

var $eJOHy = parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $j2Fae = parcelRequire("j2Fae");
const $7a1d575ee0976296$export$26fac2325408ae57 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j2Fae.ProjectArchiveTrigger), {
        ...props,
        Component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
                ref: ref,
                onClick: props.onClick
            }, children)
    }));

});
parcelRegister("j2Fae", function(module, exports) {

$parcel$export(module.exports, "useShouldShowArchiveProjectTrigger", () => $ef7bcfbc8506c992$export$b73fe2adeac2987c);
$parcel$export(module.exports, "ProjectArchiveTrigger", () => $ef7bcfbc8506c992$export$8901cb385df588dc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jYYbf = parcelRequire("jYYbf");

var $jdqdp = parcelRequire("jdqdp");

var $6ozsI = parcelRequire("6ozsI");

var $7jTnu = parcelRequire("7jTnu");

var $ln6Iy = parcelRequire("ln6Iy");

var $lRq8t = parcelRequire("lRq8t");

var $8vyDv = parcelRequire("8vyDv");

var $j5QXA = parcelRequire("j5QXA");

var $lldWQ = parcelRequire("lldWQ");
const $ef7bcfbc8506c992$export$cfc6ab8feaeadec9 = 'SHOW_PREMIUM_LOZENGE';
const $ef7bcfbc8506c992$export$ca1dc5c78590c792 = 'HIDE_PREMIUM_LOZENGE';
function $ef7bcfbc8506c992$export$b73fe2adeac2987c({ isAdmin: isAdmin, isSimplified: isSimplified, canAdministerProject: canAdministerProject, projectType: projectType, shouldHideFeatureGateTrigger: shouldHideFeatureGateTrigger, isCorePremiumUserSeat: isCorePremiumUserSeat }) {
    const appEditions = (0, $8vyDv.useAppEditions)();
    if (!(0, $lldWQ.hasPermissionToArchive)({
        projectType: projectType,
        isSimplified: isSimplified,
        isAdmin: isAdmin,
        canAdministerProject: canAdministerProject
    })) return false;
    const isJswPremiumEdition = (0, $lldWQ.hasPermissionGate)((0, $ln6Iy.SOFTWARE_PROJECT), appEditions);
    const isJswStandardEdition = (0, $lldWQ.isStandardEdition)((0, $ln6Iy.SOFTWARE_PROJECT), appEditions);
    const isJswFreeEdition = (0, $lldWQ.isFreeEdition)((0, $ln6Iy.SOFTWARE_PROJECT), appEditions);
    const isJsmPremiumEdition = (0, $lldWQ.hasPermissionGate)((0, $ln6Iy.SERVICE_DESK_PROJECT), appEditions);
    if (projectType === (0, $ln6Iy.SOFTWARE_PROJECT) && isJswPremiumEdition || projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT) && isJsmPremiumEdition) return $ef7bcfbc8506c992$export$ca1dc5c78590c792;
     // Standard or Free Edition admins should see the Project archiving FG for JSW and Core Projects
    if (isAdmin && !shouldHideFeatureGateTrigger && (projectType === (0, $ln6Iy.SOFTWARE_PROJECT) || projectType === (0, $ln6Iy.CORE_PROJECT)) && (isJswStandardEdition || isJswFreeEdition)) return $ef7bcfbc8506c992$export$cfc6ab8feaeadec9;
     // Enable Project Archiving feature for Core Projects if either Software, Service Desk or Core are Premium
    if (projectType === (0, $ln6Iy.CORE_PROJECT) && isCorePremiumUserSeat) return $ef7bcfbc8506c992$export$ca1dc5c78590c792;
    return false;
}
const $ef7bcfbc8506c992$export$8901cb385df588dc = (props)=>{
    const { projectType: projectType, onClick: onClick, isAdmin: isAdmin, canAdministerProject: canAdministerProject, isSimplified: isSimplified, Component: Component, isCorePremiumUserSeat: isCorePremiumUserSeat, shouldHideFeatureGateTrigger: shouldHideFeatureGateTrigger, customLabelText: customLabelText } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const premiumLozenge = (0, $eJOHy.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ef7bcfbc8506c992$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
            appearance: "new"
        }, formatMessage((0, $j5QXA.default).premiumLozenge))), [
        formatMessage
    ]);
    const getDropdownItem = ({ showPremiumLozenge: showPremiumLozenge })=>{
        const dropdownChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, customLabelText || formatMessage(projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT) ? (0, $j5QXA.default).archiveTriggerServiceManagement : (0, $j5QXA.default).archiveTrigger), showPremiumLozenge && premiumLozenge);
        return Component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, null, dropdownChildren) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
            elemBefore: (0, $7jTnu.fg)('jira_custom_templates_ux') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6ozsI))), {
                testId: "project-archive-trigger.ui.archive-icon",
                label: "",
                spacing: "spacious",
                color: "var(--ds-icon, #44546F)"
            }),
            onClick: onClick
        }, dropdownChildren);
    };
    const shouldShowResult = $ef7bcfbc8506c992$export$b73fe2adeac2987c({
        isAdmin: isAdmin,
        isSimplified: isSimplified,
        canAdministerProject: canAdministerProject,
        projectType: projectType,
        shouldHideFeatureGateTrigger: shouldHideFeatureGateTrigger,
        isCorePremiumUserSeat: isCorePremiumUserSeat
    });
    if (!shouldShowResult) return null;
    return getDropdownItem({
        showPremiumLozenge: shouldShowResult === $ef7bcfbc8506c992$export$cfc6ab8feaeadec9
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ef7bcfbc8506c992$var$LozengeWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1nu9 _18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6ozsI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53af402aec64299fbaefa11fd3d04c88>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4a807e0481065374$var$_react = $4a807e0481065374$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $4a807e0481065374$var$_baseNew = $4a807e0481065374$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $4a807e0481065374$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArchiveBox".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: archiving pages, storage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4a807e0481065374$var$ArchiveBoxIcon = (props)=>/*#__PURE__*/ $4a807e0481065374$var$_react.default.createElement($4a807e0481065374$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v5h-1v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6H1zm2.5 5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V6zm10-1.5h-11v-2h11zm-3 4.5h-5V7.5h5z" clip-rule="evenodd"/>`
    }, props));
$4a807e0481065374$var$ArchiveBoxIcon.displayName = 'ArchiveBoxIcon';
var $4a807e0481065374$var$_default = module.exports.default = $4a807e0481065374$var$ArchiveBoxIcon;

});

parcelRegister("j5QXA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f5c95ca7a203d09$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7f5c95ca7a203d09$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    archiveTrigger: {
        "id": "project-archive-trigger.archive-trigger",
        "defaultMessage": "Archive"
    },
    archiveTriggerServiceManagement: {
        "id": "project-archive-trigger.archive-trigger-service-management",
        "defaultMessage": "Move to archive"
    },
    premiumLozenge: {
        "id": "project-archive-trigger.premium-lozenge",
        "defaultMessage": "Premium"
    }
});

});



parcelRegister("cBHyd", function(module, exports) {

$parcel$export(module.exports, "TrashProjectDropdownItem", () => $02981c98b28391d6$export$eb302d626a2eaf73);

var $eJOHy = parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $lRq8t = parcelRequire("lRq8t");

var $gOiDq = parcelRequire("gOiDq");

var $kqmff = parcelRequire("kqmff");
const $02981c98b28391d6$export$eb302d626a2eaf73 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ onClick: onClick, ...args }, ref)=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    if (!(0, $gOiDq.shouldShowTrashProjectTrigger)(args)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        ref: ref,
        onClick: onClick
    }, formatMessage((0, $kqmff.default).delete));
});

});
parcelRegister("gOiDq", function(module, exports) {

$parcel$export(module.exports, "shouldShowTrashProjectTrigger", () => $9592364845a68dc5$export$efbe59f7e76b22d6);

var $7jTnu = parcelRequire("7jTnu");

var $ln6Iy = parcelRequire("ln6Iy");
const $9592364845a68dc5$var$shouldShowTrashTriggerForSoftwareType = (isSimplified, isAdmin, canAdministerProject)=>{
    if (isSimplified) return isAdmin || canAdministerProject; // Either Jira admins or Project admins can trash the simplified/next-gen project
    return isAdmin; // Only Jira admins can trash the classic software project
};
// There is no simplified/next-gen version of core project type. Only Jira admins can trash the core project
const $9592364845a68dc5$var$shouldShowTrashTriggerForCoreType = (isAdmin)=>isAdmin;
// Same behaviour as in Software:
// Either Jira admins or Project admins can trash the simplified/next-gen JSM project
// Only Jira admins can trash the classic JSM project
const $9592364845a68dc5$var$shouldShowTrashTriggerForJSMType = (isSimplified, isAdmin, canAdministerProject)=>$9592364845a68dc5$var$shouldShowTrashTriggerForSoftwareType(isSimplified, isAdmin, canAdministerProject);
const $9592364845a68dc5$export$efbe59f7e76b22d6 = ({ projectType: projectType, isSimplified: isSimplified, isAdmin: isAdmin, canAdministerProject: canAdministerProject })=>{
    if ((0, $7jTnu.fg)('jcs_project_type_m3')) switch(projectType){
        case 0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT:
        case 0, $ln6Iy.SOFTWARE_PROJECT:
            return $9592364845a68dc5$var$shouldShowTrashTriggerForSoftwareType(isSimplified, isAdmin, canAdministerProject);
        case 0, $ln6Iy.CUSTOMER_SERVICE_PROJECT:
        case 0, $ln6Iy.CORE_PROJECT:
            return $9592364845a68dc5$var$shouldShowTrashTriggerForCoreType(isAdmin);
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            return $9592364845a68dc5$var$shouldShowTrashTriggerForJSMType(isSimplified, isAdmin, canAdministerProject);
        default:
            return false;
    }
    switch(projectType){
        case 0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT:
        case 0, $ln6Iy.SOFTWARE_PROJECT:
            return $9592364845a68dc5$var$shouldShowTrashTriggerForSoftwareType(isSimplified, isAdmin, canAdministerProject);
        case 0, $ln6Iy.CORE_PROJECT:
            return $9592364845a68dc5$var$shouldShowTrashTriggerForCoreType(isAdmin);
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            return $9592364845a68dc5$var$shouldShowTrashTriggerForJSMType(isSimplified, isAdmin, canAdministerProject);
        default:
            return false;
    }
};

});

parcelRegister("kqmff", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7c46b9fc35e19a2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $c7c46b9fc35e19a2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    delete: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.actions-cell.delete-project-menu-item.delete",
        "defaultMessage": "Move to trash"
    }
});

});


parcelRegister("fyP0d", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5b4c222445fb720$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $b5b4c222445fb720$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    settings: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.actions-cell.settings",
        "defaultMessage": "Project settings"
    },
    moreActions: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.actions-cell.more-actions",
        "defaultMessage": "More actions for {name}"
    },
    more: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.actions-cell.more",
        "defaultMessage": "More"
    },
    moreActionsTooltip: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.actions-cell.more-actions-tooltip",
        "defaultMessage": "More actions"
    },
    settingsGalaxia: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.actions-cell.settings-galaxia",
        "defaultMessage": "Space settings"
    }
});

});

parcelRegister("4CUbd", function(module, exports) {

$parcel$export(module.exports, "getSettingsUrl", () => $e6bf0b27e576b709$export$3fe840d461122951);

var $ln6Iy = parcelRequire("ln6Iy");

var $47Jx0 = parcelRequire("47Jx0");
const $e6bf0b27e576b709$var$getClassicSettingsUrl = (projectType, projectKey)=>projectType === (0, $ln6Iy.SERVICE_DESK_PROJECT) ? `/jira/servicedesk/projects/${projectKey}/settings` : `/projects/${projectKey}/settings`;
const $e6bf0b27e576b709$export$3fe840d461122951 = (projectType, isSimplified, projectKey)=>!isSimplified || !projectType ? $e6bf0b27e576b709$var$getClassicSettingsUrl(projectType, projectKey) : (0, $47Jx0.getNextgenSettingsUrl)(projectType, projectKey);

});


parcelRegister("2Q58E", function(module, exports) {

$parcel$export(module.exports, "FavoriteCell", () => $91a851b56b78e5a5$export$d67ed47628a04c08);

var $hfss5 = parcelRequire("hfss5");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $dJ1E9 = parcelRequire("dJ1E9");

var $6zXPf = parcelRequire("6zXPf");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");
const $91a851b56b78e5a5$export$d67ed47628a04c08 = ({ project: project })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'resultsTable'
    });
    const data = (0, $j4oe4.useFragment)((0, $hfss5.default), project);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'FavoriteButton');
    }, [
        analyticsEvent
    ]);
    if ((0, $6zXPf.getWillShowNav4)()) return !data.canViewIssue?.canPerform ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJ1E9.FavoriteCell), {
        queryRef: data,
        onClick: handleClick
    });
    // Delete the following during getWillShowNav4 cleanup
    const { id: id, name: name, favouriteValue: favouriteValue, canViewIssue: canViewIssue } = data;
    if (!canViewIssue?.canPerform || !favouriteValue) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJ1E9.FavoriteCellOld), {
        id: id,
        favoriteItemName: name,
        favouriteValueRef: favouriteValue,
        onClick: handleClick
    });
};

});
parcelRegister("hfss5", function(module, exports) {

$parcel$export(module.exports, "default", () => $62448d66263ea3ec$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d44d33f756a3a4cff1533c4ee4f94ea7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $62448d66263ea3ec$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "favouriteCell_projectsDirectoryV3_FavoriteCell",
    "selections": [
        {
            "alias": "canViewIssue",
            "args": [
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "VIEW_ISSUES"
                }
            ],
            "concreteType": "JiraProjectAction",
            "kind": "LinkedField",
            "name": "action",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canPerform"
                }
            ],
            "storageKey": "action(type:\"VIEW_ISSUES\")"
        },
        {
            "kind": "FragmentSpread",
            "name": "favouriteCell_directoryBaseV3_FavoriteCell_queryRef"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "favouriteCell_directoryBaseV3_FavoriteCellOld_favouriteValueRef"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraProject"
};
$62448d66263ea3ec$var$node.hash = "ad54d41b3040372f85a46039e18e78ea";
var $62448d66263ea3ec$export$2e2bcd8739ae039 = $62448d66263ea3ec$var$node;

});

parcelRegister("dJ1E9", function(module, exports) {

$parcel$export(module.exports, "FavoriteCell", () => $19a3d6dfea73c661$export$d67ed47628a04c08);
$parcel$export(module.exports, "FavoriteCellOld", () => $19a3d6dfea73c661$export$fdcdbda2ebc451a1);

var $iuo0e = parcelRequire("iuo0e");

var $kdhef = parcelRequire("kdhef");

var $akNSi = parcelRequire("akNSi");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $gtr2v = parcelRequire("gtr2v");

var $7jTnu = parcelRequire("7jTnu");

var $fVPN0 = parcelRequire("fVPN0");

var $beI5n = parcelRequire("beI5n");

var $bILK0 = parcelRequire("bILK0");

var $8oKDI = parcelRequire("8oKDI");

var $kBBc9 = parcelRequire("kBBc9");
const $19a3d6dfea73c661$export$d67ed47628a04c08 = ({ queryRef: queryRef, onClick: onClick })=>{
    const { changeFavoriteMutation: changeFavoriteMutation } = (0, $beI5n.useChangeFavorite)();
    const { id: id, name: name, isFavourite: isFavourite } = (0, $j4oe4.useFragment)((0, $akNSi.default), queryRef);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        onClick?.({
            isFavourite: !isFavourite
        });
        changeFavoriteMutation({
            id: id,
            value: !isFavourite,
            typename: 'JiraProject'
        });
    }, [
        onClick,
        isFavourite,
        changeFavoriteMutation,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($19a3d6dfea73c661$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fVPN0.default), {
        onClick: handleClick,
        isShownInList: true,
        isFavorite: isFavourite,
        favoriteItemName: name
    }));
};
const $19a3d6dfea73c661$export$fdcdbda2ebc451a1 = ({ id: entityId, favoriteItemName: favoriteItemName, favouriteValueRef: favouriteValueRef, onClick: onClick })=>{
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const { updateFavoriteState: updateFavoriteState } = (0, $beI5n.useChangeFavorite)();
    const { __id: recordId, isFavourite: isFavourite } = (0, $j4oe4.useFragment)((0, $kdhef.default), favouriteValueRef);
    const [commit] = (0, $j4oe4.useMutation)((0, $iuo0e.default));
    const updateFavouriteRecord = (0, $eJOHy.useCallback)((store)=>{
        const { resourceId: resourceId, resourceType: resourceType } = (0, $7jTnu.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $gtr2v.AnyAri).parse(entityId) : (0, $8oKDI.getAriConfig)(entityId);
        const favouriteEntityRecord = store.get(recordId);
        if (resourceType === 'project') updateFavoriteState({
            id: resourceId,
            type: 'projects',
            value: !isFavourite
        });
        favouriteEntityRecord?.setValue(!isFavourite, 'isFavourite');
    }, [
        isFavourite,
        recordId,
        entityId,
        updateFavoriteState
    ]);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        onClick && onClick({
            isFavourite: !isFavourite
        });
        commit({
            variables: {
                entityId: entityId,
                isFavourite: !isFavourite
            },
            optimisticUpdater: updateFavouriteRecord,
            updater: updateFavouriteRecord,
            onCompleted: (data)=>{
                if (!data?.jira?.setEntityIsFavourite?.success) showFlag({
                    type: 'error',
                    title: (0, $kBBc9.default).title,
                    description: (0, $kBBc9.default).description,
                    messageId: 'directory-base-v3.ui.table-cells.favourite-cell.show-flag.error',
                    messageType: 'transactional'
                });
            }
        });
    }, [
        onClick,
        isFavourite,
        commit,
        entityId,
        updateFavouriteRecord,
        showFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($19a3d6dfea73c661$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fVPN0.default), {
        onClick: handleClick,
        isShownInList: true,
        isFavorite: isFavourite,
        favoriteItemName: favoriteItemName
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $19a3d6dfea73c661$var$ContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iuo0e", function(module, exports) {

$parcel$export(module.exports, "default", () => $272bdf715a661fe6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c0b2fed1c40da58e8adc6b850f137f9e>>
 * @relayHash d4a9710e84ebea84a643c6ab959e756e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 677bbcd9c25049b9a4296d20d4a52bcaa99e82e0d0f12414fac1ed3dbbfa1e31
const $272bdf715a661fe6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entityId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isFavourite"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "entityId",
                                    "variableName": "entityId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "isFavourite",
                                    "variableName": "isFavourite"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "input"
                        }
                    ],
                    "concreteType": "JiraSetIsFavouritePayload",
                    "kind": "LinkedField",
                    "name": "setEntityIsFavourite",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "favouriteCell_directoryBaseV3_Mutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "favouriteCell_directoryBaseV3_Mutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "677bbcd9c25049b9a4296d20d4a52bcaa99e82e0d0f12414fac1ed3dbbfa1e31",
            "metadata": {},
            "name": "favouriteCell_directoryBaseV3_Mutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$272bdf715a661fe6$var$node.hash = "bd17a743d8447fa8141ce0ba8c8f1012";
var $272bdf715a661fe6$export$2e2bcd8739ae039 = $272bdf715a661fe6$var$node;

});

parcelRegister("kdhef", function(module, exports) {

$parcel$export(module.exports, "default", () => $731bf1ed04f3cd27$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9eeddd7d3055f31cacc40c6df5ef698f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $731bf1ed04f3cd27$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "favouriteCell_directoryBaseV3_FavoriteCellOld_favouriteValueRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraFavouriteValue"
};
$731bf1ed04f3cd27$var$node.hash = "b3217e19a577d125349014040cc34d96";
var $731bf1ed04f3cd27$export$2e2bcd8739ae039 = $731bf1ed04f3cd27$var$node;

});

parcelRegister("akNSi", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4c2a36e252f2c2b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f30ced9f25eaab8d1e39e57e0b3dc8be>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a4c2a36e252f2c2b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "favouriteCell_directoryBaseV3_FavoriteCell_queryRef",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        }
    ],
    "type": "JiraProject"
};
$a4c2a36e252f2c2b$var$node.hash = "600c66fd2f77bc9eec46edf5294a9a60";
var $a4c2a36e252f2c2b$export$2e2bcd8739ae039 = $a4c2a36e252f2c2b$var$node;

});

parcelRegister("fVPN0", function(module, exports) {

$parcel$export(module.exports, "FavoriteButtonWrapper", () => $c7558d16e1b4ddea$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $c7558d16e1b4ddea$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eq3Hf = parcelRequire("eq3Hf");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $gGgaG = parcelRequire("gGgaG");

var $aaIe7 = parcelRequire("aaIe7");

var $2Cx9n = parcelRequire("2Cx9n");

var $91hUW = parcelRequire("91hUW");

var $dLR8J = parcelRequire("dLR8J");

var $k71qx = parcelRequire("k71qx");

var $l5htz = parcelRequire("l5htz");

var $f2JN3 = parcelRequire("f2JN3");

var $idGBm = parcelRequire("idGBm");

var $6XJko = parcelRequire("6XJko");

var $6urTU = parcelRequire("6urTU");
const $c7558d16e1b4ddea$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper'; // eslint-disable-next-line jira/react/no-class-components
class $c7558d16e1b4ddea$export$f8ad2acf0ec4860f extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $c7558d16e1b4ddea$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$export$db65185b5889c83, {
            "data-testid": $c7558d16e1b4ddea$var$SKELETON_TEST_ID,
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($91hUW))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6urTU.default).removeFromStarred)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aaIe7))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2Cx9n))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6urTU.default).addToStarred)
        }));
        const renderIcon = ()=>{
            const label = isFavorite ? formatMessage((0, $6urTU.default).removeFromStarred) : formatMessage((0, $6urTU.default).addToStarred);
            const StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))) : (0, (/*@__PURE__*/$parcel$interopDefault($aaIe7)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label,
                size: isSmall ? 'small' : 'medium'
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $6urTU.default).removeFromStarred) : formatMessage((0, $6urTU.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $6urTU.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $6urTU.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        }, (0, $6XJko.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args), this.state = {
            isAnimating: false
        }, this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        }, this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $c7558d16e1b4ddea$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $l5htz.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $idGBm.injectIntlV2))($c7558d16e1b4ddea$export$f8ad2acf0ec4860f);
const $c7558d16e1b4ddea$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c7558d16e1b4ddea$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn14q2 _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
});
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBase = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseNew, $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavIconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $c7558d16e1b4ddea$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.isFavorite ? "_syaz1oqg" : "_syaz1oju",
            __cmplp.isFavorite ? "_30l31vop" : "_30l3wdcn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c7558d16e1b4ddea$export$db65185b5889c83 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2Cx9n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e88d859d9ad0102$var$_react = $1e88d859d9ad0102$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $1e88d859d9ad0102$var$_starUnstarred = $1e88d859d9ad0102$var$_interopRequireDefault((parcelRequire("aaIe7")));
function $1e88d859d9ad0102$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1e88d859d9ad0102$var$StarIcon = (props)=>/*#__PURE__*/ $1e88d859d9ad0102$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
    }, props, {
        newIcon: $1e88d859d9ad0102$var$_starUnstarred.default
    }));
$1e88d859d9ad0102$var$StarIcon.displayName = 'StarIcon';
var $1e88d859d9ad0102$var$_default = module.exports.default = $1e88d859d9ad0102$var$StarIcon;

});

parcelRegister("6urTU", function(module, exports) {

$parcel$export(module.exports, "default", () => $708ae8e1a771b9ca$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $708ae8e1a771b9ca$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});

});


parcelRegister("kBBc9", function(module, exports) {

$parcel$export(module.exports, "default", () => $39397b734b476d14$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $39397b734b476d14$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    title: {
        "id": "directory-base-v3.table-cells.favourite-cell.title",
        "defaultMessage": "Something\u2019s gone wrong"
    },
    description: {
        "id": "directory-base-v3.table-cells.favourite-cell.description",
        "defaultMessage": "You cannot star items right now due to an error."
    }
});

});



parcelRegister("1TZVp", function(module, exports) {

$parcel$export(module.exports, "KeyCell", () => $5d8efbac0e1b631d$export$4d17c2f4d9bbf823);

var $eVq3C = parcelRequire("eVq3C");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");
const $5d8efbac0e1b631d$export$4d17c2f4d9bbf823 = ({ project: project })=>{
    const { key: key } = (0, $j4oe4.useFragment)((0, $eVq3C.default), project);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, key);
};

});
parcelRegister("eVq3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bf4ed8085cc0c63$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<66b9c8f5cdf7d37c300b3e6d4ae9594d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3bf4ed8085cc0c63$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "keyCell_projectsDirectoryV3",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        }
    ],
    "type": "JiraProject"
};
$3bf4ed8085cc0c63$var$node.hash = "8366f681ad04b41cb180bc7a28c738a4";
var $3bf4ed8085cc0c63$export$2e2bcd8739ae039 = $3bf4ed8085cc0c63$var$node;

});


parcelRegister("kewVL", function(module, exports) {

$parcel$export(module.exports, "LastIssueUpdateCell", () => $784194f11c6d6089$export$c2180874b4ed0214);

var $dSVWC = parcelRequire("dSVWC");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $k71qx = parcelRequire("k71qx");

var $6UAUW = parcelRequire("6UAUW");
const $784194f11c6d6089$export$c2180874b4ed0214 = ({ project: project })=>{
    const { lastUpdatedToolTipDate: lastUpdatedToolTipDate, lastUpdatedDisplayDate: lastUpdatedDisplayDate } = (0, $j4oe4.useFragment)((0, $dSVWC.default), project);
    if (!lastUpdatedDisplayDate) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UAUW.CellWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: lastUpdatedToolTipDate,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, lastUpdatedDisplayDate)));
};

});
parcelRegister("dSVWC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a6f8ba79caf3db$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<17cbac72bd869ab640a0ccd5a3afce47>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c5a6f8ba79caf3db$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "lastIssueUpdateCell_projectsDirectoryV3",
    "selections": [
        {
            "alias": "lastUpdatedToolTipDate",
            "args": [
                {
                    "kind": "Literal",
                    "name": "format",
                    "value": "COMPLETE_DATETIME_FORMAT"
                }
            ],
            "kind": "ScalarField",
            "name": "lastUpdatedFormatted",
            "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
        },
        {
            "alias": "lastUpdatedDisplayDate",
            "args": [
                {
                    "kind": "Literal",
                    "name": "format",
                    "value": "RELATIVE"
                }
            ],
            "kind": "ScalarField",
            "name": "lastUpdatedFormatted",
            "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
        }
    ],
    "type": "JiraProject"
};
$c5a6f8ba79caf3db$var$node.hash = "be249fa705b1ccb8ba2a516f14f08647";
var $c5a6f8ba79caf3db$export$2e2bcd8739ae039 = $c5a6f8ba79caf3db$var$node;

});

parcelRegister("6UAUW", function(module, exports) {

$parcel$export(module.exports, "CellWrapper", () => $0504aeb60a6b417b$export$4812fadef83edffe);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $0504aeb60a6b417b$export$4812fadef83edffe = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});


parcelRegister("3S9oE", function(module, exports) {

$parcel$export(module.exports, "LeadCell", () => $ca6fb37b5021161f$export$53c185d8cac45d1d);

var $g25Qs = parcelRequire("g25Qs");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $cOnfV = parcelRequire("cOnfV");
const $ca6fb37b5021161f$export$53c185d8cac45d1d = ({ project: project })=>{
    const data = (0, $j4oe4.useFragment)((0, $g25Qs.default), project);
    return data?.lead ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cOnfV.UserProfile), {
        dataRef: data.lead
    }) : null;
};

});
parcelRegister("g25Qs", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cc6cb530418265f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2559e9ee4fe799ba020998c3c1d63439>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5cc6cb530418265f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "leadCell_projectsDirectoryV3",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "lead",
            "plural": false,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "userProfile_directoryBaseV3"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$5cc6cb530418265f$var$node.hash = "900649656e1e2128dc46e511bce9897f";
var $5cc6cb530418265f$export$2e2bcd8739ae039 = $5cc6cb530418265f$var$node;

});

parcelRegister("cOnfV", function(module, exports) {

$parcel$export(module.exports, "UserProfile", () => $92586294e926abe3$export$b7b58f2e100445f7);

var $cPagy = parcelRequire("cPagy");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $5DgXR = parcelRequire("5DgXR");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $3AXU8 = parcelRequire("3AXU8");

var $6XJko = parcelRequire("6XJko");
const $92586294e926abe3$var$UserProfile = ({ dataRef: dataRef })=>{
    const { accountId: accountId, name: displayName, picture: avatarUrl } = (0, $j4oe4.useFragment)((0, $cPagy.default), dataRef);
    const props = {
        accountId: accountId,
        prepopulatedData: {
            fullName: displayName
        }
    };
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3AXU8.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $92586294e926abe3$var$containerStyles,
        "data-testId": `directory-user-profile-${accountId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $92586294e926abe3$var$avatarContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        src: avatarUrl,
        size: "small",
        appearance: "circle"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        color: "color.text.subtle"
    }, displayName))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3AXU8.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($92586294e926abe3$var$ContentContainer, {
        "data-testId": `directory-user-profile-${accountId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($92586294e926abe3$var$AvatarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        src: avatarUrl,
        size: "small",
        appearance: "circle"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($92586294e926abe3$var$TextContainer, null, displayName)));
};
const $92586294e926abe3$export$b7b58f2e100445f7 = /*#__PURE__*/ (0, $eJOHy.memo)($92586294e926abe3$var$UserProfile);
const $92586294e926abe3$var$ContentContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $92586294e926abe3$var$AvatarContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _u5f3u2gc _vwz4idpf",
            __cmplp.className
        ])
    });
});
const $92586294e926abe3$var$TextContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _slp31hna _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $92586294e926abe3$var$containerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    alignItems: 'center',
    flex: '1 1 auto',
    width: '100%'
});
const $92586294e926abe3$var$avatarContainerStyles = (0, $1DXK0.xcss)({
    paddingRight: 'space.100',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    flex: '0 0 auto'
});

});
parcelRegister("cPagy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4f336480bfd02e7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<17a702f64ead8e9c0f6992bf4974db90>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e4f336480bfd02e7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "userProfile_directoryBaseV3",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "accountId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "picture"
        }
    ],
    "type": "User",
    "abstractKey": "__isUser"
};
$e4f336480bfd02e7$var$node.hash = "32feb6e507f926d7932dcef23d9427a7";
var $e4f336480bfd02e7$export$2e2bcd8739ae039 = $e4f336480bfd02e7$var$node;

});

parcelRegister("3AXU8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c1c7fb5d1ac654d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");


const $1c1c7fb5d1ac654d$var$ConditionalProfileCard = (parcelRequire("gtXs1")).default;
function $1c1c7fb5d1ac654d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1c1c7fb5d1ac654d$var$ConditionalProfileCard, props);
}

});
parcelRegister("gtXs1", function(module, exports) {

module.exports = (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
    return parcelRequire('7xXvm');
}, function() {
    return parcelRequire('jQS3A');
});

});
parcelRegister("g81qY", function(module, exports) {
"use strict";
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            console.error('Conditional dependency was not registered when executing. Falling back to synchronous bundle loading.');
            for (const url of fallback.urls)fallback.loader(url);
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});





parcelRegister("d3aM8", function(module, exports) {

$parcel$export(module.exports, "NameCell", () => $64dbaf0ad239a09a$export$2e923ef80ad8608a);

var $6Uv74 = parcelRequire("6Uv74");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $hdC3k = parcelRequire("hdC3k");

var $6UAUW = parcelRequire("6UAUW");

var $7jTnu = parcelRequire("7jTnu");

var $6XJko = parcelRequire("6XJko");
const $64dbaf0ad239a09a$export$2d483fceb9cca990 = (key, navigationMetadata, projectStyle)=>{
    if (!navigationMetadata) return `/browse/${key}`;
    if (navigationMetadata.__typename === 'JiraSoftwareProjectNavigationMetadata') {
        if (projectStyle === 'TEAM_MANAGED_PROJECT') return `/jira/software/projects/${key}/boards/${navigationMetadata.boardId}`;
        if (projectStyle === 'COMPANY_MANAGED_PROJECT') return `/jira/software/c/projects/${key}/boards/${navigationMetadata.boardId}`;
    }
    if (navigationMetadata.__typename === 'JiraServiceManagementProjectNavigationMetadata') return `/jira/servicedesk/projects/${key}`;
    return `/browse/${key}`;
};
const $64dbaf0ad239a09a$var$LinkComponent = ({ href: href, children: children, onLinkClicked: onLinkClicked })=>{
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $64dbaf0ad239a09a$var$linkWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hdC3k.default), {
        href: href,
        xcss: $64dbaf0ad239a09a$var$linkStyles,
        onClick: onLinkClicked && (0, $7jTnu.fg)('project_directory_link_click_analytics') ? onLinkClicked : undefined
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($64dbaf0ad239a09a$var$Link, {
        href: href
    }, children);
};
const $64dbaf0ad239a09a$export$2e923ef80ad8608a = ({ project: project })=>{
    const data = (0, $j4oe4.useFragment)((0, $6Uv74.default), project);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const boardUrl = $64dbaf0ad239a09a$export$2d483fceb9cca990(data?.key, data?.navigationMetadata, data?.projectStyle);
    const onLinkClicked = (0, $eJOHy.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'projectDirectoryProjectLink', {
            destProjectId: data.projectId
        });
    }, [
        data.projectId,
        createAnalyticsEvent
    ]);
    if (data?.avatar?.medium) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($64dbaf0ad239a09a$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: data.name,
        isScreenReaderAnnouncementDisabled: true,
        delay: 1000,
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($64dbaf0ad239a09a$var$LinkComponent, {
        href: boardUrl,
        onLinkClicked: onLinkClicked
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $64dbaf0ad239a09a$var$AvatarStyles,
        as: "img",
        src: data.avatar.medium,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($64dbaf0ad239a09a$var$WithAvatarLabel, null, data.name))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($64dbaf0ad239a09a$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: data.name,
        isScreenReaderAnnouncementDisabled: true,
        delay: 1000,
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($64dbaf0ad239a09a$var$LinkComponent, {
        href: boardUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($64dbaf0ad239a09a$var$NoAvatarLabel, null, data.name))));
};
const $64dbaf0ad239a09a$export$29a344cbda7670b7 = '24px'; // When we need to display a label for a project that has no avatar, we need to ensure that the label is aligned
// with other labels that have avatars. To do this we need to have a larger left margin to account for the avatar
// (24px / space.300) and the gap (8px / space.100) between the avatar and the label.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64dbaf0ad239a09a$var$NoAvatarLabel = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _18u0xy5q _1bto1l2s",
            __cmplp.className
        ])
    });
}); // When we need to display a label for a project that has an avatar, we need to just ensure that there is a gap
const $64dbaf0ad239a09a$var$WithAvatarLabel = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _18u0u2gc _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $64dbaf0ad239a09a$var$AvatarStyles = (0, $1DXK0.xcss)({
    flexShrink: 0,
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: 'border.radius.050',
    display: 'inline-block',
    verticalAlign: 'middle'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64dbaf0ad239a09a$var$Link = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $hdC3k.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1ule _1reo15vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $64dbaf0ad239a09a$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = (0, $6UAUW.CellWrapper), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reon7od _18m9n7od _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $64dbaf0ad239a09a$var$linkWrapperStyles = (0, $1DXK0.xcss)({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $64dbaf0ad239a09a$var$linkStyles = (0, $1DXK0.xcss)({
    display: 'block'
});

});
parcelRegister("6Uv74", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bf28b091970784c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<70094dace29b584ccad9526fbb0d1763>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4bf28b091970784c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "nameCell_projectsDirectoryV3",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "medium"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "LinkedField",
            "name": "navigationMetadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "boardId"
                        }
                    ],
                    "type": "JiraSoftwareProjectNavigationMetadata"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$4bf28b091970784c$var$node.hash = "e4ad4ccb1a52531129ec158632c9b213";
var $4bf28b091970784c$export$2e2bcd8739ae039 = $4bf28b091970784c$var$node;

});


parcelRegister("lw8GH", function(module, exports) {

$parcel$export(module.exports, "ProjectCategoryCell", () => $1da82e2746ef1af8$export$1bd789d7a92e69d5);

var $2kOTh = parcelRequire("2kOTh");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $6djmC = parcelRequire("6djmC");

var $6UAUW = parcelRequire("6UAUW");
const $1da82e2746ef1af8$export$1bd789d7a92e69d5 = ({ project: project })=>{
    const data = (0, $j4oe4.useFragment)((0, $2kOTh.default), project);
    return data?.category?.name ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), null, data.category.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UAUW.CellWrapper), null, data?.category?.name);
};

});
parcelRegister("2kOTh", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc70769e5f1c122a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<49b4670d3a84ed70a8d64a8fc967a301>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $bc70769e5f1c122a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "projectCategoryCell_projectsDirectoryV3",
    "selections": [
        {
            "concreteType": "JiraProjectCategory",
            "kind": "LinkedField",
            "name": "category",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$bc70769e5f1c122a$var$node.hash = "8895769fe267fb6dd387e5807f5f7fe1";
var $bc70769e5f1c122a$export$2e2bcd8739ae039 = $bc70769e5f1c122a$var$node;

});


parcelRegister("55eHL", function(module, exports) {

$parcel$export(module.exports, "ProjectTypeCell", () => $f0f43364107979d0$export$8052dbb4a8a7e741);

var $jM0b9 = parcelRequire("jM0b9");

var $eJOHy = parcelRequire("eJOHy");

var $9Dhvc = parcelRequire("9Dhvc");

var $j4oe4 = parcelRequire("j4oe4");

var $6djmC = parcelRequire("6djmC");

var $lRq8t = parcelRequire("lRq8t");

var $iti3l = parcelRequire("iti3l");
const $f0f43364107979d0$var$projectTypeLabels = {
    COMPANY_MANAGED_PROJECT: {
        BUSINESS: (0, $iti3l.default).companyManagedBusiness,
        SOFTWARE: (0, $iti3l.default).companyManagedSoftware,
        SERVICE_DESK: (0, $iti3l.default).companyManagedServiceProject,
        PRODUCT_DISCOVERY: (0, $iti3l.default).productDiscoveryProject,
        CUSTOMER_SERVICE: (0, $iti3l.default).customerServiceProjectNonFinal
    },
    TEAM_MANAGED_PROJECT: {
        BUSINESS: (0, $iti3l.default).teamManagedBusiness,
        SOFTWARE: (0, $iti3l.default).teamManagedSoftware,
        SERVICE_DESK: (0, $iti3l.default).teamManagedServiceProject,
        PRODUCT_DISCOVERY: (0, $iti3l.default).productDiscoveryProject,
        CUSTOMER_SERVICE: (0, $iti3l.default).customerServiceProjectNonFinal
    }
};
const $f0f43364107979d0$export$8052dbb4a8a7e741 = ({ project: project })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { projectType: projectType, projectStyle: projectStyle } = (0, $j4oe4.useFragment)((0, $jM0b9.default), project);
    const projectStyleKey = projectStyle || 'TEAM_MANAGED_PROJECT';
    const label = (0, (/*@__PURE__*/$parcel$interopDefault($9Dhvc)))($f0f43364107979d0$var$projectTypeLabels, [
        projectStyleKey,
        projectType || ''
    ]);
    const finalLabel = label ? formatMessage(label) : projectType;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6djmC.default), null, finalLabel);
};

});
parcelRegister("jM0b9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c529b7c6082d452d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d9458663dc6de45ac7a4376a22ee51ab>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c529b7c6082d452d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "projectTypeCell_projectsDirectoryV3",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectStyle"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        }
    ],
    "type": "JiraProject"
};
$c529b7c6082d452d$var$node.hash = "070d0af17c4bb3ec3f4ea5c84d8914ff";
var $c529b7c6082d452d$export$2e2bcd8739ae039 = $c529b7c6082d452d$var$node;

});

parcelRegister("iti3l", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba5479eab4a06b35$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $ba5479eab4a06b35$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    teamManagedBusiness: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.project-type-cell.team-managed-business",
        "defaultMessage": "Team-managed business"
    },
    companyManagedBusiness: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.project-type-cell.company-managed-business",
        "defaultMessage": "Company-managed business"
    },
    companyManagedServiceProject: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.project-type-cell.company-managed-service-project",
        "defaultMessage": "Service management"
    },
    teamManagedServiceProject: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.project-type-cell.team-managed-service-project",
        "defaultMessage": "Team-managed service management"
    },
    companyManagedSoftware: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.project-type-cell.company-managed-software",
        "defaultMessage": "Company-managed software"
    },
    teamManagedSoftware: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.project-type-cell.team-managed-software",
        "defaultMessage": "Team-managed software"
    },
    productDiscoveryProject: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.project-type-cell.product-discovery-project",
        "defaultMessage": "Product Discovery"
    },
    customerServiceProjectNonFinal: {
        "id": "projects-directory-v3.page-layout.projects-list.results-table.table-rows.project-type-cell.customer-service-project-non-final",
        "defaultMessage": "Customer service"
    }
});

});


parcelRegister("ftvZv", function(module, exports) {

$parcel$export(module.exports, "UrlCell", () => $edec9bcf627f299d$export$110272e30ac53e5);

var $co7lH = parcelRequire("co7lH");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $goZPP = parcelRequire("goZPP");

var $av9Of = parcelRequire("av9Of");

var $k71qx = parcelRequire("k71qx");
const $edec9bcf627f299d$export$110272e30ac53e5 = ({ project: project })=>{
    const data = (0, $j4oe4.useFragment)((0, $co7lH.default), project);
    if (!data?.projectUrl) return null;
    const { projectUrl: projectUrl } = data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($edec9bcf627f299d$var$UrlCellContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: projectUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        href: projectUrl,
        target: "_blank",
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($av9Of))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: projectUrl
        })
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $edec9bcf627f299d$var$UrlCellContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("co7lH", function(module, exports) {

$parcel$export(module.exports, "default", () => $31e1cc73e99d65df$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d6375b0f75c09e09474a3ff052c13200>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $31e1cc73e99d65df$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "urlCell_projectsDirectoryV3",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "projectUrl"
        }
    ],
    "type": "JiraProject"
};
$31e1cc73e99d65df$var$node.hash = "bc3c770944d0003a95b4fc28334d594a";
var $31e1cc73e99d65df$export$2e2bcd8739ae039 = $31e1cc73e99d65df$var$node;

});

parcelRegister("av9Of", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c2e6e563a714afa66b2c445d0695bd6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7a54689236011148$var$_react = $7a54689236011148$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7a54689236011148$var$_link = $7a54689236011148$var$_interopRequireDefault((parcelRequire("cV8sz")));

var $7a54689236011148$var$_link2 = $7a54689236011148$var$_interopRequireDefault((parcelRequire("a2o1i")));
function $7a54689236011148$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7a54689236011148$var$LinkIcon = (props)=>/*#__PURE__*/ $7a54689236011148$var$_react.default.createElement($7a54689236011148$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $7a54689236011148$var$_link2.default
    }, props));
$7a54689236011148$var$LinkIcon.Name = 'LinkIconMigration';
var $7a54689236011148$var$_default = module.exports.default = $7a54689236011148$var$LinkIcon;

});
parcelRegister("a2o1i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74ecb925586ee899$var$_react = $74ecb925586ee899$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $kxVLD = parcelRequire("kxVLD");

var $74ecb925586ee899$var$_link = $74ecb925586ee899$var$_interopRequireDefault((parcelRequire("cV8sz")));
function $74ecb925586ee899$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $74ecb925586ee899$var$LinkIcon = (props)=>/*#__PURE__*/ $74ecb925586ee899$var$_react.default.createElement($kxVLD.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $74ecb925586ee899$var$_link.default
    }));
$74ecb925586ee899$var$LinkIcon.displayName = 'LinkIcon';
var $74ecb925586ee899$var$_default = module.exports.default = $74ecb925586ee899$var$LinkIcon;

});






parcelRegister("9QHCE", function(module, exports) {

$parcel$export(module.exports, "RefinementBar", () => $4a1c3afdc1f6027b$export$1772ce3730aa9a66);

var $7Gzxx = parcelRequire("7Gzxx");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $gpjAW = parcelRequire("gpjAW");

var $dJEUx = parcelRequire("dJEUx");

var $9QRvN = parcelRequire("9QRvN");

var $7smax = parcelRequire("7smax");

var $ameQT = parcelRequire("ameQT");

var $bx4q9 = parcelRequire("bx4q9");
const $4a1c3afdc1f6027b$var$Filters = ({ dataRef: dataRef })=>{
    const data = (0, $j4oe4.useFragment)((0, $7Gzxx.default), dataRef);
    const shouldShowCategories = data.jira && Boolean(data.jira?.allJiraProjectCategories?.edges?.length);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9QRvN.FilterBar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJEUx.FilterItem), {
        expandOnSmall: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bx4q9.SearchControl), null)), data?.jira && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJEUx.FilterItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ameQT.ProjectTypePicker), {
        dataRef: data.jira
    })), shouldShowCategories && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJEUx.FilterItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7smax.ProjectCategoryPicker), {
        dataRef: data.jira
    })));
};
const $4a1c3afdc1f6027b$export$1772ce3730aa9a66 = ({ dataRef: dataRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gpjAW.RefinementBar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($4a1c3afdc1f6027b$var$Filters, {
        dataRef: dataRef
    }));

});
parcelRegister("7Gzxx", function(module, exports) {

$parcel$export(module.exports, "default", () => $fda5c47a28e9854c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<78595a404e5a2998fb1503dd6011f88a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fda5c47a28e9854c$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAnonymous"
        }
    ],
    "kind": "Fragment",
    "name": "refinementBar_projectsDirectoryV3_Filters",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "condition": "isAnonymous",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraProjectCategoryConnection",
                            "kind": "LinkedField",
                            "name": "allJiraProjectCategories",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectCategoryEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "projectCategoryPicker_projectsDirectoryV3"
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "projectTypePicker_projectsDirectoryV3"
                }
            ]
        }
    ],
    "type": "Query"
};
$fda5c47a28e9854c$var$node.hash = "44ad103870f84d678e5203337cb09f3c";
var $fda5c47a28e9854c$export$2e2bcd8739ae039 = $fda5c47a28e9854c$var$node;

});

parcelRegister("gpjAW", function(module, exports) {

$parcel$export(module.exports, "RefinementBar", () => $d1dd310a9a8d9e09$export$1772ce3730aa9a66);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

const $d1dd310a9a8d9e09$export$1772ce3730aa9a66 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d1dd310a9a8d9e09$var$wrapperStyles
    }, children);
};
const $d1dd310a9a8d9e09$var$wrapperStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.200'
});

});

parcelRegister("dJEUx", function(module, exports) {

$parcel$export(module.exports, "FilterItem", () => $57ae9b62bc01824b$export$3cf161fcd24b6b4f);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $57ae9b62bc01824b$export$3cf161fcd24b6b4f = ({ expandOnSmall: expandOnSmall, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: expandOnSmall ? [
            $57ae9b62bc01824b$var$filterItemContainerStyles,
            $57ae9b62bc01824b$var$filterItemContainerExpandedStyles
        ] : $57ae9b62bc01824b$var$filterItemContainerStyles
    }, children);
};
const $57ae9b62bc01824b$var$filterItemContainerStyles = (0, $1DXK0.xcss)({
    // 200px is the width commonly used for directory filters, so including it here helps
    // to ensure consistency with the existing design and gives us predictability for responsive behaviour
    minWidth: '200px'
});
const $57ae9b62bc01824b$var$filterItemContainerExpandedStyles = (0, $1DXK0.xcss)({
    gridColumn: '1 / -1'
});

});

parcelRegister("9QRvN", function(module, exports) {

$parcel$export(module.exports, "FilterBar", () => $3ecd990baea72ae1$export$56a20ec2552ffba2);

var $eJOHy = parcelRequire("eJOHy");

var $6DCNy = parcelRequire("6DCNy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $gMRLG = parcelRequire("gMRLG");

var $6XJko = parcelRequire("6XJko");

const $3ecd990baea72ae1$export$56a20ec2552ffba2 = ({ children: children })=>{
    const [containerWidth, setContainerWidth] = (0, $eJOHy.useState)(900);
    const handleWidth = (0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))(setContainerWidth, 50);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3ecd990baea72ae1$var$relativeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gMRLG.WidthObserver), {
        setWidth: handleWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $3ecd990baea72ae1$var$filterBarSharedStyles,
            (0, $6XJko.isVisualRefreshEnabled)() && $3ecd990baea72ae1$var$filterBarSharedStylesVisualRefresh,
            containerWidth > (0, $5b4f651e2b94645c$export$9cc428d7e02a0e8b) && $3ecd990baea72ae1$var$filterBarLargeStyles,
            containerWidth <= (0, $5b4f651e2b94645c$export$9cc428d7e02a0e8b) && containerWidth > (0, $5b4f651e2b94645c$export$99041d531d62aef9) && $3ecd990baea72ae1$var$filterBarMidStyles,
            containerWidth <= (0, $5b4f651e2b94645c$export$99041d531d62aef9) && containerWidth > (0, $5b4f651e2b94645c$export$54280d191a58e9f6) && $3ecd990baea72ae1$var$filterBarSmallStyles
        ]
    }, children));
};
const $3ecd990baea72ae1$var$relativeWrapperStyles = (0, $1DXK0.xcss)({
    position: 'relative'
});
const $3ecd990baea72ae1$var$filterBarSharedStyles = (0, $1DXK0.xcss)({
    width: '100%',
    display: 'grid',
    columnGap: 'space.200',
    rowGap: 'space.100',
    alignItems: 'flex-end'
});
const $3ecd990baea72ae1$var$filterBarSharedStylesVisualRefresh = (0, $1DXK0.xcss)({
    columnGap: 'space.100'
});
const $3ecd990baea72ae1$var$filterBarSmallStyles = (0, $1DXK0.xcss)({
    gridTemplateColumns: 'repeat(2, 1fr)'
});
const $3ecd990baea72ae1$var$filterBarMidStyles = (0, $1DXK0.xcss)({
    gridTemplateColumns: 'repeat(3, 1fr)'
});
const $3ecd990baea72ae1$var$filterBarLargeStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexWrap: 'wrap'
});

});
parcelRegister("gMRLG", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $fc07c79ce5b93db8$export$b2ad68b9bc407b80);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ghv3t = parcelRequire("ghv3t");
const $fc07c79ce5b93db8$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ghv3t.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $fc07c79ce5b93db8$export$2e2bcd8739ae039 = $fc07c79ce5b93db8$export$b2ad68b9bc407b80;

});
parcelRegister("ghv3t", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $8fd70c84fe96dcaa$export$ff983d2a2b6112ea);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $1DXAa = parcelRequire("1DXAa");
const $8fd70c84fe96dcaa$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1DXAa.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("1DXAa", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $cca7bb4179e40d90$export$2f62ee6831462844);

var $eJOHy = parcelRequire("eJOHy");
function $cca7bb4179e40d90$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



const $5b4f651e2b94645c$export$54280d191a58e9f6 = 420;
const $5b4f651e2b94645c$export$99041d531d62aef9 = 640;
const $5b4f651e2b94645c$export$9cc428d7e02a0e8b = 850;
const $5b4f651e2b94645c$export$a4477e829bcd1e02 = 200;


parcelRegister("7smax", function(module, exports) {

$parcel$export(module.exports, "ProjectCategoryPicker", () => $a599986494fb708f$export$307a32ce3626da26);

var $97NbA = parcelRequire("97NbA");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $c4OV1 = parcelRequire("c4OV1");

var $gtr2v = parcelRequire("gtr2v");

var $epTsa = parcelRequire("epTsa");

var $7jTnu = parcelRequire("7jTnu");

var $j8Fdp = parcelRequire("j8Fdp");

var $lRq8t = parcelRequire("lRq8t");

var $8oKDI = parcelRequire("8oKDI");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $2YWby = parcelRequire("2YWby");

var $3JBFS = parcelRequire("3JBFS");

var $cdbUM = parcelRequire("cdbUM");
const $a599986494fb708f$export$307a32ce3626da26 = ({ dataRef: dataRef })=>{
    const ariaLabelGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $cdbUM.default).ariaLabelGalaxia : (0, $cdbUM.default).ariaLabel;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'changed',
        actionSubject: 'refinementBar'
    });
    const [value, { updateFilter: updateFilter }] = (0, $3JBFS.useScopedFilter)((0, $2YWby.FilterFields).ProjectCategoryId);
    const data = (0, $j4oe4.useFragment)((0, $97NbA.default), dataRef);
    const onChange = (0, $eJOHy.useCallback)((newValue)=>{
        updateFilter({
            [(0, $2YWby.FilterFields).ProjectCategoryId]: newValue ? String(newValue.value) : '',
            [(0, $2YWby.FilterFields).ProjectCategoryLabel]: newValue ? String(newValue.label) : ''
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'ProjectCategoryPicker');
    }, [
        updateFilter,
        analyticsEvent
    ]);
    const options = (0, $eJOHy.useMemo)(()=>data?.allJiraProjectCategories?.edges?.map((edge)=>({
                value: edge?.node?.id ? ((0, $7jTnu.fg)('camptasks-1102-enable-atlassian-ari-projects') ? (0, $gtr2v.AnyAri).parse(edge?.node?.id) : (0, $8oKDI.getAriConfig)(edge?.node?.id)).resourceId : '',
                label: edge?.node?.name || ''
            })) || [], [
        data
    ]);
    const selectedValue = (0, $eJOHy.useMemo)(()=>(0, $j8Fdp.matchValueToSelectOptions)(value, options), [
        value,
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a599986494fb708f$var$SelectWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
        "aria-label": formatMessage(ariaLabelGalaxia),
        placeholder: formatMessage((0, $cdbUM.default).placeholder),
        isClearable: true,
        name: (0, $2YWby.FilterFields).ProjectCategoryId,
        value: selectedValue,
        onChange: onChange,
        options: options
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a599986494fb708f$var$SelectWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ul9uuw1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("97NbA", function(module, exports) {

$parcel$export(module.exports, "default", () => $dec02e0d6f0eef89$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cf601ef97dd8c80990689dbf69ca6155>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dec02e0d6f0eef89$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "projectCategoryPicker_projectsDirectoryV3",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraProjectCategoryConnection",
            "kind": "LinkedField",
            "name": "allJiraProjectCategories",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraProjectCategoryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraProjectCategory",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$dec02e0d6f0eef89$var$node.hash = "9e121ef0e1f18f545400a0c2ac559c3f";
var $dec02e0d6f0eef89$export$2e2bcd8739ae039 = $dec02e0d6f0eef89$var$node;

});

parcelRegister("cdbUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $13d684cff128f212$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $13d684cff128f212$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    placeholder: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-category-picker.placeholder",
        "defaultMessage": "All categories"
    },
    ariaLabel: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-category-picker.aria-label",
        "defaultMessage": "Select a project category"
    },
    ariaLabelGalaxia: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-category-picker.aria-label-galaxia",
        "defaultMessage": "Select a space category"
    }
});

});


parcelRegister("ameQT", function(module, exports) {

$parcel$export(module.exports, "ProjectTypePicker", () => $6a02edf948ad0758$export$964395abe5900b56);

var $7MDCV = parcelRequire("7MDCV");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $j4oe4 = parcelRequire("j4oe4");

var $6UCkD = parcelRequire("6UCkD");
var $6XEne = parcelRequire("6XEne");

var $j8Fdp = parcelRequire("j8Fdp");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $2YWby = parcelRequire("2YWby");

var $3JBFS = parcelRequire("3JBFS");

var $Ng9Gm = parcelRequire("Ng9Gm");
const $6a02edf948ad0758$var$PROJECT_TYPE_LABELS = {
    software: (0, $Ng9Gm.default).softwareSporkGalaxia,
    business: (0, $Ng9Gm.default).businessSporkGalaxia,
    service_desk: (0, $Ng9Gm.default).serviceDesk,
    customer_service: (0, $Ng9Gm.default).customerService,
    product_discovery: (0, $Ng9Gm.default).productDiscovery
};
const $6a02edf948ad0758$var$PROJECT_TYPE_LABELS_WITH_PROJECT_TERM = {
    software: (0, $Ng9Gm.default).softwareSpork,
    business: (0, $Ng9Gm.default).businessSpork,
    service_desk: (0, $Ng9Gm.default).serviceDesk,
    customer_service: (0, $Ng9Gm.default).customerService,
    product_discovery: (0, $Ng9Gm.default).productDiscovery
};
const $6a02edf948ad0758$var$PROJECT_TYPE_ORDER = {
    software: 2,
    service_desk: 3,
    business: 1,
    product_discovery: 4
};
// JCA11Y-148 - Provide override Input component to remove aria-describedby attribute that attached by placeholder prop,
// since it is conflicted with A11Y comaptibility with aria-label screen announcement, see https://react-select.com/props#components
/* @ts-expect-error - TS2304 - Cannot find name 'SelectComponents' and 'GroupBase' */ const $6a02edf948ad0758$var$Input = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Input, {
        ...props,
        "aria-describedby": undefined
    }, children);
const $6a02edf948ad0758$export$964395abe5900b56 = ({ dataRef: dataRef })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'changed',
        actionSubject: 'refinementBar'
    });
    const [value, { updateFilter: updateFilter }] = (0, $3JBFS.useScopedFilter)((0, $2YWby.FilterFields).ProjectType);
    const data = (0, $j4oe4.useFragment)((0, $7MDCV.default), dataRef);
    const onChange = (0, $eJOHy.useCallback)((newValue)=>{
        updateFilter({
            [(0, $2YWby.FilterFields).ProjectType]: (0, $j8Fdp.serializeSelectOptions)(newValue),
            [(0, $2YWby.FilterFields).ProjectTypeLabel]: (0, $j8Fdp.serializeSelectOptionsLabel)(newValue)
        });
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'ProjectTypePicker');
    }, [
        updateFilter,
        analyticsEvent
    ]);
    const options = (0, $eJOHy.useMemo)(()=>[
            ...data?.allJiraProjectTypes?.edges?.map((edge)=>{
                const projectTypeKey = edge?.node?.key || '';
                const labelMessage = projectTypeKey && (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? $6a02edf948ad0758$var$PROJECT_TYPE_LABELS[projectTypeKey] : $6a02edf948ad0758$var$PROJECT_TYPE_LABELS_WITH_PROJECT_TERM[projectTypeKey];
                return {
                    value: projectTypeKey,
                    label: labelMessage ? formatMessage(labelMessage) : '',
                    order: $6a02edf948ad0758$var$PROJECT_TYPE_ORDER[projectTypeKey]
                };
            }) || []
        ].sort((a, b)=>a.order - b.order), [
        data,
        formatMessage
    ]);
    const selectedValue = (0, $eJOHy.useMemo)(()=>(0, $j8Fdp.matchValueToSelectOptions)(value, options), [
        value,
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6a02edf948ad0758$var$SelectWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6UCkD.default), {
        'aria-label': formatMessage((0, $Ng9Gm.default).placeholderSpork),
        components: {
            Input: $6a02edf948ad0758$var$Input
        },
        styles: {
            menu: ({ width: width, ...css })=>({
                    ...css,
                    width: 'max-content',
                    minWidth: '100%'
                })
        },
        placeholder: formatMessage((0, $Ng9Gm.default).placeholderSpork),
        isMulti: true,
        name: (0, $2YWby.FilterFields).ProjectType,
        value: selectedValue,
        onChange: onChange,
        options: options
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a02edf948ad0758$var$SelectWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1ul9uuw1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7MDCV", function(module, exports) {

$parcel$export(module.exports, "default", () => $71aca5c7c70138b4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5069b1b49714552a977f06f7c2dc5a32>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $71aca5c7c70138b4$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "projectTypePicker_projectsDirectoryV3",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "JiraProjectTypeDetailsConnection",
            "kind": "LinkedField",
            "name": "allJiraProjectTypes",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraProjectTypeDetailsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraProjectTypeDetails",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$71aca5c7c70138b4$var$node.hash = "f75b948f55a1e98fe58f7b24532671ea";
var $71aca5c7c70138b4$export$2e2bcd8739ae039 = $71aca5c7c70138b4$var$node;

});

parcelRegister("Ng9Gm", function(module, exports) {

$parcel$export(module.exports, "default", () => $002ed6ae5042a82f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $002ed6ae5042a82f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    placeholderSpork: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-type-picker.placeholder-spork",
        "defaultMessage": "Filter by product"
    },
    productDiscovery: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-type-picker.product-discovery",
        "defaultMessage": "Jira Product Discovery"
    },
    softwareSpork: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-type-picker.software-spork",
        "defaultMessage": "Jira - software projects"
    },
    serviceDesk: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-type-picker.service-desk",
        "defaultMessage": "Jira Service Management"
    },
    customerService: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-type-picker.customer-service",
        "defaultMessage": "Jira Customer Service"
    },
    businessSpork: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-type-picker.business-spork",
        "defaultMessage": "Jira - business projects"
    },
    softwareSporkGalaxia: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-type-picker.software-spork-galaxia",
        "defaultMessage": "Jira - software spaces"
    },
    businessSporkGalaxia: {
        "id": "projects-directory-v3.page-layout.refinement-bar.project-type-picker.business-spork-galaxia",
        "defaultMessage": "Jira - business spaces"
    }
});

});


parcelRegister("bx4q9", function(module, exports) {

$parcel$export(module.exports, "SearchControl", () => $7ddd8a22b54493c3$export$e8511ccde7917fd2);

var $eJOHy = parcelRequire("eJOHy");

var $kpJwJ = parcelRequire("kpJwJ");

var $epTsa = parcelRequire("epTsa");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $2YWby = parcelRequire("2YWby");

var $6XJko = parcelRequire("6XJko");

var $3JBFS = parcelRequire("3JBFS");

var $9j2hf = parcelRequire("9j2hf");
const $7ddd8a22b54493c3$export$e8511ccde7917fd2 = ()=>{
    const placeholderOldGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $9j2hf.default).placeholderOldGalaxia : (0, $9j2hf.default).placeholderOld;
    const placeholderGalaxia = (0, $epTsa.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $9j2hf.default).placeholderGalaxia : (0, $9j2hf.default).placeholder;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'changed',
        actionSubject: 'refinementBar'
    });
    const [value, { updateFilter: updateFilter }] = (0, $3JBFS.useScopedFilter)((0, $2YWby.FilterFields).Keyword);
    const onChange = (0, $eJOHy.useCallback)((newValue)=>{
        updateFilter((0, $2YWby.FilterFields).Keyword, newValue);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'FilterSearch');
    }, [
        analyticsEvent,
        updateFilter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kpJwJ.SearchControl), {
        name: (0, $2YWby.FilterFields).Keyword,
        value: value,
        onChange: onChange,
        placeholderAlwaysVisible: true,
        placeholder: formatMessage((0, $6XJko.isVisualRefreshEnabled)() ? placeholderGalaxia : placeholderOldGalaxia)
    });
};

});
parcelRegister("kpJwJ", function(module, exports) {

$parcel$export(module.exports, "SearchControl", () => $9656b147b7a10937$export$e8511ccde7917fd2);

var $eJOHy = parcelRequire("eJOHy");

var $fwzaq = parcelRequire("fwzaq");

var $dqc6Z = parcelRequire("dqc6Z");

var $6XJko = parcelRequire("6XJko");
const $9656b147b7a10937$export$e8511ccde7917fd2 = ({ name: name, value: value, onChange: onChange, placeholder: placeholder, placeholderAlwaysVisible: placeholderAlwaysVisible })=>{
    const [onInputChange] = (0, $fwzaq.default)((newValue)=>{
        onChange(newValue);
    }, 500);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dqc6Z.SearchField), {
        id: name,
        shouldFitContainerWidth: true,
        value: value,
        onChange: onInputChange,
        isAutocompleteDisabled: true,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        placeholder: placeholder,
        showIconBeforeInput: (0, $6XJko.isVisualRefreshEnabled)()
    });
};

});
parcelRegister("fwzaq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab2d121bc64be0a3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");
function $ab2d121bc64be0a3$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $eJOHy.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $eJOHy.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $eJOHy.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $eJOHy.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("dqc6Z", function(module, exports) {

$parcel$export(module.exports, "SearchField", () => $84caf67c6542222b$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $6S4l2 = parcelRequire("6S4l2");

var $ftN6c = parcelRequire("ftN6c");

var $sY9BV = parcelRequire("sY9BV");

var $k71qx = parcelRequire("k71qx");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $jd93d = parcelRequire("jd93d");

var $7jTnu = parcelRequire("7jTnu");

var $1uv7v = parcelRequire("1uv7v");

var $kUoGK = parcelRequire("kUoGK");

var $1302Y = parcelRequire("1302Y");

var $7CY7m = parcelRequire("7CY7m");

var $4jrRd = parcelRequire("4jrRd");

var $ixnXK = parcelRequire("ixnXK");
function $84caf67c6542222b$export$41946885a418e1(object) {
    return 'ref' in object && 'data-test-id' in object;
}
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $84caf67c6542222b$var$className = 'ajs-dirty-warning-exempt';
const $84caf67c6542222b$var$SearchFieldContainer = ({ shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, children: children })=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $kUoGK.useSoftwareProjectTheming)();
    return (0, $1302Y.getIsSoftwareThemingM2Enabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: [
            shouldFitContainerWidth && $84caf67c6542222b$var$fitContainerStyles,
            (0, $6XJko.isVisualRefreshEnabled)() && reducedHeight && $84caf67c6542222b$var$reducedHeightStyles,
            isSoftwareFullTheming && $84caf67c6542222b$var$themedBgStyles
        ]
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        ...(0, $6XJko.isVisualRefreshEnabled)() ? {
            reducedHeight: reducedHeight
        } : {}
    }, children);
};
const $84caf67c6542222b$var$STABLE_EMPTY_OBJECT = {};
const $84caf67c6542222b$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, reducedHeight: reducedHeight = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, searchIconPrimaryColor: searchIconPrimaryColor, testId: testId, inputProps: inputProps = $84caf67c6542222b$var$STABLE_EMPTY_OBJECT, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false, renderTooltipContent: renderTooltipContent = null })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const [value, setValue] = (0, $eJOHy.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const textInput = (0, $eJOHy.useRef)(null);
    const previousValueRef = (0, $eJOHy.useRef)();
    if (!(0, $7jTnu.fg)('jif-jam-search-filter-edit')) {
        const previousValue = previousValueRef.current;
        if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
        setValue(externalValue);
        previousValueRef.current = externalValue;
    } // If clear filters gets clicked
    (0, $eJOHy.useEffect)(()=>{
        if (externalValue === '' && (0, $7jTnu.fg)('jif-jam-search-filter-edit')) setValue('');
    }, [
        externalValue
    ]);
    const handleOnFocus = (0, $eJOHy.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eJOHy.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eJOHy.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = (0, $7jTnu.fg)('filter_refinement_search_field_tooltip') ? // condition is because of fg
    // eslint-disable-next-line react-hooks/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eJOHy.useMemo)(()=>{
        return {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, $7CY7m.messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $84caf67c6542222b$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
    }, [
        ariaLabelText,
        autoFocus,
        describedById,
        formatMessage,
        handleKeyDown,
        handleOnBlur,
        handleOnChange,
        handleOnFocus,
        inputProps,
        inputRef,
        isAutocompleteDisabled,
        isCompact,
        isDisabled,
        maxLength,
        placeholder,
        testId,
        value
    ]) : {
        ...inputProps,
        'aria-label': ariaLabelText || placeholder || formatMessage((0, $7CY7m.messages).search),
        'aria-describedby': describedById,
        type: 'text',
        'data-test-id': 'searchfield',
        testId: testId ?? 'searchfield',
        name: 'search',
        className: $84caf67c6542222b$var$className,
        placeholder: placeholder,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        width: '120px',
        onChange: handleOnChange,
        onKeyDown: handleKeyDown,
        ref: inputRef || textInput,
        isCompact: isCompact,
        autoFocus: autoFocus,
        autoComplete: isAutocompleteDisabled ? 'off' : 'on',
        value: value,
        maxLength: maxLength,
        isDisabled: isDisabled
    };
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear),
        searchIconVisible: searchIconVisible,
        primaryColor: (0, $6XJko.isVisualRefreshEnabled)() ? undefined : searchIconPrimaryColor,
        onlyIconSpacing: isResponsive && !isExpanded,
        ...(0, $7jTnu.fg)('jira_jif_jam_clear_text_icon') ? {
            inCustomSearchField: renderCustomSearchField !== undefined
        } : {}
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4jrRd.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear)
    }) : undefined;
    if ($84caf67c6542222b$export$41946885a418e1(textFieldProps) && (0, $7jTnu.fg)('filter_refinement_search_field_tooltip')) {
        const { onFocus: onFocusTextField, ref: textFieldRef, 'aria-describedby': textfieldAriaDescription, onBlur: onBlurTextField, ...restTextFieldProps } = textFieldProps; // condition is just because of fg
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const showTooltip = (0, $eJOHy.useMemo)(()=>{
            return renderTooltipContent !== null && renderTooltipContent !== undefined && value === '';
        }, [
            renderTooltipContent,
            value
        ]); // condition is because of fg - remove disabled eslint rule once fg is removed
        // eslint-disable-next-line react-hooks/react-compiler
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const useShowTooltip = (0, $eJOHy.useCallback)(()=>showTooltip, [
            showTooltip
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$SearchFieldContainer, {
            shouldFitContainerWidth: shouldFitContainerWidth,
            reducedHeight: reducedHeight
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$InputWrapper, {
            isExpanded: isExpanded,
            shouldFitContainerWidth: shouldFitContainerWidth,
            maxWidth: increasedWidth ? 328 : 184,
            placeholderAlwaysVisible: placeholderAlwaysVisible,
            isResponsive: isResponsive
        }, renderCustomSearchField !== undefined ? renderCustomSearchField({
            textFieldProps: textFieldProps,
            searchIcon: searchIconDynamic
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: renderTooltipContent,
            canAppear: useShowTooltip,
            position: "bottom-start",
            hideTooltipOnClick: true,
            ignoreTooltipPointerEvents: true
        }, ({ onFocus: onFocusTooltip, ref: tooltipRef, 'aria-describedby': tooltipAriaDescription, onBlur: onBlurTooltip, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
                ...tooltipProps,
                ...restTextFieldProps,
                elemBeforeInput: searchIcon,
                elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
                ...id !== undefined ? {
                    id: id
                } : {},
                // eslint-disable-next-line react-hooks/rules-of-hooks
                onFocus: (0, $eJOHy.useCallback)((event)=>{
                    onFocusTextField && onFocusTextField(event);
                    onFocusTooltip(event);
                }, [
                    onFocusTooltip
                ]),
                // eslint-disable-next-line react-hooks/rules-of-hooks
                onBlur: (0, $eJOHy.useCallback)((event)=>{
                    onBlurTextField && onBlurTextField(event);
                    onBlurTooltip(event);
                }, [
                    onBlurTooltip
                ]),
                ref: (0, $jd93d.mergeRefs)(textFieldRef, tooltipRef),
                "aria-describedby": tooltipAriaDescription || textfieldAriaDescription
            }))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$SearchFieldContainer, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        reducedHeight: reducedHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
        ...textFieldProps,
        elemBeforeInput: searchIcon,
        elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
        ...id !== undefined ? {
            id: id
        } : {}
    })));
};
$84caf67c6542222b$var$SearchFieldUnmemoized.displayName = 'Search';
$84caf67c6542222b$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $84caf67c6542222b$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eJOHy.memo)($84caf67c6542222b$var$SearchFieldUnmemoized);
$84caf67c6542222b$export$b94867ecbd698f21.displayName = 'Search';
const $84caf67c6542222b$var$fitContainerStyles = (0, $1DXK0.xcss)({
    width: '100%'
});
const $84caf67c6542222b$var$reducedHeightStyles = (0, $1DXK0.xcss)({
    height: '32px'
});
const $84caf67c6542222b$var$themedBgStyles = (0, $1DXK0.xcss)({
    // @ts-expect-error - Apply the dominant colour behind the search input for image background themes
    backgroundColor: (0, $1uv7v.Tokens).COLOR_ELEVATION_SURFACE /* eslint-disable-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ ,
    borderRadius: "var(--ds-border-radius, 4px)"
}); // Delete when cleaning up getIsSoftwareThemingM2Enabled
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84caf67c6542222b$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.reducedHeight && "_4t3izwfg",
            __cmplp.className
        ])
    });
});
const $84caf67c6542222b$var$InputWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $awdRS.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $awdRS.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $awdRS.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $awdRS.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v564zpk5 _1e0c1txw _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _ffa416hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7CY7m", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1790c56385a948ce$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1790c56385a948ce$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("4jrRd", function(module, exports) {

$parcel$export(module.exports, "ClearFieldIcon", () => $047d370cc11f69d8$export$84038b503874befa);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $a03qM = parcelRequire("a03qM");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");
const $047d370cc11f69d8$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            (0, $7jTnu.fg)('jira_jif_jam_clear_text_icon') ? $047d370cc11f69d8$var$wrapperStylesClearIcon : $047d370cc11f69d8$var$wrapperStylesCloseIcon
        ]
    }, (0, $7jTnu.fg)('jira_jif_jam_clear_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $047d370cc11f69d8$var$iconWrapperStyles,
        onClick: onClear,
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1,
        "aria-label": clearIconLabel,
        testId: "searchfield.ui.clearfield-icon.clear-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo)))
    }));
const $047d370cc11f69d8$var$wrapperStylesCloseIcon = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.050'
    }
});
const $047d370cc11f69d8$var$wrapperStylesClearIcon = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.050',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.075'
    }
});
const $047d370cc11f69d8$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    cursor: 'pointer',
    paddingInlineStart: 'space.0',
    paddingInlineEnd: 'space.0',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.0',
    borderRadius: 'border.radius.circle',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.accent.gray'
    }
});

});

parcelRegister("ixnXK", function(module, exports) {

$parcel$export(module.exports, "SearchFieldIconDynamic", () => $fd1be89cde4ae981$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $fd1be89cde4ae981$export$8a82bff895521bd9);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6J9k6 = parcelRequire("6J9k6");

var $i0iAU = parcelRequire("i0iAU");

var $dt3aG = parcelRequire("dt3aG");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $a03qM = parcelRequire("a03qM");

var $7jTnu = parcelRequire("7jTnu");
const $fd1be89cde4ae981$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false, inCustomSearchField: inCustomSearchField = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i0iAU))), {
        LEGACY_size: "small",
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStyles,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStyles,
            inCustomSearchField && (0, $7jTnu.fg)('jira_jif_jam_clear_text_icon') && $fd1be89cde4ae981$var$minimalSpacingStyles
        ]
    }, // eslint-disable-next-line no-nested-ternary
    hasValue ? (0, $7jTnu.fg)('jira_jif_jam_clear_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $fd1be89cde4ae981$var$iconWrapperStyles,
        onClick: onClear,
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1,
        testId: "searchfield.ui.searchfield-icon.clear-button",
        "aria-label": clearIconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        spacing: "none",
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6J9k6))), {
            LEGACY_size: "small",
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $fd1be89cde4ae981$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStylesBefore,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #44546F)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));
const $fd1be89cde4ae981$var$wrapperStyles = (0, $1DXK0.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    // the wider marginRight is applicable for when the search/clear icon is after the input
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex',
    alignItems: 'center'
});
// if this icon is used in a custom search field, we won't assume any spacing since we don't know where their searchIcon is used
// i.e. before or after the input
// it will be up to the consumers to add spacing where needed
const $fd1be89cde4ae981$var$minimalSpacingStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.0'
});
const $fd1be89cde4ae981$var$spacingStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $fd1be89cde4ae981$var$wrapperStylesBefore = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$spacingStylesBefore = (0, $1DXK0.xcss)({
    marginLeft: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    cursor: 'pointer',
    paddingInlineStart: 'space.0',
    paddingInlineEnd: 'space.0',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.0',
    borderRadius: 'border.radius.circle',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.accent.gray'
    }
});

});



parcelRegister("9j2hf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2d43f39e1616db2$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f2d43f39e1616db2$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    placeholder: {
        "id": "projects-directory-v3.page-layout.refinement-bar.search-control.placeholder",
        "defaultMessage": "Search projects"
    },
    placeholderOld: {
        "id": "projects-directory-v3.page-layout.refinement-bar.search-control.placeholder-old",
        "defaultMessage": "Search Projects"
    },
    placeholderGalaxia: {
        "id": "projects-directory-v3.page-layout.refinement-bar.search-control.placeholder-galaxia",
        "defaultMessage": "Search spaces"
    },
    placeholderOldGalaxia: {
        "id": "projects-directory-v3.page-layout.refinement-bar.search-control.placeholder-old-galaxia",
        "defaultMessage": "Search spaces"
    }
});

});





parcelRegister("fmhfo", function(module, exports) {

$parcel$export(module.exports, "default", () => $2682a2794dec76a0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1qbKn = parcelRequire("1qbKn");

var $iIqWW = parcelRequire("iIqWW");
const $2682a2794dec76a0$var$ErrorBoundaryWithExtraEventData = ({ children: children, id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorBoundaryFlag), {
        id: "spa-apps.error-boundary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iIqWW.default), null, ({ transitionsCount: transitionsCount = 0, lastTransition: lastTransition = '', navigationStart: navigationStart = '' })=>{
        const extraEventData = {
            transitionsCount: transitionsCount,
            lastTransition: lastTransition,
            navigationStart: navigationStart
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorBoundaryFlag), {
            id: id,
            extraEventData: extraEventData
        }, children);
    }));
const $2682a2794dec76a0$var$SpaErrorBoundary = $2682a2794dec76a0$var$ErrorBoundaryWithExtraEventData;
var $2682a2794dec76a0$export$2e2bcd8739ae039 = $2682a2794dec76a0$var$SpaErrorBoundary;

});

parcelRegister("j2mVo", function(module, exports) {

$parcel$export(module.exports, "METRICS_CONFIG", () => $788bff462eabba45$export$ccca72d76a53907e);

var $2YWby = parcelRequire("2YWby");
const $788bff462eabba45$export$ccca72d76a53907e = {
    default: {
        sourceName: 'projectsV3',
        experienceKey: (0, $2YWby.PROJECTS_DIRECTORY_EXPERIENCE),
        experienceSource: 'projects-directory-v3',
        errorBoundary: 'spa-app-bootstrap.directories.projects-v3',
        appNameV2: 'directory.projects-v3',
        appNameV3: 'projectsDirectoryV3'
    },
    admin: {
        sourceName: 'projectsManageV3',
        experienceKey: (0, $2YWby.MANAGE_PROJECTS_DIRECTORY_EXPERIENCE),
        experienceSource: 'projects-directory-manage-v3',
        errorBoundary: 'spa-app-bootstrap.directories.projects-manage-v3',
        appNameV2: 'directory.projects-manage-v3',
        appNameV3: 'projectsDirectoryManageV3'
    }
};

});



//# sourceMappingURL=async-projects-directory-v3.6008f6b4.js.map
